// src/data/courseData.js
// 자동 생성: 2026-09-01 — scripts/generateCourseData.mjs
// 수원대학교 포털 개설강좌 API (info.suwon.ac.kr, via workers/suwon-course-sync)
//
// COURSE_DATA[].subjectKey → requirementData.js REQUIREMENT_DATA[].requiredSubjects[].subjectKey 와 매칭
// 같은 subjectKey를 가진 행들이 각각 다른 분반(division)임

import { applyCourseDataOverrides } from './courseDataOverrides.js'

export const COURSE_DATA_META = {
  "year": 2026,
  "semester": 2,
  "semesterKey": "2026-2",
  "generatedAt": "2026-09-01",
  "source": "수원대학교 포털 API canonical snapshot"
}

const RAW_COURSE_DATA = [
  {
    "id": "00187-001-2000637",
    "subjectKey": "00187",
    "name": "GIS(도시지리정보체계실습)2",
    "division": "001",
    "department": "도시부동산학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "강동진",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "2공학306",
    "isOnline": false,
    "source": {
      "schedule": "2공학306(화1,2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "2공학306"
      }
    ],
    "sourceSchedule": "2공학306(화1,2,3,4)"
  },
  {
    "id": "00191-001-2000759",
    "subjectKey": "00191",
    "name": "JAVA",
    "division": "001",
    "department": "지능형보안학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김영미",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT306",
    "isOnline": false,
    "source": {
      "schedule": "IT306(월1,2,3,4)"
    },
    "capacity": 42,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT306"
      }
    ],
    "sourceSchedule": "IT306(월1,2,3,4)"
  },
  {
    "id": "00191-001-2000763",
    "subjectKey": "00191",
    "name": "JAVA",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김영미",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT306",
    "isOnline": false,
    "source": {
      "schedule": "IT306(월1,2,3,4)"
    },
    "capacity": 42,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT306"
      }
    ],
    "sourceSchedule": "IT306(월1,2,3,4)"
  },
  {
    "id": "00231-001-2000746",
    "subjectKey": "00231",
    "name": "P.R론",
    "division": "001",
    "department": "미디어커뮤니케이션",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정원준",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문309",
    "isOnline": false,
    "source": {
      "schedule": "인문309(화1,2,3)"
    },
    "capacity": 80,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문309"
      }
    ],
    "sourceSchedule": "인문309(화1,2,3)"
  },
  {
    "id": "00235-001-2000583",
    "subjectKey": "00235",
    "name": "P.R제작",
    "division": "001",
    "department": "미디어커뮤니케이션학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정원준",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문406",
    "isOnline": false,
    "source": {
      "schedule": "인문406(목1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문406"
      }
    ],
    "sourceSchedule": "인문406(목1,2,3)"
  },
  {
    "id": "00262-001-2000599",
    "subjectKey": "00262",
    "name": "가정관리학",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고선주",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "생활202",
    "isOnline": false,
    "source": {
      "schedule": "생활202(수2,3,4)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "생활202"
      }
    ],
    "sourceSchedule": "생활202(수2,3,4)"
  },
  {
    "id": "00295-001-2000599",
    "subjectKey": "00295",
    "name": "가족복지론",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "차승은",
    "days": [
      "수",
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "생활202",
    "isOnline": false,
    "source": {
      "schedule": "생활202(수5),생활305(월7,8)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5
        ],
        "classroom": "생활202"
      },
      {
        "day": "월",
        "periods": [
          7,
          8
        ],
        "classroom": "생활305"
      }
    ],
    "sourceSchedule": "생활202(수5),생활305(월7,8)"
  },
  {
    "id": "00350-001-2000636",
    "subjectKey": "00350",
    "name": "건축계획2",
    "division": "001",
    "department": "건축학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김민경",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "2공학313",
    "isOnline": false,
    "source": {
      "schedule": "2공학313(수1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "2공학313"
      }
    ],
    "sourceSchedule": "2공학313(수1,2,3)"
  },
  {
    "id": "00375-001-2000414",
    "subjectKey": "00375",
    "name": "건축구조설계",
    "division": "001",
    "department": "건축학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박지슬",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "2공학314",
    "isOnline": false,
    "source": {
      "schedule": "2공학314(월6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "2공학314"
      }
    ],
    "sourceSchedule": "2공학314(월6,7,8)"
  },
  {
    "id": "00401-001-2000636",
    "subjectKey": "00401",
    "name": "건축설계4",
    "division": "001",
    "department": "건축학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 4,
    "professor": "권경남",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 7,
    "room": "2공학304",
    "isOnline": false,
    "source": {
      "schedule": "2공학304(수1,2,3,5,6,7)"
    },
    "capacity": 12,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          5,
          6,
          7
        ],
        "classroom": "2공학304"
      }
    ],
    "sourceSchedule": "2공학304(수1,2,3,5,6,7)"
  },
  {
    "id": "00401-002-2000636",
    "subjectKey": "00401",
    "name": "건축설계4",
    "division": "002",
    "department": "건축학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 4,
    "professor": "고재민",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 7,
    "room": "2공학207",
    "isOnline": false,
    "source": {
      "schedule": "2공학207(수1,2,3,5,6,7)"
    },
    "capacity": 12,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          5,
          6,
          7
        ],
        "classroom": "2공학207"
      }
    ],
    "sourceSchedule": "2공학207(수1,2,3,5,6,7)"
  },
  {
    "id": "00401-003-2000636",
    "subjectKey": "00401",
    "name": "건축설계4",
    "division": "003",
    "department": "건축학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 4,
    "professor": "김한준",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 7,
    "room": "2공학213",
    "isOnline": false,
    "source": {
      "schedule": "2공학213(수1,2,3,5,6,7)"
    },
    "capacity": 12,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          5,
          6,
          7
        ],
        "classroom": "2공학213"
      }
    ],
    "sourceSchedule": "2공학213(수1,2,3,5,6,7)"
  },
  {
    "id": "00401-004-2000636",
    "subjectKey": "00401",
    "name": "건축설계4",
    "division": "004",
    "department": "건축학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 4,
    "professor": "진우성",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 7,
    "room": "2공학211",
    "isOnline": false,
    "source": {
      "schedule": "2공학211(수1,2,3,5,6,7)"
    },
    "capacity": 12,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          5,
          6,
          7
        ],
        "classroom": "2공학211"
      }
    ],
    "sourceSchedule": "2공학211(수1,2,3,5,6,7)"
  },
  {
    "id": "00403-001-2000414",
    "subjectKey": "00403",
    "name": "건축설계6(건축사업관리)",
    "division": "001",
    "department": "건축학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "임광혁",
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "자연대B103",
    "isOnline": false,
    "source": {
      "schedule": "자연대B103(월2,3),2공학314(목3,4)"
    },
    "capacity": 15,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "자연대B103"
      },
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "2공학314"
      }
    ],
    "sourceSchedule": "자연대B103(월2,3),2공학314(목3,4)"
  },
  {
    "id": "00407-001-2000636",
    "subjectKey": "00407",
    "name": "건축설계2",
    "division": "001",
    "department": "건축학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 4,
    "professor": "김현주",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 7,
    "room": "2공학204",
    "isOnline": false,
    "source": {
      "schedule": "2공학204(목1,2,3,5,6,7)"
    },
    "capacity": 16,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          5,
          6,
          7
        ],
        "classroom": "2공학204"
      }
    ],
    "sourceSchedule": "2공학204(목1,2,3,5,6,7)"
  },
  {
    "id": "00407-002-2000636",
    "subjectKey": "00407",
    "name": "건축설계2",
    "division": "002",
    "department": "건축학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 4,
    "professor": "고재민",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 7,
    "room": "2공학207",
    "isOnline": false,
    "source": {
      "schedule": "2공학207(목1,2,3,5,6,7)"
    },
    "capacity": 15,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          5,
          6,
          7
        ],
        "classroom": "2공학207"
      }
    ],
    "sourceSchedule": "2공학207(목1,2,3,5,6,7)"
  },
  {
    "id": "00407-003-2000636",
    "subjectKey": "00407",
    "name": "건축설계2",
    "division": "003",
    "department": "건축학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 4,
    "professor": "강지형",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 7,
    "room": "2공학205",
    "isOnline": false,
    "source": {
      "schedule": "2공학205(목1,2,3,5,6,7)"
    },
    "capacity": 15,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          5,
          6,
          7
        ],
        "classroom": "2공학205"
      }
    ],
    "sourceSchedule": "2공학205(목1,2,3,5,6,7)"
  },
  {
    "id": "00407-004-2000636",
    "subjectKey": "00407",
    "name": "건축설계2",
    "division": "004",
    "department": "건축학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 4,
    "professor": "김남원",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 7,
    "room": "2공학206",
    "isOnline": false,
    "source": {
      "schedule": "2공학206(목1,2,3,5,6,7)"
    },
    "capacity": 15,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          5,
          6,
          7
        ],
        "classroom": "2공학206"
      }
    ],
    "sourceSchedule": "2공학206(목1,2,3,5,6,7)"
  },
  {
    "id": "00495-001-2000636",
    "subjectKey": "00495",
    "name": "건축환경계획2",
    "division": "001",
    "department": "건축학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정창호",
    "days": [
      "수",
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "자연대B103",
    "isOnline": false,
    "source": {
      "schedule": "자연대B103(수5),자연대B106(월3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5
        ],
        "classroom": "자연대B103"
      },
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "자연대B106"
      }
    ],
    "sourceSchedule": "자연대B103(수5),자연대B106(월3,4)"
  },
  {
    "id": "00506-001-2000658",
    "subjectKey": "00506",
    "name": "결혼과가족",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "고선주",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합307",
    "isOnline": false,
    "source": {
      "schedule": "종합307(목4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합307"
      }
    ],
    "sourceSchedule": "종합307(목4,5,6)"
  },
  {
    "id": "00506-002-2000658",
    "subjectKey": "00506",
    "name": "결혼과가족",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "임이삭지순",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래109",
    "isOnline": false,
    "source": {
      "schedule": "미래109(화7,8,9)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래109"
      }
    ],
    "sourceSchedule": "미래109(화7,8,9)"
  },
  {
    "id": "00513-001-2000638",
    "subjectKey": "00513",
    "name": "경영공학",
    "division": "001",
    "department": "산업공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "정주성",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "2공학116",
    "isOnline": false,
    "source": {
      "schedule": "2공학116(월1,2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "2공학116"
      }
    ],
    "sourceSchedule": "2공학116(월1,2,3,4)"
  },
  {
    "id": "00532-001-2000626",
    "subjectKey": "00532",
    "name": "경영조직론",
    "division": "001",
    "department": "경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "소원근",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "글경603",
    "isOnline": false,
    "source": {
      "schedule": "글경603(월1,2 수1)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "글경603"
      },
      {
        "day": "수",
        "periods": [
          1
        ],
        "classroom": "글경603"
      }
    ],
    "sourceSchedule": "글경603(월1,2 수1)"
  },
  {
    "id": "00532-002-2000626",
    "subjectKey": "00532",
    "name": "경영조직론(재직자반)",
    "division": "002",
    "department": "경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "윤정권",
    "days": [
      "목"
    ],
    "startPeriod": 10,
    "endPeriod": 12,
    "room": "글경607",
    "isOnline": false,
    "source": {
      "schedule": "글경607(목10,11,12)"
    },
    "capacity": 4,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          10,
          11,
          12
        ],
        "classroom": "글경607"
      }
    ],
    "sourceSchedule": "글경607(목10,11,12)"
  },
  {
    "id": "00535-001-2000627",
    "subjectKey": "00535",
    "name": "경영통계",
    "division": "001",
    "department": "회계",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "우동호",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경401",
    "isOnline": false,
    "source": {
      "schedule": "글경401(화5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경401"
      }
    ],
    "sourceSchedule": "글경401(화5,6,7)"
  },
  {
    "id": "00535-002-2000626",
    "subjectKey": "00535",
    "name": "경영통계",
    "division": "002",
    "department": "경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고석빈",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경603",
    "isOnline": false,
    "source": {
      "schedule": "글경603(월5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경603"
      }
    ],
    "sourceSchedule": "글경603(월5,6,7)"
  },
  {
    "id": "00546-002-2000754",
    "subjectKey": "00546",
    "name": "경영학원론",
    "division": "002",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "곽정훈",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경603",
    "isOnline": false,
    "source": {
      "schedule": "글경603(수5,6,7)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경603"
      }
    ],
    "sourceSchedule": "글경603(수5,6,7)"
  },
  {
    "id": "00546-002-2000763",
    "subjectKey": "00546",
    "name": "경영학원론",
    "division": "002",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "곽정훈",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경603",
    "isOnline": false,
    "source": {
      "schedule": "글경603(수5,6,7)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경603"
      }
    ],
    "sourceSchedule": "글경603(수5,6,7)"
  },
  {
    "id": "00546-003-2000754",
    "subjectKey": "00546",
    "name": "경영학원론(외국인전용)",
    "division": "003",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이탁",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경402",
    "isOnline": false,
    "source": {
      "schedule": "글경402(수5,6,7)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경402"
      }
    ],
    "sourceSchedule": "글경402(수5,6,7)"
  },
  {
    "id": "00551-001-2000744",
    "subjectKey": "00551",
    "name": "경제법",
    "division": "001",
    "department": "법학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정우식",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "종합403",
    "isOnline": false,
    "source": {
      "schedule": "종합403(수2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "종합403"
      }
    ],
    "sourceSchedule": "종합403(수2,3,4)"
  },
  {
    "id": "00553-001-2000624",
    "subjectKey": "00553",
    "name": "경제사",
    "division": "001",
    "department": "경제금융",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "송승주",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 6,
    "room": "글경503",
    "isOnline": false,
    "source": {
      "schedule": "글경503(수6 목4,5)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6
        ],
        "classroom": "글경503"
      },
      {
        "day": "목",
        "periods": [
          4,
          5
        ],
        "classroom": "글경503"
      }
    ],
    "sourceSchedule": "글경503(수6 목4,5)"
  },
  {
    "id": "00555-001-2000591",
    "subjectKey": "00555",
    "name": "경제성공학",
    "division": "001",
    "department": "산업 및 기계공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "고현민",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "자연대B106",
    "isOnline": false,
    "source": {
      "schedule": "자연대B106(화3,4,5)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "자연대B106"
      }
    ],
    "sourceSchedule": "자연대B106(화3,4,5)"
  },
  {
    "id": "00555-002-2000591",
    "subjectKey": "00555",
    "name": "경제성공학",
    "division": "002",
    "department": "산업 및 기계공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "고현민",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "자연대B106",
    "isOnline": false,
    "source": {
      "schedule": "자연대B106(화6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "자연대B106"
      }
    ],
    "sourceSchedule": "자연대B106(화6,7,8)"
  },
  {
    "id": "00584-001-2000503",
    "subjectKey": "00584",
    "name": "경제학세미나",
    "division": "001",
    "department": "경제금융",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "윤면식",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경503",
    "isOnline": false,
    "source": {
      "schedule": "글경503(목1,2,3)"
    },
    "capacity": 21,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경503"
      }
    ],
    "sourceSchedule": "글경503(목1,2,3)"
  },
  {
    "id": "00591-001-2000754",
    "subjectKey": "00591",
    "name": "경제학원론",
    "division": "001",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이상엽",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "글경503",
    "isOnline": false,
    "source": {
      "schedule": "글경503(화2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "글경503"
      }
    ],
    "sourceSchedule": "글경503(화2,3,4)"
  },
  {
    "id": "00591-001-2000763",
    "subjectKey": "00591",
    "name": "경제학원론",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이상엽",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "글경503",
    "isOnline": false,
    "source": {
      "schedule": "글경503(화2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "글경503"
      }
    ],
    "sourceSchedule": "글경503(화2,3,4)"
  },
  {
    "id": "00591-002-2000754",
    "subjectKey": "00591",
    "name": "경제학원론",
    "division": "002",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김양우",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "글경B101",
    "isOnline": false,
    "source": {
      "schedule": "글경B101(월6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "글경B101"
      }
    ],
    "sourceSchedule": "글경B101(월6,7,8)"
  },
  {
    "id": "00591-002-2000763",
    "subjectKey": "00591",
    "name": "경제학원론",
    "division": "002",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김양우",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "글경B101",
    "isOnline": false,
    "source": {
      "schedule": "글경B101(월6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "글경B101"
      }
    ],
    "sourceSchedule": "글경B101(월6,7,8)"
  },
  {
    "id": "00591-003-2000754",
    "subjectKey": "00591",
    "name": "경제학원론",
    "division": "003",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "송승주",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경B103",
    "isOnline": false,
    "source": {
      "schedule": "글경B103(화4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경B103"
      }
    ],
    "sourceSchedule": "글경B103(화4,5,6)"
  },
  {
    "id": "00591-003-2000763",
    "subjectKey": "00591",
    "name": "경제학원론",
    "division": "003",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "송승주",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경B103",
    "isOnline": false,
    "source": {
      "schedule": "글경B103(화4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경B103"
      }
    ],
    "sourceSchedule": "글경B103(화4,5,6)"
  },
  {
    "id": "00591-005-2000754",
    "subjectKey": "00591",
    "name": "경제학원론(외국인전용)",
    "division": "005",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이수현",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "글경604",
    "isOnline": false,
    "source": {
      "schedule": "글경604(월6,7,8)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "글경604"
      }
    ],
    "sourceSchedule": "글경604(월6,7,8)"
  },
  {
    "id": "00606-001-2000617",
    "subjectKey": "00606",
    "name": "고고미술사",
    "division": "001",
    "department": "사학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "허의행",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문512",
    "isOnline": false,
    "source": {
      "schedule": "인문512(수4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문512"
      }
    ],
    "sourceSchedule": "인문512(수4,5,6)"
  },
  {
    "id": "00611-001-2000409",
    "subjectKey": "00611",
    "name": "고급무기화학",
    "division": "001",
    "department": "융합화학산업",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김은옥",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "자연대B101",
    "isOnline": false,
    "source": {
      "schedule": "자연대B101(화1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "자연대B101"
      }
    ],
    "sourceSchedule": "자연대B101(화1,2,3)"
  },
  {
    "id": "00622-001-2000632",
    "subjectKey": "00622",
    "name": "고급생화학",
    "division": "001",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "유예",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "종합408",
    "isOnline": false,
    "source": {
      "schedule": "종합408(금6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "종합408"
      }
    ],
    "sourceSchedule": "종합408(금6,7,8)"
  },
  {
    "id": "00622-002-2000632",
    "subjectKey": "00622",
    "name": "고급생화학",
    "division": "002",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "타바시아판 탐비",
    "days": [
      "목",
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "종합404",
    "isOnline": false,
    "source": {
      "schedule": "종합404(목7,8),종합409(월4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8
        ],
        "classroom": "종합404"
      },
      {
        "day": "월",
        "periods": [
          4
        ],
        "classroom": "종합409"
      }
    ],
    "sourceSchedule": "종합404(목7,8),종합409(월4)"
  },
  {
    "id": "00645-001-2000296",
    "subjectKey": "00645",
    "name": "고급일어강독2",
    "division": "001",
    "department": "일어일문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이성근",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "글경414",
    "isOnline": false,
    "source": {
      "schedule": "글경414(수2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "글경414"
      }
    ],
    "sourceSchedule": "글경414(수2,3,4)"
  },
  {
    "id": "00648-001-2000621",
    "subjectKey": "00648",
    "name": "고급중국어",
    "division": "001",
    "department": "중어중문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "손미리",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "종합503",
    "isOnline": false,
    "source": {
      "schedule": "종합503(화3 금4,5)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3
        ],
        "classroom": "종합503"
      },
      {
        "day": "금",
        "periods": [
          4,
          5
        ],
        "classroom": "종합503"
      }
    ],
    "sourceSchedule": "종합503(화3 금4,5)"
  },
  {
    "id": "00682-001-2000642",
    "subjectKey": "00682",
    "name": "고분자공학개론",
    "division": "001",
    "department": "신소재공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이성재",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "미래109",
    "isOnline": false,
    "source": {
      "schedule": "미래109(월2,3 화1)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "미래109"
      },
      {
        "day": "화",
        "periods": [
          1
        ],
        "classroom": "미래109"
      }
    ],
    "sourceSchedule": "미래109(월2,3 화1)"
  },
  {
    "id": "00743-001-2000180",
    "subjectKey": "00743",
    "name": "고전압공학",
    "division": "001",
    "department": "전기공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "송병두",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "종합502",
    "isOnline": false,
    "source": {
      "schedule": "종합502(목2,3,4)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "종합502"
      }
    ],
    "sourceSchedule": "종합502(목2,3,4)"
  },
  {
    "id": "00758-001-2000639",
    "subjectKey": "00758",
    "name": "고체역학응용",
    "division": "001",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "호광일",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합405",
    "isOnline": false,
    "source": {
      "schedule": "종합405(수5,6,7)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합405"
      }
    ],
    "sourceSchedule": "종합405(수5,6,7)"
  },
  {
    "id": "00759-001-2000592",
    "subjectKey": "00759",
    "name": "고체전자",
    "division": "001",
    "department": "반도체공학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이관",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "종합412",
    "isOnline": false,
    "source": {
      "schedule": "종합412(수3 목5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3
        ],
        "classroom": "종합412"
      },
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "종합412"
      }
    ],
    "sourceSchedule": "종합412(수3 목5,6)"
  },
  {
    "id": "00773-001-2000602",
    "subjectKey": "00773",
    "name": "골프1(체육전공)",
    "division": "001",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "박병철",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B203",
    "isOnline": false,
    "source": {
      "schedule": "미래B203(금3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B203"
      }
    ],
    "sourceSchedule": "미래B203(금3,4)"
  },
  {
    "id": "00773-002-2000602",
    "subjectKey": "00773",
    "name": "골프1(레저스포츠전공)",
    "division": "002",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "박병철",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B203",
    "isOnline": false,
    "source": {
      "schedule": "미래B203(목1,2)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B203"
      }
    ],
    "sourceSchedule": "미래B203(목1,2)"
  },
  {
    "id": "00773-003-2000602",
    "subjectKey": "00773",
    "name": "골프1(운동건강관리전공)",
    "division": "003",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "박병철",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "체육116",
    "isOnline": false,
    "source": {
      "schedule": "체육116(금1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "체육116"
      }
    ],
    "sourceSchedule": "체육116(금1,2)"
  },
  {
    "id": "00814-001-2000592",
    "subjectKey": "00814",
    "name": "공업수학2",
    "division": "001",
    "department": "반도체공학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이관",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "종합412",
    "isOnline": false,
    "source": {
      "schedule": "종합412(화5),종합507(목1,2)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5
        ],
        "classroom": "종합412"
      },
      {
        "day": "목",
        "periods": [
          1,
          2
        ],
        "classroom": "종합507"
      }
    ],
    "sourceSchedule": "종합412(화5),종합507(목1,2)"
  },
  {
    "id": "00814-005-2000593",
    "subjectKey": "00814",
    "name": "공업수학2",
    "division": "005",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "최정흠",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합502",
    "isOnline": false,
    "source": {
      "schedule": "종합502(수1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합502"
      }
    ],
    "sourceSchedule": "종합502(수1,2,3)"
  },
  {
    "id": "00814-006-2000593",
    "subjectKey": "00814",
    "name": "공업수학2",
    "division": "006",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박현호",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래105",
    "isOnline": false,
    "source": {
      "schedule": "미래105(월1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래105"
      }
    ],
    "sourceSchedule": "미래105(월1,2,3)"
  },
  {
    "id": "00814-007-2000593",
    "subjectKey": "00814",
    "name": "공업수학2",
    "division": "007",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "길상근",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합406",
    "isOnline": false,
    "source": {
      "schedule": "종합406(화1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합406"
      }
    ],
    "sourceSchedule": "종합406(화1,2,3)"
  },
  {
    "id": "00846-001-2000638",
    "subjectKey": "00846",
    "name": "공업통계2",
    "division": "001",
    "department": "산업공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김명수",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "자연관306",
    "isOnline": false,
    "source": {
      "schedule": "자연관306(금1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "자연관306"
      }
    ],
    "sourceSchedule": "자연관306(금1,2,3)"
  },
  {
    "id": "00876-001-2000601",
    "subjectKey": "00876",
    "name": "공중보건학",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "최은정",
    "days": [
      "목",
      "화"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "생활305",
    "isOnline": false,
    "source": {
      "schedule": "생활305(목8),생활502(화2,3)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          8
        ],
        "classroom": "생활305"
      },
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "생활502"
      }
    ],
    "sourceSchedule": "생활305(목8),생활502(화2,3)"
  },
  {
    "id": "00876-001-2000763",
    "subjectKey": "00876",
    "name": "공중보건학",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "최은정",
    "days": [
      "목",
      "화"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "생활305",
    "isOnline": false,
    "source": {
      "schedule": "생활305(목8),생활502(화2,3)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          8
        ],
        "classroom": "생활305"
      },
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "생활502"
      }
    ],
    "sourceSchedule": "생활305(목8),생활502(화2,3)"
  },
  {
    "id": "00938-001-2000607",
    "subjectKey": "00938",
    "name": "관현악법2",
    "division": "001",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "변현주",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(화5,6)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(화5,6)"
  },
  {
    "id": "00938-002-2000605",
    "subjectKey": "00938",
    "name": "관현악법2",
    "division": "002",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "변현주",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(화7,8)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(화7,8)"
  },
  {
    "id": "00940-001-2000605",
    "subjectKey": "00940",
    "name": "관현악법4",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "탁현욱",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(수5,6)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(수5,6)"
  },
  {
    "id": "00944-001-2000608",
    "subjectKey": "00944",
    "name": "관현악합주2",
    "division": "001",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "우레쵸",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(월5,6,7 수5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악109"
      },
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(월5,6,7 수5,6,7)"
  },
  {
    "id": "00944-002-2000608",
    "subjectKey": "00944",
    "name": "관현악합주2",
    "division": "002",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김진택",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "음악B215",
    "isOnline": false,
    "source": {
      "schedule": "음악B215(월5,6,7 수5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악B215"
      },
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악B215"
      }
    ],
    "sourceSchedule": "음악B215(월5,6,7 수5,6,7)"
  },
  {
    "id": "00948-001-2000608",
    "subjectKey": "00948",
    "name": "관현악합주4",
    "division": "001",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "우레쵸",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(월5,6,7 수5,6,7)"
    },
    "capacity": 200,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악109"
      },
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(월5,6,7 수5,6,7)"
  },
  {
    "id": "00948-002-2000608",
    "subjectKey": "00948",
    "name": "관현악합주4",
    "division": "002",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김진택",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "음악B215",
    "isOnline": false,
    "source": {
      "schedule": "음악B215(월5,6,7 수5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악B215"
      },
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악B215"
      }
    ],
    "sourceSchedule": "음악B215(월5,6,7 수5,6,7)"
  },
  {
    "id": "00952-001-2000608",
    "subjectKey": "00952",
    "name": "관현악합주6",
    "division": "001",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "우레쵸",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(월5,6,7 수5,6,7)"
    },
    "capacity": 200,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악109"
      },
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(월5,6,7 수5,6,7)"
  },
  {
    "id": "00952-002-2000608",
    "subjectKey": "00952",
    "name": "관현악합주6",
    "division": "002",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김진택",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "음악B215",
    "isOnline": false,
    "source": {
      "schedule": "음악B215(월5,6,7 수5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악B215"
      },
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악B215"
      }
    ],
    "sourceSchedule": "음악B215(월5,6,7 수5,6,7)"
  },
  {
    "id": "00956-001-2000277",
    "subjectKey": "00956",
    "name": "관현악합주8",
    "division": "001",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "우레쵸",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(월5,6,7 수5,6,7)"
    },
    "capacity": 200,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악109"
      },
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(월5,6,7 수5,6,7)"
  },
  {
    "id": "00956-002-2000277",
    "subjectKey": "00956",
    "name": "관현악합주8",
    "division": "002",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김진택",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "음악B215",
    "isOnline": false,
    "source": {
      "schedule": "음악B215(월5,6,7 수5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악B215"
      },
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악B215"
      }
    ],
    "sourceSchedule": "음악B215(월5,6,7 수5,6,7)"
  },
  {
    "id": "00964-001-2000746",
    "subjectKey": "00964",
    "name": "광고론",
    "division": "001",
    "department": "미디어커뮤니케이션",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박혜경",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문408",
    "isOnline": false,
    "source": {
      "schedule": "인문408(월2,3,4)"
    },
    "capacity": 80,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문408"
      }
    ],
    "sourceSchedule": "인문408(월2,3,4)"
  },
  {
    "id": "00969-001-2000583",
    "subjectKey": "00969",
    "name": "광고제작(AI디지털)",
    "division": "001",
    "department": "미디어커뮤니케이션학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박혜경",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래101",
    "isOnline": false,
    "source": {
      "schedule": "미래101(수1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래101"
      }
    ],
    "sourceSchedule": "미래101(수1,2,3)"
  },
  {
    "id": "00972-001-2000641",
    "subjectKey": "00972",
    "name": "광전자공학",
    "division": "001",
    "department": "전자공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조형준",
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "종합406",
    "isOnline": false,
    "source": {
      "schedule": "종합406(월5 목5,6)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5
        ],
        "classroom": "종합406"
      },
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "종합406"
      }
    ],
    "sourceSchedule": "종합406(월5 목5,6)"
  },
  {
    "id": "01051-001-2000286",
    "subjectKey": "01051",
    "name": "교육방법및교육공학",
    "division": "001",
    "department": "교양",
    "category": "교직",
    "sourceCategory": "교직",
    "credit": 2,
    "professor": "이다예",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래104",
    "isOnline": false,
    "source": {
      "schedule": "미래104(목5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "미래104"
      }
    ],
    "sourceSchedule": "미래104(목5,6)"
  },
  {
    "id": "01055-001-2000658",
    "subjectKey": "01055",
    "name": "교육사회학",
    "division": "001",
    "department": "교양",
    "category": "교직",
    "sourceCategory": "교직",
    "credit": 2,
    "professor": "김윤정",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "인문103",
    "isOnline": false,
    "source": {
      "schedule": "인문103(수5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "인문103"
      }
    ],
    "sourceSchedule": "인문103(수5,6)"
  },
  {
    "id": "01058-001-2000286",
    "subjectKey": "01058",
    "name": "교육실습",
    "division": "001",
    "department": "교양",
    "category": "교직",
    "sourceCategory": "교직",
    "credit": 2,
    "professor": "전영미",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합210-2",
    "isOnline": false,
    "source": {
      "schedule": "종합210-2(월5,6)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "종합210-2"
      }
    ],
    "sourceSchedule": "종합210-2(월5,6)"
  },
  {
    "id": "01060-001-2000658",
    "subjectKey": "01060",
    "name": "교육심리학",
    "division": "001",
    "department": "교양",
    "category": "교직",
    "sourceCategory": "교직",
    "credit": 2,
    "professor": "이다예",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래521",
    "isOnline": false,
    "source": {
      "schedule": "미래521(월5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래521"
      }
    ],
    "sourceSchedule": "미래521(월5,6)"
  },
  {
    "id": "01069-001-2000658",
    "subjectKey": "01069",
    "name": "교육철학및교육사",
    "division": "001",
    "department": "교양",
    "category": "교직",
    "sourceCategory": "교직",
    "credit": 2,
    "professor": "조진",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(수7,8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(수7,8)"
  },
  {
    "id": "01097-001-2000290",
    "subjectKey": "01097",
    "name": "구비문학론",
    "division": "001",
    "department": "국어국문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "송선령",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문512",
    "isOnline": false,
    "source": {
      "schedule": "인문512(화6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문512"
      }
    ],
    "sourceSchedule": "인문512(화6,7,8)"
  },
  {
    "id": "01102-001-2000636",
    "subjectKey": "01102",
    "name": "구조역학",
    "division": "001",
    "department": "건축학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박지슬",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "2공학202",
    "isOnline": false,
    "source": {
      "schedule": "2공학202(화6,7,8)"
    },
    "capacity": 39,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "2공학202"
      }
    ],
    "sourceSchedule": "2공학202(화6,7,8)"
  },
  {
    "id": "01102-002-2000636",
    "subjectKey": "01102",
    "name": "구조역학",
    "division": "002",
    "department": "건축학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박지슬",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "2공학313",
    "isOnline": false,
    "source": {
      "schedule": "2공학313(금5,6,7)"
    },
    "capacity": 39,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "2공학313"
      }
    ],
    "sourceSchedule": "2공학313(금5,6,7)"
  },
  {
    "id": "01121-001-2000634",
    "subjectKey": "01121",
    "name": "구조해석2",
    "division": "001",
    "department": "건설환경공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김한나",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "종합502",
    "isOnline": false,
    "source": {
      "schedule": "종합502(월7,8 수4)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8
        ],
        "classroom": "종합502"
      },
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "종합502"
      }
    ],
    "sourceSchedule": "종합502(월7,8 수4)"
  },
  {
    "id": "01154-001-2000605",
    "subjectKey": "01154",
    "name": "국악기실습1",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "유현수",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "음악215",
    "isOnline": false,
    "source": {
      "schedule": "음악215(월7)"
    },
    "capacity": 5,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "음악215"
      }
    ],
    "sourceSchedule": "음악215(월7)"
  },
  {
    "id": "01157-001-2000605",
    "subjectKey": "01157",
    "name": "국악기실습4",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "황인유",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "음악107",
    "isOnline": false,
    "source": {
      "schedule": "음악107(목5)"
    },
    "capacity": 5,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5
        ],
        "classroom": "음악107"
      }
    ],
    "sourceSchedule": "음악107(목5)"
  },
  {
    "id": "01161-001-2000264",
    "subjectKey": "01161",
    "name": "국악기실습8",
    "division": "001",
    "department": "작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "정택수",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 6,
    "room": "음악107",
    "isOnline": false,
    "source": {
      "schedule": "음악107(월6)"
    },
    "capacity": 5,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6
        ],
        "classroom": "음악107"
      }
    ],
    "sourceSchedule": "음악107(월6)"
  },
  {
    "id": "01187-001-2000609",
    "subjectKey": "01187",
    "name": "국악이론2",
    "division": "001",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "홍순욱",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(금2,3)"
    },
    "capacity": 5,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(금2,3)"
  },
  {
    "id": "01259-001-2000628",
    "subjectKey": "01259",
    "name": "국제거래법(무역자격증시험대비반)",
    "division": "001",
    "department": "글로벌비즈니스",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "설원준",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경602",
    "isOnline": false,
    "source": {
      "schedule": "글경602(화1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경602"
      }
    ],
    "sourceSchedule": "글경602(화1,2,3)"
  },
  {
    "id": "01270-001-2000505",
    "subjectKey": "01270",
    "name": "국제금융론(경영)",
    "division": "001",
    "department": "경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "임경",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경701",
    "isOnline": false,
    "source": {
      "schedule": "글경701(목5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경701"
      }
    ],
    "sourceSchedule": "글경701(목5,6,7)"
  },
  {
    "id": "01410-001-2000626",
    "subjectKey": "01410",
    "name": "금융기관론",
    "division": "001",
    "department": "경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김호영",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "글경B101",
    "isOnline": false,
    "source": {
      "schedule": "글경B101(월2,3,4)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "글경B101"
      }
    ],
    "sourceSchedule": "글경B101(월2,3,4)"
  },
  {
    "id": "01414-001-2000601",
    "subjectKey": "01414",
    "name": "급식경영학",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "홍태경",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "생활302",
    "isOnline": false,
    "source": {
      "schedule": "생활302(월6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "생활302"
      }
    ],
    "sourceSchedule": "생활302(월6,7,8)"
  },
  {
    "id": "01436-001-2000639",
    "subjectKey": "01436",
    "name": "기계설계응용",
    "division": "001",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "마부수",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합405",
    "isOnline": false,
    "source": {
      "schedule": "종합405(월2,3 화5)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "종합405"
      },
      {
        "day": "화",
        "periods": [
          5
        ],
        "classroom": "종합405"
      }
    ],
    "sourceSchedule": "종합405(월2,3 화5)"
  },
  {
    "id": "01442-001-2000639",
    "subjectKey": "01442",
    "name": "기계재료",
    "division": "001",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "마부수",
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합306",
    "isOnline": false,
    "source": {
      "schedule": "종합306(월5,6 목3)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "종합306"
      },
      {
        "day": "목",
        "periods": [
          3
        ],
        "classroom": "종합306"
      }
    ],
    "sourceSchedule": "종합306(월5,6 목3)"
  },
  {
    "id": "01473-001-2000642",
    "subjectKey": "01473",
    "name": "기능성고분자",
    "division": "001",
    "department": "신소재공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박준수",
    "days": [
      "월",
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B201",
    "isOnline": false,
    "source": {
      "schedule": "미래B201(월1,2 금1)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B201"
      },
      {
        "day": "금",
        "periods": [
          1
        ],
        "classroom": "미래B201"
      }
    ],
    "sourceSchedule": "미래B201(월1,2 금1)"
  },
  {
    "id": "01652-001-2000592",
    "subjectKey": "01652",
    "name": "기초회로기술및실험2",
    "division": "001",
    "department": "반도체공학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최광수",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "2공학215",
    "isOnline": false,
    "source": {
      "schedule": "2공학215(월5,6,7,8)"
    },
    "capacity": 24,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "2공학215"
      }
    ],
    "sourceSchedule": "2공학215(월5,6,7,8)"
  },
  {
    "id": "01652-002-2000592",
    "subjectKey": "01652",
    "name": "기초회로기술및실험2",
    "division": "002",
    "department": "반도체공학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최광수",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "2공학215",
    "isOnline": false,
    "source": {
      "schedule": "2공학215(수5,6,7,8)"
    },
    "capacity": 24,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "2공학215"
      }
    ],
    "sourceSchedule": "2공학215(수5,6,7,8)"
  },
  {
    "id": "01681-001-2000626",
    "subjectKey": "01681",
    "name": "노사관계론",
    "division": "001",
    "department": "경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "소원근",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "글경603",
    "isOnline": false,
    "source": {
      "schedule": "글경603(화1,2 수2)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "글경603"
      },
      {
        "day": "수",
        "periods": [
          2
        ],
        "classroom": "글경603"
      }
    ],
    "sourceSchedule": "글경603(화1,2 수2)"
  },
  {
    "id": "01682-001-2000431",
    "subjectKey": "01682",
    "name": "노인복지론",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "차승은",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "생활202",
    "isOnline": false,
    "source": {
      "schedule": "생활202(화1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "생활202"
      }
    ],
    "sourceSchedule": "생활202(화1,2,3)"
  },
  {
    "id": "01696-001-2000602",
    "subjectKey": "01696",
    "name": "농구1(체육전공)",
    "division": "001",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "윤미혜",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육농구장",
    "isOnline": false,
    "source": {
      "schedule": "체육농구장(금5,6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "체육농구장"
      }
    ],
    "sourceSchedule": "체육농구장(금5,6)"
  },
  {
    "id": "01696-002-2000602",
    "subjectKey": "01696",
    "name": "농구1(레저스포츠전공)",
    "division": "002",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "윤미혜",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "체육농구장",
    "isOnline": false,
    "source": {
      "schedule": "체육농구장(금1,2)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "체육농구장"
      }
    ],
    "sourceSchedule": "체육농구장(금1,2)"
  },
  {
    "id": "01696-003-2000602",
    "subjectKey": "01696",
    "name": "농구1(운동건강관리전공)",
    "division": "003",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "윤미혜",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "체육농구장",
    "isOnline": false,
    "source": {
      "schedule": "체육농구장(금3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "체육농구장"
      }
    ],
    "sourceSchedule": "체육농구장(금3,4)"
  },
  {
    "id": "01700-001-2000583",
    "subjectKey": "01700",
    "name": "뉴미디어론(인공지능과사회)",
    "division": "001",
    "department": "미디어커뮤니케이션학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "장경은",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "인문509",
    "isOnline": false,
    "source": {
      "schedule": "인문509(수4 목4,5)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "인문509"
      },
      {
        "day": "목",
        "periods": [
          4,
          5
        ],
        "classroom": "인문509"
      }
    ],
    "sourceSchedule": "인문509(수4 목4,5)"
  },
  {
    "id": "01718-001-2000635",
    "subjectKey": "01718",
    "name": "대기오염모델링",
    "division": "001",
    "department": "환경에너지공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이승언",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합410",
    "isOnline": false,
    "source": {
      "schedule": "종합410(월1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합410"
      }
    ],
    "sourceSchedule": "종합410(월1,2,3)"
  },
  {
    "id": "01723-001-2000635",
    "subjectKey": "01723",
    "name": "대기오염방지공학",
    "division": "001",
    "department": "환경에너지공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "백영순",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(목1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래103"
      }
    ],
    "sourceSchedule": "미래103(목1,2,3)"
  },
  {
    "id": "01743-001-2000607",
    "subjectKey": "01743",
    "name": "대위법2",
    "division": "001",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "강미나",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(목5,6)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(목5,6)"
  },
  {
    "id": "01743-002-2000605",
    "subjectKey": "01743",
    "name": "대위법2",
    "division": "002",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "강미나",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(목7,8)"
    },
    "capacity": 20,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(목7,8)"
  },
  {
    "id": "01760-002-2000596",
    "subjectKey": "01760",
    "name": "데이터구조",
    "division": "002",
    "department": "컴퓨터학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박현아",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "IT310",
    "isOnline": false,
    "source": {
      "schedule": "IT310(월5,6,7)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "IT310"
      }
    ],
    "sourceSchedule": "IT310(월5,6,7)"
  },
  {
    "id": "01760-005-2000596",
    "subjectKey": "01760",
    "name": "데이터구조",
    "division": "005",
    "department": "컴퓨터학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박현아",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "IT308",
    "isOnline": false,
    "source": {
      "schedule": "IT308(수5,6,7)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "IT308"
      }
    ],
    "sourceSchedule": "IT308(수5,6,7)"
  },
  {
    "id": "01760-006-2000596",
    "subjectKey": "01760",
    "name": "데이터구조",
    "division": "006",
    "department": "컴퓨터학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "신호진",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT413",
    "isOnline": false,
    "source": {
      "schedule": "IT413(목2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT413"
      }
    ],
    "sourceSchedule": "IT413(목2,3,4)"
  },
  {
    "id": "01762-001-2000644",
    "subjectKey": "01762",
    "name": "데이터베이스",
    "division": "001",
    "department": "컴퓨터SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고혁진",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT308",
    "isOnline": false,
    "source": {
      "schedule": "IT308(화6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT308"
      }
    ],
    "sourceSchedule": "IT308(화6,7,8)"
  },
  {
    "id": "01762-002-2000647",
    "subjectKey": "01762",
    "name": "데이터베이스",
    "division": "002",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김영미",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT306",
    "isOnline": false,
    "source": {
      "schedule": "IT306(월6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT306"
      }
    ],
    "sourceSchedule": "IT306(월6,7,8)"
  },
  {
    "id": "01762-003-2000644",
    "subjectKey": "01762",
    "name": "데이터베이스",
    "division": "003",
    "department": "컴퓨터SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고혁진",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT310",
    "isOnline": false,
    "source": {
      "schedule": "IT310(금6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT310"
      }
    ],
    "sourceSchedule": "IT310(금6,7,8)"
  },
  {
    "id": "01824-001-2000636",
    "subjectKey": "01824",
    "name": "도시설계론",
    "division": "001",
    "department": "건축학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이형석",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "2공학313",
    "isOnline": false,
    "source": {
      "schedule": "2공학313(목3,4,5)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "2공학313"
      }
    ],
    "sourceSchedule": "2공학313(목3,4,5)"
  },
  {
    "id": "01824-002-2000637",
    "subjectKey": "01824",
    "name": "도시설계론",
    "division": "002",
    "department": "도시부동산학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "남궁혜",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "자연대B103",
    "isOnline": false,
    "source": {
      "schedule": "자연대B103(화6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "자연대B103"
      }
    ],
    "sourceSchedule": "자연대B103(화6,7,8)"
  },
  {
    "id": "01863-001-2000655",
    "subjectKey": "01863",
    "name": "도자공예2",
    "division": "001",
    "department": "공예디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이보미",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "조형202",
    "isOnline": false,
    "source": {
      "schedule": "조형202(수2,3,4)"
    },
    "capacity": 28,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "조형202"
      }
    ],
    "sourceSchedule": "조형202(수2,3,4)"
  },
  {
    "id": "01889-001-2000408",
    "subjectKey": "01889",
    "name": "독성약화학",
    "division": "001",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "타바시아판 탐비",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "종합302",
    "isOnline": false,
    "source": {
      "schedule": "종합302(화7 수2,3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7
        ],
        "classroom": "종합302"
      },
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "종합302"
      }
    ],
    "sourceSchedule": "종합302(화7 수2,3)"
  },
  {
    "id": "01962-001-2000617",
    "subjectKey": "01962",
    "name": "동양사상사",
    "division": "001",
    "department": "사학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김호",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문501",
    "isOnline": false,
    "source": {
      "schedule": "인문501(화1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문501"
      }
    ],
    "sourceSchedule": "인문501(화1,2,3)"
  },
  {
    "id": "02007-001-2000639",
    "subjectKey": "02007",
    "name": "동역학(마이크로디그리)",
    "division": "001",
    "department": "기계공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "송준솔",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "자연관309",
    "isOnline": false,
    "source": {
      "schedule": "자연관309(화1,2,3)"
    },
    "capacity": 43,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "자연관309"
      }
    ],
    "sourceSchedule": "자연관309(화1,2,3)"
  },
  {
    "id": "02007-002-2000639",
    "subjectKey": "02007",
    "name": "동역학(마이크로디그리)",
    "division": "002",
    "department": "기계공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "송준솔",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "자연관309",
    "isOnline": false,
    "source": {
      "schedule": "자연관309(수1,2,3)"
    },
    "capacity": 44,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "자연관309"
      }
    ],
    "sourceSchedule": "자연관309(수1,2,3)"
  },
  {
    "id": "02019-001-2000651",
    "subjectKey": "02019",
    "name": "드로잉4",
    "division": "001",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최혜란",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "조형404",
    "isOnline": false,
    "source": {
      "schedule": "조형404(목6,7,8,9)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "조형404"
      }
    ],
    "sourceSchedule": "조형404(목6,7,8,9)"
  },
  {
    "id": "02028-001-2000654",
    "subjectKey": "02028",
    "name": "디자인&컨스트럭션",
    "division": "001",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "조유림",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "종합B108",
    "isOnline": false,
    "source": {
      "schedule": "종합B108(수1,2,3,4)"
    },
    "capacity": 13,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "종합B108"
      }
    ],
    "sourceSchedule": "종합B108(수1,2,3,4)"
  },
  {
    "id": "02028-002-2000654",
    "subjectKey": "02028",
    "name": "디자인&컨스트럭션",
    "division": "002",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "조유림",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "종합B108",
    "isOnline": false,
    "source": {
      "schedule": "종합B108(수6,7,8,9)"
    },
    "capacity": 13,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "종합B108"
      }
    ],
    "sourceSchedule": "종합B108(수6,7,8,9)"
  },
  {
    "id": "02047-001-2000641",
    "subjectKey": "02047",
    "name": "디지털시스템설계",
    "division": "001",
    "department": "전자공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이창수",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "자연대503",
    "isOnline": false,
    "source": {
      "schedule": "자연대503(월3 화1,2)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3
        ],
        "classroom": "자연대503"
      },
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "자연대503"
      }
    ],
    "sourceSchedule": "자연대503(월3 화1,2)"
  },
  {
    "id": "02049-002-2000646",
    "subjectKey": "02049",
    "name": "디지털신호처리",
    "division": "002",
    "department": "정보통신",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양윤기",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "IT408",
    "isOnline": false,
    "source": {
      "schedule": "IT408(수3,4 목3)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "IT408"
      },
      {
        "day": "목",
        "periods": [
          3
        ],
        "classroom": "IT408"
      }
    ],
    "sourceSchedule": "IT408(수3,4 목3)"
  },
  {
    "id": "02053-001-2000763",
    "subjectKey": "02053",
    "name": "디지털논리설계",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "장성태",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "IT415",
    "isOnline": false,
    "source": {
      "schedule": "IT415(월5,6,7)"
    },
    "capacity": 58,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "IT415"
      }
    ],
    "sourceSchedule": "IT415(월5,6,7)"
  },
  {
    "id": "02053-001-2000844",
    "subjectKey": "02053",
    "name": "디지털논리설계",
    "division": "001",
    "department": "컴퓨터공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "장성태",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "IT415",
    "isOnline": false,
    "source": {
      "schedule": "IT415(월5,6,7)"
    },
    "capacity": 58,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "IT415"
      }
    ],
    "sourceSchedule": "IT415(월5,6,7)"
  },
  {
    "id": "02053-002-2000763",
    "subjectKey": "02053",
    "name": "디지털논리설계",
    "division": "002",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "장성태",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "IT415",
    "isOnline": false,
    "source": {
      "schedule": "IT415(화7,8,9)"
    },
    "capacity": 58,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "IT415"
      }
    ],
    "sourceSchedule": "IT415(화7,8,9)"
  },
  {
    "id": "02053-002-2000844",
    "subjectKey": "02053",
    "name": "디지털논리설계",
    "division": "002",
    "department": "컴퓨터공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "장성태",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "IT415",
    "isOnline": false,
    "source": {
      "schedule": "IT415(화7,8,9)"
    },
    "capacity": 58,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "IT415"
      }
    ],
    "sourceSchedule": "IT415(화7,8,9)"
  },
  {
    "id": "02055-001-2000640",
    "subjectKey": "02055",
    "name": "디지털논리회로설계",
    "division": "001",
    "department": "전기공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최정흠",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합502",
    "isOnline": false,
    "source": {
      "schedule": "종합502(수5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합502"
      }
    ],
    "sourceSchedule": "종합502(수5,6,7)"
  },
  {
    "id": "02059-001-2000181",
    "subjectKey": "02059",
    "name": "디지털통신",
    "division": "001",
    "department": "전자공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조형준",
    "days": [
      "월",
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "종합406",
    "isOnline": false,
    "source": {
      "schedule": "종합406(월6,7),종합409(금2)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "종합406"
      },
      {
        "day": "금",
        "periods": [
          2
        ],
        "classroom": "종합409"
      }
    ],
    "sourceSchedule": "종합406(월6,7),종합409(금2)"
  },
  {
    "id": "02066-001-2000658",
    "subjectKey": "02066",
    "name": "러시아명작의이해",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이한주",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래319",
    "isOnline": false,
    "source": {
      "schedule": "미래319(목4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래319"
      }
    ],
    "sourceSchedule": "미래319(목4,5,6)"
  },
  {
    "id": "02073-001-2000658",
    "subjectKey": "02073",
    "name": "러시아문화(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박승찬",
    "days": [
      "금",
      "토"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "인문407",
    "isOnline": true,
    "source": {
      "schedule": "인문407(금1 토9,10)"
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1
        ],
        "classroom": "인문407"
      },
      {
        "day": "토",
        "periods": [
          9,
          10
        ],
        "classroom": "인문407"
      }
    ],
    "sourceSchedule": "인문407(금1 토9,10)"
  },
  {
    "id": "02114-001-2000587",
    "subjectKey": "02114",
    "name": "레스토랑운영실무",
    "division": "001",
    "department": "호텔관광학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "구원일",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경702",
    "isOnline": false,
    "source": {
      "schedule": "글경702(월1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경702"
      }
    ],
    "sourceSchedule": "글경702(월1,2,3)"
  },
  {
    "id": "02145-001-2000609",
    "subjectKey": "02145",
    "name": "리듬연구2",
    "division": "001",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "정택수",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "음악107",
    "isOnline": false,
    "source": {
      "schedule": "음악107(월4,5)"
    },
    "capacity": 5,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5
        ],
        "classroom": "음악107"
      }
    ],
    "sourceSchedule": "음악107(월4,5)"
  },
  {
    "id": "02182-001-2000626",
    "subjectKey": "02182",
    "name": "마케팅원론(외국인전용)",
    "division": "001",
    "department": "경영",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이탁",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경502",
    "isOnline": false,
    "source": {
      "schedule": "글경502(수1,2,3)"
    },
    "capacity": 25,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경502"
      }
    ],
    "sourceSchedule": "글경502(수1,2,3)"
  },
  {
    "id": "02182-002-2000505",
    "subjectKey": "02182",
    "name": "마케팅원론(학점교류)",
    "division": "002",
    "department": "경영",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "02218-001-2000401",
    "subjectKey": "02218",
    "name": "매스컴특강(저널리즘글쓰기)",
    "division": "001",
    "department": "미디어커뮤니케이션학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "강승미",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "인문506",
    "isOnline": false,
    "source": {
      "schedule": "인문506(화4 목2,3)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4
        ],
        "classroom": "인문506"
      },
      {
        "day": "목",
        "periods": [
          2,
          3
        ],
        "classroom": "인문506"
      }
    ],
    "sourceSchedule": "인문506(화4 목2,3)"
  },
  {
    "id": "02252-001-2000639",
    "subjectKey": "02252",
    "name": "메카트로닉스",
    "division": "001",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "임동원",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "자연관409",
    "isOnline": false,
    "source": {
      "schedule": "자연관409(화1,2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "자연관409"
      }
    ],
    "sourceSchedule": "자연관409(화1,2,3,4)"
  },
  {
    "id": "02342-001-2000080",
    "subjectKey": "02342",
    "name": "무역학원론(학점교류)",
    "division": "001",
    "department": "경영학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "02487-001-2000592",
    "subjectKey": "02487",
    "name": "물리전자2",
    "division": "001",
    "department": "반도체공학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최준혁",
    "days": [
      "목",
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "종합407",
    "isOnline": false,
    "source": {
      "schedule": "종합407(목5),종합412(화6,7)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5
        ],
        "classroom": "종합407"
      },
      {
        "day": "화",
        "periods": [
          6,
          7
        ],
        "classroom": "종합412"
      }
    ],
    "sourceSchedule": "종합407(목5),종합412(화6,7)"
  },
  {
    "id": "02522-001-2000763",
    "subjectKey": "02522",
    "name": "물리학및실험1",
    "division": "001",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "구재한",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래104",
    "isOnline": false,
    "source": {
      "schedule": "미래104(수1,2),미래B101(수3,4)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2
        ],
        "classroom": "미래104"
      },
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B101"
      }
    ],
    "sourceSchedule": "미래104(수1,2),미래B101(수3,4)"
  },
  {
    "id": "02525-001-2000592",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "001",
    "department": "반도체공학과",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이규행",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(월1,2),미래B102(월3,4)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "미래103"
      },
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(월1,2),미래B102(월3,4)"
  },
  {
    "id": "02525-001-2000763",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "001",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이규행",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(월1,2),미래B102(월3,4)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "미래103"
      },
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(월1,2),미래B102(월3,4)"
  },
  {
    "id": "02525-002-2000592",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "002",
    "department": "반도체공학과",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "김두일",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(화1,2),미래B102(화3,4)"
    },
    "capacity": 32,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "미래103"
      },
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(화1,2),미래B102(화3,4)"
  },
  {
    "id": "02525-002-2000763",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "002",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "김두일",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(화1,2),미래B102(화3,4)"
    },
    "capacity": 32,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "미래103"
      },
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(화1,2),미래B102(화3,4)"
  },
  {
    "id": "02525-005-2000593",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "005",
    "department": "전기전자공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "전계진",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(화5,6),미래B102(화7,8)"
    },
    "capacity": 37,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미래103"
      },
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(화5,6),미래B102(화7,8)"
  },
  {
    "id": "02525-005-2000763",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "005",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "전계진",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(화5,6),미래B102(화7,8)"
    },
    "capacity": 37,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미래103"
      },
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(화5,6),미래B102(화7,8)"
  },
  {
    "id": "02525-006-2000593",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "006",
    "department": "전기전자공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "최홍",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(수7,8),미래B102(수5,6)"
    },
    "capacity": 37,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8
        ],
        "classroom": "미래103"
      },
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(수7,8),미래B102(수5,6)"
  },
  {
    "id": "02525-006-2000763",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "006",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "최홍",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(수7,8),미래B102(수5,6)"
    },
    "capacity": 37,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8
        ],
        "classroom": "미래103"
      },
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(수7,8),미래B102(수5,6)"
  },
  {
    "id": "02525-007-2000593",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "007",
    "department": "전기전자공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이규행",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(화7,8),미래B102(화5,6)"
    },
    "capacity": 37,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "미래103"
      },
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(화7,8),미래B102(화5,6)"
  },
  {
    "id": "02525-007-2000763",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "007",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이규행",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(화7,8),미래B102(화5,6)"
    },
    "capacity": 37,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "미래103"
      },
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(화7,8),미래B102(화5,6)"
  },
  {
    "id": "02525-008-2000593",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "008",
    "department": "전기전자공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "김원년",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(금5,6),미래B102(금7,8)"
    },
    "capacity": 36,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "미래103"
      },
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(금5,6),미래B102(금7,8)"
  },
  {
    "id": "02525-008-2000763",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "008",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "김원년",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(금5,6),미래B102(금7,8)"
    },
    "capacity": 36,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "미래103"
      },
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(금5,6),미래B102(금7,8)"
  },
  {
    "id": "02525-009-2000756",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "009",
    "department": "기계공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "구재한",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(수5,6),미래B102(수7,8)"
    },
    "capacity": 36,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "미래103"
      },
      {
        "day": "수",
        "periods": [
          7,
          8
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(수5,6),미래B102(수7,8)"
  },
  {
    "id": "02525-009-2000763",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "009",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "구재한",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(수5,6),미래B102(수7,8)"
    },
    "capacity": 36,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "미래103"
      },
      {
        "day": "수",
        "periods": [
          7,
          8
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(수5,6),미래B102(수7,8)"
  },
  {
    "id": "02525-010-2000756",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "010",
    "department": "기계공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "전계진",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(월5,6),미래B102(월7,8)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래103"
      },
      {
        "day": "월",
        "periods": [
          7,
          8
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(월5,6),미래B102(월7,8)"
  },
  {
    "id": "02525-010-2000763",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "010",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "전계진",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(월5,6),미래B102(월7,8)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래103"
      },
      {
        "day": "월",
        "periods": [
          7,
          8
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(월5,6),미래B102(월7,8)"
  },
  {
    "id": "02525-011-2000594",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "011",
    "department": "화학공학·신소재공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김두일",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(목5,6),미래B102(목7,8)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "미래103"
      },
      {
        "day": "목",
        "periods": [
          7,
          8
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(목5,6),미래B102(목7,8)"
  },
  {
    "id": "02525-011-2000763",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "011",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김두일",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(목5,6),미래B102(목7,8)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "미래103"
      },
      {
        "day": "목",
        "periods": [
          7,
          8
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(목5,6),미래B102(목7,8)"
  },
  {
    "id": "02525-012-2000594",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "012",
    "department": "화학공학·신소재공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김원년",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "미래104",
    "isOnline": false,
    "source": {
      "schedule": "미래104(월7,8),미래B102(월5,6)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8
        ],
        "classroom": "미래104"
      },
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래104(월7,8),미래B102(월5,6)"
  },
  {
    "id": "02525-012-2000763",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "012",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김원년",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "미래104",
    "isOnline": false,
    "source": {
      "schedule": "미래104(월7,8),미래B102(월5,6)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8
        ],
        "classroom": "미래104"
      },
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래104(월7,8),미래B102(월5,6)"
  },
  {
    "id": "02525-013-2000594",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "013",
    "department": "화학공학·신소재공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최홍",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(금1,2),미래B102(금3,4)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "미래103"
      },
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(금1,2),미래B102(금3,4)"
  },
  {
    "id": "02525-013-2000763",
    "subjectKey": "02525",
    "name": "물리학및실험2",
    "division": "013",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최홍",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(금1,2),미래B102(금3,4)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "미래103"
      },
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B102"
      }
    ],
    "sourceSchedule": "미래103(금1,2),미래B102(금3,4)"
  },
  {
    "id": "02720-001-2000399",
    "subjectKey": "02720",
    "name": "민법총칙(학점교류)",
    "division": "001",
    "department": "법·행정학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "02721-001-2000582",
    "subjectKey": "02721",
    "name": "민사소송법(학점교류)",
    "division": "001",
    "department": "법·행정학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "02743-001-2000420",
    "subjectKey": "02743",
    "name": "박막공학",
    "division": "001",
    "department": "전자재료공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이상혁",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "종합510",
    "isOnline": false,
    "source": {
      "schedule": "종합510(월1,2 화3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "종합510"
      },
      {
        "day": "화",
        "periods": [
          3
        ],
        "classroom": "종합510"
      }
    ],
    "sourceSchedule": "종합510(월1,2 화3)"
  },
  {
    "id": "02748-001-2000420",
    "subjectKey": "02748",
    "name": "반도체공정",
    "division": "001",
    "department": "전자재료공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이상혁",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "종합510",
    "isOnline": false,
    "source": {
      "schedule": "종합510(월3 화1,2)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3
        ],
        "classroom": "종합510"
      },
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "종합510"
      }
    ],
    "sourceSchedule": "종합510(월3 화1,2)"
  },
  {
    "id": "02755-001-2000592",
    "subjectKey": "02755",
    "name": "반도체소자",
    "division": "001",
    "department": "반도체공학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이강준",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "종합412",
    "isOnline": false,
    "source": {
      "schedule": "종합412(수1,2 목2)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2
        ],
        "classroom": "종합412"
      },
      {
        "day": "목",
        "periods": [
          2
        ],
        "classroom": "종합412"
      }
    ],
    "sourceSchedule": "종합412(수1,2 목2)"
  },
  {
    "id": "02755-002-2000592",
    "subjectKey": "02755",
    "name": "반도체소자(학점교류)",
    "division": "002",
    "department": "반도체공학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "02762-001-2000643",
    "subjectKey": "02762",
    "name": "반응공학",
    "division": "001",
    "department": "화학공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최경오",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "자연관408",
    "isOnline": false,
    "source": {
      "schedule": "자연관408(화2 금3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2
        ],
        "classroom": "자연관408"
      },
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "자연관408"
      }
    ],
    "sourceSchedule": "자연관408(화2 금3,4)"
  },
  {
    "id": "02807-001-2000602",
    "subjectKey": "02807",
    "name": "배구1(체육전공)",
    "division": "001",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "정의탁",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "체육농구장",
    "isOnline": false,
    "source": {
      "schedule": "체육농구장(목1,2)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2
        ],
        "classroom": "체육농구장"
      }
    ],
    "sourceSchedule": "체육농구장(목1,2)"
  },
  {
    "id": "02807-002-2000602",
    "subjectKey": "02807",
    "name": "배구1(레저스포츠전공)",
    "division": "002",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "정의탁",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "체육농구장",
    "isOnline": false,
    "source": {
      "schedule": "체육농구장(목3,4)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "체육농구장"
      }
    ],
    "sourceSchedule": "체육농구장(목3,4)"
  },
  {
    "id": "02807-003-2000602",
    "subjectKey": "02807",
    "name": "배구1(운동건강관리전공)",
    "division": "003",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "정의탁",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육농구장",
    "isOnline": false,
    "source": {
      "schedule": "체육농구장(목5,6)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "체육농구장"
      }
    ],
    "sourceSchedule": "체육농구장(목5,6)"
  },
  {
    "id": "02813-001-2000602",
    "subjectKey": "02813",
    "name": "배드민턴1(체육전공)",
    "division": "001",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "권승택",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "체육201",
    "isOnline": false,
    "source": {
      "schedule": "체육201(월1,2)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "체육201"
      }
    ],
    "sourceSchedule": "체육201(월1,2)"
  },
  {
    "id": "02813-002-2000602",
    "subjectKey": "02813",
    "name": "배드민턴1(레저스포츠전공)",
    "division": "002",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "권승택",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "체육201",
    "isOnline": false,
    "source": {
      "schedule": "체육201(월6,7)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "체육201"
      }
    ],
    "sourceSchedule": "체육201(월6,7)"
  },
  {
    "id": "02813-003-2000602",
    "subjectKey": "02813",
    "name": "배드민턴1(운동건강관리전공)",
    "division": "003",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "권승택",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "체육201",
    "isOnline": false,
    "source": {
      "schedule": "체육201(월3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "체육201"
      }
    ],
    "sourceSchedule": "체육201(월3,4)"
  },
  {
    "id": "02816-001-2000658",
    "subjectKey": "02816",
    "name": "법과현대생활",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "윤서영",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문408",
    "isOnline": false,
    "source": {
      "schedule": "인문408(수1,2,3)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문408"
      }
    ],
    "sourceSchedule": "인문408(수1,2,3)"
  },
  {
    "id": "02820-001-2000400",
    "subjectKey": "02820",
    "name": "법철학(학점교류)",
    "division": "001",
    "department": "법학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "02848-001-2000431",
    "subjectKey": "02848",
    "name": "보육실습",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "송승민",
    "days": [
      "금",
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 5,
    "room": "생활202",
    "isOnline": false,
    "source": {
      "schedule": "생활202(금2,3,4,5),생활502(수2,3)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4,
          5
        ],
        "classroom": "생활202"
      },
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "생활502"
      }
    ],
    "sourceSchedule": "생활202(금2,3,4,5),생활502(수2,3)"
  },
  {
    "id": "02849-001-2000417",
    "subjectKey": "02849",
    "name": "보전공학",
    "division": "001",
    "department": "산업공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "오근태",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "자연관306",
    "isOnline": false,
    "source": {
      "schedule": "자연관306(월2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "자연관306"
      }
    ],
    "sourceSchedule": "자연관306(월2,3,4)"
  },
  {
    "id": "02852-001-2000400",
    "subjectKey": "02852",
    "name": "보험법(학점교류)",
    "division": "001",
    "department": "법학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "02885-001-2000649",
    "subjectKey": "02885",
    "name": "볼링",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "현재민",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육113",
    "isOnline": false,
    "source": {
      "schedule": "체육113(월5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "체육113"
      }
    ],
    "sourceSchedule": "체육113(월5,6)"
  },
  {
    "id": "02892-001-2000637",
    "subjectKey": "02892",
    "name": "부동산개발론",
    "division": "001",
    "department": "도시부동산학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "민성훈",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "2공학314",
    "isOnline": false,
    "source": {
      "schedule": "2공학314(화5 수6,7)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5
        ],
        "classroom": "2공학314"
      },
      {
        "day": "수",
        "periods": [
          6,
          7
        ],
        "classroom": "2공학314"
      }
    ],
    "sourceSchedule": "2공학314(화5 수6,7)"
  },
  {
    "id": "02911-001-2000643",
    "subjectKey": "02911",
    "name": "분석화학",
    "division": "001",
    "department": "화학공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "노호식",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "자연관408",
    "isOnline": false,
    "source": {
      "schedule": "자연관408(수2,3 목4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "자연관408"
      },
      {
        "day": "목",
        "periods": [
          4
        ],
        "classroom": "자연관408"
      }
    ],
    "sourceSchedule": "자연관408(수2,3 목4)"
  },
  {
    "id": "02945-001-2000632",
    "subjectKey": "02945",
    "name": "분자생물학2",
    "division": "001",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "손영선",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "종합407",
    "isOnline": false,
    "source": {
      "schedule": "종합407(화2 수6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2
        ],
        "classroom": "종합407"
      },
      {
        "day": "수",
        "periods": [
          6,
          7
        ],
        "classroom": "종합407"
      }
    ],
    "sourceSchedule": "종합407(화2 수6,7)"
  },
  {
    "id": "02945-002-2000632",
    "subjectKey": "02945",
    "name": "분자생물학2",
    "division": "002",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "람야 마티야라간",
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "종합404",
    "isOnline": false,
    "source": {
      "schedule": "종합404(월3,4 목3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "종합404"
      },
      {
        "day": "목",
        "periods": [
          3
        ],
        "classroom": "종합404"
      }
    ],
    "sourceSchedule": "종합404(월3,4 목3)"
  },
  {
    "id": "03096-001-2000506",
    "subjectKey": "03096",
    "name": "비영리회계",
    "division": "001",
    "department": "회계",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김경옥",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경607",
    "isOnline": false,
    "source": {
      "schedule": "글경607(화1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경607"
      }
    ],
    "sourceSchedule": "글경607(화1,2,3)"
  },
  {
    "id": "03098-001-2000644",
    "subjectKey": "03098",
    "name": "비주얼언어및실습",
    "division": "001",
    "department": "컴퓨터SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이중무",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "IT309",
    "isOnline": false,
    "source": {
      "schedule": "IT309(월6,7 화6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "IT309"
      },
      {
        "day": "화",
        "periods": [
          6,
          7
        ],
        "classroom": "IT309"
      }
    ],
    "sourceSchedule": "IT309(월6,7 화6,7)"
  },
  {
    "id": "03098-002-2000645",
    "subjectKey": "03098",
    "name": "비주얼언어및실습",
    "division": "002",
    "department": "미디어SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "딜립 쿠말",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT308",
    "isOnline": false,
    "source": {
      "schedule": "IT308(수1,2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT308"
      }
    ],
    "sourceSchedule": "IT308(수1,2,3,4)"
  },
  {
    "id": "03098-003-2000644",
    "subjectKey": "03098",
    "name": "비주얼언어및실습",
    "division": "003",
    "department": "컴퓨터SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양혜윤",
    "days": [
      "목",
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "IT308",
    "isOnline": false,
    "source": {
      "schedule": "IT308(목5,6),IT310(월2,3)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "IT308"
      },
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "IT310"
      }
    ],
    "sourceSchedule": "IT308(목5,6),IT310(월2,3)"
  },
  {
    "id": "03100-001-2000619",
    "subjectKey": "03100",
    "name": "비즈니스러시아어(마이크로디그리)",
    "division": "001",
    "department": "러시아어문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "마리나세르게예브나",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합504",
    "isOnline": false,
    "source": {
      "schedule": "종합504(월2,3),종합505(화3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "종합504"
      },
      {
        "day": "화",
        "periods": [
          3
        ],
        "classroom": "종합505"
      }
    ],
    "sourceSchedule": "종합504(월2,3),종합505(화3)"
  },
  {
    "id": "03149-001-2000599",
    "subjectKey": "03149",
    "name": "사회복지실천기술론",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이은진",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "생활502",
    "isOnline": false,
    "source": {
      "schedule": "생활502(월1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "생활502"
      }
    ],
    "sourceSchedule": "생활502(월1,2,3)"
  },
  {
    "id": "03152-001-2000599",
    "subjectKey": "03152",
    "name": "사회복지조사론",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "차승은",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "IT308",
    "isOnline": false,
    "source": {
      "schedule": "IT308(목7,8,9)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "IT308"
      }
    ],
    "sourceSchedule": "IT308(목7,8,9)"
  },
  {
    "id": "03153-001-2000599",
    "subjectKey": "03153",
    "name": "사회복지행정론",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "윤은영",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "생활101",
    "isOnline": false,
    "source": {
      "schedule": "생활101(목6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "생활101"
      }
    ],
    "sourceSchedule": "생활101(목6,7,8)"
  },
  {
    "id": "03153-002-2000431",
    "subjectKey": "03153",
    "name": "사회복지행정론(학점교류)",
    "division": "002",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "03154-001-2000599",
    "subjectKey": "03154",
    "name": "사회복지현장실습",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이은진",
    "days": [
      "금",
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "생활202",
    "isOnline": false,
    "source": {
      "schedule": "생활202(금6,7,8,9),생활502(목1,2)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "생활202"
      },
      {
        "day": "목",
        "periods": [
          1,
          2
        ],
        "classroom": "생활502"
      }
    ],
    "sourceSchedule": "생활202(금6,7,8,9),생활502(목1,2)"
  },
  {
    "id": "03154-002-2000599",
    "subjectKey": "03154",
    "name": "사회복지현장실습",
    "division": "002",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "백혜영",
    "days": [
      "수",
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "인문101",
    "isOnline": false,
    "source": {
      "schedule": "인문101(수7,8),생활101(금6,7,8,9)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8
        ],
        "classroom": "인문101"
      },
      {
        "day": "금",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "생활101"
      }
    ],
    "sourceSchedule": "인문101(수7,8),생활101(금6,7,8,9)"
  },
  {
    "id": "03173-001-2000624",
    "subjectKey": "03173",
    "name": "산업경제학",
    "division": "001",
    "department": "경제금융",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "손규현",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "글경501",
    "isOnline": false,
    "source": {
      "schedule": "글경501(화6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "글경501"
      }
    ],
    "sourceSchedule": "글경501(화6,7,8)"
  },
  {
    "id": "03186-001-2000417",
    "subjectKey": "03186",
    "name": "산업공학특론",
    "division": "001",
    "department": "산업공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정주성",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "2공학116",
    "isOnline": false,
    "source": {
      "schedule": "2공학116(월6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "2공학116"
      }
    ],
    "sourceSchedule": "2공학116(월6,7,8)"
  },
  {
    "id": "03225-001-2000507",
    "subjectKey": "03225",
    "name": "상사중재론(이러닝)",
    "division": "001",
    "department": "글로벌비즈니스",
    "category": "이러닝",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이수현",
    "days": [
      "월",
      "토"
    ],
    "startPeriod": 9,
    "endPeriod": 9,
    "room": "글경604",
    "isOnline": true,
    "source": {
      "schedule": "글경604(월9 토1,2)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          9
        ],
        "classroom": "글경604"
      },
      {
        "day": "토",
        "periods": [
          1,
          2
        ],
        "classroom": "글경604"
      }
    ],
    "sourceSchedule": "글경604(월9 토1,2)"
  },
  {
    "id": "03225-002-2000507",
    "subjectKey": "03225",
    "name": "상사중재론(이러닝_재직자반)",
    "division": "002",
    "department": "글로벌비즈니스",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이수현",
    "days": [
      "월",
      "토"
    ],
    "startPeriod": 9,
    "endPeriod": 9,
    "room": "글경604",
    "isOnline": false,
    "source": {
      "schedule": "글경604(월9 토1,2)"
    },
    "capacity": 4,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          9
        ],
        "classroom": "글경604"
      },
      {
        "day": "토",
        "periods": [
          1,
          2
        ],
        "classroom": "글경604"
      }
    ],
    "sourceSchedule": "글경604(월9 토1,2)"
  },
  {
    "id": "03321-001-2000638",
    "subjectKey": "03321",
    "name": "생산관리2",
    "division": "001",
    "department": "산업공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "오근태",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "자연관306",
    "isOnline": false,
    "source": {
      "schedule": "자연관306(월6,7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "자연관306"
      }
    ],
    "sourceSchedule": "자연관306(월6,7,8,9)"
  },
  {
    "id": "03350-001-2000588",
    "subjectKey": "03350",
    "name": "생화학1",
    "division": "001",
    "department": "바이오화학산업학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "유기태",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "종합302",
    "isOnline": false,
    "source": {
      "schedule": "종합302(목2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "종합302"
      }
    ],
    "sourceSchedule": "종합302(목2,3,4)"
  },
  {
    "id": "03350-002-2000588",
    "subjectKey": "03350",
    "name": "생화학1",
    "division": "002",
    "department": "바이오화학산업학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "하국선",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "자연대B101",
    "isOnline": false,
    "source": {
      "schedule": "자연대B101(월2 수5,6)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2
        ],
        "classroom": "자연대B101"
      },
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "자연대B101"
      }
    ],
    "sourceSchedule": "자연대B101(월2 수5,6)"
  },
  {
    "id": "03353-001-2000601",
    "subjectKey": "03353",
    "name": "생화학2",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "서정연",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "생활502",
    "isOnline": false,
    "source": {
      "schedule": "생활502(목7,8,9)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "생활502"
      }
    ],
    "sourceSchedule": "생활502(목7,8,9)"
  },
  {
    "id": "03387-001-2000740",
    "subjectKey": "03387",
    "name": "생활영어회화2",
    "division": "001",
    "department": "영미언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "크로스비 드류",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문211",
    "isOnline": false,
    "source": {
      "schedule": "인문211(월6,7,8)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문211"
      }
    ],
    "sourceSchedule": "인문211(월6,7,8)"
  },
  {
    "id": "03428-001-2000600",
    "subjectKey": "03428",
    "name": "서양복식사",
    "division": "001",
    "department": "의류학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "사사키치카",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "생활302",
    "isOnline": false,
    "source": {
      "schedule": "생활302(화5,6 목8)"
    },
    "capacity": 45,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "생활302"
      },
      {
        "day": "목",
        "periods": [
          8
        ],
        "classroom": "생활302"
      }
    ],
    "sourceSchedule": "생활302(화5,6 목8)"
  },
  {
    "id": "03437-001-2000747",
    "subjectKey": "03437",
    "name": "서양사입문",
    "division": "001",
    "department": "디지털헤리티지",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "임웅",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문512",
    "isOnline": false,
    "source": {
      "schedule": "인문512(월2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문512"
      }
    ],
    "sourceSchedule": "인문512(월2,3,4)"
  },
  {
    "id": "03438-001-2000291",
    "subjectKey": "03438",
    "name": "서양사특강(학점교류)",
    "division": "001",
    "department": "사학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "03443-001-2000606",
    "subjectKey": "03443",
    "name": "서양음악기초이론2",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "윤지현",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(월5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(월5,6)"
  },
  {
    "id": "03443-002-2000607",
    "subjectKey": "03443",
    "name": "서양음악기초이론2",
    "division": "002",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김예인",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(월1,2)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(월1,2)"
  },
  {
    "id": "03445-002-2000605",
    "subjectKey": "03445",
    "name": "서양음악사2",
    "division": "002",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김영옥",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(목3,4)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(목3,4)"
  },
  {
    "id": "03445-003-2000606",
    "subjectKey": "03445",
    "name": "서양음악사2",
    "division": "003",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김영옥",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(화5,6)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(화5,6)"
  },
  {
    "id": "03445-004-2000607",
    "subjectKey": "03445",
    "name": "서양음악사2",
    "division": "004",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김영옥",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(목3,4)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(목3,4)"
  },
  {
    "id": "03445-005-2000608",
    "subjectKey": "03445",
    "name": "서양음악사2",
    "division": "005",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김영옥",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(화5,6)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(화5,6)"
  },
  {
    "id": "03447-001-2000605",
    "subjectKey": "03447",
    "name": "서양음악사4",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김영옥",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(목5,6)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(목5,6)"
  },
  {
    "id": "03447-002-2000607",
    "subjectKey": "03447",
    "name": "서양음악사4",
    "division": "002",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김영옥",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(목5,6)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(목5,6)"
  },
  {
    "id": "03471-001-2000643",
    "subjectKey": "03471",
    "name": "석유화학공학",
    "division": "001",
    "department": "화학공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김도",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "자연관409",
    "isOnline": false,
    "source": {
      "schedule": "자연관409(금5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "자연관409"
      }
    ],
    "sourceSchedule": "자연관409(금5,6,7)"
  },
  {
    "id": "03528-001-2000655",
    "subjectKey": "03528",
    "name": "섬유공예2",
    "division": "001",
    "department": "공예디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박성림",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "조형201",
    "isOnline": false,
    "source": {
      "schedule": "조형201(월2,3,4)"
    },
    "capacity": 28,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "조형201"
      }
    ],
    "sourceSchedule": "조형201(월2,3,4)"
  },
  {
    "id": "03554-001-2000606",
    "subjectKey": "03554",
    "name": "성악문헌2",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "윤지현",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(월3,4)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(월3,4)"
  },
  {
    "id": "03627-001-2000626",
    "subjectKey": "03627",
    "name": "소비자행동론",
    "division": "001",
    "department": "경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이현정",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경B102",
    "isOnline": false,
    "source": {
      "schedule": "글경B102(화1,2,3)"
    },
    "capacity": 60,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경B102"
      }
    ],
    "sourceSchedule": "글경B102(화1,2,3)"
  },
  {
    "id": "03653-001-2000411",
    "subjectKey": "03653",
    "name": "수공설계",
    "division": "001",
    "department": "건설환경공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "유도근",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "종합307",
    "isOnline": false,
    "source": {
      "schedule": "종합307(화2),종합503(목2,3)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2
        ],
        "classroom": "종합307"
      },
      {
        "day": "목",
        "periods": [
          2,
          3
        ],
        "classroom": "종합503"
      }
    ],
    "sourceSchedule": "종합307(화2),종합503(목2,3)"
  },
  {
    "id": "03713-001-2000649",
    "subjectKey": "03713",
    "name": "수영2",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "도정욱",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "체육112",
    "isOnline": false,
    "source": {
      "schedule": "체육112(월1,2)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "체육112"
      }
    ],
    "sourceSchedule": "체육112(월1,2)"
  },
  {
    "id": "03718-001-2000634",
    "subjectKey": "03718",
    "name": "수질오염개론",
    "division": "001",
    "department": "건설환경공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이채영",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "종합411",
    "isOnline": false,
    "source": {
      "schedule": "종합411(월4 수2,3)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4
        ],
        "classroom": "종합411"
      },
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "종합411"
      }
    ],
    "sourceSchedule": "종합411(월4 수2,3)"
  },
  {
    "id": "03718-002-2000635",
    "subjectKey": "03718",
    "name": "수질오염개론",
    "division": "002",
    "department": "환경에너지공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "차규현",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "종합410",
    "isOnline": false,
    "source": {
      "schedule": "종합410(화7 수6,7)"
    },
    "capacity": 45,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7
        ],
        "classroom": "종합410"
      },
      {
        "day": "수",
        "periods": [
          6,
          7
        ],
        "classroom": "종합410"
      }
    ],
    "sourceSchedule": "종합410(화7 수6,7)"
  },
  {
    "id": "03718-003-2000635",
    "subjectKey": "03718",
    "name": "수질오염개론",
    "division": "003",
    "department": "환경에너지공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박새롬",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "자연관307",
    "isOnline": false,
    "source": {
      "schedule": "자연관307(화7 수6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7
        ],
        "classroom": "자연관307"
      },
      {
        "day": "수",
        "periods": [
          6,
          7
        ],
        "classroom": "자연관307"
      }
    ],
    "sourceSchedule": "자연관307(화7 수6,7)"
  },
  {
    "id": "03733-001-2000634",
    "subjectKey": "03733",
    "name": "수치해석",
    "division": "001",
    "department": "건설환경공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김대현",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "2공학116",
    "isOnline": false,
    "source": {
      "schedule": "2공학116(수5 목1,2)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5
        ],
        "classroom": "2공학116"
      },
      {
        "day": "목",
        "periods": [
          1,
          2
        ],
        "classroom": "2공학116"
      }
    ],
    "sourceSchedule": "2공학116(수5 목1,2)"
  },
  {
    "id": "03733-002-2000639",
    "subjectKey": "03733",
    "name": "수치해석",
    "division": "002",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "송준솔",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "자연대211",
    "isOnline": false,
    "source": {
      "schedule": "자연대211(화5),자연관309(목1,2)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5
        ],
        "classroom": "자연대211"
      },
      {
        "day": "목",
        "periods": [
          1,
          2
        ],
        "classroom": "자연관309"
      }
    ],
    "sourceSchedule": "자연대211(화5),자연관309(목1,2)"
  },
  {
    "id": "03747-001-2000763",
    "subjectKey": "03747",
    "name": "수학1",
    "division": "001",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "황상민",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경311",
    "isOnline": false,
    "source": {
      "schedule": "글경311(월4,5,6)"
    },
    "capacity": 28,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경311"
      }
    ],
    "sourceSchedule": "글경311(월4,5,6)"
  },
  {
    "id": "03751-001-2000756",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "001",
    "department": "기계공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "전상우",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래105",
    "isOnline": false,
    "source": {
      "schedule": "미래105(화4,5,6)"
    },
    "capacity": 65,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래105"
      }
    ],
    "sourceSchedule": "미래105(화4,5,6)"
  },
  {
    "id": "03751-001-2000763",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "001",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "전상우",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래105",
    "isOnline": false,
    "source": {
      "schedule": "미래105(화4,5,6)"
    },
    "capacity": 65,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래105"
      }
    ],
    "sourceSchedule": "미래105(화4,5,6)"
  },
  {
    "id": "03751-002-2000592",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "002",
    "department": "반도체공학과",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "김용일",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래105",
    "isOnline": false,
    "source": {
      "schedule": "미래105(금1,2,3)"
    },
    "capacity": 65,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래105"
      }
    ],
    "sourceSchedule": "미래105(금1,2,3)"
  },
  {
    "id": "03751-002-2000763",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "002",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "김용일",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래105",
    "isOnline": false,
    "source": {
      "schedule": "미래105(금1,2,3)"
    },
    "capacity": 65,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래105"
      }
    ],
    "sourceSchedule": "미래105(금1,2,3)"
  },
  {
    "id": "03751-003-2000593",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "003",
    "department": "전기전자공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "박정미",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래106",
    "isOnline": false,
    "source": {
      "schedule": "미래106(금1,2,3)"
    },
    "capacity": 49,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래106"
      }
    ],
    "sourceSchedule": "미래106(금1,2,3)"
  },
  {
    "id": "03751-003-2000763",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "003",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "박정미",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래106",
    "isOnline": false,
    "source": {
      "schedule": "미래106(금1,2,3)"
    },
    "capacity": 49,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래106"
      }
    ],
    "sourceSchedule": "미래106(금1,2,3)"
  },
  {
    "id": "03751-004-2000593",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "004",
    "department": "전기전자공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "박정미",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래106",
    "isOnline": false,
    "source": {
      "schedule": "미래106(금4,5,6)"
    },
    "capacity": 48,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래106"
      }
    ],
    "sourceSchedule": "미래106(금4,5,6)"
  },
  {
    "id": "03751-004-2000763",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "004",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "박정미",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래106",
    "isOnline": false,
    "source": {
      "schedule": "미래106(금4,5,6)"
    },
    "capacity": 48,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래106"
      }
    ],
    "sourceSchedule": "미래106(금4,5,6)"
  },
  {
    "id": "03751-005-2000593",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "005",
    "department": "전기전자공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이운기",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래105",
    "isOnline": false,
    "source": {
      "schedule": "미래105(화7,8,9)"
    },
    "capacity": 48,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래105"
      }
    ],
    "sourceSchedule": "미래105(화7,8,9)"
  },
  {
    "id": "03751-005-2000763",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "005",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이운기",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래105",
    "isOnline": false,
    "source": {
      "schedule": "미래105(화7,8,9)"
    },
    "capacity": 48,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래105"
      }
    ],
    "sourceSchedule": "미래105(화7,8,9)"
  },
  {
    "id": "03751-006-2000594",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "006",
    "department": "화학공학·신소재공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "전상우",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래105",
    "isOnline": false,
    "source": {
      "schedule": "미래105(화1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래105"
      }
    ],
    "sourceSchedule": "미래105(화1,2,3)"
  },
  {
    "id": "03751-006-2000763",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "006",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "전상우",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래105",
    "isOnline": false,
    "source": {
      "schedule": "미래105(화1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래105"
      }
    ],
    "sourceSchedule": "미래105(화1,2,3)"
  },
  {
    "id": "03751-007-2000594",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "007",
    "department": "화학공학·신소재공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "김용일",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래105",
    "isOnline": false,
    "source": {
      "schedule": "미래105(금4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래105"
      }
    ],
    "sourceSchedule": "미래105(금4,5,6)"
  },
  {
    "id": "03751-007-2000763",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "007",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "김용일",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래105",
    "isOnline": false,
    "source": {
      "schedule": "미래105(금4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래105"
      }
    ],
    "sourceSchedule": "미래105(금4,5,6)"
  },
  {
    "id": "03751-008-2000757",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "008",
    "department": "AI데이터과학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "남궁정일",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경315",
    "isOnline": false,
    "source": {
      "schedule": "글경315(목1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경315"
      }
    ],
    "sourceSchedule": "글경315(목1,2,3)"
  },
  {
    "id": "03751-008-2000763",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "008",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "남궁정일",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경315",
    "isOnline": false,
    "source": {
      "schedule": "글경315(목1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경315"
      }
    ],
    "sourceSchedule": "글경315(목1,2,3)"
  },
  {
    "id": "03751-009-2000757",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "009",
    "department": "AI데이터과학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "남궁정일",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "글경315",
    "isOnline": false,
    "source": {
      "schedule": "글경315(목7,8,9)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "글경315"
      }
    ],
    "sourceSchedule": "글경315(목7,8,9)"
  },
  {
    "id": "03751-009-2000763",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "009",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "남궁정일",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "글경315",
    "isOnline": false,
    "source": {
      "schedule": "글경315(목7,8,9)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "글경315"
      }
    ],
    "sourceSchedule": "글경315(목7,8,9)"
  },
  {
    "id": "03751-010-2000757",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "010",
    "department": "AI데이터과학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이운기",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경314",
    "isOnline": false,
    "source": {
      "schedule": "글경314(화4,5,6)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경314"
      }
    ],
    "sourceSchedule": "글경314(화4,5,6)"
  },
  {
    "id": "03751-010-2000763",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "010",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이운기",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경314",
    "isOnline": false,
    "source": {
      "schedule": "글경314(화4,5,6)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경314"
      }
    ],
    "sourceSchedule": "글경314(화4,5,6)"
  },
  {
    "id": "03751-011-2000758",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "011",
    "department": "컴퓨터공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "황상민",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경B104",
    "isOnline": false,
    "source": {
      "schedule": "글경B104(화4,5,6)"
    },
    "capacity": 48,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경B104"
      }
    ],
    "sourceSchedule": "글경B104(화4,5,6)"
  },
  {
    "id": "03751-011-2000763",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "011",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "황상민",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경B104",
    "isOnline": false,
    "source": {
      "schedule": "글경B104(화4,5,6)"
    },
    "capacity": 48,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경B104"
      }
    ],
    "sourceSchedule": "글경B104(화4,5,6)"
  },
  {
    "id": "03751-012-2000758",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "012",
    "department": "컴퓨터공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "황상민",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "글경B104",
    "isOnline": false,
    "source": {
      "schedule": "글경B104(화7,8,9)"
    },
    "capacity": 48,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "글경B104"
      }
    ],
    "sourceSchedule": "글경B104(화7,8,9)"
  },
  {
    "id": "03751-012-2000763",
    "subjectKey": "03751",
    "name": "수학2",
    "division": "012",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "황상민",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "글경B104",
    "isOnline": false,
    "source": {
      "schedule": "글경B104(화7,8,9)"
    },
    "capacity": 48,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "글경B104"
      }
    ],
    "sourceSchedule": "글경B104(화7,8,9)"
  },
  {
    "id": "03763-001-2000602",
    "subjectKey": "03763",
    "name": "스키1(체육전공)",
    "division": "001",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "이승환",
    "days": [
      "금"
    ],
    "startPeriod": 8,
    "endPeriod": 9,
    "room": "체육118",
    "isOnline": false,
    "source": {
      "schedule": "체육118(금8,9)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          8,
          9
        ],
        "classroom": "체육118"
      }
    ],
    "sourceSchedule": "체육118(금8,9)"
  },
  {
    "id": "03763-002-2000602",
    "subjectKey": "03763",
    "name": "스키1(레저스포츠전공)",
    "division": "002",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "이승환",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "체육118",
    "isOnline": false,
    "source": {
      "schedule": "체육118(금3,4)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "체육118"
      }
    ],
    "sourceSchedule": "체육118(금3,4)"
  },
  {
    "id": "03763-003-2000602",
    "subjectKey": "03763",
    "name": "스키1(운동건강관리전공)",
    "division": "003",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "이승환",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "체육118",
    "isOnline": false,
    "source": {
      "schedule": "체육118(금6,7)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7
        ],
        "classroom": "체육118"
      }
    ],
    "sourceSchedule": "체육118(금6,7)"
  },
  {
    "id": "03764-001-2000649",
    "subjectKey": "03764",
    "name": "스키2",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "양홍위",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "체육114",
    "isOnline": false,
    "source": {
      "schedule": "체육114(목7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8
        ],
        "classroom": "체육114"
      }
    ],
    "sourceSchedule": "체육114(목7,8)"
  },
  {
    "id": "03774-001-2000650",
    "subjectKey": "03774",
    "name": "스포츠마사지",
    "division": "001",
    "department": "운동건강관리",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "박득수",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "체육112",
    "isOnline": false,
    "source": {
      "schedule": "체육112(화3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "체육112"
      }
    ],
    "sourceSchedule": "체육112(화3,4)"
  },
  {
    "id": "03777-001-2000602",
    "subjectKey": "03777",
    "name": "스포츠사회학(체육전공)",
    "division": "001",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "신호진",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B202",
    "isOnline": false,
    "source": {
      "schedule": "미래B202(수1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B202"
      }
    ],
    "sourceSchedule": "미래B202(수1,2,3)"
  },
  {
    "id": "03777-002-2000602",
    "subjectKey": "03777",
    "name": "스포츠사회학(레저스포츠전공)",
    "division": "002",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "신호진",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "미래B202",
    "isOnline": false,
    "source": {
      "schedule": "미래B202(수5,6,7)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "미래B202"
      }
    ],
    "sourceSchedule": "미래B202(수5,6,7)"
  },
  {
    "id": "03777-003-2000602",
    "subjectKey": "03777",
    "name": "스포츠사회학(운동건강관리전공)",
    "division": "003",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "신호진",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래B202",
    "isOnline": false,
    "source": {
      "schedule": "미래B202(월6,7,8)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래B202"
      }
    ],
    "sourceSchedule": "미래B202(월6,7,8)"
  },
  {
    "id": "03801-001-2000746",
    "subjectKey": "03801",
    "name": "스피치커뮤니케이션",
    "division": "001",
    "department": "미디어커뮤니케이션",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이현승",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문508",
    "isOnline": false,
    "source": {
      "schedule": "인문508(목1,2,3)"
    },
    "capacity": 80,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문508"
      }
    ],
    "sourceSchedule": "인문508(목1,2,3)"
  },
  {
    "id": "03869-001-2000608",
    "subjectKey": "03869",
    "name": "시창과청음2",
    "division": "001",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "권오현",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악315",
    "isOnline": false,
    "source": {
      "schedule": "음악315(월3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "음악315"
      }
    ],
    "sourceSchedule": "음악315(월3,4)"
  },
  {
    "id": "03869-002-2000606",
    "subjectKey": "03869",
    "name": "시창과청음2",
    "division": "002",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "오승은",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악217",
    "isOnline": false,
    "source": {
      "schedule": "음악217(화5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "음악217"
      }
    ],
    "sourceSchedule": "음악217(화5,6)"
  },
  {
    "id": "03869-003-2000607",
    "subjectKey": "03869",
    "name": "시창과청음2",
    "division": "003",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "강민창",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(월5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(월5,6)"
  },
  {
    "id": "03869-004-2000609",
    "subjectKey": "03869",
    "name": "시창과청음2",
    "division": "004",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "장현숙",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "음악215",
    "isOnline": false,
    "source": {
      "schedule": "음악215(금2)"
    },
    "capacity": 21,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2
        ],
        "classroom": "음악215"
      }
    ],
    "sourceSchedule": "음악215(금2)"
  },
  {
    "id": "03871-002-2000606",
    "subjectKey": "03871",
    "name": "시창과청음4",
    "division": "002",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "오승은",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악217",
    "isOnline": false,
    "source": {
      "schedule": "음악217(화3,4)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "음악217"
      }
    ],
    "sourceSchedule": "음악217(화3,4)"
  },
  {
    "id": "03871-003-2000607",
    "subjectKey": "03871",
    "name": "시창과청음4",
    "division": "003",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "성지연",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악217",
    "isOnline": false,
    "source": {
      "schedule": "음악217(수3,4)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "음악217"
      }
    ],
    "sourceSchedule": "음악217(수3,4)"
  },
  {
    "id": "03871-004-2000609",
    "subjectKey": "03871",
    "name": "시창과청음4",
    "division": "004",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "장현숙",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악215",
    "isOnline": false,
    "source": {
      "schedule": "음악215(금3,4)"
    },
    "capacity": 8,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "음악215"
      }
    ],
    "sourceSchedule": "음악215(금3,4)"
  },
  {
    "id": "03961-001-2000601",
    "subjectKey": "03961",
    "name": "식품위생학",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최윤",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "생활101",
    "isOnline": false,
    "source": {
      "schedule": "생활101(화7,8,9)"
    },
    "capacity": 60,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "생활101"
      }
    ],
    "sourceSchedule": "생활101(화7,8,9)"
  },
  {
    "id": "03970-001-2000601",
    "subjectKey": "03970",
    "name": "식품화학",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "정경훈",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "생활302",
    "isOnline": false,
    "source": {
      "schedule": "생활302(수1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "생활302"
      }
    ],
    "sourceSchedule": "생활302(수1,2,3)"
  },
  {
    "id": "04025-001-2000608",
    "subjectKey": "04025",
    "name": "실내악앙상블4",
    "division": "001",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김수진",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악313",
    "isOnline": false,
    "source": {
      "schedule": "음악313(목3,4)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "음악313"
      }
    ],
    "sourceSchedule": "음악313(목3,4)"
  },
  {
    "id": "04025-002-2000608",
    "subjectKey": "04025",
    "name": "실내악앙상블4",
    "division": "002",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "유영주",
    "days": [
      "목"
    ],
    "startPeriod": 9,
    "endPeriod": 10,
    "room": "음악218",
    "isOnline": false,
    "source": {
      "schedule": "음악218(목9,10)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          9,
          10
        ],
        "classroom": "음악218"
      }
    ],
    "sourceSchedule": "음악218(목9,10)"
  },
  {
    "id": "04025-003-2000608",
    "subjectKey": "04025",
    "name": "실내악앙상블4",
    "division": "003",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "전우정",
    "days": [
      "수"
    ],
    "startPeriod": 9,
    "endPeriod": 10,
    "room": "음악313",
    "isOnline": false,
    "source": {
      "schedule": "음악313(수9,10)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          9,
          10
        ],
        "classroom": "음악313"
      }
    ],
    "sourceSchedule": "음악313(수9,10)"
  },
  {
    "id": "04095-001-2000599",
    "subjectKey": "04095",
    "name": "아동상담",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이동미",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "IT106",
    "isOnline": false,
    "source": {
      "schedule": "IT106(화3,4,5)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "IT106"
      }
    ],
    "sourceSchedule": "IT106(화3,4,5)"
  },
  {
    "id": "04109-001-2000445",
    "subjectKey": "04109",
    "name": "안전공학",
    "division": "001",
    "department": "신소재공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정성은",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "자연관407",
    "isOnline": false,
    "source": {
      "schedule": "자연관407(수5,6 목8)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "자연관407"
      },
      {
        "day": "목",
        "periods": [
          8
        ],
        "classroom": "자연관407"
      }
    ],
    "sourceSchedule": "자연관407(수5,6 목8)"
  },
  {
    "id": "04111-001-2000648",
    "subjectKey": "04111",
    "name": "안전교육",
    "division": "001",
    "department": "체육학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "이지선",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B203",
    "isOnline": false,
    "source": {
      "schedule": "미래B203(목3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B203"
      }
    ],
    "sourceSchedule": "미래B203(목3,4)"
  },
  {
    "id": "04115-001-2000644",
    "subjectKey": "04115",
    "name": "알고리즘분석",
    "division": "001",
    "department": "컴퓨터SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "한성일",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT105",
    "isOnline": false,
    "source": {
      "schedule": "IT105(화2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT105"
      }
    ],
    "sourceSchedule": "IT105(화2,3,4)"
  },
  {
    "id": "04115-002-2000644",
    "subjectKey": "04115",
    "name": "알고리즘분석",
    "division": "002",
    "department": "컴퓨터SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "한성일",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT105",
    "isOnline": false,
    "source": {
      "schedule": "IT105(목2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT105"
      }
    ],
    "sourceSchedule": "IT105(목2,3,4)"
  },
  {
    "id": "04126-001-2000648",
    "subjectKey": "04126",
    "name": "야외교육론",
    "division": "001",
    "department": "체육학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김태영",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "체육116",
    "isOnline": false,
    "source": {
      "schedule": "체육116(수1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "체육116"
      }
    ],
    "sourceSchedule": "체육116(수1,2,3)"
  },
  {
    "id": "04163-001-2000746",
    "subjectKey": "04163",
    "name": "언론학개론",
    "division": "001",
    "department": "미디어커뮤니케이션",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "강승미",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문407",
    "isOnline": false,
    "source": {
      "schedule": "인문407(수2,3,4)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문407"
      }
    ],
    "sourceSchedule": "인문407(수2,3,4)"
  },
  {
    "id": "04163-001-2000763",
    "subjectKey": "04163",
    "name": "언론학개론",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "강승미",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문407",
    "isOnline": false,
    "source": {
      "schedule": "인문407(수2,3,4)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문407"
      }
    ],
    "sourceSchedule": "인문407(수2,3,4)"
  },
  {
    "id": "04165-001-2000658",
    "subjectKey": "04165",
    "name": "언어와문화",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김동섭",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합307",
    "isOnline": false,
    "source": {
      "schedule": "종합307(월4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합307"
      }
    ],
    "sourceSchedule": "종합307(월4,5,6)"
  },
  {
    "id": "04167-001-2000740",
    "subjectKey": "04167",
    "name": "언어의이해",
    "division": "001",
    "department": "영미언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이한나",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문313",
    "isOnline": false,
    "source": {
      "schedule": "인문313(월2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문313"
      }
    ],
    "sourceSchedule": "인문313(월2,3,4)"
  },
  {
    "id": "04167-001-2000742",
    "subjectKey": "04167",
    "name": "언어의이해",
    "division": "001",
    "department": "중국언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이한나",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문313",
    "isOnline": false,
    "source": {
      "schedule": "인문313(월2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문313"
      }
    ],
    "sourceSchedule": "인문313(월2,3,4)"
  },
  {
    "id": "04167-001-2000743",
    "subjectKey": "04167",
    "name": "언어의이해",
    "division": "001",
    "department": "러시아언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이한나",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문313",
    "isOnline": false,
    "source": {
      "schedule": "인문313(월2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문313"
      }
    ],
    "sourceSchedule": "인문313(월2,3,4)"
  },
  {
    "id": "04167-002-2000741",
    "subjectKey": "04167",
    "name": "언어의이해",
    "division": "002",
    "department": "일본언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "방윤형",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "종합509",
    "isOnline": false,
    "source": {
      "schedule": "종합509(화2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "종합509"
      }
    ],
    "sourceSchedule": "종합509(화2,3,4)"
  },
  {
    "id": "04170-001-2000290",
    "subjectKey": "04170",
    "name": "언어학의이해(학점교류)",
    "division": "001",
    "department": "국어국문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "04216-001-2000613",
    "subjectKey": "04216",
    "name": "연극사",
    "division": "001",
    "department": "영화예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "손정은",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "복지202",
    "isOnline": false,
    "source": {
      "schedule": "복지202(월4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "복지202"
      }
    ],
    "sourceSchedule": "복지202(월4,5,6)"
  },
  {
    "id": "04216-002-2000614",
    "subjectKey": "04216",
    "name": "연극사",
    "division": "002",
    "department": "연기예술",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "고영민",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "복지203",
    "isOnline": false,
    "source": {
      "schedule": "복지203(수7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "복지203"
      }
    ],
    "sourceSchedule": "복지203(수7,8,9)"
  },
  {
    "id": "04216-003-2000614",
    "subjectKey": "04216",
    "name": "연극사(재수강)",
    "division": "003",
    "department": "연기예술",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "고영민",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "복지203",
    "isOnline": false,
    "source": {
      "schedule": "복지203(수4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "복지203"
      }
    ],
    "sourceSchedule": "복지203(수4,5,6)"
  },
  {
    "id": "04235-001-2000606",
    "subjectKey": "04235",
    "name": "연기법4",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김성은",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "복지B106",
    "isOnline": false,
    "source": {
      "schedule": "복지B106(목7,8)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8
        ],
        "classroom": "복지B106"
      }
    ],
    "sourceSchedule": "복지B106(목7,8)"
  },
  {
    "id": "04240-001-2000639",
    "subjectKey": "04240",
    "name": "연소공학",
    "division": "001",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이찬",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "종합405",
    "isOnline": false,
    "source": {
      "schedule": "종합405(월5 화1,2)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5
        ],
        "classroom": "종합405"
      },
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "종합405"
      }
    ],
    "sourceSchedule": "종합405(월5 화1,2)"
  },
  {
    "id": "04294-001-2000643",
    "subjectKey": "04294",
    "name": "열및물질전달",
    "division": "001",
    "department": "화학공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "황인국",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "자연관408",
    "isOnline": false,
    "source": {
      "schedule": "자연관408(화5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "자연관408"
      }
    ],
    "sourceSchedule": "자연관408(화5,6,7)"
  },
  {
    "id": "04303-001-2000639",
    "subjectKey": "04303",
    "name": "열유체응용및실험",
    "division": "001",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "한태훈",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "2공학306",
    "isOnline": false,
    "source": {
      "schedule": "2공학306(목5,6,7,8)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "2공학306"
      }
    ],
    "sourceSchedule": "2공학306(목5,6,7,8)"
  },
  {
    "id": "04304-001-2000639",
    "subjectKey": "04304",
    "name": "열전달",
    "division": "001",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "한태훈",
    "days": [
      "화",
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "종합405",
    "isOnline": false,
    "source": {
      "schedule": "종합405(화7,8),종합408(월9)"
    },
    "capacity": 25,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "종합405"
      },
      {
        "day": "월",
        "periods": [
          9
        ],
        "classroom": "종합408"
      }
    ],
    "sourceSchedule": "종합405(화7,8),종합408(월9)"
  },
  {
    "id": "04310-001-2000655",
    "subjectKey": "04310",
    "name": "염색2",
    "division": "001",
    "department": "공예디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "홍동희",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "조형201",
    "isOnline": false,
    "source": {
      "schedule": "조형201(화6,7,8)"
    },
    "capacity": 25,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "조형201"
      }
    ],
    "sourceSchedule": "조형201(화6,7,8)"
  },
  {
    "id": "04409-001-2000601",
    "subjectKey": "04409",
    "name": "영양교육",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "엄정인",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "생활302",
    "isOnline": false,
    "source": {
      "schedule": "생활302(화2,3,4)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "생활302"
      }
    ],
    "sourceSchedule": "생활302(화2,3,4)"
  },
  {
    "id": "04422-001-2000601",
    "subjectKey": "04422",
    "name": "영양학실험",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이유현",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "생활302",
    "isOnline": false,
    "source": {
      "schedule": "생활302(월2,3,4)"
    },
    "capacity": 15,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "생활302"
      }
    ],
    "sourceSchedule": "생활302(월2,3,4)"
  },
  {
    "id": "04491-001-2000740",
    "subjectKey": "04491",
    "name": "영어방송청취",
    "division": "001",
    "department": "영미언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박경선",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문301",
    "isOnline": false,
    "source": {
      "schedule": "인문301(화6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문301"
      }
    ],
    "sourceSchedule": "인문301(화6,7,8)"
  },
  {
    "id": "04518-001-2000618",
    "subjectKey": "04518",
    "name": "영어의미연구",
    "division": "001",
    "department": "영어영문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이한나",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문313",
    "isOnline": false,
    "source": {
      "schedule": "인문313(월6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문313"
      }
    ],
    "sourceSchedule": "인문313(월6,7,8)"
  },
  {
    "id": "04566-001-2000639",
    "subjectKey": "04566",
    "name": "컴퓨터프로그래밍",
    "division": "001",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이기용",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "자연대211",
    "isOnline": false,
    "source": {
      "schedule": "자연대211(금1,2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "자연대211"
      }
    ],
    "sourceSchedule": "자연대211(금1,2,3,4)"
  },
  {
    "id": "04566-002-2000639",
    "subjectKey": "04566",
    "name": "컴퓨터프로그래밍",
    "division": "002",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이상엽",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연대211",
    "isOnline": false,
    "source": {
      "schedule": "자연대211(금5,6,7,8)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연대211"
      }
    ],
    "sourceSchedule": "자연대211(금5,6,7,8)"
  },
  {
    "id": "04575-001-2000613",
    "subjectKey": "04575",
    "name": "영화사",
    "division": "001",
    "department": "영화예술",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김동윤",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "복지405",
    "isOnline": false,
    "source": {
      "schedule": "복지405(금6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "복지405"
      }
    ],
    "sourceSchedule": "복지405(금6,7,8)"
  },
  {
    "id": "04600-001-2000606",
    "subjectKey": "04600",
    "name": "예술가곡2",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "추주현",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악216",
    "isOnline": false,
    "source": {
      "schedule": "음악216(수3,4)"
    },
    "capacity": 10,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "음악216"
      }
    ],
    "sourceSchedule": "음악216(수3,4)"
  },
  {
    "id": "04613-001-2000606",
    "subjectKey": "04613",
    "name": "오페라사",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "윤아르나",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(월5,6)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(월5,6)"
  },
  {
    "id": "04651-001-2000650",
    "subjectKey": "04651",
    "name": "운동생리학2",
    "division": "001",
    "department": "운동건강관리",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "주정선",
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "체육114",
    "isOnline": false,
    "source": {
      "schedule": "체육114(월5),체육116(목1,2)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5
        ],
        "classroom": "체육114"
      },
      {
        "day": "목",
        "periods": [
          1,
          2
        ],
        "classroom": "체육116"
      }
    ],
    "sourceSchedule": "체육114(월5),체육116(목1,2)"
  },
  {
    "id": "04663-001-2000596",
    "subjectKey": "04663",
    "name": "운영체제론",
    "division": "001",
    "department": "컴퓨터학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "구창진",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT308",
    "isOnline": false,
    "source": {
      "schedule": "IT308(월2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT308"
      }
    ],
    "sourceSchedule": "IT308(월2,3,4)"
  },
  {
    "id": "04663-003-2000647",
    "subjectKey": "04663",
    "name": "운영체제론",
    "division": "003",
    "department": "정보보호",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박두식",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT215",
    "isOnline": false,
    "source": {
      "schedule": "IT215(화6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT215"
      }
    ],
    "sourceSchedule": "IT215(화6,7,8)"
  },
  {
    "id": "04663-004-2000596",
    "subjectKey": "04663",
    "name": "운영체제론",
    "division": "004",
    "department": "컴퓨터학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "구창진",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT308",
    "isOnline": false,
    "source": {
      "schedule": "IT308(월6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT308"
      }
    ],
    "sourceSchedule": "IT308(월6,7,8)"
  },
  {
    "id": "04663-005-2000647",
    "subjectKey": "04663",
    "name": "운영체제론",
    "division": "005",
    "department": "정보보호",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박두식",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "IT215",
    "isOnline": false,
    "source": {
      "schedule": "IT215(금5,6,7)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "IT215"
      }
    ],
    "sourceSchedule": "IT215(금5,6,7)"
  },
  {
    "id": "04663-006-2000596",
    "subjectKey": "04663",
    "name": "운영체제론",
    "division": "006",
    "department": "컴퓨터학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "양혜윤",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT310",
    "isOnline": false,
    "source": {
      "schedule": "IT310(월2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT310"
      }
    ],
    "sourceSchedule": "IT310(월2,3,4)"
  },
  {
    "id": "04668-001-2000627",
    "subjectKey": "04668",
    "name": "원가회계",
    "division": "001",
    "department": "회계",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김동원",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "글경601",
    "isOnline": false,
    "source": {
      "schedule": "글경601(화1,2 수4)"
    },
    "capacity": 90,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "글경601"
      },
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "글경601"
      }
    ],
    "sourceSchedule": "글경601(화1,2 수4)"
  },
  {
    "id": "04739-001-2000658",
    "subjectKey": "04739",
    "name": "유럽통합의이해(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "윤성원",
    "days": [
      "목",
      "토"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "종합608",
    "isOnline": true,
    "source": {
      "schedule": "종합608(목1 토1,2)"
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1
        ],
        "classroom": "종합608"
      },
      {
        "day": "토",
        "periods": [
          1,
          2
        ],
        "classroom": "종합608"
      }
    ],
    "sourceSchedule": "종합608(목1 토1,2)"
  },
  {
    "id": "04745-001-2000418",
    "subjectKey": "04745",
    "name": "유압공학",
    "division": "001",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "임성혁",
    "days": [
      "목",
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "자연관309",
    "isOnline": false,
    "source": {
      "schedule": "자연관309(목3),종합405(수2,3)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3
        ],
        "classroom": "자연관309"
      },
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "종합405"
      }
    ],
    "sourceSchedule": "자연관309(목3),종합405(수2,3)"
  },
  {
    "id": "04755-001-2000408",
    "subjectKey": "04755",
    "name": "생명(유전)공학특수연구2",
    "division": "001",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "유기태",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "2공학104",
    "isOnline": false,
    "source": {
      "schedule": "2공학104(월5,6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "2공학104"
      }
    ],
    "sourceSchedule": "2공학104(월5,6,7,8)"
  },
  {
    "id": "04755-002-2000408",
    "subjectKey": "04755",
    "name": "생명(유전)공학특수연구2",
    "division": "002",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "강성수",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "2공학104",
    "isOnline": false,
    "source": {
      "schedule": "2공학104(목5,6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "2공학104"
      }
    ],
    "sourceSchedule": "2공학104(목5,6,7,8)"
  },
  {
    "id": "04757-001-2000632",
    "subjectKey": "04757",
    "name": "유전자공학",
    "division": "001",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "라메쉬 카칼라",
    "days": [
      "목",
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "종합409",
    "isOnline": false,
    "source": {
      "schedule": "종합409(목2),종합511(금2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2
        ],
        "classroom": "종합409"
      },
      {
        "day": "금",
        "periods": [
          2,
          3
        ],
        "classroom": "종합511"
      }
    ],
    "sourceSchedule": "종합409(목2),종합511(금2,3)"
  },
  {
    "id": "04760-001-2000588",
    "subjectKey": "04760",
    "name": "유전학",
    "division": "001",
    "department": "바이오화학산업학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "신령",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "종합404",
    "isOnline": false,
    "source": {
      "schedule": "종합404(화2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "종합404"
      }
    ],
    "sourceSchedule": "종합404(화2,3,4)"
  },
  {
    "id": "04760-002-2000588",
    "subjectKey": "04760",
    "name": "유전학",
    "division": "002",
    "department": "바이오화학산업학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "신령",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "종합404",
    "isOnline": false,
    "source": {
      "schedule": "종합404(화6,7,8)"
    },
    "capacity": 25,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "종합404"
      }
    ],
    "sourceSchedule": "종합404(화6,7,8)"
  },
  {
    "id": "04772-001-2000634",
    "subjectKey": "04772",
    "name": "유체역학",
    "division": "001",
    "department": "건설환경공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "유도근",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합511",
    "isOnline": false,
    "source": {
      "schedule": "종합511(월2,3 수4)"
    },
    "capacity": 60,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "종합511"
      },
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "종합511"
      }
    ],
    "sourceSchedule": "종합511(월2,3 수4)"
  },
  {
    "id": "04772-002-2000635",
    "subjectKey": "04772",
    "name": "유체역학",
    "division": "002",
    "department": "환경에너지공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "성기명",
    "days": [
      "수",
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "종합302",
    "isOnline": false,
    "source": {
      "schedule": "종합302(수4),종합408(화5,6)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "종합302"
      },
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "종합408"
      }
    ],
    "sourceSchedule": "종합302(수4),종합408(화5,6)"
  },
  {
    "id": "04772-003-2000639",
    "subjectKey": "04772",
    "name": "유체역학",
    "division": "003",
    "department": "기계공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이찬",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합307",
    "isOnline": false,
    "source": {
      "schedule": "종합307(월1,2,3)"
    },
    "capacity": 42,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합307"
      }
    ],
    "sourceSchedule": "종합307(월1,2,3)"
  },
  {
    "id": "04772-004-2000639",
    "subjectKey": "04772",
    "name": "유체역학",
    "division": "004",
    "department": "기계공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "임성혁",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "자연관309",
    "isOnline": false,
    "source": {
      "schedule": "자연관309(월1,2,3)"
    },
    "capacity": 44,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "자연관309"
      }
    ],
    "sourceSchedule": "자연관309(월1,2,3)"
  },
  {
    "id": "04800-001-2000602",
    "subjectKey": "04800",
    "name": "육상1(학부A반)",
    "division": "001",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "윤신혜",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "체육201",
    "isOnline": false,
    "source": {
      "schedule": "체육201(금1,2)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "체육201"
      }
    ],
    "sourceSchedule": "체육201(금1,2)"
  },
  {
    "id": "04800-002-2000602",
    "subjectKey": "04800",
    "name": "육상1(학부B반)",
    "division": "002",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "윤신혜",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "체육201",
    "isOnline": false,
    "source": {
      "schedule": "체육201(금3,4)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "체육201"
      }
    ],
    "sourceSchedule": "체육201(금3,4)"
  },
  {
    "id": "04800-003-2000602",
    "subjectKey": "04800",
    "name": "육상1(학부C반)",
    "division": "003",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "윤신혜",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B203",
    "isOnline": false,
    "source": {
      "schedule": "미래B203(금5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B203"
      }
    ],
    "sourceSchedule": "미래B203(금5,6)"
  },
  {
    "id": "04813-001-2000264",
    "subjectKey": "04813",
    "name": "음악미학2",
    "division": "001",
    "department": "작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "이해미",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(목3,4)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(목3,4)"
  },
  {
    "id": "04817-001-2000605",
    "subjectKey": "04817",
    "name": "음악분석2",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "이형민",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(수7,8)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(수7,8)"
  },
  {
    "id": "04817-002-2000607",
    "subjectKey": "04817",
    "name": "음악분석2",
    "division": "002",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "유진선",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(목7,8)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(목7,8)"
  },
  {
    "id": "04820-001-2000607",
    "subjectKey": "04820",
    "name": "음악소프트웨어실습2",
    "division": "001",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "이율구",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악106",
    "isOnline": false,
    "source": {
      "schedule": "음악106(수5,6)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "음악106"
      }
    ],
    "sourceSchedule": "음악106(수5,6)"
  },
  {
    "id": "04836-001-2000634",
    "subjectKey": "04836",
    "name": "응용수리학및실험",
    "division": "001",
    "department": "건설환경공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "유도근",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합511",
    "isOnline": false,
    "source": {
      "schedule": "종합511(월5,6 수2,3)"
    },
    "capacity": 55,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "종합511"
      },
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "종합511"
      }
    ],
    "sourceSchedule": "종합511(월5,6 수2,3)"
  },
  {
    "id": "04852-001-2000634",
    "subjectKey": "04852",
    "name": "응용측량학및실습",
    "division": "001",
    "department": "건설환경공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이강욱",
    "days": [
      "목",
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합511",
    "isOnline": false,
    "source": {
      "schedule": "종합511(목5,6 금5,6)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "종합511"
      },
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "종합511"
      }
    ],
    "sourceSchedule": "종합511(목5,6 금5,6)"
  },
  {
    "id": "04864-001-2000600",
    "subjectKey": "04864",
    "name": "의복구성1",
    "division": "001",
    "department": "의류학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "홍유화",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "생활301",
    "isOnline": false,
    "source": {
      "schedule": "생활301(화1,2,3,4)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "생활301"
      }
    ],
    "sourceSchedule": "생활301(화1,2,3,4)"
  },
  {
    "id": "04864-001-2000763",
    "subjectKey": "04864",
    "name": "의복구성1",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "홍유화",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "생활301",
    "isOnline": false,
    "source": {
      "schedule": "생활301(화1,2,3,4)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "생활301"
      }
    ],
    "sourceSchedule": "생활301(화1,2,3,4)"
  },
  {
    "id": "04864-002-2000600",
    "subjectKey": "04864",
    "name": "의복구성1",
    "division": "002",
    "department": "의류학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "홍유화",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "생활301",
    "isOnline": false,
    "source": {
      "schedule": "생활301(화6,7,8,9)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "생활301"
      }
    ],
    "sourceSchedule": "생활301(화6,7,8,9)"
  },
  {
    "id": "04864-002-2000763",
    "subjectKey": "04864",
    "name": "의복구성1",
    "division": "002",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "홍유화",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "생활301",
    "isOnline": false,
    "source": {
      "schedule": "생활301(화6,7,8,9)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "생활301"
      }
    ],
    "sourceSchedule": "생활301(화6,7,8,9)"
  },
  {
    "id": "04865-001-2000600",
    "subjectKey": "04865",
    "name": "의복구성2",
    "division": "001",
    "department": "의류학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김선영",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "생활301",
    "isOnline": false,
    "source": {
      "schedule": "생활301(수1,2,3)"
    },
    "capacity": 25,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "생활301"
      }
    ],
    "sourceSchedule": "생활301(수1,2,3)"
  },
  {
    "id": "04865-002-2000600",
    "subjectKey": "04865",
    "name": "의복구성2",
    "division": "002",
    "department": "의류학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이동아",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "생활301",
    "isOnline": false,
    "source": {
      "schedule": "생활301(월1,2,3)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "생활301"
      }
    ],
    "sourceSchedule": "생활301(월1,2,3)"
  },
  {
    "id": "04896-001-2000759",
    "subjectKey": "04896",
    "name": "이산수학",
    "division": "001",
    "department": "지능형보안학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고승철",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT307",
    "isOnline": false,
    "source": {
      "schedule": "IT307(목6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT307"
      }
    ],
    "sourceSchedule": "IT307(목6,7,8)"
  },
  {
    "id": "04896-001-2000763",
    "subjectKey": "04896",
    "name": "이산수학",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고승철",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT307",
    "isOnline": false,
    "source": {
      "schedule": "IT307(목6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT307"
      }
    ],
    "sourceSchedule": "IT307(목6,7,8)"
  },
  {
    "id": "04910-001-2000638",
    "subjectKey": "04910",
    "name": "인간/로보트작업연구",
    "division": "001",
    "department": "산업공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이동하",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "2공학113",
    "isOnline": false,
    "source": {
      "schedule": "2공학113(화1,2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "2공학113"
      }
    ],
    "sourceSchedule": "2공학113(화1,2,3,4)"
  },
  {
    "id": "04925-001-2000658",
    "subjectKey": "04925",
    "name": "인간과우주(마이크로디그리)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김충섭",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래110",
    "isOnline": false,
    "source": {
      "schedule": "미래110(목7,8,9)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래110"
      }
    ],
    "sourceSchedule": "미래110(목7,8,9)"
  },
  {
    "id": "04960-001-2000638",
    "subjectKey": "04960",
    "name": "인터넷과산업정보",
    "division": "001",
    "department": "산업공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이동하",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "2공학113",
    "isOnline": false,
    "source": {
      "schedule": "2공학113(화6,7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "2공학113"
      }
    ],
    "sourceSchedule": "2공학113(화6,7,8,9)"
  },
  {
    "id": "04961-001-2000626",
    "subjectKey": "04961",
    "name": "인터넷마케팅",
    "division": "001",
    "department": "경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이현정",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경B102",
    "isOnline": false,
    "source": {
      "schedule": "글경B102(화4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경B102"
      }
    ],
    "sourceSchedule": "글경B102(화4,5,6)"
  },
  {
    "id": "05080-001-2000635",
    "subjectKey": "05080",
    "name": "일반생물학",
    "division": "001",
    "department": "환경에너지공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김미아",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합408",
    "isOnline": false,
    "source": {
      "schedule": "종합408(목4,5,6)"
    },
    "capacity": 70,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합408"
      }
    ],
    "sourceSchedule": "종합408(목4,5,6)"
  },
  {
    "id": "05086-001-2000755",
    "subjectKey": "05086",
    "name": "일반생물학2",
    "division": "001",
    "department": "바이오공학과",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "하국선",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "자연대B101",
    "isOnline": false,
    "source": {
      "schedule": "자연대B101(화5,6 목2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "자연대B101"
      },
      {
        "day": "목",
        "periods": [
          2,
          3
        ],
        "classroom": "자연대B101"
      }
    ],
    "sourceSchedule": "자연대B101(화5,6 목2,3)"
  },
  {
    "id": "05086-001-2000763",
    "subjectKey": "05086",
    "name": "일반생물학2",
    "division": "001",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "하국선",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "자연대B101",
    "isOnline": false,
    "source": {
      "schedule": "자연대B101(화5,6 목2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "자연대B101"
      },
      {
        "day": "목",
        "periods": [
          2,
          3
        ],
        "classroom": "자연대B101"
      }
    ],
    "sourceSchedule": "자연대B101(화5,6 목2,3)"
  },
  {
    "id": "05086-002-2000755",
    "subjectKey": "05086",
    "name": "일반생물학2",
    "division": "002",
    "department": "바이오공학과",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이우린",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "자연대505",
    "isOnline": false,
    "source": {
      "schedule": "자연대505(화1,2,3,4)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "자연대505"
      }
    ],
    "sourceSchedule": "자연대505(화1,2,3,4)"
  },
  {
    "id": "05086-002-2000763",
    "subjectKey": "05086",
    "name": "일반생물학2",
    "division": "002",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이우린",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "자연대505",
    "isOnline": false,
    "source": {
      "schedule": "자연대505(화1,2,3,4)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "자연대505"
      }
    ],
    "sourceSchedule": "자연대505(화1,2,3,4)"
  },
  {
    "id": "05177-001-2000620",
    "subjectKey": "05177",
    "name": "일본문학의이해2",
    "division": "001",
    "department": "일어일문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김욱",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합505",
    "isOnline": false,
    "source": {
      "schedule": "종합505(월5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합505"
      }
    ],
    "sourceSchedule": "종합505(월5,6,7)"
  },
  {
    "id": "05229-001-2000620",
    "subjectKey": "05229",
    "name": "일어음성학",
    "division": "001",
    "department": "일어일문학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김선희",
    "days": [
      "목",
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "인문313",
    "isOnline": false,
    "source": {
      "schedule": "인문313(목3),인문404(화4,5)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3
        ],
        "classroom": "인문313"
      },
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "인문404"
      }
    ],
    "sourceSchedule": "인문313(목3),인문404(화4,5)"
  },
  {
    "id": "05305-001-2000641",
    "subjectKey": "05305",
    "name": "자료구조및알고리즘",
    "division": "001",
    "department": "전자공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김우성",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "자연대503",
    "isOnline": false,
    "source": {
      "schedule": "자연대503(금5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "자연대503"
      }
    ],
    "sourceSchedule": "자연대503(금5,6,7)"
  },
  {
    "id": "05310-001-2000658",
    "subjectKey": "05310",
    "name": "자연과학의이해(마이크로디그리)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김상준",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래109",
    "isOnline": false,
    "source": {
      "schedule": "미래109(월4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래109"
      }
    ],
    "sourceSchedule": "미래109(월4,5,6)"
  },
  {
    "id": "05326-001-2000605",
    "subjectKey": "05326",
    "name": "작곡법연습2",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "조한나",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(수3,4)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(수3,4)"
  },
  {
    "id": "05372-001-2000634",
    "subjectKey": "05372",
    "name": "재료역학",
    "division": "001",
    "department": "건설환경공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김한나",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합511",
    "isOnline": false,
    "source": {
      "schedule": "종합511(화2,3 목4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "종합511"
      },
      {
        "day": "목",
        "periods": [
          4
        ],
        "classroom": "종합511"
      }
    ],
    "sourceSchedule": "종합511(화2,3 목4)"
  },
  {
    "id": "05379-001-2000626",
    "subjectKey": "05379",
    "name": "재무관리",
    "division": "001",
    "department": "경영",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "고석빈",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경603",
    "isOnline": false,
    "source": {
      "schedule": "글경603(화5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경603"
      }
    ],
    "sourceSchedule": "글경603(화5,6,7)"
  },
  {
    "id": "05379-002-2000626",
    "subjectKey": "05379",
    "name": "재무관리",
    "division": "002",
    "department": "경영",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "고석빈",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경603",
    "isOnline": false,
    "source": {
      "schedule": "글경603(목5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경603"
      }
    ],
    "sourceSchedule": "글경603(목5,6,7)"
  },
  {
    "id": "05379-003-2000626",
    "subjectKey": "05379",
    "name": "재무관리(재직자반)",
    "division": "003",
    "department": "경영",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "고석빈",
    "days": [
      "화"
    ],
    "startPeriod": 10,
    "endPeriod": 12,
    "room": "글경603",
    "isOnline": false,
    "source": {
      "schedule": "글경603(화10,11,12)"
    },
    "capacity": 2,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          10,
          11,
          12
        ],
        "classroom": "글경603"
      }
    ],
    "sourceSchedule": "글경603(화10,11,12)"
  },
  {
    "id": "05379-004-2000626",
    "subjectKey": "05379",
    "name": "재무관리(외국인전용)",
    "division": "004",
    "department": "경영",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "왕두균",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경402",
    "isOnline": false,
    "source": {
      "schedule": "글경402(화5,6,7)"
    },
    "capacity": 25,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경402"
      }
    ],
    "sourceSchedule": "글경402(화5,6,7)"
  },
  {
    "id": "05379-005-2000626",
    "subjectKey": "05379",
    "name": "재무관리",
    "division": "005",
    "department": "경영",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "고석빈",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경101",
    "isOnline": false,
    "source": {
      "schedule": "글경101(수1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경101"
      }
    ],
    "sourceSchedule": "글경101(수1,2,3)"
  },
  {
    "id": "05389-001-2000624",
    "subjectKey": "05389",
    "name": "재정학",
    "division": "001",
    "department": "경제금융",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "송승주",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "글경503",
    "isOnline": false,
    "source": {
      "schedule": "글경503(수4,5 목6)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5
        ],
        "classroom": "글경503"
      },
      {
        "day": "목",
        "periods": [
          6
        ],
        "classroom": "글경503"
      }
    ],
    "sourceSchedule": "글경503(수4,5 목6)"
  },
  {
    "id": "05432-001-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "001",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김판주",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-002-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "002",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김예지",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-003-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "003",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이지연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-004-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "004",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "한기원",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-005-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "005",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김영윤",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-006-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "006",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박가경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-007-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "007",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박보형",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-008-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "008",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이상옥",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-009-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "009",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이지은",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-010-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "010",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤현임",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-011-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "011",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김나연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-012-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "012",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "서상백",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-013-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "013",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤현임",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-014-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "014",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "오병철",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-015-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "015",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "고부현",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-016-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "016",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박은영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-017-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "017",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김은경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-018-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "018",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이지은",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-019-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "019",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김영은",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-020-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "020",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "오병철",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-021-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "021",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "한기원",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-022-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "022",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김수진",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-023-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "023",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김수진",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-024-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "024",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박가경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-025-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "025",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "허원경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-026-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "026",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김지희",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-027-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "027",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "나혜수",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-028-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "028",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이지연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-029-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "029",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "나혜수",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-030-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "030",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김은경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-031-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "031",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤현임",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-032-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "032",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권오민",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-033-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "033",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박진영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-034-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "034",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "한기원",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-035-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "035",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김지희",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-036-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "036",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김정연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-037-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "037",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이지연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-038-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "038",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "유영주",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-039-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "039",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박가경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-040-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "040",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "최태근",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-041-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "041",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이상옥",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-042-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "042",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김수진",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-043-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "043",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김판주",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05432-044-2000608",
    "subjectKey": "05432",
    "name": "전공실기2(관현악)",
    "division": "044",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박가경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-001-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "001",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김진택",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-002-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "002",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박은영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-003-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "003",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권오민",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-004-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "004",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이지훈",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-005-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "005",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이지연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-006-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "006",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정태진",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-007-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "007",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "허원경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-008-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "008",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김영윤",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-009-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "009",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "전우정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-010-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "010",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤현임",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-011-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "011",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤현임",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-012-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "012",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤현임",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-013-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "013",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이선영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-014-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "014",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤현임",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-015-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "015",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이상옥",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-016-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "016",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "임재민",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-017-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "017",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이지훈",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05434-018-2000608",
    "subjectKey": "05434",
    "name": "전공실기4(관현악)",
    "division": "018",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤현임",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-001-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "001",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정태진",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-002-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "002",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "임재민",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-003-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "003",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "나혜수",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-004-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "004",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박보형",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-005-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "005",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "한기원",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-006-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "006",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "최태근",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-007-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "007",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김영윤",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-008-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "008",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "임재민",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-009-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "009",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이지훈",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-010-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "010",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "전우정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-011-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "011",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김소연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-012-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "012",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박보형",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-013-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "013",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김소연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-014-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "014",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "홍보경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-015-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "015",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이지훈",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-016-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "016",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박가경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-017-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "017",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박가경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-018-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "018",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정태진",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-019-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "019",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박가경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-020-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "020",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "유영주",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-021-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "021",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤현임",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-022-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "022",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박가경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-023-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "023",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김수진",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-024-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "024",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤현임",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-025-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "025",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김은경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-026-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "026",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박가경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-027-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "027",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김수진",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-028-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "028",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김수진",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-029-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "029",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "나혜수",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-030-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "030",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김지희",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-031-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "031",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이지은",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05436-032-2000608",
    "subjectKey": "05436",
    "name": "전공실기6(관현악)",
    "division": "032",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이도은",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-001-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "001",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김나연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-002-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "002",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "임재민",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-003-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "003",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "송나예",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-004-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "004",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김은경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-005-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "005",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "최태근",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-006-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "006",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김영윤",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-007-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "007",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권오민",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-008-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "008",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박은영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-009-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "009",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "최태근",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-010-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "010",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "송나예",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-011-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "011",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이선영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-012-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "012",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박은영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-013-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "013",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김은경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-014-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "014",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "허원경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-015-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "015",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "임재민",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-016-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "016",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김정연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-017-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "017",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김소연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-018-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "018",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤현임",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-019-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "019",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이지은",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-020-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "020",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김나연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-021-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "021",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이지훈",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-022-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "022",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권오민",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-023-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "023",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "홍보경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-024-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "024",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤현임",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-025-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "025",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "홍보경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-026-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "026",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박은영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-027-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "027",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이지연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-028-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "028",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "나혜수",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-029-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "029",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "허원경",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-030-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "030",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김소연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-031-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "031",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김수진",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05438-032-2000277",
    "subjectKey": "05438",
    "name": "전공실기8(관현악)",
    "division": "032",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박보형",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-001-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "001",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "홍주희",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-002-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "002",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "홍주희",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-003-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "003",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "홍주희",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-004-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "004",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "홍주희",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-005-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "005",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김유선",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-006-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "006",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "류지연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-007-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "007",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "심은용",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-008-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "008",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김휘곤",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-009-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "009",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "유현수",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-010-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "010",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박혜진",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-011-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "011",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "남상일",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-012-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "012",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "강경아",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-013-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "013",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "전은령",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-014-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "014",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "채수현",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-015-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "015",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "채수현",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-016-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "016",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "민수민",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-017-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "017",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "민수민",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05441-018-2000609",
    "subjectKey": "05441",
    "name": "전공실기2(국악)",
    "division": "018",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "최문실",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05443-001-2000609",
    "subjectKey": "05443",
    "name": "전공실기4(국악)",
    "division": "001",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "홍주희",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05443-002-2000609",
    "subjectKey": "05443",
    "name": "전공실기4(국악)",
    "division": "002",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정난희",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05443-004-2000609",
    "subjectKey": "05443",
    "name": "전공실기4(국악)",
    "division": "004",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이용원",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05443-005-2000609",
    "subjectKey": "05443",
    "name": "전공실기4(국악)",
    "division": "005",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이용원",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05443-006-2000609",
    "subjectKey": "05443",
    "name": "전공실기4(국악)",
    "division": "006",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박혜진",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05443-007-2000609",
    "subjectKey": "05443",
    "name": "전공실기4(국악)",
    "division": "007",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박혜진",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05443-008-2000609",
    "subjectKey": "05443",
    "name": "전공실기4(국악)",
    "division": "008",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "채수현",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05443-009-2000609",
    "subjectKey": "05443",
    "name": "전공실기4(국악)",
    "division": "009",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "채수현",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05443-010-2000609",
    "subjectKey": "05443",
    "name": "전공실기4(국악)",
    "division": "010",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이선",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05443-011-2000609",
    "subjectKey": "05443",
    "name": "전공실기4(국악)",
    "division": "011",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "강경아",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05445-001-2000609",
    "subjectKey": "05445",
    "name": "전공실기6(국악)",
    "division": "001",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김종미",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05445-002-2000609",
    "subjectKey": "05445",
    "name": "전공실기6(국악)",
    "division": "002",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권새별",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05447-001-2000267",
    "subjectKey": "05447",
    "name": "전공실기8(국악)",
    "division": "001",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김유선",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05447-002-2000267",
    "subjectKey": "05447",
    "name": "전공실기8(국악)",
    "division": "002",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김유선",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05447-003-2000267",
    "subjectKey": "05447",
    "name": "전공실기8(국악)",
    "division": "003",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "류지연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05447-004-2000267",
    "subjectKey": "05447",
    "name": "전공실기8(국악)",
    "division": "004",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박혜진",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05447-005-2000267",
    "subjectKey": "05447",
    "name": "전공실기8(국악)",
    "division": "005",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박혜진",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05447-006-2000267",
    "subjectKey": "05447",
    "name": "전공실기8(국악)",
    "division": "006",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권새별",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05447-007-2000267",
    "subjectKey": "05447",
    "name": "전공실기8(국악)",
    "division": "007",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "전은령",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05447-008-2000267",
    "subjectKey": "05447",
    "name": "전공실기8(국악)",
    "division": "008",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "천혜인",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05447-009-2000267",
    "subjectKey": "05447",
    "name": "전공실기8(국악)",
    "division": "009",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "천혜인",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05447-010-2000267",
    "subjectKey": "05447",
    "name": "전공실기8(국악)",
    "division": "010",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이선",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05447-011-2000267",
    "subjectKey": "05447",
    "name": "전공실기8(국악)",
    "division": "011",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "최문실",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05449-001-2000606",
    "subjectKey": "05449",
    "name": "전공실기2(성악)",
    "division": "001",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤이나",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05449-002-2000606",
    "subjectKey": "05449",
    "name": "전공실기2(성악)",
    "division": "002",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05449-003-2000606",
    "subjectKey": "05449",
    "name": "전공실기2(성악)",
    "division": "003",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05449-004-2000606",
    "subjectKey": "05449",
    "name": "전공실기2(성악)",
    "division": "004",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "모질레베츠",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05449-005-2000606",
    "subjectKey": "05449",
    "name": "전공실기2(성악)",
    "division": "005",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "모질레베츠",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05449-006-2000606",
    "subjectKey": "05449",
    "name": "전공실기2(성악)",
    "division": "006",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "타티아나",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05449-007-2000606",
    "subjectKey": "05449",
    "name": "전공실기2(성악)",
    "division": "007",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "국윤종",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05449-008-2000606",
    "subjectKey": "05449",
    "name": "전공실기2(성악)",
    "division": "008",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이명국",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05449-009-2000606",
    "subjectKey": "05449",
    "name": "전공실기2(성악)",
    "division": "009",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이명국",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05449-010-2000606",
    "subjectKey": "05449",
    "name": "전공실기2(성악)",
    "division": "010",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박준석",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05449-011-2000606",
    "subjectKey": "05449",
    "name": "전공실기2(성악)",
    "division": "011",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이호철",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05449-012-2000606",
    "subjectKey": "05449",
    "name": "전공실기2(성악)",
    "division": "012",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이호철",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05449-013-2000606",
    "subjectKey": "05449",
    "name": "전공실기2(성악)",
    "division": "013",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이호철",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05449-014-2000606",
    "subjectKey": "05449",
    "name": "전공실기2(성악)",
    "division": "014",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이호철",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05449-015-2000606",
    "subjectKey": "05449",
    "name": "전공실기2(성악)",
    "division": "015",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이명국",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05451-001-2000606",
    "subjectKey": "05451",
    "name": "전공실기4(성악)",
    "division": "001",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05451-002-2000606",
    "subjectKey": "05451",
    "name": "전공실기4(성악)",
    "division": "002",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤이나",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05451-003-2000606",
    "subjectKey": "05451",
    "name": "전공실기4(성악)",
    "division": "003",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤이나",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05451-004-2000606",
    "subjectKey": "05451",
    "name": "전공실기4(성악)",
    "division": "004",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05451-005-2000606",
    "subjectKey": "05451",
    "name": "전공실기4(성악)",
    "division": "005",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05451-006-2000606",
    "subjectKey": "05451",
    "name": "전공실기4(성악)",
    "division": "006",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "국윤종",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05451-007-2000606",
    "subjectKey": "05451",
    "name": "전공실기4(성악)",
    "division": "007",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이명국",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05451-008-2000606",
    "subjectKey": "05451",
    "name": "전공실기4(성악)",
    "division": "008",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박준석",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05451-009-2000606",
    "subjectKey": "05451",
    "name": "전공실기4(성악)",
    "division": "009",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이정명",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05451-010-2000606",
    "subjectKey": "05451",
    "name": "전공실기4(성악)",
    "division": "010",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김민지",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05451-011-2000606",
    "subjectKey": "05451",
    "name": "전공실기4(성악)",
    "division": "011",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김민지",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05452-001-2000265",
    "subjectKey": "05452",
    "name": "전공실기5(성악)",
    "division": "001",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "모질레베츠",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-001-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "001",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-002-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "002",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-003-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "003",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤이나",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-004-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "004",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-005-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "005",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-006-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "006",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-007-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "007",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-008-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "008",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "모질레베츠",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-009-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "009",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "모질레베츠",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-010-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "010",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "타티아나",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-011-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "011",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "타티아나",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-012-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "012",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "타티아나",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-013-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "013",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "타티아나",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-014-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "014",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이호철",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-015-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "015",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "배애령",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-016-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "016",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "국윤종",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-017-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "017",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이명국",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-018-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "018",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박준석",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-019-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "019",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박준석",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-020-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "020",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤지현",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-021-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "021",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤지현",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-022-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "022",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "허종훈",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-023-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "023",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이승희",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-024-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "024",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "윤아르나",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05453-025-2000606",
    "subjectKey": "05453",
    "name": "전공실기6(성악)",
    "division": "025",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김민지",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05455-001-2000265",
    "subjectKey": "05455",
    "name": "전공실기8(성악)",
    "division": "001",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05455-002-2000265",
    "subjectKey": "05455",
    "name": "전공실기8(성악)",
    "division": "002",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05455-003-2000265",
    "subjectKey": "05455",
    "name": "전공실기8(성악)",
    "division": "003",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05455-004-2000265",
    "subjectKey": "05455",
    "name": "전공실기8(성악)",
    "division": "004",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05455-005-2000265",
    "subjectKey": "05455",
    "name": "전공실기8(성악)",
    "division": "005",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05455-006-2000265",
    "subjectKey": "05455",
    "name": "전공실기8(성악)",
    "division": "006",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05455-007-2000265",
    "subjectKey": "05455",
    "name": "전공실기8(성악)",
    "division": "007",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05455-008-2000265",
    "subjectKey": "05455",
    "name": "전공실기8(성악)",
    "division": "008",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "국윤종",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05455-009-2000265",
    "subjectKey": "05455",
    "name": "전공실기8(성악)",
    "division": "009",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "추주현",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05455-010-2000265",
    "subjectKey": "05455",
    "name": "전공실기8(성악)",
    "division": "010",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박준석",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05455-011-2000265",
    "subjectKey": "05455",
    "name": "전공실기8(성악)",
    "division": "011",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "허종훈",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-001-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "001",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공원영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-002-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "002",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공원영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-003-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "003",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "알렉산더",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-004-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "004",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "알렉산더",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-005-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "005",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "히로타슌지",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-006-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "006",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김문정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-007-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "007",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김문정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-008-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "008",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김문정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-009-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "009",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정영하",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-010-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "010",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "성지연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-011-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "011",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "성지연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-012-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "012",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "소현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-013-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "013",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "제보람",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-014-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "014",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "제보람",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-015-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "015",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "주진서",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-016-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "016",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김소영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-017-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "017",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김인영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-018-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "018",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "한지현",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-019-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "019",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김예인",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-020-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "020",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공은지",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05467-021-2000607",
    "subjectKey": "05467",
    "name": "전공실기2(피아노)",
    "division": "021",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "방지윤",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-001-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "001",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공원영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-002-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "002",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공원영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-003-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "003",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공원영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-004-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "004",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공원영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-005-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "005",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공원영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-006-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "006",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "알렉산더",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-007-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "007",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "알렉산더",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-008-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "008",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "알렉산더",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-009-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "009",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "알렉산더",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-010-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "010",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "알렉산더",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-011-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "011",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "히로타슌지",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-012-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "012",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이성주",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-013-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "013",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이성주",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-014-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "014",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이성주",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-015-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "015",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "천세정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-016-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "016",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "천세정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-017-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "017",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정영하",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-018-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "018",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정영하",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-019-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "019",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정영하",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-020-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "020",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이소은",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-021-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "021",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이소은",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-022-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "022",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이소은",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-023-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "023",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "성지연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-024-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "024",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "소현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-025-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "025",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "소현정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-026-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "026",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "신민정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-027-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "027",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김소영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-028-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "028",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김인영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-029-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "029",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김인영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-030-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "030",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김인영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-031-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "031",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "한지현",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-032-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "032",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "한지현",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05469-033-2000607",
    "subjectKey": "05469",
    "name": "전공실기4(피아노)",
    "division": "033",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김예인",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-001-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "001",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공원영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-002-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "002",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공원영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-003-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "003",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "알렉산더",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-004-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "004",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "히로타슌지",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-005-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "005",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "히로타슌지",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-006-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "006",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "히로타슌지",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-007-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "007",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "히로타슌지",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-008-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "008",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "히로타슌지",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-009-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "009",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이성주",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-010-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "010",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이성주",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-011-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "011",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이성주",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-012-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "012",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "천세정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-013-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "013",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "천세정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-014-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "014",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "천세정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-015-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "015",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김문정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-016-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "016",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김문정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-017-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "017",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김문정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-018-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "018",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김민정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-019-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "019",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김민정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-020-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "020",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "안소희",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-021-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "021",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "안소희",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-022-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "022",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권경희",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-023-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "023",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "주진서",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-024-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "024",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "신민정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-025-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "025",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김보람",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-026-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "026",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김인영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05471-027-2000607",
    "subjectKey": "05471",
    "name": "전공실기6(피아노)",
    "division": "027",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공은지",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-001-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "001",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공원영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-002-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "002",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공원영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-003-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "003",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공원영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-004-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "004",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공원영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-005-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "005",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공원영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-006-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "006",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공원영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-007-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "007",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "알렉산더",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-008-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "008",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "알렉산더",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-009-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "009",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "알렉산더",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-010-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "010",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "알렉산더",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-011-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "011",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "히로타슌지",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-012-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "012",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "히로타슌지",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-013-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "013",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이성주",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-014-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "014",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이성주",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-015-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "015",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이성주",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-016-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "016",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "천세정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-017-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "017",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "천세정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-018-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "018",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "천세정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-019-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "019",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "천세정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-020-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "020",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김문정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-021-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "021",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김문정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-022-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "022",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정영하",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-023-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "023",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이소은",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-024-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "024",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이소은",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-025-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "025",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이소은",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-026-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "026",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "성지연",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-027-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "027",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김민정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-028-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "028",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "안소희",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-029-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "029",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권경희",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-030-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "030",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권경희",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-031-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "031",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "제보람",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-032-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "032",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "제보람",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-033-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "033",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "신민정",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-034-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "034",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김보람",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-035-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "035",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김소영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-036-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "036",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김소영",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05473-037-2000276",
    "subjectKey": "05473",
    "name": "전공실기8(피아노)",
    "division": "037",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "공은지",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05484-001-2000605",
    "subjectKey": "05484",
    "name": "전공실기2",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권지원",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05484-002-2000605",
    "subjectKey": "05484",
    "name": "전공실기2",
    "division": "002",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정진호",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05484-003-2000605",
    "subjectKey": "05484",
    "name": "전공실기2",
    "division": "003",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정진호",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05484-004-2000605",
    "subjectKey": "05484",
    "name": "전공실기2",
    "division": "004",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박영란",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05484-005-2000605",
    "subjectKey": "05484",
    "name": "전공실기2",
    "division": "005",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박영란",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05484-006-2000605",
    "subjectKey": "05484",
    "name": "전공실기2",
    "division": "006",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박영란",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05484-007-2000605",
    "subjectKey": "05484",
    "name": "전공실기2",
    "division": "007",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이율구",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05484-008-2000605",
    "subjectKey": "05484",
    "name": "전공실기2",
    "division": "008",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이율구",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05484-009-2000605",
    "subjectKey": "05484",
    "name": "전공실기2",
    "division": "009",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "변현주",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05484-010-2000605",
    "subjectKey": "05484",
    "name": "전공실기2",
    "division": "010",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "유영우",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05484-011-2000605",
    "subjectKey": "05484",
    "name": "전공실기2",
    "division": "011",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "유진선",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05484-012-2000605",
    "subjectKey": "05484",
    "name": "전공실기2",
    "division": "012",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이아름",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05484-013-2000605",
    "subjectKey": "05484",
    "name": "전공실기2",
    "division": "013",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이의진",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05484-014-2000605",
    "subjectKey": "05484",
    "name": "전공실기2",
    "division": "014",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정영빈",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05484-015-2000605",
    "subjectKey": "05484",
    "name": "전공실기2",
    "division": "015",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권지원",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05487-001-2000605",
    "subjectKey": "05487",
    "name": "전공실기4",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권지원",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05487-002-2000605",
    "subjectKey": "05487",
    "name": "전공실기4",
    "division": "002",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권지원",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05487-003-2000605",
    "subjectKey": "05487",
    "name": "전공실기4",
    "division": "003",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권지원",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05487-005-2000605",
    "subjectKey": "05487",
    "name": "전공실기4",
    "division": "005",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정진호",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05487-006-2000605",
    "subjectKey": "05487",
    "name": "전공실기4",
    "division": "006",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정진호",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05487-007-2000605",
    "subjectKey": "05487",
    "name": "전공실기4",
    "division": "007",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박영란",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05487-008-2000605",
    "subjectKey": "05487",
    "name": "전공실기4",
    "division": "008",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박영란",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05487-009-2000605",
    "subjectKey": "05487",
    "name": "전공실기4",
    "division": "009",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박영란",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05487-010-2000605",
    "subjectKey": "05487",
    "name": "전공실기4",
    "division": "010",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김명종",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05487-011-2000605",
    "subjectKey": "05487",
    "name": "전공실기4",
    "division": "011",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "유진선",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05487-012-2000605",
    "subjectKey": "05487",
    "name": "전공실기4",
    "division": "012",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "탁현욱",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05489-001-2000605",
    "subjectKey": "05489",
    "name": "전공실기6",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권지원",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05489-002-2000605",
    "subjectKey": "05489",
    "name": "전공실기6",
    "division": "002",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권지원",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05489-003-2000605",
    "subjectKey": "05489",
    "name": "전공실기6",
    "division": "003",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정진호",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05489-004-2000605",
    "subjectKey": "05489",
    "name": "전공실기6",
    "division": "004",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정진호",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05489-005-2000605",
    "subjectKey": "05489",
    "name": "전공실기6",
    "division": "005",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정진호",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05489-006-2000605",
    "subjectKey": "05489",
    "name": "전공실기6",
    "division": "006",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정진호",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05489-007-2000605",
    "subjectKey": "05489",
    "name": "전공실기6",
    "division": "007",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박영란",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05489-008-2000605",
    "subjectKey": "05489",
    "name": "전공실기6",
    "division": "008",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박영란",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05489-009-2000605",
    "subjectKey": "05489",
    "name": "전공실기6",
    "division": "009",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김명종",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05489-010-2000605",
    "subjectKey": "05489",
    "name": "전공실기6",
    "division": "010",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "강민창",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05489-011-2000605",
    "subjectKey": "05489",
    "name": "전공실기6",
    "division": "011",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "유영우",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05489-012-2000605",
    "subjectKey": "05489",
    "name": "전공실기6",
    "division": "012",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이아름",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05491-001-2000264",
    "subjectKey": "05491",
    "name": "전공실기8",
    "division": "001",
    "department": "작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정진호",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05491-002-2000264",
    "subjectKey": "05491",
    "name": "전공실기8",
    "division": "002",
    "department": "작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정진호",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05491-003-2000264",
    "subjectKey": "05491",
    "name": "전공실기8",
    "division": "003",
    "department": "작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박영란",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05491-004-2000264",
    "subjectKey": "05491",
    "name": "전공실기8",
    "division": "004",
    "department": "작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박영란",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05491-005-2000264",
    "subjectKey": "05491",
    "name": "전공실기8",
    "division": "005",
    "department": "작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박영란",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05491-006-2000264",
    "subjectKey": "05491",
    "name": "전공실기8",
    "division": "006",
    "department": "작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "조한나",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05491-007-2000264",
    "subjectKey": "05491",
    "name": "전공실기8",
    "division": "007",
    "department": "작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이의진",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05491-008-2000264",
    "subjectKey": "05491",
    "name": "전공실기8",
    "division": "008",
    "department": "작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "정혜윤",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "05514-001-2000180",
    "subjectKey": "05514",
    "name": "전기공학특수과제",
    "division": "001",
    "department": "전기공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "유민권",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합508",
    "isOnline": false,
    "source": {
      "schedule": "종합508(화1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합508"
      }
    ],
    "sourceSchedule": "종합508(화1,2,3)"
  },
  {
    "id": "05517-001-2000640",
    "subjectKey": "05517",
    "name": "전기기기",
    "division": "001",
    "department": "전기공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "배진용",
    "days": [
      "화",
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "종합307",
    "isOnline": false,
    "source": {
      "schedule": "종합307(화3),종합506(월2,3)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3
        ],
        "classroom": "종합307"
      },
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "종합506"
      }
    ],
    "sourceSchedule": "종합307(화3),종합506(월2,3)"
  },
  {
    "id": "05562-001-2000640",
    "subjectKey": "05562",
    "name": "전력공학",
    "division": "001",
    "department": "전기공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "송병두",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "종합502",
    "isOnline": false,
    "source": {
      "schedule": "종합502(목6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "종합502"
      }
    ],
    "sourceSchedule": "종합502(목6,7,8)"
  },
  {
    "id": "05601-001-2000627",
    "subjectKey": "05601",
    "name": "전산회계",
    "division": "001",
    "department": "회계",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조태진",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경401",
    "isOnline": false,
    "source": {
      "schedule": "글경401(수1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경401"
      }
    ],
    "sourceSchedule": "글경401(수1,2,3)"
  },
  {
    "id": "05601-002-2000627",
    "subjectKey": "05601",
    "name": "전산회계",
    "division": "002",
    "department": "회계",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조태진",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경407",
    "isOnline": false,
    "source": {
      "schedule": "글경407(목1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경407"
      }
    ],
    "sourceSchedule": "글경407(목1,2,3)"
  },
  {
    "id": "05634-001-2000592",
    "subjectKey": "05634",
    "name": "전자기학2",
    "division": "001",
    "department": "반도체공학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정석환",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합302",
    "isOnline": false,
    "source": {
      "schedule": "종합302(수5,6),종합412(목1)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "종합302"
      },
      {
        "day": "목",
        "periods": [
          1
        ],
        "classroom": "종합412"
      }
    ],
    "sourceSchedule": "종합302(수5,6),종합412(목1)"
  },
  {
    "id": "05634-003-2000593",
    "subjectKey": "05634",
    "name": "전자기학2",
    "division": "003",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김용준",
    "days": [
      "월",
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "종합502",
    "isOnline": false,
    "source": {
      "schedule": "종합502(월2 금6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2
        ],
        "classroom": "종합502"
      },
      {
        "day": "금",
        "periods": [
          6,
          7
        ],
        "classroom": "종합502"
      }
    ],
    "sourceSchedule": "종합502(월2 금6,7)"
  },
  {
    "id": "05634-004-2000593",
    "subjectKey": "05634",
    "name": "전자기학2",
    "division": "004",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박현호",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합502",
    "isOnline": false,
    "source": {
      "schedule": "종합502(화5,6,7)"
    },
    "capacity": 32,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합502"
      }
    ],
    "sourceSchedule": "종합502(화5,6,7)"
  },
  {
    "id": "05634-005-2000593",
    "subjectKey": "05634",
    "name": "전자기학2",
    "division": "005",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "길상근",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합406",
    "isOnline": false,
    "source": {
      "schedule": "종합406(화5,6,7)"
    },
    "capacity": 32,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합406"
      }
    ],
    "sourceSchedule": "종합406(화5,6,7)"
  },
  {
    "id": "05660-001-2000420",
    "subjectKey": "05660",
    "name": "전자세라믹스소자및실험",
    "division": "001",
    "department": "전자재료공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이강준",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "첨단610",
    "isOnline": false,
    "source": {
      "schedule": "첨단610(화5,6,7,8)"
    },
    "capacity": 13,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "첨단610"
      }
    ],
    "sourceSchedule": "첨단610(화5,6,7,8)"
  },
  {
    "id": "05679-001-2000592",
    "subjectKey": "05679",
    "name": "전자재료분석",
    "division": "001",
    "department": "반도체공학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "강동헌",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합608",
    "isOnline": false,
    "source": {
      "schedule": "종합608(월1,2,3)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합608"
      }
    ],
    "sourceSchedule": "종합608(월1,2,3)"
  },
  {
    "id": "05679-002-2000592",
    "subjectKey": "05679",
    "name": "전자재료분석",
    "division": "002",
    "department": "반도체공학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "강동헌",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합412",
    "isOnline": false,
    "source": {
      "schedule": "종합412(화1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합412"
      }
    ],
    "sourceSchedule": "종합412(화1,2,3)"
  },
  {
    "id": "05751-001-2000658",
    "subjectKey": "05751",
    "name": "전통예술의이해",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "안효정",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B103",
    "isOnline": false,
    "source": {
      "schedule": "미래B103(월1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B103"
      }
    ],
    "sourceSchedule": "미래B103(월1,2,3)"
  },
  {
    "id": "05773-001-2000401",
    "subjectKey": "05773",
    "name": "정보사회론(AI기반 미디어데이터분석)",
    "division": "001",
    "department": "미디어커뮤니케이션학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "장경은",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "미래101",
    "isOnline": false,
    "source": {
      "schedule": "미래101(수5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "미래101"
      }
    ],
    "sourceSchedule": "미래101(수5,6,7)"
  },
  {
    "id": "05773-002-2000401",
    "subjectKey": "05773",
    "name": "정보사회론(AI기반 미디어데이터분석)",
    "division": "002",
    "department": "미디어커뮤니케이션학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "장경은",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "미래101",
    "isOnline": false,
    "source": {
      "schedule": "미래101(금3,4,5)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "미래101"
      }
    ],
    "sourceSchedule": "미래101(금3,4,5)"
  },
  {
    "id": "05778-001-2000644",
    "subjectKey": "05778",
    "name": "정보처리기술",
    "division": "001",
    "department": "컴퓨터SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김장영",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "IT310",
    "isOnline": false,
    "source": {
      "schedule": "IT310(목1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "IT310"
      }
    ],
    "sourceSchedule": "IT310(목1,2,3)"
  },
  {
    "id": "05778-002-2000644",
    "subjectKey": "05778",
    "name": "정보처리기술",
    "division": "002",
    "department": "컴퓨터SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김장영",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "IT310",
    "isOnline": false,
    "source": {
      "schedule": "IT310(목5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "IT310"
      }
    ],
    "sourceSchedule": "IT310(목5,6,7)"
  },
  {
    "id": "05790-001-2000623",
    "subjectKey": "05790",
    "name": "정보체계론",
    "division": "001",
    "department": "행정학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "장다흰",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문409",
    "isOnline": false,
    "source": {
      "schedule": "인문409(목2,3,4)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문409"
      }
    ],
    "sourceSchedule": "인문409(목2,3,4)"
  },
  {
    "id": "05810-001-2000431",
    "subjectKey": "05810",
    "name": "정신건강론",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김정은",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "생활502",
    "isOnline": false,
    "source": {
      "schedule": "생활502(수4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "생활502"
      }
    ],
    "sourceSchedule": "생활502(수4,5,6)"
  },
  {
    "id": "05916-001-2000640",
    "subjectKey": "05916",
    "name": "제어시스템설계",
    "division": "001",
    "department": "전기공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "강정민",
    "days": [
      "목",
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합508",
    "isOnline": false,
    "source": {
      "schedule": "종합508(목2,3),미래109(화2)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3
        ],
        "classroom": "종합508"
      },
      {
        "day": "화",
        "periods": [
          2
        ],
        "classroom": "미래109"
      }
    ],
    "sourceSchedule": "종합508(목2,3),미래109(화2)"
  },
  {
    "id": "05917-001-2000639",
    "subjectKey": "05917",
    "name": "제조공학",
    "division": "001",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이상엽",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "종합405",
    "isOnline": false,
    "source": {
      "schedule": "종합405(월6,7),종합503(수8)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "종합405"
      },
      {
        "day": "수",
        "periods": [
          8
        ],
        "classroom": "종합503"
      }
    ],
    "sourceSchedule": "종합405(월6,7),종합503(수8)"
  },
  {
    "id": "05946-001-2000601",
    "subjectKey": "05946",
    "name": "조리원리및실험2",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최은정",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "생활401",
    "isOnline": false,
    "source": {
      "schedule": "생활401(월2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "생활401"
      }
    ],
    "sourceSchedule": "생활401(월2,3,4)"
  },
  {
    "id": "05996-001-2000603",
    "subjectKey": "05996",
    "name": "조형연구2",
    "division": "001",
    "department": "조형예술학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "소미정",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "조형407",
    "isOnline": false,
    "source": {
      "schedule": "조형407(금6,7,8,9)"
    },
    "capacity": 13,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "조형407"
      }
    ],
    "sourceSchedule": "조형407(금6,7,8,9)"
  },
  {
    "id": "05996-002-2000603",
    "subjectKey": "05996",
    "name": "조형연구2",
    "division": "002",
    "department": "조형예술학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "신주혜",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "조형407",
    "isOnline": false,
    "source": {
      "schedule": "조형407(목6,7,8,9)"
    },
    "capacity": 14,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "조형407"
      }
    ],
    "sourceSchedule": "조형407(목6,7,8,9)"
  },
  {
    "id": "05996-003-2000603",
    "subjectKey": "05996",
    "name": "조형연구2",
    "division": "003",
    "department": "조형예술학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "심유미",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "조형407",
    "isOnline": false,
    "source": {
      "schedule": "조형407(금1,2,3,4)"
    },
    "capacity": 14,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "조형407"
      }
    ],
    "sourceSchedule": "조형407(금1,2,3,4)"
  },
  {
    "id": "05996-005-2000603",
    "subjectKey": "05996",
    "name": "조형연구2",
    "division": "005",
    "department": "조형예술학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김성헌",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "조형208",
    "isOnline": false,
    "source": {
      "schedule": "조형208(화6,7,8,9)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "조형208"
      }
    ],
    "sourceSchedule": "조형208(화6,7,8,9)"
  },
  {
    "id": "06096-001-2000621",
    "subjectKey": "06096",
    "name": "중국어문법",
    "division": "001",
    "department": "중어중문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최영",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "인문401",
    "isOnline": false,
    "source": {
      "schedule": "인문401(월3,4,5)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "인문401"
      }
    ],
    "sourceSchedule": "인문401(월3,4,5)"
  },
  {
    "id": "06102-001-2000297",
    "subjectKey": "06102",
    "name": "중국어학개론(학점교류)",
    "division": "001",
    "department": "중어중문학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "06115-001-2000742",
    "subjectKey": "06115",
    "name": "중국현대문학의이해",
    "division": "001",
    "department": "중국언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고건혜",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "종합504",
    "isOnline": false,
    "source": {
      "schedule": "종합504(수3,4,5)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "종합504"
      }
    ],
    "sourceSchedule": "종합504(수3,4,5)"
  },
  {
    "id": "06144-001-2000620",
    "subjectKey": "06144",
    "name": "중급일어강독2",
    "division": "001",
    "department": "일어일문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이성근",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "글경414",
    "isOnline": false,
    "source": {
      "schedule": "글경414(화2,3 목6)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "글경414"
      },
      {
        "day": "목",
        "periods": [
          6
        ],
        "classroom": "글경414"
      }
    ],
    "sourceSchedule": "글경414(화2,3 목6)"
  },
  {
    "id": "06169-001-2000627",
    "subjectKey": "06169",
    "name": "중급회계1",
    "division": "001",
    "department": "회계",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "권성수",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경601",
    "isOnline": false,
    "source": {
      "schedule": "글경601(금1,2,3)"
    },
    "capacity": 90,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경601"
      }
    ],
    "sourceSchedule": "글경601(금1,2,3)"
  },
  {
    "id": "06175-001-2000626",
    "subjectKey": "06175",
    "name": "증권시장론",
    "division": "001",
    "department": "경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "임경",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경B102",
    "isOnline": false,
    "source": {
      "schedule": "글경B102(수1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경B102"
      }
    ],
    "sourceSchedule": "글경B102(수1,2,3)"
  },
  {
    "id": "06190-001-2000599",
    "subjectKey": "06190",
    "name": "지역사회복지론",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최보라",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문101",
    "isOnline": false,
    "source": {
      "schedule": "인문101(화7,8,9)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문101"
      }
    ],
    "sourceSchedule": "인문101(화7,8,9)"
  },
  {
    "id": "06191-001-2000601",
    "subjectKey": "06191",
    "name": "지역사회영양학",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박경애",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "생활305",
    "isOnline": false,
    "source": {
      "schedule": "생활305(수1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "생활305"
      }
    ],
    "sourceSchedule": "생활305(수1,2,3)"
  },
  {
    "id": "06200-001-2000264",
    "subjectKey": "06200",
    "name": "지휘법2",
    "division": "001",
    "department": "작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "최영선",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악215",
    "isOnline": false,
    "source": {
      "schedule": "음악215(화5,6)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "음악215"
      }
    ],
    "sourceSchedule": "음악215(화5,6)"
  },
  {
    "id": "06200-002-2000265",
    "subjectKey": "06200",
    "name": "지휘법2",
    "division": "002",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "최영선",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "음악215",
    "isOnline": false,
    "source": {
      "schedule": "음악215(화7,8)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "음악215"
      }
    ],
    "sourceSchedule": "음악215(화7,8)"
  },
  {
    "id": "06200-003-2000276",
    "subjectKey": "06200",
    "name": "지휘법2",
    "division": "003",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "최영선",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악215",
    "isOnline": false,
    "source": {
      "schedule": "음악215(화5,6)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "음악215"
      }
    ],
    "sourceSchedule": "음악215(화5,6)"
  },
  {
    "id": "06200-004-2000277",
    "subjectKey": "06200",
    "name": "지휘법2",
    "division": "004",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "최영선",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "음악215",
    "isOnline": false,
    "source": {
      "schedule": "음악215(화7,8)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "음악215"
      }
    ],
    "sourceSchedule": "음악215(화7,8)"
  },
  {
    "id": "06211-001-2000600",
    "subjectKey": "06211",
    "name": "직물학",
    "division": "001",
    "department": "의류학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김종범",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합410",
    "isOnline": false,
    "source": {
      "schedule": "종합410(월5,6,7)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합410"
      }
    ],
    "sourceSchedule": "종합410(월5,6,7)"
  },
  {
    "id": "06219-001-2000646",
    "subjectKey": "06219",
    "name": "집적회로",
    "division": "001",
    "department": "정보통신",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김시현",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "IT408",
    "isOnline": false,
    "source": {
      "schedule": "IT408(화5,6,7,8)"
    },
    "capacity": 24,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "IT408"
      }
    ],
    "sourceSchedule": "IT408(화5,6,7,8)"
  },
  {
    "id": "06219-002-2000420",
    "subjectKey": "06219",
    "name": "집적회로",
    "division": "002",
    "department": "전자재료공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김영환",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "종합412",
    "isOnline": false,
    "source": {
      "schedule": "종합412(수6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "종합412"
      }
    ],
    "sourceSchedule": "종합412(수6,7,8)"
  },
  {
    "id": "06256-001-2000409",
    "subjectKey": "06256",
    "name": "천연물화학",
    "division": "001",
    "department": "융합화학산업",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김준현",
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합408",
    "isOnline": false,
    "source": {
      "schedule": "종합408(월2,3 목3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "종합408"
      },
      {
        "day": "목",
        "periods": [
          3
        ],
        "classroom": "종합408"
      }
    ],
    "sourceSchedule": "종합408(월2,3 목3)"
  },
  {
    "id": "06289-001-2000634",
    "subjectKey": "06289",
    "name": "철근콘크리트및실험",
    "division": "001",
    "department": "건설환경공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이주하",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합511",
    "isOnline": false,
    "source": {
      "schedule": "종합511(화5,6 수5,6)"
    },
    "capacity": 60,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "종합511"
      },
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "종합511"
      }
    ],
    "sourceSchedule": "종합511(화5,6 수5,6)"
  },
  {
    "id": "06317-001-2000599",
    "subjectKey": "06317",
    "name": "청소년복지론",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최보라",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "IT107",
    "isOnline": false,
    "source": {
      "schedule": "IT107(화3,4,5)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "IT107"
      }
    ],
    "sourceSchedule": "IT107(화3,4,5)"
  },
  {
    "id": "06317-001-2000763",
    "subjectKey": "06317",
    "name": "청소년복지론",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최보라",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "IT107",
    "isOnline": false,
    "source": {
      "schedule": "IT107(화3,4,5)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "IT107"
      }
    ],
    "sourceSchedule": "IT107(화3,4,5)"
  },
  {
    "id": "06379-001-2000648",
    "subjectKey": "06379",
    "name": "체육측정평가",
    "division": "001",
    "department": "체육학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김정준",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "체육116",
    "isOnline": false,
    "source": {
      "schedule": "체육116(수7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "체육116"
      }
    ],
    "sourceSchedule": "체육116(수7,8,9)"
  },
  {
    "id": "06382-001-2000648",
    "subjectKey": "06382",
    "name": "체육통계",
    "division": "001",
    "department": "체육학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김호묵",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "체육117",
    "isOnline": false,
    "source": {
      "schedule": "체육117(금5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "체육117"
      }
    ],
    "sourceSchedule": "체육117(금5,6,7)"
  },
  {
    "id": "06391-001-2000435",
    "subjectKey": "06391",
    "name": "체육학연구법",
    "division": "001",
    "department": "체육학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김호묵",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "체육117",
    "isOnline": false,
    "source": {
      "schedule": "체육117(금1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "체육117"
      }
    ],
    "sourceSchedule": "체육117(금1,2,3)"
  },
  {
    "id": "06395-001-2000602",
    "subjectKey": "06395",
    "name": "체조1(학부A반)",
    "division": "001",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "정하린",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "체육201",
    "isOnline": false,
    "source": {
      "schedule": "체육201(목3,4)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "체육201"
      }
    ],
    "sourceSchedule": "체육201(목3,4)"
  },
  {
    "id": "06395-002-2000602",
    "subjectKey": "06395",
    "name": "체조1(학부B반)",
    "division": "002",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "정하린",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "체육201",
    "isOnline": false,
    "source": {
      "schedule": "체육201(목1,2)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2
        ],
        "classroom": "체육201"
      }
    ],
    "sourceSchedule": "체육201(목1,2)"
  },
  {
    "id": "06395-003-2000602",
    "subjectKey": "06395",
    "name": "체조1(학부C반)",
    "division": "003",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "정하린",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육201",
    "isOnline": false,
    "source": {
      "schedule": "체육201(목5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "체육201"
      }
    ],
    "sourceSchedule": "체육201(목5,6)"
  },
  {
    "id": "06437-001-2000741",
    "subjectKey": "06437",
    "name": "초급일어회화2",
    "division": "001",
    "department": "일본언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "미도리",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합509",
    "isOnline": false,
    "source": {
      "schedule": "종합509(월5,6,7)"
    },
    "capacity": 15,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합509"
      }
    ],
    "sourceSchedule": "종합509(월5,6,7)"
  },
  {
    "id": "06474-001-2000648",
    "subjectKey": "06474",
    "name": "축구2",
    "division": "001",
    "department": "체육학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "곽태원",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "체육112",
    "isOnline": false,
    "source": {
      "schedule": "체육112(목3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "체육112"
      }
    ],
    "sourceSchedule": "체육112(목3,4)"
  },
  {
    "id": "06532-001-2000514",
    "subjectKey": "06532",
    "name": "컴퓨터과학특강",
    "division": "001",
    "department": "컴퓨터SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김장영",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "IT310",
    "isOnline": false,
    "source": {
      "schedule": "IT310(수1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "IT310"
      }
    ],
    "sourceSchedule": "IT310(수1,2,3)"
  },
  {
    "id": "06533-001-2000641",
    "subjectKey": "06533",
    "name": "컴퓨터구조",
    "division": "001",
    "department": "전자공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김우성",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합406",
    "isOnline": false,
    "source": {
      "schedule": "종합406(금1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합406"
      }
    ],
    "sourceSchedule": "종합406(금1,2,3)"
  },
  {
    "id": "06533-002-2000596",
    "subjectKey": "06533",
    "name": "컴퓨터구조",
    "division": "002",
    "department": "컴퓨터학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "장성태",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "IT415",
    "isOnline": false,
    "source": {
      "schedule": "IT415(월1,2,3)"
    },
    "capacity": 58,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "IT415"
      }
    ],
    "sourceSchedule": "IT415(월1,2,3)"
  },
  {
    "id": "06533-003-2000646",
    "subjectKey": "06533",
    "name": "컴퓨터구조",
    "division": "003",
    "department": "정보통신",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김시현",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "IT413",
    "isOnline": false,
    "source": {
      "schedule": "IT413(월2,3 수6)"
    },
    "capacity": 45,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "IT413"
      },
      {
        "day": "수",
        "periods": [
          6
        ],
        "classroom": "IT413"
      }
    ],
    "sourceSchedule": "IT413(월2,3 수6)"
  },
  {
    "id": "06533-004-2000647",
    "subjectKey": "06533",
    "name": "컴퓨터구조",
    "division": "004",
    "department": "정보보호",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김명숙",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT407",
    "isOnline": false,
    "source": {
      "schedule": "IT407(화2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT407"
      }
    ],
    "sourceSchedule": "IT407(화2,3,4)"
  },
  {
    "id": "06533-006-2000596",
    "subjectKey": "06533",
    "name": "컴퓨터구조",
    "division": "006",
    "department": "컴퓨터학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "장성태",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT415",
    "isOnline": false,
    "source": {
      "schedule": "IT415(화2,3,4)"
    },
    "capacity": 58,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT415"
      }
    ],
    "sourceSchedule": "IT415(화2,3,4)"
  },
  {
    "id": "06533-007-2000647",
    "subjectKey": "06533",
    "name": "컴퓨터구조",
    "division": "007",
    "department": "정보보호",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김명숙",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT407",
    "isOnline": false,
    "source": {
      "schedule": "IT407(화6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT407"
      }
    ],
    "sourceSchedule": "IT407(화6,7,8)"
  },
  {
    "id": "06547-001-2000759",
    "subjectKey": "06547",
    "name": "컴퓨터네트워크",
    "division": "001",
    "department": "지능형보안학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김아람",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "IT514",
    "isOnline": false,
    "source": {
      "schedule": "IT514(화1,2,3)"
    },
    "capacity": 43,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "IT514"
      }
    ],
    "sourceSchedule": "IT514(화1,2,3)"
  },
  {
    "id": "06547-001-2000763",
    "subjectKey": "06547",
    "name": "컴퓨터네트워크",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김아람",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "IT514",
    "isOnline": false,
    "source": {
      "schedule": "IT514(화1,2,3)"
    },
    "capacity": 43,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "IT514"
      }
    ],
    "sourceSchedule": "IT514(화1,2,3)"
  },
  {
    "id": "06557-001-2000638",
    "subjectKey": "06557",
    "name": "컴퓨터시뮬레이션응용",
    "division": "001",
    "department": "산업공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김국",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "자연관306",
    "isOnline": false,
    "source": {
      "schedule": "자연관306(수6,7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "자연관306"
      }
    ],
    "sourceSchedule": "자연관306(수6,7,8,9)"
  },
  {
    "id": "06601-003-2000593",
    "subjectKey": "06601",
    "name": "컴퓨터프로그래밍2",
    "division": "003",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이경희",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연관508",
    "isOnline": false,
    "source": {
      "schedule": "자연관508(화5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연관508"
      }
    ],
    "sourceSchedule": "자연관508(화5,6,7,8)"
  },
  {
    "id": "06601-003-2000763",
    "subjectKey": "06601",
    "name": "컴퓨터프로그래밍2",
    "division": "003",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이경희",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연관508",
    "isOnline": false,
    "source": {
      "schedule": "자연관508(화5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연관508"
      }
    ],
    "sourceSchedule": "자연관508(화5,6,7,8)"
  },
  {
    "id": "06601-004-2000593",
    "subjectKey": "06601",
    "name": "컴퓨터프로그래밍2",
    "division": "004",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이경희",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연관508",
    "isOnline": false,
    "source": {
      "schedule": "자연관508(금5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연관508"
      }
    ],
    "sourceSchedule": "자연관508(금5,6,7,8)"
  },
  {
    "id": "06601-004-2000763",
    "subjectKey": "06601",
    "name": "컴퓨터프로그래밍2",
    "division": "004",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이경희",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연관508",
    "isOnline": false,
    "source": {
      "schedule": "자연관508(금5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연관508"
      }
    ],
    "sourceSchedule": "자연관508(금5,6,7,8)"
  },
  {
    "id": "06601-005-2000593",
    "subjectKey": "06601",
    "name": "컴퓨터프로그래밍2",
    "division": "005",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "서종완",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "자연대503",
    "isOnline": false,
    "source": {
      "schedule": "자연대503(수1,2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "자연대503"
      }
    ],
    "sourceSchedule": "자연대503(수1,2,3,4)"
  },
  {
    "id": "06601-005-2000763",
    "subjectKey": "06601",
    "name": "컴퓨터프로그래밍2",
    "division": "005",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "서종완",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "자연대503",
    "isOnline": false,
    "source": {
      "schedule": "자연대503(수1,2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "자연대503"
      }
    ],
    "sourceSchedule": "자연대503(수1,2,3,4)"
  },
  {
    "id": "06601-006-2000593",
    "subjectKey": "06601",
    "name": "컴퓨터프로그래밍2",
    "division": "006",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이철우",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연대503",
    "isOnline": false,
    "source": {
      "schedule": "자연대503(목5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연대503"
      }
    ],
    "sourceSchedule": "자연대503(목5,6,7,8)"
  },
  {
    "id": "06601-006-2000763",
    "subjectKey": "06601",
    "name": "컴퓨터프로그래밍2",
    "division": "006",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이철우",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연대503",
    "isOnline": false,
    "source": {
      "schedule": "자연대503(목5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연대503"
      }
    ],
    "sourceSchedule": "자연대503(목5,6,7,8)"
  },
  {
    "id": "06601-007-2000593",
    "subjectKey": "06601",
    "name": "컴퓨터프로그래밍2",
    "division": "007",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이중무",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT307",
    "isOnline": false,
    "source": {
      "schedule": "IT307(월1,2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT307"
      }
    ],
    "sourceSchedule": "IT307(월1,2,3,4)"
  },
  {
    "id": "06601-007-2000763",
    "subjectKey": "06601",
    "name": "컴퓨터프로그래밍2",
    "division": "007",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이중무",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT307",
    "isOnline": false,
    "source": {
      "schedule": "IT307(월1,2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT307"
      }
    ],
    "sourceSchedule": "IT307(월1,2,3,4)"
  },
  {
    "id": "06632-001-2000605",
    "subjectKey": "06632",
    "name": "클라스피아노4",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "소현정",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "음악314",
    "isOnline": false,
    "source": {
      "schedule": "음악314(화3)"
    },
    "capacity": 10,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3
        ],
        "classroom": "음악314"
      }
    ],
    "sourceSchedule": "음악314(화3)"
  },
  {
    "id": "06644-001-2000649",
    "subjectKey": "06644",
    "name": "탁구1",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "이지선",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "체육201",
    "isOnline": false,
    "source": {
      "schedule": "체육201(수1,2)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2
        ],
        "classroom": "체육201"
      }
    ],
    "sourceSchedule": "체육201(수1,2)"
  },
  {
    "id": "06649-001-2000648",
    "subjectKey": "06649",
    "name": "태권도2",
    "division": "001",
    "department": "체육학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "허갑철",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육103",
    "isOnline": false,
    "source": {
      "schedule": "체육103(수5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "체육103"
      }
    ],
    "sourceSchedule": "체육103(수5,6)"
  },
  {
    "id": "06661-001-2000648",
    "subjectKey": "06661",
    "name": "테니스2",
    "division": "001",
    "department": "체육학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "유정인",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육113",
    "isOnline": false,
    "source": {
      "schedule": "체육113(화5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "체육113"
      }
    ],
    "sourceSchedule": "체육113(화5,6)"
  },
  {
    "id": "06676-001-2000655",
    "subjectKey": "06676",
    "name": "텍스타일디자인2",
    "division": "001",
    "department": "공예디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "심용주",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술111",
    "isOnline": false,
    "source": {
      "schedule": "미술111(금6,7,8,9)"
    },
    "capacity": 25,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술111"
      }
    ],
    "sourceSchedule": "미술111(금6,7,8,9)"
  },
  {
    "id": "06710-001-2000635",
    "subjectKey": "06710",
    "name": "토양오염",
    "division": "001",
    "department": "환경에너지공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "백승기",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "종합410",
    "isOnline": false,
    "source": {
      "schedule": "종합410(수3 목5,6)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3
        ],
        "classroom": "종합410"
      },
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "종합410"
      }
    ],
    "sourceSchedule": "종합410(수3 목5,6)"
  },
  {
    "id": "06724-001-2000634",
    "subjectKey": "06724",
    "name": "토질역학및실험2",
    "division": "001",
    "department": "건설환경공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김대현",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합411",
    "isOnline": false,
    "source": {
      "schedule": "종합411(화5,6 금3,4)"
    },
    "capacity": 26,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "종합411"
      },
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "종합411"
      }
    ],
    "sourceSchedule": "종합411(화5,6 금3,4)"
  },
  {
    "id": "06724-002-2000634",
    "subjectKey": "06724",
    "name": "토질역학및실험2",
    "division": "002",
    "department": "건설환경공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김대현",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "종합411",
    "isOnline": false,
    "source": {
      "schedule": "종합411(화7,8 금1,2)"
    },
    "capacity": 26,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "종합411"
      },
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "종합411"
      }
    ],
    "sourceSchedule": "종합411(화7,8 금1,2)"
  },
  {
    "id": "06740-001-2000589",
    "subjectKey": "06740",
    "name": "통계학",
    "division": "001",
    "department": "건설환경에너지공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이경복",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래106",
    "isOnline": false,
    "source": {
      "schedule": "미래106(수1,2,3)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래106"
      }
    ],
    "sourceSchedule": "미래106(수1,2,3)"
  },
  {
    "id": "06740-001-2000763",
    "subjectKey": "06740",
    "name": "통계학",
    "division": "001",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이경복",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래106",
    "isOnline": false,
    "source": {
      "schedule": "미래106(수1,2,3)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래106"
      }
    ],
    "sourceSchedule": "미래106(수1,2,3)"
  },
  {
    "id": "06740-002-2000589",
    "subjectKey": "06740",
    "name": "통계학",
    "division": "002",
    "department": "건설환경에너지공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이경복",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합305",
    "isOnline": false,
    "source": {
      "schedule": "종합305(금1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합305"
      }
    ],
    "sourceSchedule": "종합305(금1,2,3)"
  },
  {
    "id": "06740-002-2000763",
    "subjectKey": "06740",
    "name": "통계학",
    "division": "002",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이경복",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합305",
    "isOnline": false,
    "source": {
      "schedule": "종합305(금1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합305"
      }
    ],
    "sourceSchedule": "종합305(금1,2,3)"
  },
  {
    "id": "06740-003-2000589",
    "subjectKey": "06740",
    "name": "통계학",
    "division": "003",
    "department": "건설환경에너지공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이경복",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합305",
    "isOnline": false,
    "source": {
      "schedule": "종합305(금4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합305"
      }
    ],
    "sourceSchedule": "종합305(금4,5,6)"
  },
  {
    "id": "06740-003-2000763",
    "subjectKey": "06740",
    "name": "통계학",
    "division": "003",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이경복",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합305",
    "isOnline": false,
    "source": {
      "schedule": "종합305(금4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합305"
      }
    ],
    "sourceSchedule": "종합305(금4,5,6)"
  },
  {
    "id": "06753-001-2000641",
    "subjectKey": "06753",
    "name": "통신시스템설계",
    "division": "001",
    "department": "전자공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이창수",
    "days": [
      "화",
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "자연관408",
    "isOnline": false,
    "source": {
      "schedule": "자연관408(화3),종합302(월1,2)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3
        ],
        "classroom": "자연관408"
      },
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "종합302"
      }
    ],
    "sourceSchedule": "자연관408(화3),종합302(월1,2)"
  },
  {
    "id": "06754-001-2000646",
    "subjectKey": "06754",
    "name": "통신이론",
    "division": "001",
    "department": "정보통신",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "양윤기",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "IT407",
    "isOnline": false,
    "source": {
      "schedule": "IT407(월7 수7,8)"
    },
    "capacity": 45,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "IT407"
      },
      {
        "day": "수",
        "periods": [
          7,
          8
        ],
        "classroom": "IT407"
      }
    ],
    "sourceSchedule": "IT407(월7 수7,8)"
  },
  {
    "id": "06805-003-2000609",
    "subjectKey": "06805",
    "name": "특수악기4(가야금)",
    "division": "003",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "정난희",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "음악107",
    "isOnline": false,
    "source": {
      "schedule": "음악107(목2)"
    },
    "capacity": 10,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2
        ],
        "classroom": "음악107"
      }
    ],
    "sourceSchedule": "음악107(목2)"
  },
  {
    "id": "06805-004-2000609",
    "subjectKey": "06805",
    "name": "특수악기4(아쟁)",
    "division": "004",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "김승철",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 6,
    "room": "음악310",
    "isOnline": false,
    "source": {
      "schedule": "음악310(월6)"
    },
    "capacity": 5,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6
        ],
        "classroom": "음악310"
      }
    ],
    "sourceSchedule": "음악310(월6)"
  },
  {
    "id": "06805-005-2000609",
    "subjectKey": "06805",
    "name": "특수악기4(대풍류)",
    "division": "005",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "유현수",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "음악107",
    "isOnline": false,
    "source": {
      "schedule": "음악107(월3)"
    },
    "capacity": 5,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3
        ],
        "classroom": "음악107"
      }
    ],
    "sourceSchedule": "음악107(월3)"
  },
  {
    "id": "06845-001-2000609",
    "subjectKey": "06845",
    "name": "판소리의이해2",
    "division": "001",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "전은령",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악215",
    "isOnline": false,
    "source": {
      "schedule": "음악215(화1,2)"
    },
    "capacity": 5,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "음악215"
      }
    ],
    "sourceSchedule": "음악215(화1,2)"
  },
  {
    "id": "06868-001-2000600",
    "subjectKey": "06868",
    "name": "패션머천다이징",
    "division": "001",
    "department": "의류학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이지선",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "생활302",
    "isOnline": false,
    "source": {
      "schedule": "생활302(금2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "생활302"
      }
    ],
    "sourceSchedule": "생활302(금2,3,4)"
  },
  {
    "id": "06913-001-2000635",
    "subjectKey": "06913",
    "name": "폐기물처리공학(마이크로디그리)",
    "division": "001",
    "department": "환경에너지공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "백승기",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "종합302",
    "isOnline": false,
    "source": {
      "schedule": "종합302(화4 금2,3)"
    },
    "capacity": 70,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4
        ],
        "classroom": "종합302"
      },
      {
        "day": "금",
        "periods": [
          2,
          3
        ],
        "classroom": "종합302"
      }
    ],
    "sourceSchedule": "종합302(화4 금2,3)"
  },
  {
    "id": "06915-001-2000635",
    "subjectKey": "06915",
    "name": "폐수처리공학2",
    "division": "001",
    "department": "환경에너지공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "차규현",
    "days": [
      "목",
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "종합408",
    "isOnline": false,
    "source": {
      "schedule": "종합408(목7 금2,3)"
    },
    "capacity": 70,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7
        ],
        "classroom": "종합408"
      },
      {
        "day": "금",
        "periods": [
          2,
          3
        ],
        "classroom": "종합408"
      }
    ],
    "sourceSchedule": "종합408(목7 금2,3)"
  },
  {
    "id": "06925-001-2000255",
    "subjectKey": "06925",
    "name": "포트폴리오",
    "division": "001",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이상희",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술110",
    "isOnline": false,
    "source": {
      "schedule": "미술110(화6,7,8,9)"
    },
    "capacity": 10,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술110"
      }
    ],
    "sourceSchedule": "미술110(화6,7,8,9)"
  },
  {
    "id": "06925-002-2000255",
    "subjectKey": "06925",
    "name": "포트폴리오",
    "division": "002",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이상희",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술110",
    "isOnline": false,
    "source": {
      "schedule": "미술110(금6,7,8,9)"
    },
    "capacity": 10,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술110"
      }
    ],
    "sourceSchedule": "미술110(금6,7,8,9)"
  },
  {
    "id": "06938-001-2000651",
    "subjectKey": "06938",
    "name": "표현기법4",
    "division": "001",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김지혜",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "조형305",
    "isOnline": false,
    "source": {
      "schedule": "조형305(목1,2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "조형305"
      }
    ],
    "sourceSchedule": "조형305(목1,2,3,4)"
  },
  {
    "id": "06964-001-2000294",
    "subjectKey": "06964",
    "name": "프랑스시와예술(학점교류)",
    "division": "001",
    "department": "프랑스어문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "07027-001-2000600",
    "subjectKey": "07027",
    "name": "피복재료학(교직해당자전용)",
    "division": "001",
    "department": "의류학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김종범",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합410",
    "isOnline": false,
    "source": {
      "schedule": "종합410(월5,6,7)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합410"
      }
    ],
    "sourceSchedule": "종합410(월5,6,7)"
  },
  {
    "id": "07029-001-2000276",
    "subjectKey": "07029",
    "name": "피아노교수법2",
    "division": "001",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "문혜주",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악314",
    "isOnline": false,
    "source": {
      "schedule": "음악314(월3,4)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "음악314"
      }
    ],
    "sourceSchedule": "음악314(월3,4)"
  },
  {
    "id": "07031-001-2000607",
    "subjectKey": "07031",
    "name": "피아노문헌2",
    "division": "001",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "신민정",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(수3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(수3,4)"
  },
  {
    "id": "07034-001-2000607",
    "subjectKey": "07034",
    "name": "피아노반주법2",
    "division": "001",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김지연",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "음악315",
    "isOnline": false,
    "source": {
      "schedule": "음악315(월5,6,7)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악315"
      }
    ],
    "sourceSchedule": "음악315(월5,6,7)"
  },
  {
    "id": "07066-001-2000624",
    "subjectKey": "07066",
    "name": "한국경제사",
    "division": "001",
    "department": "경제금융",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조기준",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경502",
    "isOnline": false,
    "source": {
      "schedule": "글경502(화1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경502"
      }
    ],
    "sourceSchedule": "글경502(화1,2,3)"
  },
  {
    "id": "07068-001-2000658",
    "subjectKey": "07068",
    "name": "한국경제의이해",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이용회",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경501",
    "isOnline": false,
    "source": {
      "schedule": "글경501(목1,2,3)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경501"
      }
    ],
    "sourceSchedule": "글경501(목1,2,3)"
  },
  {
    "id": "07071-001-2000747",
    "subjectKey": "07071",
    "name": "한국고대사",
    "division": "001",
    "department": "디지털헤리티지",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "장우영",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합510",
    "isOnline": false,
    "source": {
      "schedule": "종합510(화4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합510"
      }
    ],
    "sourceSchedule": "종합510(화4,5,6)"
  },
  {
    "id": "07073-001-2000739",
    "subjectKey": "07073",
    "name": "한국고전문학의이해",
    "division": "001",
    "department": "한국언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박순",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문500",
    "isOnline": false,
    "source": {
      "schedule": "인문500(월2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문500"
      }
    ],
    "sourceSchedule": "인문500(월2,3,4)"
  },
  {
    "id": "07096-001-2000291",
    "subjectKey": "07096",
    "name": "한국독립운동사(학점교류)",
    "division": "001",
    "department": "사학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "07128-001-2000616",
    "subjectKey": "07128",
    "name": "한국문학사",
    "division": "001",
    "department": "국어국문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "송민규",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문500",
    "isOnline": false,
    "source": {
      "schedule": "인문500(금2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문500"
      }
    ],
    "sourceSchedule": "인문500(금2,3,4)"
  },
  {
    "id": "07128-002-2000616",
    "subjectKey": "07128",
    "name": "한국문학사(외국인전용)",
    "division": "002",
    "department": "국어국문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "문미종",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문400",
    "isOnline": false,
    "source": {
      "schedule": "인문400(화2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문400"
      }
    ],
    "sourceSchedule": "인문400(화2,3,4)"
  },
  {
    "id": "07156-001-2000291",
    "subjectKey": "07156",
    "name": "한국사강독(학점교류)",
    "division": "001",
    "department": "사학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "07196-001-2000602",
    "subjectKey": "07196",
    "name": "한국체육사(학부A반)",
    "division": "001",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "강동균",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B203",
    "isOnline": false,
    "source": {
      "schedule": "미래B203(수1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B203"
      }
    ],
    "sourceSchedule": "미래B203(수1,2,3)"
  },
  {
    "id": "07196-002-2000602",
    "subjectKey": "07196",
    "name": "한국체육사(학부B반)",
    "division": "002",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "강동균",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "미래B203",
    "isOnline": false,
    "source": {
      "schedule": "미래B203(화5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "미래B203"
      }
    ],
    "sourceSchedule": "미래B203(화5,6,7)"
  },
  {
    "id": "07196-003-2000602",
    "subjectKey": "07196",
    "name": "한국체육사(학부C반)",
    "division": "003",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "강동균",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "미래B203",
    "isOnline": false,
    "source": {
      "schedule": "미래B203(수5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "미래B203"
      }
    ],
    "sourceSchedule": "미래B203(수5,6,7)"
  },
  {
    "id": "07206-001-2000745",
    "subjectKey": "07206",
    "name": "한국행정론",
    "division": "001",
    "department": "행정학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김병수",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문407",
    "isOnline": false,
    "source": {
      "schedule": "인문407(수5,6,7)"
    },
    "capacity": 80,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문407"
      }
    ],
    "sourceSchedule": "인문407(수5,6,7)"
  },
  {
    "id": "07206-002-2000399",
    "subjectKey": "07206",
    "name": "한국행정론(학점교류)",
    "division": "002",
    "department": "법·행정학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "07207-001-2000290",
    "subjectKey": "07207",
    "name": "한국현대문학의이해(학점교류)",
    "division": "001",
    "department": "국어국문학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "07208-001-2000616",
    "subjectKey": "07208",
    "name": "한국현대미디어문학론",
    "division": "001",
    "department": "국어국문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김중신",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문411",
    "isOnline": false,
    "source": {
      "schedule": "인문411(화6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문411"
      }
    ],
    "sourceSchedule": "인문411(화6,7,8)"
  },
  {
    "id": "07228-001-2000600",
    "subjectKey": "07228",
    "name": "한복구성1",
    "division": "001",
    "department": "의류학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이동아",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "생활301",
    "isOnline": false,
    "source": {
      "schedule": "생활301(목1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "생활301"
      }
    ],
    "sourceSchedule": "생활301(목1,2,3)"
  },
  {
    "id": "07285-001-2000745",
    "subjectKey": "07285",
    "name": "행정법",
    "division": "001",
    "department": "행정학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조재우",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문103",
    "isOnline": false,
    "source": {
      "schedule": "인문103(월5,6,7)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문103"
      }
    ],
    "sourceSchedule": "인문103(월5,6,7)"
  },
  {
    "id": "07296-001-2000748",
    "subjectKey": "07296",
    "name": "행정법총론2",
    "division": "001",
    "department": "소방행정",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "전세혁",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문506",
    "isOnline": false,
    "source": {
      "schedule": "인문506(수2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문506"
      }
    ],
    "sourceSchedule": "인문506(수2,3,4)"
  },
  {
    "id": "07299-001-2000623",
    "subjectKey": "07299",
    "name": "행정사무관리",
    "division": "001",
    "department": "행정학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "장다흰",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문409",
    "isOnline": false,
    "source": {
      "schedule": "인문409(목6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문409"
      }
    ],
    "sourceSchedule": "인문409(목6,7,8)"
  },
  {
    "id": "07314-001-2000745",
    "subjectKey": "07314",
    "name": "행정학원론",
    "division": "001",
    "department": "행정학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김병수",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문508",
    "isOnline": false,
    "source": {
      "schedule": "인문508(수2,3,4)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문508"
      }
    ],
    "sourceSchedule": "인문508(수2,3,4)"
  },
  {
    "id": "07314-001-2000763",
    "subjectKey": "07314",
    "name": "행정학원론",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김병수",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문508",
    "isOnline": false,
    "source": {
      "schedule": "인문508(수2,3,4)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문508"
      }
    ],
    "sourceSchedule": "인문508(수2,3,4)"
  },
  {
    "id": "07427-001-2000744",
    "subjectKey": "07427",
    "name": "형법총론2",
    "division": "001",
    "department": "법학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "권지혜",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문310",
    "isOnline": false,
    "source": {
      "schedule": "인문310(수5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문310"
      }
    ],
    "sourceSchedule": "인문310(수5,6,7)"
  },
  {
    "id": "07427-002-2000744",
    "subjectKey": "07427",
    "name": "형법총론2",
    "division": "002",
    "department": "법학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "권지혜",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문409",
    "isOnline": false,
    "source": {
      "schedule": "인문409(화5,6,7)"
    },
    "capacity": 45,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문409"
      }
    ],
    "sourceSchedule": "인문409(화5,6,7)"
  },
  {
    "id": "07429-001-2000622",
    "subjectKey": "07429",
    "name": "형사소송법",
    "division": "001",
    "department": "법학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최은미",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문506",
    "isOnline": false,
    "source": {
      "schedule": "인문506(화5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문506"
      }
    ],
    "sourceSchedule": "인문506(화5,6,7)"
  },
  {
    "id": "07436-001-2000622",
    "subjectKey": "07436",
    "name": "행정법1",
    "division": "001",
    "department": "법학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "윤서영",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문409",
    "isOnline": false,
    "source": {
      "schedule": "인문409(수5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문409"
      }
    ],
    "sourceSchedule": "인문409(수5,6,7)"
  },
  {
    "id": "07456-001-2000629",
    "subjectKey": "07456",
    "name": "호텔관광마케팅(마이크로디그리)",
    "division": "001",
    "department": "호텔경영",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "마여실",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경703",
    "isOnline": false,
    "source": {
      "schedule": "글경703(목5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경703"
      }
    ],
    "sourceSchedule": "글경703(목5,6,7)"
  },
  {
    "id": "07464-001-2000587",
    "subjectKey": "07464",
    "name": "호텔관광연구조사방법론",
    "division": "001",
    "department": "호텔관광학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "허경석",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "글경401",
    "isOnline": false,
    "source": {
      "schedule": "글경401(목2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "글경401"
      }
    ],
    "sourceSchedule": "글경401(목2,3,4)"
  },
  {
    "id": "07530-001-2000605",
    "subjectKey": "07530",
    "name": "화성및건반화성4",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "이형민",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악314",
    "isOnline": false,
    "source": {
      "schedule": "음악314(수5,6)"
    },
    "capacity": 15,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "음악314"
      }
    ],
    "sourceSchedule": "음악314(수5,6)"
  },
  {
    "id": "07530-003-2000607",
    "subjectKey": "07530",
    "name": "화성및건반화성4",
    "division": "003",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "이의진",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(금1,2)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(금1,2)"
  },
  {
    "id": "07530-004-2000608",
    "subjectKey": "07530",
    "name": "화성및건반화성4",
    "division": "004",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "안소희",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악314",
    "isOnline": false,
    "source": {
      "schedule": "음악314(수3,4)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "음악314"
      }
    ],
    "sourceSchedule": "음악314(수3,4)"
  },
  {
    "id": "07579-001-2000594",
    "subjectKey": "07579",
    "name": "화학및실험2",
    "division": "001",
    "department": "화학공학·신소재공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "김규식",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연대505",
    "isOnline": false,
    "source": {
      "schedule": "자연대505(금5,6,7,8)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연대505"
      }
    ],
    "sourceSchedule": "자연대505(금5,6,7,8)"
  },
  {
    "id": "07579-001-2000763",
    "subjectKey": "07579",
    "name": "화학및실험2",
    "division": "001",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "김규식",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연대505",
    "isOnline": false,
    "source": {
      "schedule": "자연대505(금5,6,7,8)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연대505"
      }
    ],
    "sourceSchedule": "자연대505(금5,6,7,8)"
  },
  {
    "id": "07579-002-2000755",
    "subjectKey": "07579",
    "name": "화학및실험2",
    "division": "002",
    "department": "바이오공학과",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "하국선",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연대B101",
    "isOnline": false,
    "source": {
      "schedule": "자연대B101(월5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연대B101"
      }
    ],
    "sourceSchedule": "자연대B101(월5,6,7,8)"
  },
  {
    "id": "07579-002-2000763",
    "subjectKey": "07579",
    "name": "화학및실험2",
    "division": "002",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "하국선",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연대B101",
    "isOnline": false,
    "source": {
      "schedule": "자연대B101(월5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연대B101"
      }
    ],
    "sourceSchedule": "자연대B101(월5,6,7,8)"
  },
  {
    "id": "07579-003-2000755",
    "subjectKey": "07579",
    "name": "화학및실험2",
    "division": "003",
    "department": "바이오공학과",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "강성수",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "종합411",
    "isOnline": false,
    "source": {
      "schedule": "종합411(월5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "종합411"
      }
    ],
    "sourceSchedule": "종합411(월5,6,7,8)"
  },
  {
    "id": "07579-003-2000763",
    "subjectKey": "07579",
    "name": "화학및실험2",
    "division": "003",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "강성수",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "종합411",
    "isOnline": false,
    "source": {
      "schedule": "종합411(월5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "종합411"
      }
    ],
    "sourceSchedule": "종합411(월5,6,7,8)"
  },
  {
    "id": "07579-004-2000594",
    "subjectKey": "07579",
    "name": "화학및실험2",
    "division": "004",
    "department": "화학공학·신소재공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "박종국",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "자연대B102",
    "isOnline": false,
    "source": {
      "schedule": "자연대B102(화1,2,3,4)"
    },
    "capacity": 42,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "자연대B102"
      }
    ],
    "sourceSchedule": "자연대B102(화1,2,3,4)"
  },
  {
    "id": "07579-004-2000763",
    "subjectKey": "07579",
    "name": "화학및실험2",
    "division": "004",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "박종국",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "자연대B102",
    "isOnline": false,
    "source": {
      "schedule": "자연대B102(화1,2,3,4)"
    },
    "capacity": 42,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "자연대B102"
      }
    ],
    "sourceSchedule": "자연대B102(화1,2,3,4)"
  },
  {
    "id": "07579-005-2000594",
    "subjectKey": "07579",
    "name": "화학및실험2",
    "division": "005",
    "department": "화학공학·신소재공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이대호",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "자연대505",
    "isOnline": false,
    "source": {
      "schedule": "자연대505(월1,2,3,4)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "자연대505"
      }
    ],
    "sourceSchedule": "자연대505(월1,2,3,4)"
  },
  {
    "id": "07579-005-2000763",
    "subjectKey": "07579",
    "name": "화학및실험2",
    "division": "005",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "이대호",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "자연대505",
    "isOnline": false,
    "source": {
      "schedule": "자연대505(월1,2,3,4)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "자연대505"
      }
    ],
    "sourceSchedule": "자연대505(월1,2,3,4)"
  },
  {
    "id": "07587-001-2000409",
    "subjectKey": "07587",
    "name": "화학연구2",
    "division": "001",
    "department": "융합화학산업",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김규식",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "자연대B101",
    "isOnline": false,
    "source": {
      "schedule": "자연대B101(금1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "자연대B101"
      }
    ],
    "sourceSchedule": "자연대B101(금1,2,3)"
  },
  {
    "id": "07590-001-2000595",
    "subjectKey": "07590",
    "name": "확률론",
    "division": "001",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정형철",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "글경315",
    "isOnline": false,
    "source": {
      "schedule": "글경315(월3 수2,3)"
    },
    "capacity": 70,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3
        ],
        "classroom": "글경315"
      },
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "글경315"
      }
    ],
    "sourceSchedule": "글경315(월3 수2,3)"
  },
  {
    "id": "07598-001-2000624",
    "subjectKey": "07598",
    "name": "환경경제학",
    "division": "001",
    "department": "경제금융",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김종천",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경501",
    "isOnline": false,
    "source": {
      "schedule": "글경501(월5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경501"
      }
    ],
    "sourceSchedule": "글경501(월5,6,7)"
  },
  {
    "id": "07614-001-2000658",
    "subjectKey": "07614",
    "name": "환경과학(마이크로디그리)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김미아",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합507",
    "isOnline": false,
    "source": {
      "schedule": "종합507(수4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합507"
      }
    ],
    "sourceSchedule": "종합507(수4,5,6)"
  },
  {
    "id": "07614-002-2000658",
    "subjectKey": "07614",
    "name": "환경과학(마이크로디그리)",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김미아",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합507",
    "isOnline": false,
    "source": {
      "schedule": "종합507(수7,8,9)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합507"
      }
    ],
    "sourceSchedule": "종합507(수7,8,9)"
  },
  {
    "id": "07635-001-2000635",
    "subjectKey": "07635",
    "name": "환경반응공학",
    "division": "001",
    "department": "환경에너지공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "성기명",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "종합411",
    "isOnline": false,
    "source": {
      "schedule": "종합411(수6,7,8,9)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "종합411"
      }
    ],
    "sourceSchedule": "종합411(수6,7,8,9)"
  },
  {
    "id": "07657-001-2000627",
    "subjectKey": "07657",
    "name": "회계감사",
    "division": "001",
    "department": "회계",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김동원",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "글경601",
    "isOnline": false,
    "source": {
      "schedule": "글경601(화3 수2,3)"
    },
    "capacity": 65,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3
        ],
        "classroom": "글경601"
      },
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "글경601"
      }
    ],
    "sourceSchedule": "글경601(화3 수2,3)"
  },
  {
    "id": "07661-001-2000754",
    "subjectKey": "07661",
    "name": "회계원리(1-1전용반_마이크로디그리)",
    "division": "001",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김동선",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경601",
    "isOnline": false,
    "source": {
      "schedule": "글경601(목5,6,7)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경601"
      }
    ],
    "sourceSchedule": "글경601(목5,6,7)"
  },
  {
    "id": "07661-002-2000754",
    "subjectKey": "07661",
    "name": "회계원리(1-2전용반_마이크로디그리)",
    "division": "002",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "윤명옥",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경B101",
    "isOnline": false,
    "source": {
      "schedule": "글경B101(목5,6,7)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경B101"
      }
    ],
    "sourceSchedule": "글경B101(목5,6,7)"
  },
  {
    "id": "07661-003-2000754",
    "subjectKey": "07661",
    "name": "회계원리(1-3전용반_마이크로디그리)",
    "division": "003",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "신하준",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경B102",
    "isOnline": false,
    "source": {
      "schedule": "글경B102(목5,6,7)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경B102"
      }
    ],
    "sourceSchedule": "글경B102(목5,6,7)"
  },
  {
    "id": "07661-004-2000754",
    "subjectKey": "07661",
    "name": "회계원리(1-4전용반_마이크로디그리)",
    "division": "004",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "조태진",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경B103",
    "isOnline": false,
    "source": {
      "schedule": "글경B103(목5,6,7)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경B103"
      }
    ],
    "sourceSchedule": "글경B103(목5,6,7)"
  },
  {
    "id": "07661-005-2000754",
    "subjectKey": "07661",
    "name": "회계원리(1-5전용반_마이크로디그리)",
    "division": "005",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "윤명옥",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경601",
    "isOnline": false,
    "source": {
      "schedule": "글경601(목1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경601"
      }
    ],
    "sourceSchedule": "글경601(목1,2,3)"
  },
  {
    "id": "07661-006-2000754",
    "subjectKey": "07661",
    "name": "회계원리",
    "division": "006",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "우동호",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경B101",
    "isOnline": false,
    "source": {
      "schedule": "글경B101(화1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경B101"
      }
    ],
    "sourceSchedule": "글경B101(화1,2,3)"
  },
  {
    "id": "07661-006-2000763",
    "subjectKey": "07661",
    "name": "회계원리",
    "division": "006",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "우동호",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경B101",
    "isOnline": false,
    "source": {
      "schedule": "글경B101(화1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경B101"
      }
    ],
    "sourceSchedule": "글경B101(화1,2,3)"
  },
  {
    "id": "07661-008-2000754",
    "subjectKey": "07661",
    "name": "회계원리",
    "division": "008",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "조태진",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경B104",
    "isOnline": false,
    "source": {
      "schedule": "글경B104(화1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경B104"
      }
    ],
    "sourceSchedule": "글경B104(화1,2,3)"
  },
  {
    "id": "07661-008-2000763",
    "subjectKey": "07661",
    "name": "회계원리",
    "division": "008",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "조태진",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경B104",
    "isOnline": false,
    "source": {
      "schedule": "글경B104(화1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경B104"
      }
    ],
    "sourceSchedule": "글경B104(화1,2,3)"
  },
  {
    "id": "07685-001-2000627",
    "subjectKey": "07685",
    "name": "회계학세미나",
    "division": "001",
    "department": "회계",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "권성수",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경601",
    "isOnline": false,
    "source": {
      "schedule": "글경601(금5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경601"
      }
    ],
    "sourceSchedule": "글경601(금5,6,7)"
  },
  {
    "id": "07686-001-2000506",
    "subjectKey": "07686",
    "name": "회계학연습",
    "division": "001",
    "department": "회계",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "허강성",
    "days": [
      "수",
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "글경603",
    "isOnline": false,
    "source": {
      "schedule": "글경603(수4),글경607(화5,6)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "글경603"
      },
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "글경607"
      }
    ],
    "sourceSchedule": "글경603(수4),글경607(화5,6)"
  },
  {
    "id": "07695-001-2000646",
    "subjectKey": "07695",
    "name": "회로및시스템",
    "division": "001",
    "department": "정보통신",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양윤기",
    "days": [
      "월",
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "IT408",
    "isOnline": false,
    "source": {
      "schedule": "IT408(월5 금2,3)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5
        ],
        "classroom": "IT408"
      },
      {
        "day": "금",
        "periods": [
          2,
          3
        ],
        "classroom": "IT408"
      }
    ],
    "sourceSchedule": "IT408(월5 금2,3)"
  },
  {
    "id": "07699-001-2000592",
    "subjectKey": "07699",
    "name": "회로이론2",
    "division": "001",
    "department": "반도체공학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이강준",
    "days": [
      "목",
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "종합407",
    "isOnline": false,
    "source": {
      "schedule": "종합407(목3),종합412(월1,2)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3
        ],
        "classroom": "종합407"
      },
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "종합412"
      }
    ],
    "sourceSchedule": "종합407(목3),종합412(월1,2)"
  },
  {
    "id": "07699-003-2000593",
    "subjectKey": "07699",
    "name": "회로이론2",
    "division": "003",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "정태혁",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래106",
    "isOnline": false,
    "source": {
      "schedule": "미래106(목1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래106"
      }
    ],
    "sourceSchedule": "미래106(목1,2,3)"
  },
  {
    "id": "07699-004-2000593",
    "subjectKey": "07699",
    "name": "회로이론2",
    "division": "004",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "정태혁",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "미래106",
    "isOnline": false,
    "source": {
      "schedule": "미래106(목5,6,7)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "미래106"
      }
    ],
    "sourceSchedule": "미래106(목5,6,7)"
  },
  {
    "id": "07699-005-2000593",
    "subjectKey": "07699",
    "name": "회로이론2",
    "division": "005",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이상국",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "종합502",
    "isOnline": false,
    "source": {
      "schedule": "종합502(화2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "종합502"
      }
    ],
    "sourceSchedule": "종합502(화2,3,4)"
  },
  {
    "id": "07699-006-2000592",
    "subjectKey": "07699",
    "name": "회로이론2(학점교류)",
    "division": "006",
    "department": "반도체공학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "07723-001-2000658",
    "subjectKey": "07723",
    "name": "프랑스문학과미술",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박규현",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문407",
    "isOnline": false,
    "source": {
      "schedule": "인문407(목4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문407"
      }
    ],
    "sourceSchedule": "인문407(목4,5,6)"
  },
  {
    "id": "07757-001-2000658",
    "subjectKey": "07757",
    "name": "유럽의문화적전통",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "임웅",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문408",
    "isOnline": false,
    "source": {
      "schedule": "인문408(월6,7,8)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문408"
      }
    ],
    "sourceSchedule": "인문408(월6,7,8)"
  },
  {
    "id": "07779-001-2000658",
    "subjectKey": "07779",
    "name": "성과사랑",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "임이삭지순",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래109",
    "isOnline": false,
    "source": {
      "schedule": "미래109(화4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래109"
      }
    ],
    "sourceSchedule": "미래109(화4,5,6)"
  },
  {
    "id": "07808-001-2000643",
    "subjectKey": "07808",
    "name": "응용생물학",
    "division": "001",
    "department": "화학공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최경오",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "자연관408",
    "isOnline": false,
    "source": {
      "schedule": "자연관408(수4 목2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "자연관408"
      },
      {
        "day": "목",
        "periods": [
          2,
          3
        ],
        "classroom": "자연관408"
      }
    ],
    "sourceSchedule": "자연관408(수4 목2,3)"
  },
  {
    "id": "07809-001-2000590",
    "subjectKey": "07809",
    "name": "CAD/CAM",
    "division": "001",
    "department": "건축도시부동산학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "권혁만",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "2공학202",
    "isOnline": false,
    "source": {
      "schedule": "2공학202(월1,2,3,4)"
    },
    "capacity": 38,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "2공학202"
      }
    ],
    "sourceSchedule": "2공학202(월1,2,3,4)"
  },
  {
    "id": "07809-001-2000763",
    "subjectKey": "07809",
    "name": "CAD/CAM",
    "division": "001",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "권혁만",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "2공학202",
    "isOnline": false,
    "source": {
      "schedule": "2공학202(월1,2,3,4)"
    },
    "capacity": 38,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "2공학202"
      }
    ],
    "sourceSchedule": "2공학202(월1,2,3,4)"
  },
  {
    "id": "07809-002-2000590",
    "subjectKey": "07809",
    "name": "CAD/CAM",
    "division": "002",
    "department": "건축도시부동산학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "최고운정",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 5,
    "room": "2공학306",
    "isOnline": false,
    "source": {
      "schedule": "2공학306(금2,3,4,5)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4,
          5
        ],
        "classroom": "2공학306"
      }
    ],
    "sourceSchedule": "2공학306(금2,3,4,5)"
  },
  {
    "id": "07809-002-2000763",
    "subjectKey": "07809",
    "name": "CAD/CAM",
    "division": "002",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "최고운정",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 5,
    "room": "2공학306",
    "isOnline": false,
    "source": {
      "schedule": "2공학306(금2,3,4,5)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4,
          5
        ],
        "classroom": "2공학306"
      }
    ],
    "sourceSchedule": "2공학306(금2,3,4,5)"
  },
  {
    "id": "07809-003-2000590",
    "subjectKey": "07809",
    "name": "CAD/CAM",
    "division": "003",
    "department": "건축도시부동산학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "송희영",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 5,
    "room": "2공학202",
    "isOnline": false,
    "source": {
      "schedule": "2공학202(수2,3,4,5)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4,
          5
        ],
        "classroom": "2공학202"
      }
    ],
    "sourceSchedule": "2공학202(수2,3,4,5)"
  },
  {
    "id": "07809-003-2000763",
    "subjectKey": "07809",
    "name": "CAD/CAM",
    "division": "003",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "송희영",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 5,
    "room": "2공학202",
    "isOnline": false,
    "source": {
      "schedule": "2공학202(수2,3,4,5)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4,
          5
        ],
        "classroom": "2공학202"
      }
    ],
    "sourceSchedule": "2공학202(수2,3,4,5)"
  },
  {
    "id": "07818-001-2000740",
    "subjectKey": "07818",
    "name": "영어사들여다보기",
    "division": "001",
    "department": "영미언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김현진",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문313",
    "isOnline": false,
    "source": {
      "schedule": "인문313(화2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문313"
      }
    ],
    "sourceSchedule": "인문313(화2,3,4)"
  },
  {
    "id": "07826-001-2000618",
    "subjectKey": "07826",
    "name": "영어구문연습",
    "division": "001",
    "department": "영어영문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김현진",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문313",
    "isOnline": false,
    "source": {
      "schedule": "인문313(목5,6,7)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문313"
      }
    ],
    "sourceSchedule": "인문313(목5,6,7)"
  },
  {
    "id": "07827-001-2000618",
    "subjectKey": "07827",
    "name": "영미명작감상",
    "division": "001",
    "department": "영어영문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고영란",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문301",
    "isOnline": false,
    "source": {
      "schedule": "인문301(수2,3,4)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문301"
      }
    ],
    "sourceSchedule": "인문301(수2,3,4)"
  },
  {
    "id": "07831-001-2000293",
    "subjectKey": "07831",
    "name": "인터넷실무영작",
    "division": "001",
    "department": "영어영문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박경선",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문301",
    "isOnline": false,
    "source": {
      "schedule": "인문301(화2,3,4)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문301"
      }
    ],
    "sourceSchedule": "인문301(화2,3,4)"
  },
  {
    "id": "07906-001-2000503",
    "subjectKey": "07906",
    "name": "세계지역경제론",
    "division": "001",
    "department": "경제금융",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이탁",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "글경502",
    "isOnline": false,
    "source": {
      "schedule": "글경502(월5,6 화4)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "글경502"
      },
      {
        "day": "화",
        "periods": [
          4
        ],
        "classroom": "글경502"
      }
    ],
    "sourceSchedule": "글경502(월5,6 화4)"
  },
  {
    "id": "07958-001-2000291",
    "subjectKey": "07958",
    "name": "해방과한국현대사회의전개",
    "division": "001",
    "department": "사학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "예대열",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문512",
    "isOnline": false,
    "source": {
      "schedule": "인문512(목1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문512"
      }
    ],
    "sourceSchedule": "인문512(목1,2,3)"
  },
  {
    "id": "07962-001-2000617",
    "subjectKey": "07962",
    "name": "경기지역의역사와문화",
    "division": "001",
    "department": "사학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이창섭",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문313",
    "isOnline": false,
    "source": {
      "schedule": "인문313(금1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문313"
      }
    ],
    "sourceSchedule": "인문313(금1,2,3)"
  },
  {
    "id": "07971-001-2000291",
    "subjectKey": "07971",
    "name": "중국의혁명과근대화",
    "division": "001",
    "department": "사학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "권인용",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문501",
    "isOnline": false,
    "source": {
      "schedule": "인문501(수1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문501"
      }
    ],
    "sourceSchedule": "인문501(수1,2,3)"
  },
  {
    "id": "08001-001-2000742",
    "subjectKey": "08001",
    "name": "응용중국어(마이크로디그리)",
    "division": "001",
    "department": "중국언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이화자",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "종합503",
    "isOnline": false,
    "source": {
      "schedule": "종합503(월3,4,5)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "종합503"
      }
    ],
    "sourceSchedule": "종합503(월3,4,5)"
  },
  {
    "id": "08011-001-2000297",
    "subjectKey": "08011",
    "name": "현대중국영화와소설(마이크로디그리)",
    "division": "001",
    "department": "중어중문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고건혜",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "종합508",
    "isOnline": false,
    "source": {
      "schedule": "종합508(월3,4,5)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "종합508"
      }
    ],
    "sourceSchedule": "종합508(월3,4,5)"
  },
  {
    "id": "08021-001-2000614",
    "subjectKey": "08021",
    "name": "화술연구2",
    "division": "001",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "반무섭",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "복지B103",
    "isOnline": false,
    "source": {
      "schedule": "복지B103(월4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "복지B103"
      }
    ],
    "sourceSchedule": "복지B103(월4,5,6)"
  },
  {
    "id": "08021-002-2000614",
    "subjectKey": "08021",
    "name": "화술연구2",
    "division": "002",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "반무섭",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "복지B103",
    "isOnline": false,
    "source": {
      "schedule": "복지B103(월7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "복지B103"
      }
    ],
    "sourceSchedule": "복지B103(월7,8,9)"
  },
  {
    "id": "08105-001-2000639",
    "subjectKey": "08105",
    "name": "유한요소해석",
    "division": "001",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이기용",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "종합506",
    "isOnline": false,
    "source": {
      "schedule": "종합506(수4 목2,3)"
    },
    "capacity": 25,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "종합506"
      },
      {
        "day": "목",
        "periods": [
          2,
          3
        ],
        "classroom": "종합506"
      }
    ],
    "sourceSchedule": "종합506(수4 목2,3)"
  },
  {
    "id": "08137-001-2000264",
    "subjectKey": "08137",
    "name": "국악작곡실습2",
    "division": "001",
    "department": "작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "장현숙",
    "days": [
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "음악215",
    "isOnline": false,
    "source": {
      "schedule": "음악215(금7,8)"
    },
    "capacity": 5,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "음악215"
      }
    ],
    "sourceSchedule": "음악215(금7,8)"
  },
  {
    "id": "08141-001-2000295",
    "subjectKey": "08141",
    "name": "고급러시아어회화2",
    "division": "001",
    "department": "러시아어문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "마리나세르게예브나",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "종합508",
    "isOnline": false,
    "source": {
      "schedule": "종합508(월6,7 화7)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "종합508"
      },
      {
        "day": "화",
        "periods": [
          7
        ],
        "classroom": "종합508"
      }
    ],
    "sourceSchedule": "종합508(월6,7 화7)"
  },
  {
    "id": "08153-001-2000624",
    "subjectKey": "08153",
    "name": "화폐와금융",
    "division": "001",
    "department": "경제금융",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조기준",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경501",
    "isOnline": false,
    "source": {
      "schedule": "글경501(목5,6,7)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경501"
      }
    ],
    "sourceSchedule": "글경501(목5,6,7)"
  },
  {
    "id": "08153-002-2000625",
    "subjectKey": "08153",
    "name": "화폐와금융",
    "division": "002",
    "department": "국제개발협력",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조기준",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경501",
    "isOnline": false,
    "source": {
      "schedule": "글경501(목5,6,7)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경501"
      }
    ],
    "sourceSchedule": "글경501(목5,6,7)"
  },
  {
    "id": "08167-001-2000628",
    "subjectKey": "08167",
    "name": "국제물류론",
    "division": "001",
    "department": "글로벌비즈니스",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "류덕기",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경602",
    "isOnline": false,
    "source": {
      "schedule": "글경602(수1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경602"
      }
    ],
    "sourceSchedule": "글경602(수1,2,3)"
  },
  {
    "id": "08193-001-2000601",
    "subjectKey": "08193",
    "name": "유기화학",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박경애",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "생활302",
    "isOnline": false,
    "source": {
      "schedule": "생활302(수5,6,7)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "생활302"
      }
    ],
    "sourceSchedule": "생활302(수5,6,7)"
  },
  {
    "id": "08193-001-2000763",
    "subjectKey": "08193",
    "name": "유기화학",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박경애",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "생활302",
    "isOnline": false,
    "source": {
      "schedule": "생활302(수5,6,7)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "생활302"
      }
    ],
    "sourceSchedule": "생활302(수5,6,7)"
  },
  {
    "id": "08212-001-2000409",
    "subjectKey": "08212",
    "name": "나노화학",
    "division": "001",
    "department": "융합화학산업",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "연경열",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "자연대B106",
    "isOnline": false,
    "source": {
      "schedule": "자연대B106(수5,6 목5)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "자연대B106"
      },
      {
        "day": "목",
        "periods": [
          5
        ],
        "classroom": "자연대B106"
      }
    ],
    "sourceSchedule": "자연대B106(수5,6 목5)"
  },
  {
    "id": "08220-001-2000409",
    "subjectKey": "08220",
    "name": "생유기화학",
    "division": "001",
    "department": "융합화학산업",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "유예",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "종합408",
    "isOnline": false,
    "source": {
      "schedule": "종합408(금6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "종합408"
      }
    ],
    "sourceSchedule": "종합408(금6,7,8)"
  },
  {
    "id": "08223-001-2000409",
    "subjectKey": "08223",
    "name": "화학정보학",
    "division": "001",
    "department": "융합화학산업",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박종민",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "자연대B106",
    "isOnline": false,
    "source": {
      "schedule": "자연대B106(수1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "자연대B106"
      }
    ],
    "sourceSchedule": "자연대B106(수1,2,3)"
  },
  {
    "id": "08240-001-2000634",
    "subjectKey": "08240",
    "name": "암반공학및실험",
    "division": "001",
    "department": "건설환경공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김한나",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "종합511",
    "isOnline": false,
    "source": {
      "schedule": "종합511(수7,8 목2,3)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8
        ],
        "classroom": "종합511"
      },
      {
        "day": "목",
        "periods": [
          2,
          3
        ],
        "classroom": "종합511"
      }
    ],
    "sourceSchedule": "종합511(수7,8 목2,3)"
  },
  {
    "id": "08265-001-2000636",
    "subjectKey": "08265",
    "name": "건축시공관리",
    "division": "001",
    "department": "건축학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "임광혁",
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "자연대B106",
    "isOnline": false,
    "source": {
      "schedule": "자연대B106(월7,8),2공학313(목7)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8
        ],
        "classroom": "자연대B106"
      },
      {
        "day": "목",
        "periods": [
          7
        ],
        "classroom": "2공학313"
      }
    ],
    "sourceSchedule": "자연대B106(월7,8),2공학313(목7)"
  },
  {
    "id": "08267-001-2000638",
    "subjectKey": "08267",
    "name": "신뢰성공학1",
    "division": "001",
    "department": "산업공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김명수",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "자연관306",
    "isOnline": false,
    "source": {
      "schedule": "자연관306(금5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "자연관306"
      }
    ],
    "sourceSchedule": "자연관306(금5,6,7)"
  },
  {
    "id": "08272-001-2000417",
    "subjectKey": "08272",
    "name": "컴퓨터통합제조시스템",
    "division": "001",
    "department": "산업공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김국",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "자연관306",
    "isOnline": false,
    "source": {
      "schedule": "자연관306(수1,2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "자연관306"
      }
    ],
    "sourceSchedule": "자연관306(수1,2,3,4)"
  },
  {
    "id": "08282-001-2000420",
    "subjectKey": "08282",
    "name": "반도체패키징",
    "division": "001",
    "department": "전자재료공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박흥수",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합508",
    "isOnline": false,
    "source": {
      "schedule": "종합508(수1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합508"
      }
    ],
    "sourceSchedule": "종합508(수1,2,3)"
  },
  {
    "id": "08285-001-2000590",
    "subjectKey": "08285",
    "name": "부동산학개론",
    "division": "001",
    "department": "건축도시부동산학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이형석",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래106",
    "isOnline": false,
    "source": {
      "schedule": "미래106(화6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래106"
      }
    ],
    "sourceSchedule": "미래106(화6,7,8)"
  },
  {
    "id": "08285-001-2000763",
    "subjectKey": "08285",
    "name": "부동산학개론",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이형석",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래106",
    "isOnline": false,
    "source": {
      "schedule": "미래106(화6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래106"
      }
    ],
    "sourceSchedule": "미래106(화6,7,8)"
  },
  {
    "id": "08285-002-2000590",
    "subjectKey": "08285",
    "name": "부동산학개론",
    "division": "002",
    "department": "건축도시부동산학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김주원",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "2공학313",
    "isOnline": false,
    "source": {
      "schedule": "2공학313(화6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "2공학313"
      }
    ],
    "sourceSchedule": "2공학313(화6,7,8)"
  },
  {
    "id": "08285-002-2000763",
    "subjectKey": "08285",
    "name": "부동산학개론",
    "division": "002",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김주원",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "2공학313",
    "isOnline": false,
    "source": {
      "schedule": "2공학313(화6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "2공학313"
      }
    ],
    "sourceSchedule": "2공학313(화6,7,8)"
  },
  {
    "id": "08286-001-2000637",
    "subjectKey": "08286",
    "name": "오픈스페이스계획(마이크로디그리)",
    "division": "001",
    "department": "도시부동산학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "장남수",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "자연대B105",
    "isOnline": false,
    "source": {
      "schedule": "자연대B105(월5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "자연대B105"
      }
    ],
    "sourceSchedule": "자연대B105(월5,6,7)"
  },
  {
    "id": "08314-001-2000180",
    "subjectKey": "08314",
    "name": "산업전자응용",
    "division": "001",
    "department": "전기공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김용준",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "자연관508",
    "isOnline": false,
    "source": {
      "schedule": "자연관508(목6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "자연관508"
      }
    ],
    "sourceSchedule": "자연관508(목6,7,8)"
  },
  {
    "id": "08336-001-2000639",
    "subjectKey": "08336",
    "name": "열역학응용",
    "division": "001",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "한태훈",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "종합408",
    "isOnline": false,
    "source": {
      "schedule": "종합408(월7,8 화9)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8
        ],
        "classroom": "종합408"
      },
      {
        "day": "화",
        "periods": [
          9
        ],
        "classroom": "종합408"
      }
    ],
    "sourceSchedule": "종합408(월7,8 화9)"
  },
  {
    "id": "08348-002-2000593",
    "subjectKey": "08348",
    "name": "반도체소자기초",
    "division": "002",
    "department": "전기전자공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이병렬",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "종합406",
    "isOnline": false,
    "source": {
      "schedule": "종합406(수6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "종합406"
      }
    ],
    "sourceSchedule": "종합406(수6,7,8)"
  },
  {
    "id": "08348-003-2000593",
    "subjectKey": "08348",
    "name": "반도체소자기초",
    "division": "003",
    "department": "전기전자공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "윤보열",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합411",
    "isOnline": false,
    "source": {
      "schedule": "종합411(목1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합411"
      }
    ],
    "sourceSchedule": "종합411(목1,2,3)"
  },
  {
    "id": "08357-001-2000181",
    "subjectKey": "08357",
    "name": "디지털집적회로설계",
    "division": "001",
    "department": "전자공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이병렬",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합406",
    "isOnline": false,
    "source": {
      "schedule": "종합406(월1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합406"
      }
    ],
    "sourceSchedule": "종합406(월1,2,3)"
  },
  {
    "id": "08371-001-2000647",
    "subjectKey": "08371",
    "name": "시스템보안",
    "division": "001",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이창선",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "IT310",
    "isOnline": false,
    "source": {
      "schedule": "IT310(화1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "IT310"
      }
    ],
    "sourceSchedule": "IT310(화1,2,3)"
  },
  {
    "id": "08384-001-2000645",
    "subjectKey": "08384",
    "name": "디지털신호및사운드처리",
    "division": "001",
    "department": "미디어SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "딜립 쿠말",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT214",
    "isOnline": false,
    "source": {
      "schedule": "IT214(목2,3,4)"
    },
    "capacity": 35,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT214"
      }
    ],
    "sourceSchedule": "IT214(목2,3,4)"
  },
  {
    "id": "08389-001-2000645",
    "subjectKey": "08389",
    "name": "컨텐츠제작프로젝트",
    "division": "001",
    "department": "미디어SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박효문",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT309",
    "isOnline": false,
    "source": {
      "schedule": "IT309(수2,3,4)"
    },
    "capacity": 35,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT309"
      }
    ],
    "sourceSchedule": "IT309(수2,3,4)"
  },
  {
    "id": "08405-001-2000600",
    "subjectKey": "08405",
    "name": "의류소재개발",
    "division": "001",
    "department": "의류학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이동아",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "생활405",
    "isOnline": false,
    "source": {
      "schedule": "생활405(목5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "생활405"
      }
    ],
    "sourceSchedule": "생활405(목5,6,7)"
  },
  {
    "id": "08406-001-2000600",
    "subjectKey": "08406",
    "name": "무대의상고증(캡스톤디자인제작)",
    "division": "001",
    "department": "의류학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김선영",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "생활301",
    "isOnline": false,
    "source": {
      "schedule": "생활301(수5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "생활301"
      }
    ],
    "sourceSchedule": "생활301(수5,6,7)"
  },
  {
    "id": "08408-001-2000432",
    "subjectKey": "08408",
    "name": "비주얼머천다이징",
    "division": "001",
    "department": "의류학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이지선",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "생활302",
    "isOnline": false,
    "source": {
      "schedule": "생활302(금6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "생활302"
      }
    ],
    "sourceSchedule": "생활302(금6,7,8)"
  },
  {
    "id": "08412-001-2000601",
    "subjectKey": "08412",
    "name": "한국조리및실험",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이승민",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "생활401",
    "isOnline": false,
    "source": {
      "schedule": "생활401(월5,6,7)"
    },
    "capacity": 32,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "생활401"
      }
    ],
    "sourceSchedule": "생활401(월5,6,7)"
  },
  {
    "id": "08412-001-2000763",
    "subjectKey": "08412",
    "name": "한국조리및실험",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이승민",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "생활401",
    "isOnline": false,
    "source": {
      "schedule": "생활401(월5,6,7)"
    },
    "capacity": 32,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "생활401"
      }
    ],
    "sourceSchedule": "생활401(월5,6,7)"
  },
  {
    "id": "08430-001-2000648",
    "subjectKey": "08430",
    "name": "체육행정관리",
    "division": "001",
    "department": "체육학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이지선",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "미래B203",
    "isOnline": false,
    "source": {
      "schedule": "미래B203(화1 금1,2)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1
        ],
        "classroom": "미래B203"
      },
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B203"
      }
    ],
    "sourceSchedule": "미래B203(화1 금1,2)"
  },
  {
    "id": "08456-001-2000651",
    "subjectKey": "08456",
    "name": "서양미술사(근대이전)2",
    "division": "001",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "강지선",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미술102",
    "isOnline": false,
    "source": {
      "schedule": "미술102(월6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미술102"
      }
    ],
    "sourceSchedule": "미술102(월6,7,8)"
  },
  {
    "id": "08459-001-2000651",
    "subjectKey": "08459",
    "name": "서양미술사(근대이후)4",
    "division": "001",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김소현",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "종합403",
    "isOnline": false,
    "source": {
      "schedule": "종합403(금2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "종합403"
      }
    ],
    "sourceSchedule": "종합403(금2,3,4)"
  },
  {
    "id": "08463-001-2000447",
    "subjectKey": "08463",
    "name": "현대회화론2",
    "division": "001",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김수정",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미술102",
    "isOnline": false,
    "source": {
      "schedule": "미술102(월1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미술102"
      }
    ],
    "sourceSchedule": "미술102(월1,2,3)"
  },
  {
    "id": "08468-001-2000651",
    "subjectKey": "08468",
    "name": "표현기법2",
    "division": "001",
    "department": "회화",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김건희",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "조형408",
    "isOnline": false,
    "source": {
      "schedule": "조형408(수1,2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "조형408"
      }
    ],
    "sourceSchedule": "조형408(수1,2,3,4)"
  },
  {
    "id": "08468-002-2000651",
    "subjectKey": "08468",
    "name": "표현기법2",
    "division": "002",
    "department": "회화",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김명실",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "조형301",
    "isOnline": false,
    "source": {
      "schedule": "조형301(월6,7,8,9)"
    },
    "capacity": 32,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "조형301"
      }
    ],
    "sourceSchedule": "조형301(월6,7,8,9)"
  },
  {
    "id": "08481-001-2000653",
    "subjectKey": "08481",
    "name": "타이포그래피",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이진형",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술203",
    "isOnline": false,
    "source": {
      "schedule": "미술203(수1,2,3,4)"
    },
    "capacity": 28,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술203"
      }
    ],
    "sourceSchedule": "미술203(수1,2,3,4)"
  },
  {
    "id": "08481-002-2000653",
    "subjectKey": "08481",
    "name": "타이포그래피",
    "division": "002",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이진형",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술203",
    "isOnline": false,
    "source": {
      "schedule": "미술203(수5,6,7,8)"
    },
    "capacity": 28,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술203"
      }
    ],
    "sourceSchedule": "미술203(수5,6,7,8)"
  },
  {
    "id": "08481-003-2000653",
    "subjectKey": "08481",
    "name": "타이포그래피",
    "division": "003",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박민규",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술208",
    "isOnline": false,
    "source": {
      "schedule": "미술208(월5,6,7,8)"
    },
    "capacity": 28,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술208"
      }
    ],
    "sourceSchedule": "미술208(월5,6,7,8)"
  },
  {
    "id": "08484-001-2000603",
    "subjectKey": "08484",
    "name": "Digital Design2(마이크로디그리)",
    "division": "001",
    "department": "조형예술학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "문정화",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술201",
    "isOnline": false,
    "source": {
      "schedule": "미술201(화1,2,3,4)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술201"
      }
    ],
    "sourceSchedule": "미술201(화1,2,3,4)"
  },
  {
    "id": "08484-002-2000654",
    "subjectKey": "08484",
    "name": "Digital Design2(마이크로디그리)",
    "division": "002",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "문정화",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술202",
    "isOnline": false,
    "source": {
      "schedule": "미술202(화6,7,8,9)"
    },
    "capacity": 16,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술202"
      }
    ],
    "sourceSchedule": "미술202(화6,7,8,9)"
  },
  {
    "id": "08484-003-2000655",
    "subjectKey": "08484",
    "name": "Digital Design2(마이크로디그리)",
    "division": "003",
    "department": "공예디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "서원",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술201",
    "isOnline": false,
    "source": {
      "schedule": "미술201(수6,7,8,9)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술201"
      }
    ],
    "sourceSchedule": "미술201(수6,7,8,9)"
  },
  {
    "id": "08484-005-2000603",
    "subjectKey": "08484",
    "name": "Digital Design2(마이크로디그리)",
    "division": "005",
    "department": "조형예술학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "전지현",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술201",
    "isOnline": false,
    "source": {
      "schedule": "미술201(금1,2,3,4)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술201"
      }
    ],
    "sourceSchedule": "미술201(금1,2,3,4)"
  },
  {
    "id": "08484-006-2000603",
    "subjectKey": "08484",
    "name": "Digital Design2(마이크로디그리)",
    "division": "006",
    "department": "조형예술학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "한동석",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술202",
    "isOnline": false,
    "source": {
      "schedule": "미술202(수6,7,8,9)"
    },
    "capacity": 32,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술202"
      }
    ],
    "sourceSchedule": "미술202(수6,7,8,9)"
  },
  {
    "id": "08484-007-2000654",
    "subjectKey": "08484",
    "name": "Digital Design2(마이크로디그리)",
    "division": "007",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "임성경",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술202",
    "isOnline": false,
    "source": {
      "schedule": "미술202(목1,2,3,4)"
    },
    "capacity": 15,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술202"
      }
    ],
    "sourceSchedule": "미술202(목1,2,3,4)"
  },
  {
    "id": "08489-001-2000653",
    "subjectKey": "08489",
    "name": "기초타이포그래피",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "정영신",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술205",
    "isOnline": false,
    "source": {
      "schedule": "미술205(목1,2,3,4)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술205"
      }
    ],
    "sourceSchedule": "미술205(목1,2,3,4)"
  },
  {
    "id": "08489-002-2000653",
    "subjectKey": "08489",
    "name": "기초타이포그래피",
    "division": "002",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박민규",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술213-2",
    "isOnline": false,
    "source": {
      "schedule": "미술213-2(수1,2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술213-2"
      }
    ],
    "sourceSchedule": "미술213-2(수1,2,3,4)"
  },
  {
    "id": "08490-001-2000653",
    "subjectKey": "08490",
    "name": "Form & Identity",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김연희",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술203",
    "isOnline": false,
    "source": {
      "schedule": "미술203(월1,2,3,4)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술203"
      }
    ],
    "sourceSchedule": "미술203(월1,2,3,4)"
  },
  {
    "id": "08490-002-2000653",
    "subjectKey": "08490",
    "name": "Form & Identity",
    "division": "002",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김연희",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술203",
    "isOnline": false,
    "source": {
      "schedule": "미술203(월5,6,7,8)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술203"
      }
    ],
    "sourceSchedule": "미술203(월5,6,7,8)"
  },
  {
    "id": "08491-001-2000653",
    "subjectKey": "08491",
    "name": "Editorial Design",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박민규",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술213-2",
    "isOnline": false,
    "source": {
      "schedule": "미술213-2(수5,6,7,8)"
    },
    "capacity": 28,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술213-2"
      }
    ],
    "sourceSchedule": "미술213-2(수5,6,7,8)"
  },
  {
    "id": "08491-002-2000653",
    "subjectKey": "08491",
    "name": "Editorial Design",
    "division": "002",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정영신",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술205",
    "isOnline": false,
    "source": {
      "schedule": "미술205(목5,6,7,8)"
    },
    "capacity": 28,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술205"
      }
    ],
    "sourceSchedule": "미술205(목5,6,7,8)"
  },
  {
    "id": "08504-001-2000653",
    "subjectKey": "08504",
    "name": "Motion Graphics(마이크로디그리)",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조윤희",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술205",
    "isOnline": false,
    "source": {
      "schedule": "미술205(월1,2,3,4)"
    },
    "capacity": 38,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술205"
      }
    ],
    "sourceSchedule": "미술205(월1,2,3,4)"
  },
  {
    "id": "08514-001-2000654",
    "subjectKey": "08514",
    "name": "패션소재개발",
    "division": "001",
    "department": "패션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김유림",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "종합B108",
    "isOnline": false,
    "source": {
      "schedule": "종합B108(월1,2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "종합B108"
      }
    ],
    "sourceSchedule": "종합B108(월1,2,3,4)"
  },
  {
    "id": "08515-001-2000654",
    "subjectKey": "08515",
    "name": "Fashion Design2",
    "division": "001",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "권지현",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술211",
    "isOnline": false,
    "source": {
      "schedule": "미술211(화1,2,3,4)"
    },
    "capacity": 11,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술211"
      }
    ],
    "sourceSchedule": "미술211(화1,2,3,4)"
  },
  {
    "id": "08515-002-2000654",
    "subjectKey": "08515",
    "name": "Fashion Design2",
    "division": "002",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "허민",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술211",
    "isOnline": false,
    "source": {
      "schedule": "미술211(수6,7,8,9)"
    },
    "capacity": 11,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술211"
      }
    ],
    "sourceSchedule": "미술211(수6,7,8,9)"
  },
  {
    "id": "08517-001-2000654",
    "subjectKey": "08517",
    "name": "Draping2",
    "division": "001",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "범서희",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "종합B107",
    "isOnline": false,
    "source": {
      "schedule": "종합B107(금1,2,3,4)"
    },
    "capacity": 11,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "종합B107"
      }
    ],
    "sourceSchedule": "종합B107(금1,2,3,4)"
  },
  {
    "id": "08517-002-2000654",
    "subjectKey": "08517",
    "name": "Draping2",
    "division": "002",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "범서희",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "종합B107",
    "isOnline": false,
    "source": {
      "schedule": "종합B107(금6,7,8,9)"
    },
    "capacity": 11,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "종합B107"
      }
    ],
    "sourceSchedule": "종합B107(금6,7,8,9)"
  },
  {
    "id": "08525-001-2000654",
    "subjectKey": "08525",
    "name": "디지털패션스튜디오2",
    "division": "001",
    "department": "패션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "임성경",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술202",
    "isOnline": false,
    "source": {
      "schedule": "미술202(목6,7,8,9)"
    },
    "capacity": 15,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술202"
      }
    ],
    "sourceSchedule": "미술202(목6,7,8,9)"
  },
  {
    "id": "08557-001-2000256",
    "subjectKey": "08557",
    "name": "포트폴리오제작",
    "division": "001",
    "department": "공예디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "서원",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "미술212",
    "isOnline": false,
    "source": {
      "schedule": "미술212(수2,3,4)"
    },
    "capacity": 25,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "미술212"
      }
    ],
    "sourceSchedule": "미술212(수2,3,4)"
  },
  {
    "id": "08571-002-2000609",
    "subjectKey": "08571",
    "name": "특수악기6(아쟁)",
    "division": "002",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "김승철",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 6,
    "room": "음악310",
    "isOnline": false,
    "source": {
      "schedule": "음악310(월6)"
    },
    "capacity": 5,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6
        ],
        "classroom": "음악310"
      }
    ],
    "sourceSchedule": "음악310(월6)"
  },
  {
    "id": "08571-003-2000609",
    "subjectKey": "08571",
    "name": "특수악기6(대풍류)",
    "division": "003",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "유현수",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "음악107",
    "isOnline": false,
    "source": {
      "schedule": "음악107(월3)"
    },
    "capacity": 5,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3
        ],
        "classroom": "음악107"
      }
    ],
    "sourceSchedule": "음악107(월3)"
  },
  {
    "id": "08573-001-2000264",
    "subjectKey": "08573",
    "name": "재즈이론",
    "division": "001",
    "department": "작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정진호",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(목1,2)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(목1,2)"
  },
  {
    "id": "08573-002-2000276",
    "subjectKey": "08573",
    "name": "재즈이론",
    "division": "002",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정진호",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(목1,2)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(목1,2)"
  },
  {
    "id": "08579-001-2000606",
    "subjectKey": "08579",
    "name": "독일어딕션2",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "이정명",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악315",
    "isOnline": false,
    "source": {
      "schedule": "음악315(수3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "음악315"
      }
    ],
    "sourceSchedule": "음악315(수3,4)"
  },
  {
    "id": "08583-001-2000265",
    "subjectKey": "08583",
    "name": "영어딕션2",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "이승희",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(수5,6)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(수5,6)"
  },
  {
    "id": "08586-001-2000608",
    "subjectKey": "08586",
    "name": "관악/현악합주2",
    "division": "001",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "에르완리샤",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(월1,2 수3,4)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "음악109"
      },
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(월1,2 수3,4)"
  },
  {
    "id": "08586-002-2000608",
    "subjectKey": "08586",
    "name": "관악/현악합주2",
    "division": "002",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "오병철",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 9,
    "endPeriod": 10,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(화9,10 목9,10)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          9,
          10
        ],
        "classroom": "음악109"
      },
      {
        "day": "목",
        "periods": [
          9,
          10
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(화9,10 목9,10)"
  },
  {
    "id": "08588-001-2000608",
    "subjectKey": "08588",
    "name": "관악/현악합주4",
    "division": "001",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "에르완리샤",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(월1,2 수3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "음악109"
      },
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(월1,2 수3,4)"
  },
  {
    "id": "08588-002-2000608",
    "subjectKey": "08588",
    "name": "관악/현악합주4",
    "division": "002",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "오병철",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 9,
    "endPeriod": 10,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(화9,10 목9,10)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          9,
          10
        ],
        "classroom": "음악109"
      },
      {
        "day": "목",
        "periods": [
          9,
          10
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(화9,10 목9,10)"
  },
  {
    "id": "08590-001-2000608",
    "subjectKey": "08590",
    "name": "관악/현악합주6",
    "division": "001",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "에르완리샤",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(월1,2 수3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "음악109"
      },
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(월1,2 수3,4)"
  },
  {
    "id": "08590-002-2000608",
    "subjectKey": "08590",
    "name": "관악/현악합주6",
    "division": "002",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "오병철",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 9,
    "endPeriod": 10,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(화9,10 목9,10)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          9,
          10
        ],
        "classroom": "음악109"
      },
      {
        "day": "목",
        "periods": [
          9,
          10
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(화9,10 목9,10)"
  },
  {
    "id": "08593-001-2000277",
    "subjectKey": "08593",
    "name": "관악/현악합주8",
    "division": "001",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "에르완리샤",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(월1,2 수3,4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "음악109"
      },
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(월1,2 수3,4)"
  },
  {
    "id": "08593-002-2000277",
    "subjectKey": "08593",
    "name": "관악/현악합주8",
    "division": "002",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "오병철",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 9,
    "endPeriod": 10,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(화9,10 목9,10)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          9,
          10
        ],
        "classroom": "음악109"
      },
      {
        "day": "목",
        "periods": [
          9,
          10
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(화9,10 목9,10)"
  },
  {
    "id": "08602-001-2000609",
    "subjectKey": "08602",
    "name": "한국음악사2",
    "division": "001",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "홍주희",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(화3,4)"
    },
    "capacity": 15,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(화3,4)"
  },
  {
    "id": "08603-001-2000609",
    "subjectKey": "08603",
    "name": "국악합주2",
    "division": "001",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "유현수",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악107",
    "isOnline": false,
    "source": {
      "schedule": "음악107(월1,2)"
    },
    "capacity": 8,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "음악107"
      }
    ],
    "sourceSchedule": "음악107(월1,2)"
  },
  {
    "id": "08656-001-2000592",
    "subjectKey": "08656",
    "name": "전자회로1",
    "division": "001",
    "department": "반도체공학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김연준",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합412",
    "isOnline": false,
    "source": {
      "schedule": "종합412(금1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합412"
      }
    ],
    "sourceSchedule": "종합412(금1,2,3)"
  },
  {
    "id": "08657-003-2000641",
    "subjectKey": "08657",
    "name": "전자회로2",
    "division": "003",
    "department": "전자공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이철우",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래105",
    "isOnline": false,
    "source": {
      "schedule": "미래105(목1,2,3)"
    },
    "capacity": 60,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래105"
      }
    ],
    "sourceSchedule": "미래105(목1,2,3)"
  },
  {
    "id": "08660-001-2000588",
    "subjectKey": "08660",
    "name": "물리화학1",
    "division": "001",
    "department": "바이오화학산업학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "유기태",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "종합407",
    "isOnline": false,
    "source": {
      "schedule": "종합407(월4 수2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4
        ],
        "classroom": "종합407"
      },
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "종합407"
      }
    ],
    "sourceSchedule": "종합407(월4 수2,3)"
  },
  {
    "id": "08661-002-2000642",
    "subjectKey": "08661",
    "name": "물리화학2",
    "division": "002",
    "department": "신소재공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박상원",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합409",
    "isOnline": false,
    "source": {
      "schedule": "종합409(화5,6 목7)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "종합409"
      },
      {
        "day": "목",
        "periods": [
          7
        ],
        "classroom": "종합409"
      }
    ],
    "sourceSchedule": "종합409(화5,6 목7)"
  },
  {
    "id": "08661-003-2000643",
    "subjectKey": "08661",
    "name": "물리화학2",
    "division": "003",
    "department": "화학공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박진혁",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "미래B202",
    "isOnline": false,
    "source": {
      "schedule": "미래B202(월2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "미래B202"
      }
    ],
    "sourceSchedule": "미래B202(월2,3,4)"
  },
  {
    "id": "08663-002-2000642",
    "subjectKey": "08663",
    "name": "유기화학2",
    "division": "002",
    "department": "신소재공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "장건수",
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래105",
    "isOnline": false,
    "source": {
      "schedule": "미래105(월6,7 목8)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "미래105"
      },
      {
        "day": "목",
        "periods": [
          8
        ],
        "classroom": "미래105"
      }
    ],
    "sourceSchedule": "미래105(월6,7 목8)"
  },
  {
    "id": "08663-003-2000643",
    "subjectKey": "08663",
    "name": "유기화학2",
    "division": "003",
    "department": "화학공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "유종훈",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "자연관409",
    "isOnline": false,
    "source": {
      "schedule": "자연관409(화6,7 수5)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7
        ],
        "classroom": "자연관409"
      },
      {
        "day": "수",
        "periods": [
          5
        ],
        "classroom": "자연관409"
      }
    ],
    "sourceSchedule": "자연관409(화6,7 수5)"
  },
  {
    "id": "08663-004-2000643",
    "subjectKey": "08663",
    "name": "유기화학2",
    "division": "004",
    "department": "화학공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "유종훈",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "자연관409",
    "isOnline": false,
    "source": {
      "schedule": "자연관409(화5 수6,7)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5
        ],
        "classroom": "자연관409"
      },
      {
        "day": "수",
        "periods": [
          6,
          7
        ],
        "classroom": "자연관409"
      }
    ],
    "sourceSchedule": "자연관409(화5 수6,7)"
  },
  {
    "id": "08675-001-2000401",
    "subjectKey": "08675",
    "name": "인턴쉽",
    "division": "001",
    "department": "미디어커뮤니케이션학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이문행",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문310",
    "isOnline": false,
    "source": {
      "schedule": "인문310(월5,6,7)"
    },
    "capacity": 12,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문310"
      }
    ],
    "sourceSchedule": "인문310(월5,6,7)"
  },
  {
    "id": "08683-001-2000644",
    "subjectKey": "08683",
    "name": "리눅스시스템",
    "division": "001",
    "department": "컴퓨터SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "신호진",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT310",
    "isOnline": false,
    "source": {
      "schedule": "IT310(금2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT310"
      }
    ],
    "sourceSchedule": "IT310(금2,3,4)"
  },
  {
    "id": "08683-002-2000644",
    "subjectKey": "08683",
    "name": "리눅스시스템",
    "division": "002",
    "department": "컴퓨터SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양수미",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT310",
    "isOnline": false,
    "source": {
      "schedule": "IT310(화6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT310"
      }
    ],
    "sourceSchedule": "IT310(화6,7,8)"
  },
  {
    "id": "08705-001-2000639",
    "subjectKey": "08705",
    "name": "전산제도",
    "division": "001",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "마부수",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연대211",
    "isOnline": false,
    "source": {
      "schedule": "자연대211(목5,6,7,8)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연대211"
      }
    ],
    "sourceSchedule": "자연대211(목5,6,7,8)"
  },
  {
    "id": "08705-002-2000639",
    "subjectKey": "08705",
    "name": "전산제도",
    "division": "002",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이기용",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "자연대211",
    "isOnline": false,
    "source": {
      "schedule": "자연대211(월1,2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "자연대211"
      }
    ],
    "sourceSchedule": "자연대211(월1,2,3,4)"
  },
  {
    "id": "08707-001-2000639",
    "subjectKey": "08707",
    "name": "유체시스템해석설계",
    "division": "001",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "임성혁",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "종합405",
    "isOnline": false,
    "source": {
      "schedule": "종합405(월4 화3,4)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4
        ],
        "classroom": "종합405"
      },
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "종합405"
      }
    ],
    "sourceSchedule": "종합405(월4 화3,4)"
  },
  {
    "id": "08714-001-2000642",
    "subjectKey": "08714",
    "name": "신소재공학특강1",
    "division": "001",
    "department": "신소재공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이성재",
    "days": [
      "수",
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(수2,3 금3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "미래103"
      },
      {
        "day": "금",
        "periods": [
          3
        ],
        "classroom": "미래103"
      }
    ],
    "sourceSchedule": "미래103(수2,3 금3)"
  },
  {
    "id": "08723-001-2000635",
    "subjectKey": "08723",
    "name": "전과정평가와친환경제품설계",
    "division": "001",
    "department": "환경에너지공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "백영순",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "미래106",
    "isOnline": false,
    "source": {
      "schedule": "미래106(월5,6,7)"
    },
    "capacity": 38,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "미래106"
      }
    ],
    "sourceSchedule": "미래106(월5,6,7)"
  },
  {
    "id": "08725-001-2000599",
    "subjectKey": "08725",
    "name": "언어지도",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "송승민",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "생활305",
    "isOnline": false,
    "source": {
      "schedule": "생활305(화2,3,4)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "생활305"
      }
    ],
    "sourceSchedule": "생활305(화2,3,4)"
  },
  {
    "id": "08736-001-2000599",
    "subjectKey": "08736",
    "name": "보육학개론",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "송승민",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "생활305",
    "isOnline": false,
    "source": {
      "schedule": "생활305(목5,6,7)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "생활305"
      }
    ],
    "sourceSchedule": "생활305(목5,6,7)"
  },
  {
    "id": "08736-001-2000763",
    "subjectKey": "08736",
    "name": "보육학개론",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "송승민",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "생활305",
    "isOnline": false,
    "source": {
      "schedule": "생활305(목5,6,7)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "생활305"
      }
    ],
    "sourceSchedule": "생활305(목5,6,7)"
  },
  {
    "id": "08741-001-2000620",
    "subjectKey": "08741",
    "name": "실용일어회화2",
    "division": "001",
    "department": "일어일문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "미도리",
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합509",
    "isOnline": false,
    "source": {
      "schedule": "종합509(월2,3 목5)"
    },
    "capacity": 15,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "종합509"
      },
      {
        "day": "목",
        "periods": [
          5
        ],
        "classroom": "종합509"
      }
    ],
    "sourceSchedule": "종합509(월2,3 목5)"
  },
  {
    "id": "08747-001-2000606",
    "subjectKey": "08747",
    "name": "콘서트콰이어2",
    "division": "001",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "임병욱",
    "days": [
      "목",
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악110",
    "isOnline": false,
    "source": {
      "schedule": "음악110(목5,6 금5,6)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "음악110"
      },
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "음악110"
      }
    ],
    "sourceSchedule": "음악110(목5,6 금5,6)"
  },
  {
    "id": "08749-001-2000606",
    "subjectKey": "08749",
    "name": "콘서트콰이어4",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "임병욱",
    "days": [
      "목",
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악110",
    "isOnline": false,
    "source": {
      "schedule": "음악110(목5,6 금5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "음악110"
      },
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "음악110"
      }
    ],
    "sourceSchedule": "음악110(목5,6 금5,6)"
  },
  {
    "id": "08751-001-2000606",
    "subjectKey": "08751",
    "name": "콘서트콰이어6",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "임병욱",
    "days": [
      "목",
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악110",
    "isOnline": false,
    "source": {
      "schedule": "음악110(목5,6 금5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "음악110"
      },
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "음악110"
      }
    ],
    "sourceSchedule": "음악110(목5,6 금5,6)"
  },
  {
    "id": "08756-001-2000618",
    "subjectKey": "08756",
    "name": "영미극의이해",
    "division": "001",
    "department": "영어영문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이용관",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문301",
    "isOnline": false,
    "source": {
      "schedule": "인문301(월2,3,4)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문301"
      }
    ],
    "sourceSchedule": "인문301(월2,3,4)"
  },
  {
    "id": "08758-001-2000293",
    "subjectKey": "08758",
    "name": "BusinessEnglish(마이크로디그리)",
    "division": "001",
    "department": "영어영문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "니콜라스",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문301",
    "isOnline": false,
    "source": {
      "schedule": "인문301(금1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문301"
      }
    ],
    "sourceSchedule": "인문301(금1,2,3)"
  },
  {
    "id": "08775-001-2000658",
    "subjectKey": "08775",
    "name": "박물관문화콘텐츠",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "장우영",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합510",
    "isOnline": false,
    "source": {
      "schedule": "종합510(월4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합510"
      }
    ],
    "sourceSchedule": "종합510(월4,5,6)"
  },
  {
    "id": "08786-001-2000616",
    "subjectKey": "08786",
    "name": "공연과영상대본",
    "division": "001",
    "department": "국어국문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김명기",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문506",
    "isOnline": false,
    "source": {
      "schedule": "인문506(목4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문506"
      }
    ],
    "sourceSchedule": "인문506(목4,5,6)"
  },
  {
    "id": "08811-001-2000614",
    "subjectKey": "08811",
    "name": "뮤지컬노래연습2",
    "division": "001",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정혜령",
    "days": [
      "월"
    ],
    "startPeriod": 10,
    "endPeriod": 12,
    "room": "복지B104",
    "isOnline": false,
    "source": {
      "schedule": "복지B104(월10,11,12)"
    },
    "capacity": 10,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          10,
          11,
          12
        ],
        "classroom": "복지B104"
      }
    ],
    "sourceSchedule": "복지B104(월10,11,12)"
  },
  {
    "id": "08811-002-2000614",
    "subjectKey": "08811",
    "name": "뮤지컬노래연습2",
    "division": "002",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정혜령",
    "days": [
      "수"
    ],
    "startPeriod": 10,
    "endPeriod": 12,
    "room": "복지B104",
    "isOnline": false,
    "source": {
      "schedule": "복지B104(수10,11,12)"
    },
    "capacity": 10,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          10,
          11,
          12
        ],
        "classroom": "복지B104"
      }
    ],
    "sourceSchedule": "복지B104(수10,11,12)"
  },
  {
    "id": "08815-001-2000614",
    "subjectKey": "08815",
    "name": "세익스피어극연구",
    "division": "001",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김선욱",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "복지203",
    "isOnline": false,
    "source": {
      "schedule": "복지203(목1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "복지203"
      }
    ],
    "sourceSchedule": "복지203(목1,2,3)"
  },
  {
    "id": "08829-001-2000614",
    "subjectKey": "08829",
    "name": "희곡작법",
    "division": "001",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "배진아",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "복지305",
    "isOnline": false,
    "source": {
      "schedule": "복지305(수7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "복지305"
      }
    ],
    "sourceSchedule": "복지305(수7,8,9)"
  },
  {
    "id": "08832-001-2000614",
    "subjectKey": "08832",
    "name": "공연스텝실습2",
    "division": "001",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "이은경",
    "days": [
      "월"
    ],
    "startPeriod": 8,
    "endPeriod": 9,
    "room": "복지B105",
    "isOnline": false,
    "source": {
      "schedule": "복지B105(월8,9)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          8,
          9
        ],
        "classroom": "복지B105"
      }
    ],
    "sourceSchedule": "복지B105(월8,9)"
  },
  {
    "id": "08832-002-2000614",
    "subjectKey": "08832",
    "name": "공연스텝실습2",
    "division": "002",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "경은주",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "복지B105",
    "isOnline": false,
    "source": {
      "schedule": "복지B105(화5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "복지B105"
      }
    ],
    "sourceSchedule": "복지B105(화5,6)"
  },
  {
    "id": "08835-001-2000628",
    "subjectKey": "08835",
    "name": "인적자원관리",
    "division": "001",
    "department": "글로벌비즈니스",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조니",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경604",
    "isOnline": false,
    "source": {
      "schedule": "글경604(화1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경604"
      }
    ],
    "sourceSchedule": "글경604(화1,2,3)"
  },
  {
    "id": "08835-002-2000626",
    "subjectKey": "08835",
    "name": "인적자원관리(외국인전용)",
    "division": "002",
    "department": "경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "윤정권",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경607",
    "isOnline": false,
    "source": {
      "schedule": "글경607(목4,5,6)"
    },
    "capacity": 25,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경607"
      }
    ],
    "sourceSchedule": "글경607(목4,5,6)"
  },
  {
    "id": "08866-001-2000514",
    "subjectKey": "08866",
    "name": "자유전공",
    "division": "001",
    "department": "컴퓨터SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정양구",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "IT415",
    "isOnline": false,
    "source": {
      "schedule": "IT415(금5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "IT415"
      }
    ],
    "sourceSchedule": "IT415(금5,6,7)"
  },
  {
    "id": "08886-002-2000516",
    "subjectKey": "08886",
    "name": "창의적공학설계2",
    "division": "002",
    "department": "정보통신",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김시현",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT415",
    "isOnline": false,
    "source": {
      "schedule": "IT415(수1,2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT415"
      }
    ],
    "sourceSchedule": "IT415(수1,2,3,4)"
  },
  {
    "id": "08886-003-2000516",
    "subjectKey": "08886",
    "name": "창의적공학설계2",
    "division": "003",
    "department": "정보통신",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이중무",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT413",
    "isOnline": false,
    "source": {
      "schedule": "IT413(수1,2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT413"
      }
    ],
    "sourceSchedule": "IT413(수1,2,3,4)"
  },
  {
    "id": "08893-001-2000647",
    "subjectKey": "08893",
    "name": "소프트웨어설계",
    "division": "001",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김명숙",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT407",
    "isOnline": false,
    "source": {
      "schedule": "IT407(목2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT407"
      }
    ],
    "sourceSchedule": "IT407(목2,3,4)"
  },
  {
    "id": "08894-001-2000645",
    "subjectKey": "08894",
    "name": "알고리즘",
    "division": "001",
    "department": "미디어SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "신호진",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT413",
    "isOnline": false,
    "source": {
      "schedule": "IT413(목6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT413"
      }
    ],
    "sourceSchedule": "IT413(목6,7,8)"
  },
  {
    "id": "08894-002-2000647",
    "subjectKey": "08894",
    "name": "알고리즘",
    "division": "002",
    "department": "정보보호",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "전상훈",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT306",
    "isOnline": false,
    "source": {
      "schedule": "IT306(화1,2,3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT306"
      }
    ],
    "sourceSchedule": "IT306(화1,2,3,4)"
  },
  {
    "id": "08894-004-2000647",
    "subjectKey": "08894",
    "name": "알고리즘",
    "division": "004",
    "department": "정보보호",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "전상훈",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT306",
    "isOnline": false,
    "source": {
      "schedule": "IT306(목1,2,3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT306"
      }
    ],
    "sourceSchedule": "IT306(목1,2,3,4)"
  },
  {
    "id": "08898-001-2000645",
    "subjectKey": "08898",
    "name": "웹정보시스템",
    "division": "001",
    "department": "미디어SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "딜립 쿠말",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT413",
    "isOnline": false,
    "source": {
      "schedule": "IT413(화6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT413"
      }
    ],
    "sourceSchedule": "IT413(화6,7,8)"
  },
  {
    "id": "08904-001-2000589",
    "subjectKey": "08904",
    "name": "컴퓨터활용",
    "division": "001",
    "department": "건설환경에너지공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이재선",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "2공학116",
    "isOnline": false,
    "source": {
      "schedule": "2공학116(목4,5,6)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "2공학116"
      }
    ],
    "sourceSchedule": "2공학116(목4,5,6)"
  },
  {
    "id": "08904-001-2000763",
    "subjectKey": "08904",
    "name": "컴퓨터활용",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이재선",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "2공학116",
    "isOnline": false,
    "source": {
      "schedule": "2공학116(목4,5,6)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "2공학116"
      }
    ],
    "sourceSchedule": "2공학116(목4,5,6)"
  },
  {
    "id": "08904-002-2000589",
    "subjectKey": "08904",
    "name": "컴퓨터활용",
    "division": "002",
    "department": "건설환경에너지공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이재선",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "2공학116",
    "isOnline": false,
    "source": {
      "schedule": "2공학116(목7,8,9)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "2공학116"
      }
    ],
    "sourceSchedule": "2공학116(목7,8,9)"
  },
  {
    "id": "08904-002-2000763",
    "subjectKey": "08904",
    "name": "컴퓨터활용",
    "division": "002",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이재선",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "2공학116",
    "isOnline": false,
    "source": {
      "schedule": "2공학116(목7,8,9)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "2공학116"
      }
    ],
    "sourceSchedule": "2공학116(목7,8,9)"
  },
  {
    "id": "08904-003-2000589",
    "subjectKey": "08904",
    "name": "컴퓨터활용",
    "division": "003",
    "department": "건설환경에너지공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이재선",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "2공학116",
    "isOnline": false,
    "source": {
      "schedule": "2공학116(수6,7,8)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "2공학116"
      }
    ],
    "sourceSchedule": "2공학116(수6,7,8)"
  },
  {
    "id": "08904-003-2000763",
    "subjectKey": "08904",
    "name": "컴퓨터활용",
    "division": "003",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이재선",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "2공학116",
    "isOnline": false,
    "source": {
      "schedule": "2공학116(수6,7,8)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "2공학116"
      }
    ],
    "sourceSchedule": "2공학116(수6,7,8)"
  },
  {
    "id": "08933-001-2000636",
    "subjectKey": "08933",
    "name": "건축철근콘크리트",
    "division": "001",
    "department": "건축학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박지슬",
    "days": [
      "목",
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "2공학314",
    "isOnline": false,
    "source": {
      "schedule": "2공학314(목1,2),종합410(금3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2
        ],
        "classroom": "2공학314"
      },
      {
        "day": "금",
        "periods": [
          3
        ],
        "classroom": "종합410"
      }
    ],
    "sourceSchedule": "2공학314(목1,2),종합410(금3)"
  },
  {
    "id": "08947-001-2000746",
    "subjectKey": "08947",
    "name": "문화콘텐츠의이해",
    "division": "001",
    "department": "미디어커뮤니케이션",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이문행",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문400",
    "isOnline": false,
    "source": {
      "schedule": "인문400(수5,6,7)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문400"
      }
    ],
    "sourceSchedule": "인문400(수5,6,7)"
  },
  {
    "id": "09025-001-2000634",
    "subjectKey": "09025",
    "name": "하수도공학및실험",
    "division": "001",
    "department": "건설환경공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이채영",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합411",
    "isOnline": false,
    "source": {
      "schedule": "종합411(월2,3 화2,3)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "종합411"
      },
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "종합411"
      }
    ],
    "sourceSchedule": "종합411(월2,3 화2,3)"
  },
  {
    "id": "09034-001-2000642",
    "subjectKey": "09034",
    "name": "재료과학및공학2",
    "division": "001",
    "department": "신소재공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김창민",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합409",
    "isOnline": false,
    "source": {
      "schedule": "종합409(화2,3 목3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "종합409"
      },
      {
        "day": "목",
        "periods": [
          3
        ],
        "classroom": "종합409"
      }
    ],
    "sourceSchedule": "종합409(화2,3 목3)"
  },
  {
    "id": "09035-001-2000642",
    "subjectKey": "09035",
    "name": "고분자재료공정및설계",
    "division": "001",
    "department": "신소재공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정성은",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "2공학115",
    "isOnline": false,
    "source": {
      "schedule": "2공학115(월7 화5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "2공학115"
      },
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "2공학115"
      }
    ],
    "sourceSchedule": "2공학115(월7 화5,6)"
  },
  {
    "id": "09037-001-2000445",
    "subjectKey": "09037",
    "name": "환경친화형도료설계",
    "division": "001",
    "department": "신소재공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정경호",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "자연관407",
    "isOnline": false,
    "source": {
      "schedule": "자연관407(화1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "자연관407"
      }
    ],
    "sourceSchedule": "자연관407(화1,2,3)"
  },
  {
    "id": "09042-001-2000180",
    "subjectKey": "09042",
    "name": "센서시스템설계",
    "division": "001",
    "department": "전기공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "강정민",
    "days": [
      "수",
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합306",
    "isOnline": false,
    "source": {
      "schedule": "종합306(수2,3),종합404(화5)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "종합306"
      },
      {
        "day": "화",
        "periods": [
          5
        ],
        "classroom": "종합404"
      }
    ],
    "sourceSchedule": "종합306(수2,3),종합404(화5)"
  },
  {
    "id": "09058-001-2000653",
    "subjectKey": "09058",
    "name": "Package Design2",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고은미",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술205",
    "isOnline": false,
    "source": {
      "schedule": "미술205(월5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술205"
      }
    ],
    "sourceSchedule": "미술205(월5,6,7,8)"
  },
  {
    "id": "09058-002-2000653",
    "subjectKey": "09058",
    "name": "Package Design2",
    "division": "002",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고은미",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술203",
    "isOnline": false,
    "source": {
      "schedule": "미술203(화5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술203"
      }
    ],
    "sourceSchedule": "미술203(화5,6,7,8)"
  },
  {
    "id": "09062-001-2000603",
    "subjectKey": "09062",
    "name": "Art History2",
    "division": "001",
    "department": "조형예술학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "강나영",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미술102",
    "isOnline": false,
    "source": {
      "schedule": "미술102(금6,7)"
    },
    "capacity": 22,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7
        ],
        "classroom": "미술102"
      }
    ],
    "sourceSchedule": "미술102(금6,7)"
  },
  {
    "id": "09062-002-2000654",
    "subjectKey": "09062",
    "name": "Art History2",
    "division": "002",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김미경",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "종합403",
    "isOnline": false,
    "source": {
      "schedule": "종합403(화4,5)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "종합403"
      }
    ],
    "sourceSchedule": "종합403(화4,5)"
  },
  {
    "id": "09062-003-2000655",
    "subjectKey": "09062",
    "name": "Art History2",
    "division": "003",
    "department": "공예디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박성림",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미술204",
    "isOnline": false,
    "source": {
      "schedule": "미술204(월6,7)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "미술204"
      }
    ],
    "sourceSchedule": "미술204(월6,7)"
  },
  {
    "id": "09062-004-2000603",
    "subjectKey": "09062",
    "name": "Art History2",
    "division": "004",
    "department": "조형예술학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김수정",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미술102",
    "isOnline": false,
    "source": {
      "schedule": "미술102(월4,5)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5
        ],
        "classroom": "미술102"
      }
    ],
    "sourceSchedule": "미술102(월4,5)"
  },
  {
    "id": "09062-005-2000603",
    "subjectKey": "09062",
    "name": "Art History2",
    "division": "005",
    "department": "조형예술학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "최정희",
    "days": [
      "월"
    ],
    "startPeriod": 8,
    "endPeriod": 9,
    "room": "미술114",
    "isOnline": false,
    "source": {
      "schedule": "미술114(월8,9)"
    },
    "capacity": 31,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          8,
          9
        ],
        "classroom": "미술114"
      }
    ],
    "sourceSchedule": "미술114(월8,9)"
  },
  {
    "id": "09067-001-2000654",
    "subjectKey": "09067",
    "name": "Pattern Design2",
    "division": "001",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "조유림",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "종합B107",
    "isOnline": false,
    "source": {
      "schedule": "종합B107(월1,2,3,4)"
    },
    "capacity": 11,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "종합B107"
      }
    ],
    "sourceSchedule": "종합B107(월1,2,3,4)"
  },
  {
    "id": "09067-002-2000654",
    "subjectKey": "09067",
    "name": "Pattern Design2",
    "division": "002",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "강민정",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "종합B107",
    "isOnline": false,
    "source": {
      "schedule": "종합B107(수1,2,3,4)"
    },
    "capacity": 11,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "종합B107"
      }
    ],
    "sourceSchedule": "종합B107(수1,2,3,4)"
  },
  {
    "id": "09068-001-2000654",
    "subjectKey": "09068",
    "name": "Fashion Design4",
    "division": "001",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "원경미",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "종합B108",
    "isOnline": false,
    "source": {
      "schedule": "종합B108(화2,3,4)"
    },
    "capacity": 14,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "종합B108"
      }
    ],
    "sourceSchedule": "종합B108(화2,3,4)"
  },
  {
    "id": "09068-002-2000654",
    "subjectKey": "09068",
    "name": "Fashion Design4",
    "division": "002",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "원경미",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "종합B108",
    "isOnline": false,
    "source": {
      "schedule": "종합B108(금2,3,4)"
    },
    "capacity": 13,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "종합B108"
      }
    ],
    "sourceSchedule": "종합B108(금2,3,4)"
  },
  {
    "id": "09069-001-2000653",
    "subjectKey": "09069",
    "name": "Design Studio1",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이의정",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술208",
    "isOnline": false,
    "source": {
      "schedule": "미술208(화5,6,7,8)"
    },
    "capacity": 24,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술208"
      }
    ],
    "sourceSchedule": "미술208(화5,6,7,8)"
  },
  {
    "id": "09069-002-2000653",
    "subjectKey": "09069",
    "name": "Design Studio1",
    "division": "002",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이의정",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술208",
    "isOnline": false,
    "source": {
      "schedule": "미술208(수1,2,3,4)"
    },
    "capacity": 24,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술208"
      }
    ],
    "sourceSchedule": "미술208(수1,2,3,4)"
  },
  {
    "id": "09071-001-2000255",
    "subjectKey": "09071",
    "name": "Design Studio2",
    "division": "001",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이상희",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술110",
    "isOnline": false,
    "source": {
      "schedule": "미술110(월1,2,3,4)"
    },
    "capacity": 10,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술110"
      }
    ],
    "sourceSchedule": "미술110(월1,2,3,4)"
  },
  {
    "id": "09071-002-2000255",
    "subjectKey": "09071",
    "name": "Design Studio2",
    "division": "002",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이상희",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술110",
    "isOnline": false,
    "source": {
      "schedule": "미술110(금1,2,3,4)"
    },
    "capacity": 10,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술110"
      }
    ],
    "sourceSchedule": "미술110(금1,2,3,4)"
  },
  {
    "id": "09083-001-2000654",
    "subjectKey": "09083",
    "name": "Fashion Drawing2",
    "division": "001",
    "department": "패션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "권지현",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술211",
    "isOnline": false,
    "source": {
      "schedule": "미술211(목1,2,3,4)"
    },
    "capacity": 15,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술211"
      }
    ],
    "sourceSchedule": "미술211(목1,2,3,4)"
  },
  {
    "id": "09087-001-2000583",
    "subjectKey": "09087",
    "name": "방송영상제작2",
    "division": "001",
    "department": "미디어커뮤니케이션학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김민수",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문310",
    "isOnline": false,
    "source": {
      "schedule": "인문310(금6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문310"
      }
    ],
    "sourceSchedule": "인문310(금6,7,8)"
  },
  {
    "id": "09116-001-2000645",
    "subjectKey": "09116",
    "name": "IT표준",
    "division": "001",
    "department": "미디어SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "딜립 쿠말",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT309",
    "isOnline": false,
    "source": {
      "schedule": "IT309(목6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT309"
      }
    ],
    "sourceSchedule": "IT309(목6,7,8)"
  },
  {
    "id": "09133-001-2000658",
    "subjectKey": "09133",
    "name": "교양한국어초급(외국인전용)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "두린린",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "국제309",
    "isOnline": false,
    "source": {
      "schedule": "국제309(화1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "국제309"
      }
    ],
    "sourceSchedule": "국제309(화1,2,3)"
  },
  {
    "id": "09139-001-2000601",
    "subjectKey": "09139",
    "name": "고급영양학",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김형숙",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "생활302",
    "isOnline": false,
    "source": {
      "schedule": "생활302(월1),생활502(화4,5)"
    },
    "capacity": 80,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1
        ],
        "classroom": "생활302"
      },
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "생활502"
      }
    ],
    "sourceSchedule": "생활302(월1),생활502(화4,5)"
  },
  {
    "id": "09143-001-2000601",
    "subjectKey": "09143",
    "name": "단체급식관리",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최은정",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합609",
    "isOnline": false,
    "source": {
      "schedule": "종합609(수5,6,7)"
    },
    "capacity": 60,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합609"
      }
    ],
    "sourceSchedule": "종합609(수5,6,7)"
  },
  {
    "id": "09145-001-2000433",
    "subjectKey": "09145",
    "name": "영양사현장실습",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김형숙",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "생활302",
    "isOnline": false,
    "source": {
      "schedule": "생활302(수4 목5,6)"
    },
    "capacity": 80,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "생활302"
      },
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "생활302"
      }
    ],
    "sourceSchedule": "생활302(수4 목5,6)"
  },
  {
    "id": "09147-001-2000658",
    "subjectKey": "09147",
    "name": "교육과정",
    "division": "001",
    "department": "교양",
    "category": "교직",
    "sourceCategory": "교직",
    "credit": 2,
    "professor": "전영미",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합210-2",
    "isOnline": false,
    "source": {
      "schedule": "종합210-2(화5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "종합210-2"
      }
    ],
    "sourceSchedule": "종합210-2(화5,6)"
  },
  {
    "id": "09151-001-2000286",
    "subjectKey": "09151",
    "name": "교육봉사(교직이수예정자 전용)",
    "division": "001",
    "department": "교양",
    "category": "교직",
    "sourceCategory": "교직",
    "credit": 2,
    "professor": "전영미",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "09164-001-2000643",
    "subjectKey": "09164",
    "name": "화학공학응용및실험 ",
    "division": "001",
    "department": "화학공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박진혁",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "2공학409",
    "isOnline": false,
    "source": {
      "schedule": "2공학409(수5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "2공학409"
      }
    ],
    "sourceSchedule": "2공학409(수5,6,7,8)"
  },
  {
    "id": "09164-002-2000643",
    "subjectKey": "09164",
    "name": "화학공학응용및실험 ",
    "division": "002",
    "department": "화학공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "황인국",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 7,
    "room": "2공학409",
    "isOnline": false,
    "source": {
      "schedule": "2공학409(목4,5,6,7)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6,
          7
        ],
        "classroom": "2공학409"
      }
    ],
    "sourceSchedule": "2공학409(목4,5,6,7)"
  },
  {
    "id": "09179-001-2000296",
    "subjectKey": "09179",
    "name": "일본의역사와문화",
    "division": "001",
    "department": "일어일문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이성근",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경414",
    "isOnline": false,
    "source": {
      "schedule": "글경414(수5,6,7)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경414"
      }
    ],
    "sourceSchedule": "글경414(수5,6,7)"
  },
  {
    "id": "09184-001-2000405",
    "subjectKey": "09184",
    "name": "정부규제론",
    "division": "001",
    "department": "행정학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정하나",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문406",
    "isOnline": false,
    "source": {
      "schedule": "인문406(수6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문406"
      }
    ],
    "sourceSchedule": "인문406(수6,7,8)"
  },
  {
    "id": "09184-002-2000301",
    "subjectKey": "09184",
    "name": "정부규제론",
    "division": "002",
    "department": "행정학과(야)",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정하나",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문406",
    "isOnline": false,
    "source": {
      "schedule": "인문406(수6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문406"
      }
    ],
    "sourceSchedule": "인문406(수6,7,8)"
  },
  {
    "id": "09188-001-2000405",
    "subjectKey": "09188",
    "name": "과학기술정책",
    "division": "001",
    "department": "행정학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김병수",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문107",
    "isOnline": false,
    "source": {
      "schedule": "인문107(목2,3,4)"
    },
    "capacity": 35,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문107"
      }
    ],
    "sourceSchedule": "인문107(목2,3,4)"
  },
  {
    "id": "09190-001-2000628",
    "subjectKey": "09190",
    "name": "경영전략",
    "division": "001",
    "department": "글로벌비즈니스",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "양지연",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "글경602",
    "isOnline": false,
    "source": {
      "schedule": "글경602(월2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "글경602"
      }
    ],
    "sourceSchedule": "글경602(월2,3,4)"
  },
  {
    "id": "09190-002-2000628",
    "subjectKey": "09190",
    "name": "경영전략",
    "division": "002",
    "department": "글로벌비즈니스",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "양지연",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경602",
    "isOnline": false,
    "source": {
      "schedule": "글경602(수5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경602"
      }
    ],
    "sourceSchedule": "글경602(수5,6,7)"
  },
  {
    "id": "09191-001-2000505",
    "subjectKey": "09191",
    "name": "윤리경영(경영_마이크로디그리)",
    "division": "001",
    "department": "경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "윤정권",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "글경607",
    "isOnline": false,
    "source": {
      "schedule": "글경607(목7,8,9)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "글경607"
      }
    ],
    "sourceSchedule": "글경607(목7,8,9)"
  },
  {
    "id": "09216-001-2000411",
    "subjectKey": "09216",
    "name": "토목구조물설계",
    "division": "001",
    "department": "건설환경공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이주하",
    "days": [
      "화",
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "미래103",
    "isOnline": false,
    "source": {
      "schedule": "미래103(화3),미래104(월5,6)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3
        ],
        "classroom": "미래103"
      },
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래104"
      }
    ],
    "sourceSchedule": "미래103(화3),미래104(월5,6)"
  },
  {
    "id": "09221-001-2000639",
    "subjectKey": "09221",
    "name": "기계가공",
    "division": "001",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "진장민",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합405",
    "isOnline": false,
    "source": {
      "schedule": "종합405(목1,2,3)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합405"
      }
    ],
    "sourceSchedule": "종합405(목1,2,3)"
  },
  {
    "id": "09221-002-2000639",
    "subjectKey": "09221",
    "name": "기계가공",
    "division": "002",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "진장민",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "자연관309",
    "isOnline": false,
    "source": {
      "schedule": "자연관309(목5,6,7)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "자연관309"
      }
    ],
    "sourceSchedule": "자연관309(목5,6,7)"
  },
  {
    "id": "09225-001-2000643",
    "subjectKey": "09225",
    "name": "화공기초응용및실험",
    "division": "001",
    "department": "화학공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "유종훈",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "2공학407",
    "isOnline": false,
    "source": {
      "schedule": "2공학407(월5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "2공학407"
      }
    ],
    "sourceSchedule": "2공학407(월5,6,7,8)"
  },
  {
    "id": "09225-002-2000643",
    "subjectKey": "09225",
    "name": "화공기초응용및실험",
    "division": "002",
    "department": "화학공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "노호식",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "2공학407",
    "isOnline": false,
    "source": {
      "schedule": "2공학407(화1,2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "2공학407"
      }
    ],
    "sourceSchedule": "2공학407(화1,2,3,4)"
  },
  {
    "id": "09230-001-2000589",
    "subjectKey": "09230",
    "name": "환경에너지공학개론",
    "division": "001",
    "department": "건설환경에너지공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "백승기",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합302",
    "isOnline": false,
    "source": {
      "schedule": "종합302(화2,3)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "종합302"
      }
    ],
    "sourceSchedule": "종합302(화2,3)"
  },
  {
    "id": "09230-001-2000763",
    "subjectKey": "09230",
    "name": "환경에너지공학개론",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "백승기",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합302",
    "isOnline": false,
    "source": {
      "schedule": "종합302(화2,3)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "종합302"
      }
    ],
    "sourceSchedule": "종합302(화2,3)"
  },
  {
    "id": "09230-002-2000589",
    "subjectKey": "09230",
    "name": "환경에너지공학개론",
    "division": "002",
    "department": "건설환경에너지공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "차규현",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합408",
    "isOnline": false,
    "source": {
      "schedule": "종합408(화2,3)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "종합408"
      }
    ],
    "sourceSchedule": "종합408(화2,3)"
  },
  {
    "id": "09230-002-2000763",
    "subjectKey": "09230",
    "name": "환경에너지공학개론",
    "division": "002",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "차규현",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합408",
    "isOnline": false,
    "source": {
      "schedule": "종합408(화2,3)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "종합408"
      }
    ],
    "sourceSchedule": "종합408(화2,3)"
  },
  {
    "id": "09242-001-2000614",
    "subjectKey": "09242",
    "name": "세계영화사",
    "division": "001",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이수길",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "복지305",
    "isOnline": false,
    "source": {
      "schedule": "복지305(금1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "복지305"
      }
    ],
    "sourceSchedule": "복지305(금1,2,3)"
  },
  {
    "id": "09247-001-2000614",
    "subjectKey": "09247",
    "name": "기초연기2",
    "division": "001",
    "department": "연기예술",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "고영민",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "복지B104",
    "isOnline": false,
    "source": {
      "schedule": "복지B104(금4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "복지B104"
      }
    ],
    "sourceSchedule": "복지B104(금4,5,6)"
  },
  {
    "id": "09247-002-2000614",
    "subjectKey": "09247",
    "name": "기초연기2",
    "division": "002",
    "department": "연기예술",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "고영민",
    "days": [
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "복지B104",
    "isOnline": false,
    "source": {
      "schedule": "복지B104(금7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "복지B104"
      }
    ],
    "sourceSchedule": "복지B104(금7,8,9)"
  },
  {
    "id": "09247-003-2000614",
    "subjectKey": "09247",
    "name": "기초연기2",
    "division": "003",
    "department": "연기예술",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "고영민",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "복지B104",
    "isOnline": false,
    "source": {
      "schedule": "복지B104(월3,4,5)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "복지B104"
      }
    ],
    "sourceSchedule": "복지B104(월3,4,5)"
  },
  {
    "id": "09248-001-2000614",
    "subjectKey": "09248",
    "name": "연극제작실습기초",
    "division": "001",
    "department": "연기예술",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김은경",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 12,
    "room": "복지B104",
    "isOnline": false,
    "source": {
      "schedule": "복지B104(목7,8,9,10,11,12)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9,
          10,
          11,
          12
        ],
        "classroom": "복지B104"
      }
    ],
    "sourceSchedule": "복지B104(목7,8,9,10,11,12)"
  },
  {
    "id": "09248-002-2000614",
    "subjectKey": "09248",
    "name": "연극제작실습기초",
    "division": "002",
    "department": "연기예술",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박진우",
    "days": [
      "수"
    ],
    "startPeriod": 10,
    "endPeriod": 15,
    "room": "복지B103",
    "isOnline": false,
    "source": {
      "schedule": "복지B103(수10,11,12,13,14,15)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          10,
          11,
          12,
          13,
          14,
          15
        ],
        "classroom": "복지B103"
      }
    ],
    "sourceSchedule": "복지B103(수10,11,12,13,14,15)"
  },
  {
    "id": "09257-001-2000614",
    "subjectKey": "09257",
    "name": "중급연기2",
    "division": "001",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "문경태",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "복지B109-1",
    "isOnline": false,
    "source": {
      "schedule": "복지B109-1(금2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "복지B109-1"
      }
    ],
    "sourceSchedule": "복지B109-1(금2,3,4)"
  },
  {
    "id": "09257-002-2000614",
    "subjectKey": "09257",
    "name": "중급연기2",
    "division": "002",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "문경태",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "복지B109-1",
    "isOnline": false,
    "source": {
      "schedule": "복지B109-1(금6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "복지B109-1"
      }
    ],
    "sourceSchedule": "복지B109-1(금6,7,8)"
  },
  {
    "id": "09257-003-2000614",
    "subjectKey": "09257",
    "name": "중급연기2",
    "division": "003",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "문경태",
    "days": [
      "금"
    ],
    "startPeriod": 9,
    "endPeriod": 11,
    "room": "복지B109-1",
    "isOnline": false,
    "source": {
      "schedule": "복지B109-1(금9,10,11)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          9,
          10,
          11
        ],
        "classroom": "복지B109-1"
      }
    ],
    "sourceSchedule": "복지B109-1(금9,10,11)"
  },
  {
    "id": "09258-001-2000614",
    "subjectKey": "09258",
    "name": "연극제작실습2",
    "division": "001",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "오광욱",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 12,
    "room": "복지B109",
    "isOnline": false,
    "source": {
      "schedule": "복지B109(목7,8,9,10,11,12)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9,
          10,
          11,
          12
        ],
        "classroom": "복지B109"
      }
    ],
    "sourceSchedule": "복지B109(목7,8,9,10,11,12)"
  },
  {
    "id": "09258-002-2000614",
    "subjectKey": "09258",
    "name": "연극제작실습2",
    "division": "002",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김보경",
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 10,
    "endPeriod": 12,
    "room": "복지B109-1",
    "isOnline": false,
    "source": {
      "schedule": "복지B109-1(월10,11,12 목10,11,12)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          10,
          11,
          12
        ],
        "classroom": "복지B109-1"
      },
      {
        "day": "목",
        "periods": [
          10,
          11,
          12
        ],
        "classroom": "복지B109-1"
      }
    ],
    "sourceSchedule": "복지B109-1(월10,11,12 목10,11,12)"
  },
  {
    "id": "09267-001-2000614",
    "subjectKey": "09267",
    "name": "고급연기2",
    "division": "001",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "전용환",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "복지B109-1",
    "isOnline": false,
    "source": {
      "schedule": "복지B109-1(화2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "복지B109-1"
      }
    ],
    "sourceSchedule": "복지B109-1(화2,3,4)"
  },
  {
    "id": "09267-002-2000614",
    "subjectKey": "09267",
    "name": "고급연기2",
    "division": "002",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "최연수",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "복지B105",
    "isOnline": false,
    "source": {
      "schedule": "복지B105(화2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "복지B105"
      }
    ],
    "sourceSchedule": "복지B105(화2,3,4)"
  },
  {
    "id": "09268-001-2000614",
    "subjectKey": "09268",
    "name": "연극제작실습3",
    "division": "001",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양기찬",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 10,
    "endPeriod": 12,
    "room": "복지B105",
    "isOnline": false,
    "source": {
      "schedule": "복지B105(화10,11,12 금7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          10,
          11,
          12
        ],
        "classroom": "복지B105"
      },
      {
        "day": "금",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "복지B105"
      }
    ],
    "sourceSchedule": "복지B105(화10,11,12 금7,8,9)"
  },
  {
    "id": "09268-002-2000614",
    "subjectKey": "09268",
    "name": "연극제작실습3",
    "division": "002",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양기찬",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "복지B105",
    "isOnline": false,
    "source": {
      "schedule": "복지B105(화7,8,9 금10,11,12)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "복지B105"
      },
      {
        "day": "금",
        "periods": [
          10,
          11,
          12
        ],
        "classroom": "복지B105"
      }
    ],
    "sourceSchedule": "복지B105(화7,8,9 금10,11,12)"
  },
  {
    "id": "09269-001-2000441",
    "subjectKey": "09269",
    "name": "카메라연기2",
    "division": "001",
    "department": "연극",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "권형진",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "복지B105",
    "isOnline": false,
    "source": {
      "schedule": "복지B105(수5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "복지B105"
      }
    ],
    "sourceSchedule": "복지B105(수5,6,7)"
  },
  {
    "id": "09269-002-2000441",
    "subjectKey": "09269",
    "name": "카메라연기2",
    "division": "002",
    "department": "연극",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "권형진",
    "days": [
      "수"
    ],
    "startPeriod": 8,
    "endPeriod": 10,
    "room": "복지B105",
    "isOnline": false,
    "source": {
      "schedule": "복지B105(수8,9,10)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          8,
          9,
          10
        ],
        "classroom": "복지B105"
      }
    ],
    "sourceSchedule": "복지B105(수8,9,10)"
  },
  {
    "id": "09271-001-2000441",
    "subjectKey": "09271",
    "name": "연극제작실습5",
    "division": "001",
    "department": "연극",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "전용환",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 12,
    "room": "복지B106-1",
    "isOnline": false,
    "source": {
      "schedule": "복지B106-1(월7,8,9,10,11,12)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9,
          10,
          11,
          12
        ],
        "classroom": "복지B106-1"
      }
    ],
    "sourceSchedule": "복지B106-1(월7,8,9,10,11,12)"
  },
  {
    "id": "09271-002-2000441",
    "subjectKey": "09271",
    "name": "연극제작실습5",
    "division": "002",
    "department": "연극",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "경은주",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 10,
    "endPeriod": 12,
    "room": "복지B106-1",
    "isOnline": false,
    "source": {
      "schedule": "복지B106-1(화10,11,12 금11,12,13)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          10,
          11,
          12
        ],
        "classroom": "복지B106-1"
      },
      {
        "day": "금",
        "periods": [
          11,
          12,
          13
        ],
        "classroom": "복지B106-1"
      }
    ],
    "sourceSchedule": "복지B106-1(화10,11,12 금11,12,13)"
  },
  {
    "id": "09277-001-2000613",
    "subjectKey": "09277",
    "name": "관찰과상상",
    "division": "001",
    "department": "영화예술",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김계중",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "복지405",
    "isOnline": false,
    "source": {
      "schedule": "복지405(수2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "복지405"
      }
    ],
    "sourceSchedule": "복지405(수2,3,4)"
  },
  {
    "id": "09277-002-2000613",
    "subjectKey": "09277",
    "name": "관찰과상상",
    "division": "002",
    "department": "영화예술",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김계중",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "복지405",
    "isOnline": false,
    "source": {
      "schedule": "복지405(수6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "복지405"
      }
    ],
    "sourceSchedule": "복지405(수6,7,8)"
  },
  {
    "id": "09291-001-2000613",
    "subjectKey": "09291",
    "name": "프로덕션디자인실습",
    "division": "001",
    "department": "영화예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "임찬상",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "복지305",
    "isOnline": false,
    "source": {
      "schedule": "복지305(화1,2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "복지305"
      }
    ],
    "sourceSchedule": "복지305(화1,2,3,4)"
  },
  {
    "id": "09295-001-2000613",
    "subjectKey": "09295",
    "name": "촬영및조명실습2",
    "division": "001",
    "department": "영화예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "엄태식",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "복지306",
    "isOnline": false,
    "source": {
      "schedule": "복지306(화1,2,3)"
    },
    "capacity": 10,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "복지306"
      }
    ],
    "sourceSchedule": "복지306(화1,2,3)"
  },
  {
    "id": "09317-001-2000630",
    "subjectKey": "09317",
    "name": "외식경영전략",
    "division": "001",
    "department": "외식경영",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "최준봉",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경701",
    "isOnline": false,
    "source": {
      "schedule": "글경701(월1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경701"
      }
    ],
    "sourceSchedule": "글경701(월1,2,3)"
  },
  {
    "id": "09319-001-2000631",
    "subjectKey": "09319",
    "name": "관광컨텐츠개발",
    "division": "001",
    "department": "관광경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조영훈",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경701",
    "isOnline": false,
    "source": {
      "schedule": "글경701(수1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경701"
      }
    ],
    "sourceSchedule": "글경701(수1,2,3)"
  },
  {
    "id": "09323-001-2000630",
    "subjectKey": "09323",
    "name": "외식마케팅",
    "division": "001",
    "department": "외식경영",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "조미나",
    "days": [
      "수",
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "글경702",
    "isOnline": false,
    "source": {
      "schedule": "글경702(수3,4),글경703(화2)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "글경702"
      },
      {
        "day": "화",
        "periods": [
          2
        ],
        "classroom": "글경703"
      }
    ],
    "sourceSchedule": "글경702(수3,4),글경703(화2)"
  },
  {
    "id": "09327-001-2000630",
    "subjectKey": "09327",
    "name": "메뉴기획과디자인",
    "division": "001",
    "department": "외식경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최준봉",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "글경701",
    "isOnline": false,
    "source": {
      "schedule": "글경701(화6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "글경701"
      }
    ],
    "sourceSchedule": "글경701(화6,7,8)"
  },
  {
    "id": "09333-001-2000587",
    "subjectKey": "09333",
    "name": "호텔관광재무관리",
    "division": "001",
    "department": "호텔관광학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "임경",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경701",
    "isOnline": false,
    "source": {
      "schedule": "글경701(목1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경701"
      }
    ],
    "sourceSchedule": "글경701(목1,2,3)"
  },
  {
    "id": "09342-001-2000587",
    "subjectKey": "09342",
    "name": "호텔관광경영정보론",
    "division": "001",
    "department": "호텔관광학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "허경석",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "글경701",
    "isOnline": false,
    "source": {
      "schedule": "글경701(화2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "글경701"
      }
    ],
    "sourceSchedule": "글경701(화2,3,4)"
  },
  {
    "id": "09357-001-2000614",
    "subjectKey": "09357",
    "name": "연극영화교과교재연구및지도법",
    "division": "001",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "권석류",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "복지202",
    "isOnline": false,
    "source": {
      "schedule": "복지202(금2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "복지202"
      }
    ],
    "sourceSchedule": "복지202(금2,3,4)"
  },
  {
    "id": "09358-001-2000441",
    "subjectKey": "09358",
    "name": "연극영화교과논리및논술",
    "division": "001",
    "department": "연극",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김선욱",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "복지203",
    "isOnline": false,
    "source": {
      "schedule": "복지203(목4,5)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5
        ],
        "classroom": "복지203"
      }
    ],
    "sourceSchedule": "복지203(목4,5)"
  },
  {
    "id": "09375-001-2000599",
    "subjectKey": "09375",
    "name": "가정교과교재연구및지도법",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "강남주",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "생활202",
    "isOnline": false,
    "source": {
      "schedule": "생활202(월7,8,9)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "생활202"
      }
    ],
    "sourceSchedule": "생활202(월7,8,9)"
  },
  {
    "id": "09376-001-2000431",
    "subjectKey": "09376",
    "name": "가정교과논리및논술",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "고은경",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "IT107",
    "isOnline": false,
    "source": {
      "schedule": "IT107(목6,7)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7
        ],
        "classroom": "IT107"
      }
    ],
    "sourceSchedule": "IT107(목6,7)"
  },
  {
    "id": "09401-001-2000651",
    "subjectKey": "09401",
    "name": "채색화2",
    "division": "001",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "홍미림",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "조형408",
    "isOnline": false,
    "source": {
      "schedule": "조형408(월1,2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "조형408"
      }
    ],
    "sourceSchedule": "조형408(월1,2,3,4)"
  },
  {
    "id": "09440-001-2000651",
    "subjectKey": "09440",
    "name": "회화2",
    "division": "001",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "장양희",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "조형408",
    "isOnline": false,
    "source": {
      "schedule": "조형408(화6,7,8,9)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "조형408"
      }
    ],
    "sourceSchedule": "조형408(화6,7,8,9)"
  },
  {
    "id": "09440-002-2000651",
    "subjectKey": "09440",
    "name": "회화2",
    "division": "002",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이태경",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "조형301",
    "isOnline": false,
    "source": {
      "schedule": "조형301(목1,2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "조형301"
      }
    ],
    "sourceSchedule": "조형301(목1,2,3,4)"
  },
  {
    "id": "09450-001-2000651",
    "subjectKey": "09450",
    "name": "판화2",
    "division": "001",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "윤세희",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "조형209",
    "isOnline": false,
    "source": {
      "schedule": "조형209(수6,7,8,9)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "조형209"
      }
    ],
    "sourceSchedule": "조형209(수6,7,8,9)"
  },
  {
    "id": "09464-001-2000651",
    "subjectKey": "09464",
    "name": "영상2",
    "division": "001",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김규년",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술201",
    "isOnline": false,
    "source": {
      "schedule": "미술201(수1,2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술201"
      }
    ],
    "sourceSchedule": "미술201(수1,2,3,4)"
  },
  {
    "id": "09466-001-2000651",
    "subjectKey": "09466",
    "name": "회화4",
    "division": "001",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김명곤",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "조형305",
    "isOnline": false,
    "source": {
      "schedule": "조형305(월1,2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "조형305"
      }
    ],
    "sourceSchedule": "조형305(월1,2,3,4)"
  },
  {
    "id": "09466-002-2000651",
    "subjectKey": "09466",
    "name": "회화4",
    "division": "002",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이소영",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "조형302",
    "isOnline": false,
    "source": {
      "schedule": "조형302(목1,2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "조형302"
      }
    ],
    "sourceSchedule": "조형302(목1,2,3,4)"
  },
  {
    "id": "09472-001-2000447",
    "subjectKey": "09472",
    "name": "회화6",
    "division": "001",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이소영",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미술108",
    "isOnline": false,
    "source": {
      "schedule": "미술108(수1,2),미술109(수6,7)"
    },
    "capacity": 21,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2
        ],
        "classroom": "미술108"
      },
      {
        "day": "수",
        "periods": [
          6,
          7
        ],
        "classroom": "미술109"
      }
    ],
    "sourceSchedule": "미술108(수1,2),미술109(수6,7)"
  },
  {
    "id": "09472-002-2000447",
    "subjectKey": "09472",
    "name": "회화6",
    "division": "002",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이태경",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 7,
    "room": "조형307",
    "isOnline": false,
    "source": {
      "schedule": "조형307(수1,2,6,7)"
    },
    "capacity": 21,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          6,
          7
        ],
        "classroom": "조형307"
      }
    ],
    "sourceSchedule": "조형307(수1,2,6,7)"
  },
  {
    "id": "09473-001-2000251",
    "subjectKey": "09473",
    "name": "특수실기연구2",
    "division": "001",
    "department": "조소",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이지은",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "조형101",
    "isOnline": false,
    "source": {
      "schedule": "조형101(목1,2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "조형101"
      }
    ],
    "sourceSchedule": "조형101(목1,2,3,4)"
  },
  {
    "id": "09473-002-2000447",
    "subjectKey": "09473",
    "name": "특수실기연구2",
    "division": "002",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이소영",
    "days": [
      "목",
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미술108",
    "isOnline": false,
    "source": {
      "schedule": "미술108(목6,7),미술109(월6,7)"
    },
    "capacity": 21,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7
        ],
        "classroom": "미술108"
      },
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "미술109"
      }
    ],
    "sourceSchedule": "미술108(목6,7),미술109(월6,7)"
  },
  {
    "id": "09473-003-2000447",
    "subjectKey": "09473",
    "name": "특수실기연구2",
    "division": "003",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이태경",
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 8,
    "endPeriod": 9,
    "room": "조형307",
    "isOnline": false,
    "source": {
      "schedule": "조형307(월8,9 목6,7)"
    },
    "capacity": 21,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          8,
          9
        ],
        "classroom": "조형307"
      },
      {
        "day": "목",
        "periods": [
          6,
          7
        ],
        "classroom": "조형307"
      }
    ],
    "sourceSchedule": "조형307(월8,9 목6,7)"
  },
  {
    "id": "09476-001-2000251",
    "subjectKey": "09476",
    "name": "자유제작실기2",
    "division": "001",
    "department": "조소",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김희경",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "조형101",
    "isOnline": false,
    "source": {
      "schedule": "조형101(목6,7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "조형101"
      }
    ],
    "sourceSchedule": "조형101(목6,7,8,9)"
  },
  {
    "id": "09476-002-2000447",
    "subjectKey": "09476",
    "name": "자유제작실기2",
    "division": "002",
    "department": "회화",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이소영",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미술108",
    "isOnline": false,
    "source": {
      "schedule": "미술108(수3,4),미술109(수8,9)"
    },
    "capacity": 23,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "미술108"
      },
      {
        "day": "수",
        "periods": [
          8,
          9
        ],
        "classroom": "미술109"
      }
    ],
    "sourceSchedule": "미술108(수3,4),미술109(수8,9)"
  },
  {
    "id": "09476-003-2000447",
    "subjectKey": "09476",
    "name": "자유제작실기2",
    "division": "003",
    "department": "회화",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이태경",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 9,
    "room": "조형307",
    "isOnline": false,
    "source": {
      "schedule": "조형307(수3,4,8,9)"
    },
    "capacity": 21,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4,
          8,
          9
        ],
        "classroom": "조형307"
      }
    ],
    "sourceSchedule": "조형307(수3,4,8,9)"
  },
  {
    "id": "09484-001-2000652",
    "subjectKey": "09484",
    "name": "금속조2",
    "division": "001",
    "department": "조소",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박용국",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술야외실기장",
    "isOnline": false,
    "source": {
      "schedule": "미술야외실기장(월6,7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술야외실기장"
      }
    ],
    "sourceSchedule": "미술야외실기장(월6,7,8,9)"
  },
  {
    "id": "09485-001-2000652",
    "subjectKey": "09485",
    "name": "석조2",
    "division": "001",
    "department": "조소",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "지경수",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술야외실기장",
    "isOnline": false,
    "source": {
      "schedule": "미술야외실기장(화6,7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술야외실기장"
      }
    ],
    "sourceSchedule": "미술야외실기장(화6,7,8,9)"
  },
  {
    "id": "09493-001-2000652",
    "subjectKey": "09493",
    "name": "조형실기2",
    "division": "001",
    "department": "조소",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "장해미",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "조형204",
    "isOnline": false,
    "source": {
      "schedule": "조형204(화6,7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "조형204"
      }
    ],
    "sourceSchedule": "조형204(화6,7,8,9)"
  },
  {
    "id": "09497-001-2000651",
    "subjectKey": "09497",
    "name": "매체연구2",
    "division": "001",
    "department": "회화",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "최정호",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "조형302",
    "isOnline": false,
    "source": {
      "schedule": "조형302(수6,7,8,9)"
    },
    "capacity": 22,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "조형302"
      }
    ],
    "sourceSchedule": "조형302(수6,7,8,9)"
  },
  {
    "id": "09497-002-2000652",
    "subjectKey": "09497",
    "name": "매체연구2",
    "division": "002",
    "department": "조소",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김성헌",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "조형204",
    "isOnline": false,
    "source": {
      "schedule": "조형204(수1,2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "조형204"
      }
    ],
    "sourceSchedule": "조형204(수1,2,3,4)"
  },
  {
    "id": "09497-003-2000651",
    "subjectKey": "09497",
    "name": "매체연구2",
    "division": "003",
    "department": "회화",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김건희",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "조형305",
    "isOnline": false,
    "source": {
      "schedule": "조형305(화1,2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "조형305"
      }
    ],
    "sourceSchedule": "조형305(화1,2,3,4)"
  },
  {
    "id": "09505-001-2000652",
    "subjectKey": "09505",
    "name": "영상2(조소)",
    "division": "001",
    "department": "조소",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "한동석",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술202",
    "isOnline": false,
    "source": {
      "schedule": "미술202(수1,2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술202"
      }
    ],
    "sourceSchedule": "미술202(수1,2,3,4)"
  },
  {
    "id": "09514-001-2000251",
    "subjectKey": "09514",
    "name": "형상표현2",
    "division": "001",
    "department": "조소",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "지경수",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "조형101",
    "isOnline": false,
    "source": {
      "schedule": "조형101(금1,2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "조형101"
      }
    ],
    "sourceSchedule": "조형101(금1,2,3,4)"
  },
  {
    "id": "09523-001-2000603",
    "subjectKey": "09523",
    "name": "드로잉2",
    "division": "001",
    "department": "조형예술학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "황민희",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "조형402-1",
    "isOnline": false,
    "source": {
      "schedule": "조형402-1(화1,2,3,4)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "조형402-1"
      }
    ],
    "sourceSchedule": "조형402-1(화1,2,3,4)"
  },
  {
    "id": "09523-003-2000603",
    "subjectKey": "09523",
    "name": "드로잉2",
    "division": "003",
    "department": "조형예술학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "심유미",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "조형406",
    "isOnline": false,
    "source": {
      "schedule": "조형406(수1,2,3,4)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "조형406"
      }
    ],
    "sourceSchedule": "조형406(수1,2,3,4)"
  },
  {
    "id": "09523-005-2000603",
    "subjectKey": "09523",
    "name": "드로잉2",
    "division": "005",
    "department": "조형예술학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이지은",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "조형208",
    "isOnline": false,
    "source": {
      "schedule": "조형208(금5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "조형208"
      }
    ],
    "sourceSchedule": "조형208(금5,6,7,8)"
  },
  {
    "id": "09524-001-2000651",
    "subjectKey": "09524",
    "name": "선묘연구2",
    "division": "001",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "황현숙",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "조형408",
    "isOnline": false,
    "source": {
      "schedule": "조형408(목6,7,8,9)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "조형408"
      }
    ],
    "sourceSchedule": "조형408(목6,7,8,9)"
  },
  {
    "id": "09528-001-2000658",
    "subjectKey": "09528",
    "name": "특수교육학개론",
    "division": "001",
    "department": "교양",
    "category": "교직",
    "sourceCategory": "교직",
    "credit": 2,
    "professor": "윤은희",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(화7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(화7,8)"
  },
  {
    "id": "09538-001-2000598",
    "subjectKey": "09538",
    "name": "간호학개론",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "차은정",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래417",
    "isOnline": false,
    "source": {
      "schedule": "미래417(화6,7)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7
        ],
        "classroom": "미래417"
      }
    ],
    "sourceSchedule": "미래417(화6,7)"
  },
  {
    "id": "09538-002-2000598",
    "subjectKey": "09538",
    "name": "간호학개론",
    "division": "002",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "차은정",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래418",
    "isOnline": false,
    "source": {
      "schedule": "미래418(수6,7)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7
        ],
        "classroom": "미래418"
      }
    ],
    "sourceSchedule": "미래418(수6,7)"
  },
  {
    "id": "09543-001-2000598",
    "subjectKey": "09543",
    "name": "간호와영양",
    "division": "001",
    "department": "간호학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "이예나",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래314",
    "isOnline": false,
    "source": {
      "schedule": "미래314(금3,4)"
    },
    "capacity": 25,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "미래314"
      }
    ],
    "sourceSchedule": "미래314(금3,4)"
  },
  {
    "id": "09548-001-2000650",
    "subjectKey": "09548",
    "name": "병태생리학",
    "division": "001",
    "department": "운동건강관리",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "한진희",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "체육116",
    "isOnline": false,
    "source": {
      "schedule": "체육116(월1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "체육116"
      }
    ],
    "sourceSchedule": "체육116(월1,2,3)"
  },
  {
    "id": "09548-002-2000598",
    "subjectKey": "09548",
    "name": "병태생리학(마이크로디그리)",
    "division": "002",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박유선",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래314",
    "isOnline": false,
    "source": {
      "schedule": "미래314(월4,5)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5
        ],
        "classroom": "미래314"
      }
    ],
    "sourceSchedule": "미래314(월4,5)"
  },
  {
    "id": "09548-003-2000598",
    "subjectKey": "09548",
    "name": "병태생리학(마이크로디그리)",
    "division": "003",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박유선",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래315",
    "isOnline": false,
    "source": {
      "schedule": "미래315(목4,5)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5
        ],
        "classroom": "미래315"
      }
    ],
    "sourceSchedule": "미래315(목4,5)"
  },
  {
    "id": "09549-001-2000598",
    "subjectKey": "09549",
    "name": "지역사회간호학1",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박경희",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래417",
    "isOnline": false,
    "source": {
      "schedule": "미래417(화1,2)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "미래417"
      }
    ],
    "sourceSchedule": "미래417(화1,2)"
  },
  {
    "id": "09549-002-2000598",
    "subjectKey": "09549",
    "name": "지역사회간호학1",
    "division": "002",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박경희",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래421",
    "isOnline": false,
    "source": {
      "schedule": "미래421(목5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "미래421"
      }
    ],
    "sourceSchedule": "미래421(목5,6)"
  },
  {
    "id": "09552-001-2000598",
    "subjectKey": "09552",
    "name": "건강교육과상담",
    "division": "001",
    "department": "간호학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "박선아",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "미래421",
    "isOnline": false,
    "source": {
      "schedule": "미래421(목7,8)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8
        ],
        "classroom": "미래421"
      }
    ],
    "sourceSchedule": "미래421(목7,8)"
  },
  {
    "id": "09560-001-2000598",
    "subjectKey": "09560",
    "name": "성인간호학2",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박유선",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래417",
    "isOnline": false,
    "source": {
      "schedule": "미래417(월1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래417"
      }
    ],
    "sourceSchedule": "미래417(월1,2,3)"
  },
  {
    "id": "09560-002-2000598",
    "subjectKey": "09560",
    "name": "성인간호학2",
    "division": "002",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박유선",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래421",
    "isOnline": false,
    "source": {
      "schedule": "미래421(화1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래421"
      }
    ],
    "sourceSchedule": "미래421(화1,2,3)"
  },
  {
    "id": "09561-001-2000598",
    "subjectKey": "09561",
    "name": "성인간호학실습2",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박유선",
    "days": [
      "수",
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래416",
    "isOnline": false,
    "source": {
      "schedule": "미래416(수1,2,3 금1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래416"
      },
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래416"
      }
    ],
    "sourceSchedule": "미래416(수1,2,3 금1,2,3)"
  },
  {
    "id": "09561-002-2000598",
    "subjectKey": "09561",
    "name": "성인간호학실습2",
    "division": "002",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김라영",
    "days": [
      "목",
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래416",
    "isOnline": false,
    "source": {
      "schedule": "미래416(목1,2,3),미래422(금7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래416"
      },
      {
        "day": "금",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래422"
      }
    ],
    "sourceSchedule": "미래416(목1,2,3),미래422(금7,8,9)"
  },
  {
    "id": "09564-001-2000598",
    "subjectKey": "09564",
    "name": "정신간호학1",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권민",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래417",
    "isOnline": false,
    "source": {
      "schedule": "미래417(화4,5)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "미래417"
      }
    ],
    "sourceSchedule": "미래417(화4,5)"
  },
  {
    "id": "09564-002-2000598",
    "subjectKey": "09564",
    "name": "정신간호학1",
    "division": "002",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권민",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래421",
    "isOnline": false,
    "source": {
      "schedule": "미래421(수6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7
        ],
        "classroom": "미래421"
      }
    ],
    "sourceSchedule": "미래421(수6,7)"
  },
  {
    "id": "09568-001-2000598",
    "subjectKey": "09568",
    "name": "모성간호학실습2",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "박선아",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래422",
    "isOnline": false,
    "source": {
      "schedule": "미래422(목1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래422"
      }
    ],
    "sourceSchedule": "미래422(목1,2,3)"
  },
  {
    "id": "09568-002-2000598",
    "subjectKey": "09568",
    "name": "모성간호학실습2",
    "division": "002",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "박선아",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래424",
    "isOnline": false,
    "source": {
      "schedule": "미래424(월7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래424"
      }
    ],
    "sourceSchedule": "미래424(월7,8,9)"
  },
  {
    "id": "09589-001-2000400",
    "subjectKey": "09589",
    "name": "형법각론1(학점교류)",
    "division": "001",
    "department": "법학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "09592-001-2000622",
    "subjectKey": "09592",
    "name": "형법각론2",
    "division": "001",
    "department": "법학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "권지혜",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문400",
    "isOnline": false,
    "source": {
      "schedule": "인문400(월5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문400"
      }
    ],
    "sourceSchedule": "인문400(월5,6,7)"
  },
  {
    "id": "09594-001-2000622",
    "subjectKey": "09594",
    "name": "영미법",
    "division": "001",
    "department": "법학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "손창일",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "인문406",
    "isOnline": false,
    "source": {
      "schedule": "인문406(화2,3 목5)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "인문406"
      },
      {
        "day": "목",
        "periods": [
          5
        ],
        "classroom": "인문406"
      }
    ],
    "sourceSchedule": "인문406(화2,3 목5)"
  },
  {
    "id": "09615-001-2000408",
    "subjectKey": "09615",
    "name": "생명공학특허",
    "division": "001",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최용복",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "종합404",
    "isOnline": false,
    "source": {
      "schedule": "종합404(금6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "종합404"
      }
    ],
    "sourceSchedule": "종합404(금6,7,8)"
  },
  {
    "id": "09635-001-2000647",
    "subjectKey": "09635",
    "name": "현대암호응용",
    "division": "001",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고승철",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT407",
    "isOnline": false,
    "source": {
      "schedule": "IT407(금2,3,4)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT407"
      }
    ],
    "sourceSchedule": "IT407(금2,3,4)"
  },
  {
    "id": "09639-001-2000647",
    "subjectKey": "09639",
    "name": "고급자바프로그래밍",
    "division": "001",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김아람",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "IT214",
    "isOnline": false,
    "source": {
      "schedule": "IT214(월1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "IT214"
      }
    ],
    "sourceSchedule": "IT214(월1,2,3)"
  },
  {
    "id": "09642-001-2000517",
    "subjectKey": "09642",
    "name": "데이터베이스보안",
    "division": "001",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김영미",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "IT215",
    "isOnline": false,
    "source": {
      "schedule": "IT215(화1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "IT215"
      }
    ],
    "sourceSchedule": "IT215(화1,2,3)"
  },
  {
    "id": "09655-001-2000757",
    "subjectKey": "09655",
    "name": "객체지향프로그래밍",
    "division": "001",
    "department": "AI데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김인환",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경203",
    "isOnline": false,
    "source": {
      "schedule": "글경203(수5,6,7)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경203"
      }
    ],
    "sourceSchedule": "글경203(수5,6,7)"
  },
  {
    "id": "09655-001-2000763",
    "subjectKey": "09655",
    "name": "객체지향프로그래밍",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김인환",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경203",
    "isOnline": false,
    "source": {
      "schedule": "글경203(수5,6,7)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경203"
      }
    ],
    "sourceSchedule": "글경203(수5,6,7)"
  },
  {
    "id": "09664-001-2000599",
    "subjectKey": "09664",
    "name": "영유아교수방법론",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김혜수",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "생활502",
    "isOnline": false,
    "source": {
      "schedule": "생활502(목3,4,5)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "생활502"
      }
    ],
    "sourceSchedule": "생활502(목3,4,5)"
  },
  {
    "id": "09666-001-2000431",
    "subjectKey": "09666",
    "name": "학교사회복지론",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "윤은영",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "생활101",
    "isOnline": false,
    "source": {
      "schedule": "생활101(목3,4,5)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "생활101"
      }
    ],
    "sourceSchedule": "생활101(목3,4,5)"
  },
  {
    "id": "09668-001-2000599",
    "subjectKey": "09668",
    "name": "가족과문화",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김정은",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "생활305",
    "isOnline": false,
    "source": {
      "schedule": "생활305(목2,3,4)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "생활305"
      }
    ],
    "sourceSchedule": "생활305(목2,3,4)"
  },
  {
    "id": "09668-001-2000763",
    "subjectKey": "09668",
    "name": "가족과문화",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김정은",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "생활305",
    "isOnline": false,
    "source": {
      "schedule": "생활305(목2,3,4)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "생활305"
      }
    ],
    "sourceSchedule": "생활305(목2,3,4)"
  },
  {
    "id": "09671-001-2000600",
    "subjectKey": "09671",
    "name": "인체드로잉",
    "division": "001",
    "department": "의류학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "사사키치카",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "생활405",
    "isOnline": false,
    "source": {
      "schedule": "생활405(월1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "생활405"
      }
    ],
    "sourceSchedule": "생활405(월1,2,3)"
  },
  {
    "id": "09671-001-2000763",
    "subjectKey": "09671",
    "name": "인체드로잉",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "사사키치카",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "생활405",
    "isOnline": false,
    "source": {
      "schedule": "생활405(월1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "생활405"
      }
    ],
    "sourceSchedule": "생활405(월1,2,3)"
  },
  {
    "id": "09676-001-2000432",
    "subjectKey": "09676",
    "name": "패션에디팅(그린패션디자인1)",
    "division": "001",
    "department": "의류학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "사사키치카",
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 8,
    "endPeriod": 9,
    "room": "생활101",
    "isOnline": false,
    "source": {
      "schedule": "생활101(월8,9),생활302(목4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          8,
          9
        ],
        "classroom": "생활101"
      },
      {
        "day": "목",
        "periods": [
          4
        ],
        "classroom": "생활302"
      }
    ],
    "sourceSchedule": "생활101(월8,9),생활302(목4)"
  },
  {
    "id": "09678-001-2000650",
    "subjectKey": "09678",
    "name": "기능해부학",
    "division": "001",
    "department": "운동건강관리",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "임유은",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "체육117",
    "isOnline": false,
    "source": {
      "schedule": "체육117(수3,4,5)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "체육117"
      }
    ],
    "sourceSchedule": "체육117(수3,4,5)"
  },
  {
    "id": "09707-001-2000650",
    "subjectKey": "09707",
    "name": "스트레칭",
    "division": "001",
    "department": "운동건강관리",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "김소정",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "체육105",
    "isOnline": false,
    "source": {
      "schedule": "체육105(화1,2)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "체육105"
      }
    ],
    "sourceSchedule": "체육105(화1,2)"
  },
  {
    "id": "09712-001-2000650",
    "subjectKey": "09712",
    "name": "스포츠테이핑",
    "division": "001",
    "department": "운동건강관리",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "백형진",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "체육114",
    "isOnline": false,
    "source": {
      "schedule": "체육114(금1,2)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "체육114"
      }
    ],
    "sourceSchedule": "체육114(금1,2)"
  },
  {
    "id": "09740-001-2000608",
    "subjectKey": "09740",
    "name": "오케스트라워크샵4",
    "division": "001",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "백향민",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 11,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(목7,8,11)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          11
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(목7,8,11)"
  },
  {
    "id": "09740-002-2000608",
    "subjectKey": "09740",
    "name": "오케스트라워크샵4",
    "division": "002",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김영윤",
    "days": [
      "금"
    ],
    "startPeriod": 9,
    "endPeriod": 11,
    "room": "음악221",
    "isOnline": false,
    "source": {
      "schedule": "음악221(금9,10,11)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          9,
          10,
          11
        ],
        "classroom": "음악221"
      }
    ],
    "sourceSchedule": "음악221(금9,10,11)"
  },
  {
    "id": "09740-003-2000608",
    "subjectKey": "09740",
    "name": "오케스트라워크샵4",
    "division": "003",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "이지원",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 11,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(월3,4,11)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4,
          11
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(월3,4,11)"
  },
  {
    "id": "09742-001-2000608",
    "subjectKey": "09742",
    "name": "오케스트라워크샵6",
    "division": "001",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "백향민",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 11,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(목7,8,11)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          11
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(목7,8,11)"
  },
  {
    "id": "09742-002-2000608",
    "subjectKey": "09742",
    "name": "오케스트라워크샵6",
    "division": "002",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김영윤",
    "days": [
      "금"
    ],
    "startPeriod": 9,
    "endPeriod": 11,
    "room": "음악221",
    "isOnline": false,
    "source": {
      "schedule": "음악221(금9,10,11)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          9,
          10,
          11
        ],
        "classroom": "음악221"
      }
    ],
    "sourceSchedule": "음악221(금9,10,11)"
  },
  {
    "id": "09742-003-2000608",
    "subjectKey": "09742",
    "name": "오케스트라워크샵6",
    "division": "003",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "이지원",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 11,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(월3,4,11)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4,
          11
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(월3,4,11)"
  },
  {
    "id": "09755-001-2000625",
    "subjectKey": "09755",
    "name": "글로벌리더쉽",
    "division": "001",
    "department": "국제개발협력",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이재민",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "글경502",
    "isOnline": false,
    "source": {
      "schedule": "글경502(목6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "글경502"
      }
    ],
    "sourceSchedule": "글경502(목6,7,8)"
  },
  {
    "id": "09756-001-2000624",
    "subjectKey": "09756",
    "name": "개발경제학1",
    "division": "001",
    "department": "경제금융",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "왕두균",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경501",
    "isOnline": false,
    "source": {
      "schedule": "글경501(수1,2,3)"
    },
    "capacity": null,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경501"
      }
    ],
    "sourceSchedule": "글경501(수1,2,3)"
  },
  {
    "id": "09756-002-2000625",
    "subjectKey": "09756",
    "name": "개발경제학1",
    "division": "002",
    "department": "국제개발협력",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "왕두균",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경501",
    "isOnline": false,
    "source": {
      "schedule": "글경501(수1,2,3)"
    },
    "capacity": null,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경501"
      }
    ],
    "sourceSchedule": "글경501(수1,2,3)"
  },
  {
    "id": "09762-001-2000625",
    "subjectKey": "09762",
    "name": "국제관계론",
    "division": "001",
    "department": "국제개발협력",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이재민",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "글경502",
    "isOnline": false,
    "source": {
      "schedule": "글경502(목2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "글경502"
      }
    ],
    "sourceSchedule": "글경502(목2,3,4)"
  },
  {
    "id": "09768-001-2000625",
    "subjectKey": "09768",
    "name": "NGO와국제협력",
    "division": "001",
    "department": "국제개발협력",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김지송",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "글경503",
    "isOnline": false,
    "source": {
      "schedule": "글경503(월2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "글경503"
      }
    ],
    "sourceSchedule": "글경503(월2,3,4)"
  },
  {
    "id": "09778-001-2000658",
    "subjectKey": "09778",
    "name": "무의식과마음의대화",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이주향",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합608",
    "isOnline": false,
    "source": {
      "schedule": "종합608(목4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합608"
      }
    ],
    "sourceSchedule": "종합608(목4,5,6)"
  },
  {
    "id": "09779-001-2000658",
    "subjectKey": "09779",
    "name": "동아시아역사속의전쟁과평화",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "권인용",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문309",
    "isOnline": false,
    "source": {
      "schedule": "인문309(수4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문309"
      }
    ],
    "sourceSchedule": "인문309(수4,5,6)"
  },
  {
    "id": "09787-001-2000651",
    "subjectKey": "09787",
    "name": "조형예술론2",
    "division": "001",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "변청자",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미술114",
    "isOnline": false,
    "source": {
      "schedule": "미술114(수6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미술114"
      }
    ],
    "sourceSchedule": "미술114(수6,7,8)"
  },
  {
    "id": "09797-001-2000599",
    "subjectKey": "09797",
    "name": "아동미술",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "전효훈",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "생활305",
    "isOnline": false,
    "source": {
      "schedule": "생활305(화6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "생활305"
      }
    ],
    "sourceSchedule": "생활305(화6,7,8)"
  },
  {
    "id": "09797-001-2000763",
    "subjectKey": "09797",
    "name": "아동미술",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "전효훈",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "생활305",
    "isOnline": false,
    "source": {
      "schedule": "생활305(화6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "생활305"
      }
    ],
    "sourceSchedule": "생활305(화6,7,8)"
  },
  {
    "id": "09798-001-2000599",
    "subjectKey": "09798",
    "name": "아동생활지도",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김정은",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "생활202",
    "isOnline": false,
    "source": {
      "schedule": "생활202(수7,8,9)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "생활202"
      }
    ],
    "sourceSchedule": "생활202(수7,8,9)"
  },
  {
    "id": "09800-001-2000599",
    "subjectKey": "09800",
    "name": "아동관찰및행동연구",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김윤희",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "생활305",
    "isOnline": false,
    "source": {
      "schedule": "생활305(월3,4,5)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "생활305"
      }
    ],
    "sourceSchedule": "생활305(월3,4,5)"
  },
  {
    "id": "09819-001-2000431",
    "subjectKey": "09819",
    "name": "아동수학지도(학점교류)",
    "division": "001",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "09821-001-2000601",
    "subjectKey": "09821",
    "name": "생리학1",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김형숙",
    "days": [
      "목",
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "생활302",
    "isOnline": false,
    "source": {
      "schedule": "생활302(목2,3),생활502(월7)"
    },
    "capacity": 80,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3
        ],
        "classroom": "생활302"
      },
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "생활502"
      }
    ],
    "sourceSchedule": "생활302(목2,3),생활502(월7)"
  },
  {
    "id": "09835-001-2000760",
    "subjectKey": "09835",
    "name": "한국어회화2",
    "division": "001",
    "department": "글로벌자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "박카밀라",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "국제309",
    "isOnline": false,
    "source": {
      "schedule": "국제309(화4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "국제309"
      }
    ],
    "sourceSchedule": "국제309(화4,5,6)"
  },
  {
    "id": "09837-001-2000760",
    "subjectKey": "09837",
    "name": "기초한국어2",
    "division": "001",
    "department": "글로벌자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "김연희",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "국제309",
    "isOnline": false,
    "source": {
      "schedule": "국제309(월5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "국제309"
      }
    ],
    "sourceSchedule": "국제309(월5,6,7)"
  },
  {
    "id": "09852-002-2000747",
    "subjectKey": "09852",
    "name": "영상인문학",
    "division": "002",
    "department": "디지털헤리티지",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양정석",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문401",
    "isOnline": false,
    "source": {
      "schedule": "인문401(목1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문401"
      }
    ],
    "sourceSchedule": "인문401(목1,2,3)"
  },
  {
    "id": "09853-001-2000290",
    "subjectKey": "09853",
    "name": "언어정보학(학점교류)",
    "division": "001",
    "department": "국어국문학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "09854-001-2000739",
    "subjectKey": "09854",
    "name": "언어와역사",
    "division": "001",
    "department": "한국언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "문현수",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문500",
    "isOnline": false,
    "source": {
      "schedule": "인문500(수2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문500"
      }
    ],
    "sourceSchedule": "인문500(수2,3,4)"
  },
  {
    "id": "09854-002-2000739",
    "subjectKey": "09854",
    "name": "언어와역사(외국인전용)",
    "division": "002",
    "department": "한국언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "문현수",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문500",
    "isOnline": false,
    "source": {
      "schedule": "인문500(목6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문500"
      }
    ],
    "sourceSchedule": "인문500(목6,7,8)"
  },
  {
    "id": "09856-001-2000617",
    "subjectKey": "09856",
    "name": "한국사회생활사",
    "division": "001",
    "department": "사학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최재성",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문309",
    "isOnline": false,
    "source": {
      "schedule": "인문309(화4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문309"
      }
    ],
    "sourceSchedule": "인문309(화4,5,6)"
  },
  {
    "id": "09860-001-2000296",
    "subjectKey": "09860",
    "name": "일본어학특강",
    "division": "001",
    "department": "일어일문학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "방윤형",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 6,
    "room": "종합509",
    "isOnline": false,
    "source": {
      "schedule": "종합509(화6 목6,7)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6
        ],
        "classroom": "종합509"
      },
      {
        "day": "목",
        "periods": [
          6,
          7
        ],
        "classroom": "종합509"
      }
    ],
    "sourceSchedule": "종합509(화6 목6,7)"
  },
  {
    "id": "09864-001-2000619",
    "subjectKey": "09864",
    "name": "러시아지역사회문화",
    "division": "001",
    "department": "러시아어문학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "벨랴코프일리야",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "종합503",
    "isOnline": false,
    "source": {
      "schedule": "종합503(화2),종합504(목6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2
        ],
        "classroom": "종합503"
      },
      {
        "day": "목",
        "periods": [
          6,
          7
        ],
        "classroom": "종합504"
      }
    ],
    "sourceSchedule": "종합503(화2),종합504(목6,7)"
  },
  {
    "id": "09886-001-2000742",
    "subjectKey": "09886",
    "name": "중국지역문화특강(마이크로디그리)",
    "division": "001",
    "department": "중국언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "송진영",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문301",
    "isOnline": false,
    "source": {
      "schedule": "인문301(목2,3,4)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문301"
      }
    ],
    "sourceSchedule": "인문301(목2,3,4)"
  },
  {
    "id": "09887-001-2000742",
    "subjectKey": "09887",
    "name": "스크린중국어와대중문화",
    "division": "001",
    "department": "중국언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고건혜",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문500",
    "isOnline": false,
    "source": {
      "schedule": "인문500(화4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문500"
      }
    ],
    "sourceSchedule": "인문500(화4,5,6)"
  },
  {
    "id": "09889-001-2000621",
    "subjectKey": "09889",
    "name": "중국시가와전통문화",
    "division": "001",
    "department": "중어중문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "전주현",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "종합503",
    "isOnline": false,
    "source": {
      "schedule": "종합503(수3,4,5)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "종합503"
      }
    ],
    "sourceSchedule": "종합503(수3,4,5)"
  },
  {
    "id": "09890-001-2000621",
    "subjectKey": "09890",
    "name": "시사중국어발표와토론",
    "division": "001",
    "department": "중어중문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이화자",
    "days": [
      "화",
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "인문401",
    "isOnline": false,
    "source": {
      "schedule": "인문401(화5,6),종합504(월7)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "인문401"
      },
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "종합504"
      }
    ],
    "sourceSchedule": "인문401(화5,6),종합504(월7)"
  },
  {
    "id": "09893-001-2000296",
    "subjectKey": "09893",
    "name": "관광비지니스일어회화2",
    "division": "001",
    "department": "일어일문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "야스코우치 아키코",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "인문401",
    "isOnline": false,
    "source": {
      "schedule": "인문401(화2),종합505(목4,5)"
    },
    "capacity": 12,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2
        ],
        "classroom": "인문401"
      },
      {
        "day": "목",
        "periods": [
          4,
          5
        ],
        "classroom": "종합505"
      }
    ],
    "sourceSchedule": "인문401(화2),종합505(목4,5)"
  },
  {
    "id": "09901-001-2000743",
    "subjectKey": "09901",
    "name": "러시아어의응용2",
    "division": "001",
    "department": "러시아언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이혜승",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문501",
    "isOnline": false,
    "source": {
      "schedule": "인문501(화4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문501"
      }
    ],
    "sourceSchedule": "인문501(화4,5,6)"
  },
  {
    "id": "09903-001-2000743",
    "subjectKey": "09903",
    "name": "실용러시아어말하기2",
    "division": "001",
    "department": "러시아언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박카밀라",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문301",
    "isOnline": false,
    "source": {
      "schedule": "인문301(목5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문301"
      }
    ],
    "sourceSchedule": "인문301(목5,6,7)"
  },
  {
    "id": "09908-001-2000619",
    "subjectKey": "09908",
    "name": "실무러시아어말하기2",
    "division": "001",
    "department": "러시아어문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "마리나세르게예브나",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "종합504",
    "isOnline": false,
    "source": {
      "schedule": "종합504(월5),종합508(화5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5
        ],
        "classroom": "종합504"
      },
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "종합508"
      }
    ],
    "sourceSchedule": "종합504(월5),종합508(화5,6)"
  },
  {
    "id": "09910-001-2000619",
    "subjectKey": "09910",
    "name": "러시아문학텍스트이해",
    "division": "001",
    "department": "러시아어문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박카밀라",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합505",
    "isOnline": false,
    "source": {
      "schedule": "종합505(수5,6 목2)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "종합505"
      },
      {
        "day": "목",
        "periods": [
          2
        ],
        "classroom": "종합505"
      }
    ],
    "sourceSchedule": "종합505(수5,6 목2)"
  },
  {
    "id": "09912-001-2000399",
    "subjectKey": "09912",
    "name": "상법총론(학점교류)",
    "division": "001",
    "department": "법·행정학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "09915-001-2000744",
    "subjectKey": "09915",
    "name": "물권법각론",
    "division": "001",
    "department": "법학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최우령",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문400",
    "isOnline": false,
    "source": {
      "schedule": "인문400(목5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문400"
      }
    ],
    "sourceSchedule": "인문400(목5,6,7)"
  },
  {
    "id": "09919-001-2000622",
    "subjectKey": "09919",
    "name": "채권법각론",
    "division": "001",
    "department": "법학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최우령",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문500",
    "isOnline": false,
    "source": {
      "schedule": "인문500(목1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문500"
      }
    ],
    "sourceSchedule": "인문500(목1,2,3)"
  },
  {
    "id": "09920-001-2000400",
    "subjectKey": "09920",
    "name": "민사법의이해와사례",
    "division": "001",
    "department": "법학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김기영",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문509",
    "isOnline": false,
    "source": {
      "schedule": "인문509(목1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문509"
      }
    ],
    "sourceSchedule": "인문509(목1,2,3)"
  },
  {
    "id": "09922-001-2000745",
    "subjectKey": "09922",
    "name": "행정과경제분석",
    "division": "001",
    "department": "행정학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김정민",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문310",
    "isOnline": false,
    "source": {
      "schedule": "인문310(월2,3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문310"
      }
    ],
    "sourceSchedule": "인문310(월2,3,4)"
  },
  {
    "id": "09927-001-2000746",
    "subjectKey": "09927",
    "name": "디지털콘텐츠제작2",
    "division": "001",
    "department": "미디어커뮤니케이션",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김민수",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문310",
    "isOnline": false,
    "source": {
      "schedule": "인문310(금2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문310"
      }
    ],
    "sourceSchedule": "인문310(금2,3,4)"
  },
  {
    "id": "09929-001-2000583",
    "subjectKey": "09929",
    "name": "위기커뮤니케이션",
    "division": "001",
    "department": "미디어커뮤니케이션학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "강승미",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "인문409",
    "isOnline": false,
    "source": {
      "schedule": "인문409(월4 화2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4
        ],
        "classroom": "인문409"
      },
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "인문409"
      }
    ],
    "sourceSchedule": "인문409(월4 화2,3)"
  },
  {
    "id": "09942-001-2000628",
    "subjectKey": "09942",
    "name": "Business English2",
    "division": "001",
    "department": "글로벌비즈니스",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "조니",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경B103",
    "isOnline": false,
    "source": {
      "schedule": "글경B103(월1,2,3)"
    },
    "capacity": 17,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경B103"
      }
    ],
    "sourceSchedule": "글경B103(월1,2,3)"
  },
  {
    "id": "09942-002-2000628",
    "subjectKey": "09942",
    "name": "Business English2",
    "division": "002",
    "department": "글로벌비즈니스",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "조니",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경B103",
    "isOnline": false,
    "source": {
      "schedule": "글경B103(금1,2,3)"
    },
    "capacity": 17,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경B103"
      }
    ],
    "sourceSchedule": "글경B103(금1,2,3)"
  },
  {
    "id": "09946-001-2000626",
    "subjectKey": "09946",
    "name": "e-비즈니스전략",
    "division": "001",
    "department": "경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이은곤",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경401",
    "isOnline": false,
    "source": {
      "schedule": "글경401(월4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경401"
      }
    ],
    "sourceSchedule": "글경401(월4,5,6)"
  },
  {
    "id": "09946-002-2000626",
    "subjectKey": "09946",
    "name": "e-비즈니스전략(재직자반)",
    "division": "002",
    "department": "경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "장은호",
    "days": [
      "금"
    ],
    "startPeriod": 10,
    "endPeriod": 12,
    "room": "글경401",
    "isOnline": false,
    "source": {
      "schedule": "글경401(금10,11,12)"
    },
    "capacity": 4,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          10,
          11,
          12
        ],
        "classroom": "글경401"
      }
    ],
    "sourceSchedule": "글경401(금10,11,12)"
  },
  {
    "id": "09961-001-2000507",
    "subjectKey": "09961",
    "name": "글로벌비즈니스협상론(이러닝)",
    "division": "001",
    "department": "글로벌비즈니스",
    "category": "이러닝",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "윤성원",
    "days": [
      "금",
      "토"
    ],
    "startPeriod": 9,
    "endPeriod": 9,
    "room": "글경607",
    "isOnline": true,
    "source": {
      "schedule": "글경607(금9 토3,4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          9
        ],
        "classroom": "글경607"
      },
      {
        "day": "토",
        "periods": [
          3,
          4
        ],
        "classroom": "글경607"
      }
    ],
    "sourceSchedule": "글경607(금9 토3,4)"
  },
  {
    "id": "09962-001-2000627",
    "subjectKey": "09962",
    "name": "법인세연습",
    "division": "001",
    "department": "회계",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "구자은",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "글경601",
    "isOnline": false,
    "source": {
      "schedule": "글경601(월6,7,8)"
    },
    "capacity": 60,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "글경601"
      }
    ],
    "sourceSchedule": "글경601(월6,7,8)"
  },
  {
    "id": "09966-001-2000587",
    "subjectKey": "09966",
    "name": "와인과소믈리에",
    "division": "001",
    "department": "호텔관광학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김단비",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "글경702",
    "isOnline": false,
    "source": {
      "schedule": "글경702(화6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "글경702"
      }
    ],
    "sourceSchedule": "글경702(화6,7,8)"
  },
  {
    "id": "09967-001-2000587",
    "subjectKey": "09967",
    "name": "문화예술경영",
    "division": "001",
    "department": "호텔관광학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김승준",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경701",
    "isOnline": false,
    "source": {
      "schedule": "글경701(수4,5,6)"
    },
    "capacity": 61,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경701"
      }
    ],
    "sourceSchedule": "글경701(수4,5,6)"
  },
  {
    "id": "09971-001-2000757",
    "subjectKey": "09971",
    "name": "통계학2",
    "division": "001",
    "department": "AI데이터과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박진우",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "글경203",
    "isOnline": false,
    "source": {
      "schedule": "글경203(화3),글경315(화4,5)"
    },
    "capacity": 42,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3
        ],
        "classroom": "글경203"
      },
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "글경315"
      }
    ],
    "sourceSchedule": "글경203(화3),글경315(화4,5)"
  },
  {
    "id": "09971-001-2000763",
    "subjectKey": "09971",
    "name": "통계학2",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박진우",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "글경203",
    "isOnline": false,
    "source": {
      "schedule": "글경203(화3),글경315(화4,5)"
    },
    "capacity": 42,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3
        ],
        "classroom": "글경203"
      },
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "글경315"
      }
    ],
    "sourceSchedule": "글경203(화3),글경315(화4,5)"
  },
  {
    "id": "09971-002-2000757",
    "subjectKey": "09971",
    "name": "통계학2",
    "division": "002",
    "department": "AI데이터과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김진흠",
    "days": [
      "목",
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "글경203",
    "isOnline": false,
    "source": {
      "schedule": "글경203(목2),글경314(수1,2)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2
        ],
        "classroom": "글경203"
      },
      {
        "day": "수",
        "periods": [
          1,
          2
        ],
        "classroom": "글경314"
      }
    ],
    "sourceSchedule": "글경203(목2),글경314(수1,2)"
  },
  {
    "id": "09971-002-2000763",
    "subjectKey": "09971",
    "name": "통계학2",
    "division": "002",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김진흠",
    "days": [
      "목",
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "글경203",
    "isOnline": false,
    "source": {
      "schedule": "글경203(목2),글경314(수1,2)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2
        ],
        "classroom": "글경203"
      },
      {
        "day": "수",
        "periods": [
          1,
          2
        ],
        "classroom": "글경314"
      }
    ],
    "sourceSchedule": "글경203(목2),글경314(수1,2)"
  },
  {
    "id": "09971-003-2000757",
    "subjectKey": "09971",
    "name": "통계학2",
    "division": "003",
    "department": "AI데이터과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김진흠",
    "days": [
      "수",
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "글경203",
    "isOnline": false,
    "source": {
      "schedule": "글경203(수4),글경314(월5,6)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "글경203"
      },
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "글경314"
      }
    ],
    "sourceSchedule": "글경203(수4),글경314(월5,6)"
  },
  {
    "id": "09971-003-2000763",
    "subjectKey": "09971",
    "name": "통계학2",
    "division": "003",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김진흠",
    "days": [
      "수",
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "글경203",
    "isOnline": false,
    "source": {
      "schedule": "글경203(수4),글경314(월5,6)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "글경203"
      },
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "글경314"
      }
    ],
    "sourceSchedule": "글경203(수4),글경314(월5,6)"
  },
  {
    "id": "09974-001-2000632",
    "subjectKey": "09974",
    "name": "식물생명공학",
    "division": "001",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "신령",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "종합404",
    "isOnline": false,
    "source": {
      "schedule": "종합404(수3 목5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3
        ],
        "classroom": "종합404"
      },
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "종합404"
      }
    ],
    "sourceSchedule": "종합404(수3 목5,6)"
  },
  {
    "id": "09974-002-2000632",
    "subjectKey": "09974",
    "name": "식물생명공학",
    "division": "002",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "라메쉬 카칼라",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 6,
    "room": "종합302",
    "isOnline": false,
    "source": {
      "schedule": "종합302(화6),종합408(수3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6
        ],
        "classroom": "종합302"
      },
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "종합408"
      }
    ],
    "sourceSchedule": "종합302(화6),종합408(수3,4)"
  },
  {
    "id": "09975-001-2000632",
    "subjectKey": "09975",
    "name": "인체면역학",
    "division": "001",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "강성수",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "종합407",
    "isOnline": false,
    "source": {
      "schedule": "종합407(화7,8 금4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "종합407"
      },
      {
        "day": "금",
        "periods": [
          4
        ],
        "classroom": "종합407"
      }
    ],
    "sourceSchedule": "종합407(화7,8 금4)"
  },
  {
    "id": "09984-001-2000632",
    "subjectKey": "09984",
    "name": "산업미생물학",
    "division": "001",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "손영선",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "종합407",
    "isOnline": false,
    "source": {
      "schedule": "종합407(화3,4 목2)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "종합407"
      },
      {
        "day": "목",
        "periods": [
          2
        ],
        "classroom": "종합407"
      }
    ],
    "sourceSchedule": "종합407(화3,4 목2)"
  },
  {
    "id": "09990-001-2000408",
    "subjectKey": "09990",
    "name": "바이오제약공학(마이크로디그리)",
    "division": "001",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김준현",
    "days": [
      "목",
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "종합408",
    "isOnline": false,
    "source": {
      "schedule": "종합408(목2),종합410(화2,3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2
        ],
        "classroom": "종합408"
      },
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "종합410"
      }
    ],
    "sourceSchedule": "종합408(목2),종합410(화2,3)"
  },
  {
    "id": "09991-001-2000408",
    "subjectKey": "09991",
    "name": "바이오향장공학(마이크로디그리)",
    "division": "001",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김준현",
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합408",
    "isOnline": false,
    "source": {
      "schedule": "종합408(월2,3 목3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "종합408"
      },
      {
        "day": "목",
        "periods": [
          3
        ],
        "classroom": "종합408"
      }
    ],
    "sourceSchedule": "종합408(월2,3 목3)"
  },
  {
    "id": "09991-002-2000408",
    "subjectKey": "09991",
    "name": "바이오향장공학(마이크로디그리)",
    "division": "002",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "강성수",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 6,
    "room": "종합407",
    "isOnline": false,
    "source": {
      "schedule": "종합407(화6 금2,3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6
        ],
        "classroom": "종합407"
      },
      {
        "day": "금",
        "periods": [
          2,
          3
        ],
        "classroom": "종합407"
      }
    ],
    "sourceSchedule": "종합407(화6 금2,3)"
  },
  {
    "id": "09996-001-2000589",
    "subjectKey": "09996",
    "name": "건설환경공학개론",
    "division": "001",
    "department": "건설환경에너지공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김한나",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합408",
    "isOnline": false,
    "source": {
      "schedule": "종합408(월5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "종합408"
      }
    ],
    "sourceSchedule": "종합408(월5,6)"
  },
  {
    "id": "09996-001-2000763",
    "subjectKey": "09996",
    "name": "건설환경공학개론",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김한나",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합408",
    "isOnline": false,
    "source": {
      "schedule": "종합408(월5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "종합408"
      }
    ],
    "sourceSchedule": "종합408(월5,6)"
  },
  {
    "id": "09996-002-2000589",
    "subjectKey": "09996",
    "name": "건설환경공학개론",
    "division": "002",
    "department": "건설환경에너지공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이강욱",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합302",
    "isOnline": false,
    "source": {
      "schedule": "종합302(월5,6)"
    },
    "capacity": 55,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "종합302"
      }
    ],
    "sourceSchedule": "종합302(월5,6)"
  },
  {
    "id": "09996-002-2000763",
    "subjectKey": "09996",
    "name": "건설환경공학개론",
    "division": "002",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이강욱",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합302",
    "isOnline": false,
    "source": {
      "schedule": "종합302(월5,6)"
    },
    "capacity": 55,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "종합302"
      }
    ],
    "sourceSchedule": "종합302(월5,6)"
  },
  {
    "id": "10000-001-2000655",
    "subjectKey": "10000",
    "name": "전통공예표현기법",
    "division": "001",
    "department": "공예디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "나미경",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미술204",
    "isOnline": false,
    "source": {
      "schedule": "미술204(수6,7,8)"
    },
    "capacity": 25,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미술204"
      }
    ],
    "sourceSchedule": "미술204(수6,7,8)"
  },
  {
    "id": "10011-001-2000598",
    "subjectKey": "10011",
    "name": "아동간호학1",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이경희",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "미래314",
    "isOnline": false,
    "source": {
      "schedule": "미래314(목2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3
        ],
        "classroom": "미래314"
      }
    ],
    "sourceSchedule": "미래314(목2,3)"
  },
  {
    "id": "10011-002-2000598",
    "subjectKey": "10011",
    "name": "아동간호학1",
    "division": "002",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이경희",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "미래315",
    "isOnline": false,
    "source": {
      "schedule": "미래315(월2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "미래315"
      }
    ],
    "sourceSchedule": "미래315(월2,3)"
  },
  {
    "id": "10014-001-2000598",
    "subjectKey": "10014",
    "name": "아동간호학실습2",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "이경희",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래424",
    "isOnline": false,
    "source": {
      "schedule": "미래424(수4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래424"
      }
    ],
    "sourceSchedule": "미래424(수4,5,6)"
  },
  {
    "id": "10014-002-2000598",
    "subjectKey": "10014",
    "name": "아동간호학실습2",
    "division": "002",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "이경희",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래424",
    "isOnline": false,
    "source": {
      "schedule": "미래424(금1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래424"
      }
    ],
    "sourceSchedule": "미래424(금1,2,3)"
  },
  {
    "id": "10017-001-2000430",
    "subjectKey": "10017",
    "name": "성인간호학4",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박금주",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래418",
    "isOnline": false,
    "source": {
      "schedule": "미래418(화1,2)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "미래418"
      }
    ],
    "sourceSchedule": "미래418(화1,2)"
  },
  {
    "id": "10020-001-2000598",
    "subjectKey": "10020",
    "name": "모성간호학2",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박선아",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래417",
    "isOnline": false,
    "source": {
      "schedule": "미래417(월5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래417"
      }
    ],
    "sourceSchedule": "미래417(월5,6)"
  },
  {
    "id": "10020-002-2000598",
    "subjectKey": "10020",
    "name": "모성간호학2",
    "division": "002",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박선아",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "미래421",
    "isOnline": false,
    "source": {
      "schedule": "미래421(수2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "미래421"
      }
    ],
    "sourceSchedule": "미래421(수2,3)"
  },
  {
    "id": "10021-001-2000430",
    "subjectKey": "10021",
    "name": "보건의료관계법규",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "이경희",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "미래418",
    "isOnline": false,
    "source": {
      "schedule": "미래418(월5)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5
        ],
        "classroom": "미래418"
      }
    ],
    "sourceSchedule": "미래418(월5)"
  },
  {
    "id": "10022-001-2000430",
    "subjectKey": "10022",
    "name": "간호관리학실습",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "차은정",
    "days": [
      "목",
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래416",
    "isOnline": false,
    "source": {
      "schedule": "미래416(목7,8,9),미래420(금7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래416"
      },
      {
        "day": "금",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래420"
      }
    ],
    "sourceSchedule": "미래416(목7,8,9),미래420(금7,8,9)"
  },
  {
    "id": "10023-001-2000658",
    "subjectKey": "10023",
    "name": "인간심리의분석",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이주향",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합608",
    "isOnline": false,
    "source": {
      "schedule": "종합608(금4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합608"
      }
    ],
    "sourceSchedule": "종합608(금4,5,6)"
  },
  {
    "id": "10023-002-2000286",
    "subjectKey": "10023",
    "name": "인간심리의분석(학점교류)",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "10031-001-2000430",
    "subjectKey": "10031",
    "name": "시뮬레이션통합실습",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "박금주",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "미래314",
    "isOnline": false,
    "source": {
      "schedule": "미래314(월1),미래427(월2,3,6)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1
        ],
        "classroom": "미래314"
      },
      {
        "day": "월",
        "periods": [
          2,
          3,
          6
        ],
        "classroom": "미래427"
      }
    ],
    "sourceSchedule": "미래314(월1),미래427(월2,3,6)"
  },
  {
    "id": "10031-002-2000430",
    "subjectKey": "10031",
    "name": "시뮬레이션통합실습",
    "division": "002",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "이경희",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "미래315",
    "isOnline": false,
    "source": {
      "schedule": "미래315(월1),미래427(월4 화3,4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1
        ],
        "classroom": "미래315"
      },
      {
        "day": "월",
        "periods": [
          4
        ],
        "classroom": "미래427"
      },
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "미래427"
      }
    ],
    "sourceSchedule": "미래315(월1),미래427(월4 화3,4)"
  },
  {
    "id": "10031-003-2000430",
    "subjectKey": "10031",
    "name": "시뮬레이션통합실습",
    "division": "003",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "양정하",
    "days": [
      "월",
      "수",
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 9,
    "room": "미래427",
    "isOnline": false,
    "source": {
      "schedule": "미래427(월1,9 수4 목1)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          9
        ],
        "classroom": "미래427"
      },
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "미래427"
      },
      {
        "day": "목",
        "periods": [
          1
        ],
        "classroom": "미래427"
      }
    ],
    "sourceSchedule": "미래427(월1,9 수4 목1)"
  },
  {
    "id": "10031-004-2000430",
    "subjectKey": "10031",
    "name": "시뮬레이션통합실습",
    "division": "004",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권민",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미래427",
    "isOnline": false,
    "source": {
      "schedule": "미래427(금1,2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미래427"
      }
    ],
    "sourceSchedule": "미래427(금1,2,3,4)"
  },
  {
    "id": "10032-001-2000598",
    "subjectKey": "10032",
    "name": "약물의기전과효과",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "양정하",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "미래314",
    "isOnline": false,
    "source": {
      "schedule": "미래314(월2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "미래314"
      }
    ],
    "sourceSchedule": "미래314(월2,3)"
  },
  {
    "id": "10032-002-2000598",
    "subjectKey": "10032",
    "name": "약물의기전과효과",
    "division": "002",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "양정하",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "미래315",
    "isOnline": false,
    "source": {
      "schedule": "미래315(목2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3
        ],
        "classroom": "미래315"
      }
    ],
    "sourceSchedule": "미래315(목2,3)"
  },
  {
    "id": "10036-001-2000401",
    "subjectKey": "10036",
    "name": "외국어와문화(학점교류)",
    "division": "001",
    "department": "미디어커뮤니케이션학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "10037-001-2000740",
    "subjectKey": "10037",
    "name": "외국문학의이해",
    "division": "001",
    "department": "영미언어문화",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이용관",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문301",
    "isOnline": false,
    "source": {
      "schedule": "인문301(월6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문301"
      }
    ],
    "sourceSchedule": "인문301(월6,7,8)"
  },
  {
    "id": "10042-001-2000754",
    "subjectKey": "10042",
    "name": "서비스경영론(1-1전용반)",
    "division": "001",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김병용",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경B101",
    "isOnline": false,
    "source": {
      "schedule": "글경B101(목1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경B101"
      }
    ],
    "sourceSchedule": "글경B101(목1,2,3)"
  },
  {
    "id": "10042-002-2000754",
    "subjectKey": "10042",
    "name": "서비스경영론(1-2전용반)",
    "division": "002",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "최준봉",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경702",
    "isOnline": false,
    "source": {
      "schedule": "글경702(목1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경702"
      }
    ],
    "sourceSchedule": "글경702(목1,2,3)"
  },
  {
    "id": "10042-003-2000754",
    "subjectKey": "10042",
    "name": "서비스경영론(1-3전용반)",
    "division": "003",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "마여실",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경703",
    "isOnline": false,
    "source": {
      "schedule": "글경703(목1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경703"
      }
    ],
    "sourceSchedule": "글경703(목1,2,3)"
  },
  {
    "id": "10042-004-2000754",
    "subjectKey": "10042",
    "name": "서비스경영론(1-4전용반)",
    "division": "004",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "조미나",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경B103",
    "isOnline": false,
    "source": {
      "schedule": "글경B103(목1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경B103"
      }
    ],
    "sourceSchedule": "글경B103(목1,2,3)"
  },
  {
    "id": "10042-005-2000754",
    "subjectKey": "10042",
    "name": "서비스경영론(1-5전용반)",
    "division": "005",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "최준봉",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경702",
    "isOnline": false,
    "source": {
      "schedule": "글경702(목5,6,7)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경702"
      }
    ],
    "sourceSchedule": "글경702(목5,6,7)"
  },
  {
    "id": "10042-006-2000754",
    "subjectKey": "10042",
    "name": "서비스경영론",
    "division": "006",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "오세영",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경702",
    "isOnline": false,
    "source": {
      "schedule": "글경702(금1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경702"
      }
    ],
    "sourceSchedule": "글경702(금1,2,3)"
  },
  {
    "id": "10042-006-2000763",
    "subjectKey": "10042",
    "name": "서비스경영론",
    "division": "006",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "오세영",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경702",
    "isOnline": false,
    "source": {
      "schedule": "글경702(금1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경702"
      }
    ],
    "sourceSchedule": "글경702(금1,2,3)"
  },
  {
    "id": "10042-007-2000754",
    "subjectKey": "10042",
    "name": "서비스경영론(외국인전용)",
    "division": "007",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "왕두균",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경402",
    "isOnline": false,
    "source": {
      "schedule": "글경402(목1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경402"
      }
    ],
    "sourceSchedule": "글경402(목1,2,3)"
  },
  {
    "id": "10073-001-2000650",
    "subjectKey": "10073",
    "name": "운동건강관리(마이크로디그리)",
    "division": "001",
    "department": "운동건강관리",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "한진희",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "체육116",
    "isOnline": false,
    "source": {
      "schedule": "체육116(월5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "체육116"
      }
    ],
    "sourceSchedule": "체육116(월5,6,7)"
  },
  {
    "id": "10102-001-2000658",
    "subjectKey": "10102",
    "name": "한국사인물전",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이창섭",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문309",
    "isOnline": false,
    "source": {
      "schedule": "인문309(금4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문309"
      }
    ],
    "sourceSchedule": "인문309(금4,5,6)"
  },
  {
    "id": "10105-001-2000658",
    "subjectKey": "10105",
    "name": "20세기한국사",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "최재성",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문309",
    "isOnline": false,
    "source": {
      "schedule": "인문309(화7,8,9)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문309"
      }
    ],
    "sourceSchedule": "인문309(화7,8,9)"
  },
  {
    "id": "10110-001-2000658",
    "subjectKey": "10110",
    "name": "일본어Level1",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "미도리",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합609",
    "isOnline": false,
    "source": {
      "schedule": "종합609(목1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합609"
      }
    ],
    "sourceSchedule": "종합609(목1,2,3)"
  },
  {
    "id": "10110-002-2000658",
    "subjectKey": "10110",
    "name": "일본어Level1",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "미도리",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합609",
    "isOnline": false,
    "source": {
      "schedule": "종합609(금1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합609"
      }
    ],
    "sourceSchedule": "종합609(금1,2,3)"
  },
  {
    "id": "10110-003-2000658",
    "subjectKey": "10110",
    "name": "일본어Level1",
    "division": "003",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "방윤형",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합609",
    "isOnline": false,
    "source": {
      "schedule": "종합609(월1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합609"
      }
    ],
    "sourceSchedule": "종합609(월1,2,3)"
  },
  {
    "id": "10110-004-2000658",
    "subjectKey": "10110",
    "name": "일본어Level1",
    "division": "004",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이성근",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경B103",
    "isOnline": false,
    "source": {
      "schedule": "글경B103(월4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경B103"
      }
    ],
    "sourceSchedule": "글경B103(월4,5,6)"
  },
  {
    "id": "10111-001-2000658",
    "subjectKey": "10111",
    "name": "일본어Level2",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "미도리",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문507",
    "isOnline": false,
    "source": {
      "schedule": "인문507(화1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문507"
      }
    ],
    "sourceSchedule": "인문507(화1,2,3)"
  },
  {
    "id": "10111-002-2000658",
    "subjectKey": "10111",
    "name": "일본어Level2",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "야스코우치 아키코",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문407",
    "isOnline": false,
    "source": {
      "schedule": "인문407(월4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문407"
      }
    ],
    "sourceSchedule": "인문407(월4,5,6)"
  },
  {
    "id": "10111-003-2000658",
    "subjectKey": "10111",
    "name": "일본어Level2",
    "division": "003",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "야스코우치 아키코",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문407",
    "isOnline": false,
    "source": {
      "schedule": "인문407(화4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문407"
      }
    ],
    "sourceSchedule": "인문407(화4,5,6)"
  },
  {
    "id": "10116-001-2000658",
    "subjectKey": "10116",
    "name": "기초한국어이해(외국인전용)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박카밀라",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "국제309",
    "isOnline": false,
    "source": {
      "schedule": "국제309(월1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "국제309"
      }
    ],
    "sourceSchedule": "국제309(월1,2,3)"
  },
  {
    "id": "10126-001-2000658",
    "subjectKey": "10126",
    "name": "디아스포라문학과영화",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이한주",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래319",
    "isOnline": false,
    "source": {
      "schedule": "미래319(목1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래319"
      }
    ],
    "sourceSchedule": "미래319(목1,2,3)"
  },
  {
    "id": "10150-001-2000658",
    "subjectKey": "10150",
    "name": "중앙아시아의이해(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박승찬",
    "days": [
      "수",
      "토"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "인문407",
    "isOnline": true,
    "source": {
      "schedule": "인문407(수1 토5,6)"
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1
        ],
        "classroom": "인문407"
      },
      {
        "day": "토",
        "periods": [
          5,
          6
        ],
        "classroom": "인문407"
      }
    ],
    "sourceSchedule": "인문407(수1 토5,6)"
  },
  {
    "id": "10173-001-2000658",
    "subjectKey": "10173",
    "name": "발명과특허",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김창회",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래104",
    "isOnline": false,
    "source": {
      "schedule": "미래104(화4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래104"
      }
    ],
    "sourceSchedule": "미래104(화4,5,6)"
  },
  {
    "id": "10219-001-2000598",
    "subjectKey": "10219",
    "name": "기본간호학2",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "양정하",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래314",
    "isOnline": false,
    "source": {
      "schedule": "미래314(목4,5)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5
        ],
        "classroom": "미래314"
      }
    ],
    "sourceSchedule": "미래314(목4,5)"
  },
  {
    "id": "10219-002-2000598",
    "subjectKey": "10219",
    "name": "기본간호학2",
    "division": "002",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "양정하",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래315",
    "isOnline": false,
    "source": {
      "schedule": "미래315(월4,5)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5
        ],
        "classroom": "미래315"
      }
    ],
    "sourceSchedule": "미래315(월4,5)"
  },
  {
    "id": "10220-001-2000598",
    "subjectKey": "10220",
    "name": "기본간호학실습2",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "양정하",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래420",
    "isOnline": false,
    "source": {
      "schedule": "미래420(수6,7)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7
        ],
        "classroom": "미래420"
      }
    ],
    "sourceSchedule": "미래420(수6,7)"
  },
  {
    "id": "10220-002-2000598",
    "subjectKey": "10220",
    "name": "기본간호학실습2",
    "division": "002",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "이예나",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "미래420",
    "isOnline": false,
    "source": {
      "schedule": "미래420(수2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "미래420"
      }
    ],
    "sourceSchedule": "미래420(수2,3)"
  },
  {
    "id": "10220-003-2000598",
    "subjectKey": "10220",
    "name": "기본간호학실습2",
    "division": "003",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "이예나",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래420",
    "isOnline": false,
    "source": {
      "schedule": "미래420(화4,5)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "미래420"
      }
    ],
    "sourceSchedule": "미래420(화4,5)"
  },
  {
    "id": "10220-004-2000598",
    "subjectKey": "10220",
    "name": "기본간호학실습2",
    "division": "004",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "이예나",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "미래420",
    "isOnline": false,
    "source": {
      "schedule": "미래420(화2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "미래420"
      }
    ],
    "sourceSchedule": "미래420(화2,3)"
  },
  {
    "id": "10228-001-2000744",
    "subjectKey": "10228",
    "name": "세계무역과법",
    "division": "001",
    "department": "법학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "손창일",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문400",
    "isOnline": false,
    "source": {
      "schedule": "인문400(목2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문400"
      }
    ],
    "sourceSchedule": "인문400(목2,3,4)"
  },
  {
    "id": "10235-001-2000623",
    "subjectKey": "10235",
    "name": "협상론",
    "division": "001",
    "department": "행정학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정하나",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문406",
    "isOnline": false,
    "source": {
      "schedule": "인문406(수2,3,4)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문406"
      }
    ],
    "sourceSchedule": "인문406(수2,3,4)"
  },
  {
    "id": "10255-001-2000616",
    "subjectKey": "10255",
    "name": "이야기와스토리텔링",
    "division": "001",
    "department": "국어국문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "송민규",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문500",
    "isOnline": false,
    "source": {
      "schedule": "인문500(금6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문500"
      }
    ],
    "sourceSchedule": "인문500(금6,7,8)"
  },
  {
    "id": "10259-001-2000618",
    "subjectKey": "10259",
    "name": "Topic Discussion2",
    "division": "001",
    "department": "영어영문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "니콜라스",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문301",
    "isOnline": false,
    "source": {
      "schedule": "인문301(금4,5,6)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문301"
      }
    ],
    "sourceSchedule": "인문301(금4,5,6)"
  },
  {
    "id": "10263-001-2000293",
    "subjectKey": "10263",
    "name": "Debate2",
    "division": "001",
    "department": "영어영문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "크로스비 드류",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문211",
    "isOnline": false,
    "source": {
      "schedule": "인문211(금4,5,6)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문211"
      }
    ],
    "sourceSchedule": "인문211(금4,5,6)"
  },
  {
    "id": "10265-001-2000619",
    "subjectKey": "10265",
    "name": "러시아어강독",
    "division": "001",
    "department": "러시아어문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "벨랴코프일리야",
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 6,
    "room": "종합503",
    "isOnline": false,
    "source": {
      "schedule": "종합503(월6),종합504(목3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6
        ],
        "classroom": "종합503"
      },
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "종합504"
      }
    ],
    "sourceSchedule": "종합503(월6),종합504(목3,4)"
  },
  {
    "id": "10272-001-2000297",
    "subjectKey": "10272",
    "name": "의료관광중국어",
    "division": "001",
    "department": "중어중문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최영",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "인문400",
    "isOnline": false,
    "source": {
      "schedule": "인문400(화5),인문500(목4,5)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5
        ],
        "classroom": "인문400"
      },
      {
        "day": "목",
        "periods": [
          4,
          5
        ],
        "classroom": "인문500"
      }
    ],
    "sourceSchedule": "인문400(화5),인문500(목4,5)"
  },
  {
    "id": "10273-001-2000297",
    "subjectKey": "10273",
    "name": "실무통상중국어(마이크로디그리)",
    "division": "001",
    "department": "중어중문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "손미리",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합508",
    "isOnline": false,
    "source": {
      "schedule": "종합508(수4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합508"
      }
    ],
    "sourceSchedule": "종합508(수4,5,6)"
  },
  {
    "id": "10274-001-2000297",
    "subjectKey": "10274",
    "name": "중국기업탐방과현장실습",
    "division": "001",
    "department": "중어중문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고건혜",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문501",
    "isOnline": false,
    "source": {
      "schedule": "인문501(목1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문501"
      }
    ],
    "sourceSchedule": "인문501(목1,2,3)"
  },
  {
    "id": "10275-001-2000741",
    "subjectKey": "10275",
    "name": "실용일본어작문1",
    "division": "001",
    "department": "일본언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이성근",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "글경414",
    "isOnline": false,
    "source": {
      "schedule": "글경414(목2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "글경414"
      }
    ],
    "sourceSchedule": "글경414(목2,3,4)"
  },
  {
    "id": "10300-001-2000650",
    "subjectKey": "10300",
    "name": "운동재활2",
    "division": "001",
    "department": "운동건강관리",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "백형진",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "체육114",
    "isOnline": false,
    "source": {
      "schedule": "체육114(금3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "체육114"
      }
    ],
    "sourceSchedule": "체육114(금3,4)"
  },
  {
    "id": "10301-001-2000650",
    "subjectKey": "10301",
    "name": "퍼스널트레이닝2",
    "division": "001",
    "department": "운동건강관리",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "박득수",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육112",
    "isOnline": false,
    "source": {
      "schedule": "체육112(화5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "체육112"
      }
    ],
    "sourceSchedule": "체육112(화5,6)"
  },
  {
    "id": "10320-001-2000605",
    "subjectKey": "10320",
    "name": "문화예술교육개론",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정상경",
    "days": [
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(금7,8)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(금7,8)"
  },
  {
    "id": "10320-002-2000606",
    "subjectKey": "10320",
    "name": "문화예술교육개론",
    "division": "002",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정상경",
    "days": [
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(금7,8)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(금7,8)"
  },
  {
    "id": "10320-003-2000607",
    "subjectKey": "10320",
    "name": "문화예술교육개론",
    "division": "003",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정상경",
    "days": [
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(금7,8)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(금7,8)"
  },
  {
    "id": "10320-004-2000608",
    "subjectKey": "10320",
    "name": "문화예술교육개론",
    "division": "004",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정상경",
    "days": [
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(금7,8)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(금7,8)"
  },
  {
    "id": "10331-001-2000256",
    "subjectKey": "10331",
    "name": "문화예술교육현장의이해와실습",
    "division": "001",
    "department": "공예디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "장혜진",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합403",
    "isOnline": false,
    "source": {
      "schedule": "종합403(월2,3)"
    },
    "capacity": 25,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "종합403"
      }
    ],
    "sourceSchedule": "종합403(월2,3)"
  },
  {
    "id": "10331-002-2000264",
    "subjectKey": "10331",
    "name": "문화예술교육현장의이해와실습",
    "division": "002",
    "department": "작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정상경",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(수3,4)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(수3,4)"
  },
  {
    "id": "10331-003-2000265",
    "subjectKey": "10331",
    "name": "문화예술교육현장의이해와실습",
    "division": "003",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정상경",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(수3,4)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(수3,4)"
  },
  {
    "id": "10331-004-2000267",
    "subjectKey": "10331",
    "name": "문화예술교육현장의이해와실습",
    "division": "004",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "박선영",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(화3,4)"
    },
    "capacity": 11,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(화3,4)"
  },
  {
    "id": "10331-005-2000276",
    "subjectKey": "10331",
    "name": "문화예술교육현장의이해와실습",
    "division": "005",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정상경",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(수3,4)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(수3,4)"
  },
  {
    "id": "10331-006-2000277",
    "subjectKey": "10331",
    "name": "문화예술교육현장의이해와실습",
    "division": "006",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정상경",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(수3,4)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(수3,4)"
  },
  {
    "id": "10331-007-2000440",
    "subjectKey": "10331",
    "name": "문화예술교육현장의이해와실습",
    "division": "007",
    "department": "영화영상",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "홍세은",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "글경502",
    "isOnline": false,
    "source": {
      "schedule": "글경502(금3,4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "글경502"
      }
    ],
    "sourceSchedule": "글경502(금3,4)"
  },
  {
    "id": "10331-008-2000441",
    "subjectKey": "10331",
    "name": "문화예술교육현장의이해와실습",
    "division": "008",
    "department": "연극",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "홍세은",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "글경502",
    "isOnline": false,
    "source": {
      "schedule": "글경502(금3,4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "글경502"
      }
    ],
    "sourceSchedule": "글경502(금3,4)"
  },
  {
    "id": "10335-001-2000624",
    "subjectKey": "10335",
    "name": "거시경제학2",
    "division": "001",
    "department": "경제금융",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이용회",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경B103",
    "isOnline": false,
    "source": {
      "schedule": "글경B103(화1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경B103"
      }
    ],
    "sourceSchedule": "글경B103(화1,2,3)"
  },
  {
    "id": "10336-001-2000624",
    "subjectKey": "10336",
    "name": "미시경제학2",
    "division": "001",
    "department": "경제금융",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이탁",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "글경502",
    "isOnline": false,
    "source": {
      "schedule": "글경502(월7 화5,6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "글경502"
      },
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "글경502"
      }
    ],
    "sourceSchedule": "글경502(월7 화5,6)"
  },
  {
    "id": "10338-001-2000624",
    "subjectKey": "10338",
    "name": "금융자산투자의이해(마이크로디그리)",
    "division": "001",
    "department": "경제금융",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김양우",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "글경502",
    "isOnline": false,
    "source": {
      "schedule": "글경502(월2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "글경502"
      }
    ],
    "sourceSchedule": "글경502(월2,3,4)"
  },
  {
    "id": "10338-002-2000624",
    "subjectKey": "10338",
    "name": "금융자산투자의이해(마이크로디그리)",
    "division": "002",
    "department": "경제금융",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이상엽",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "글경501",
    "isOnline": false,
    "source": {
      "schedule": "글경501(월2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "글경501"
      }
    ],
    "sourceSchedule": "글경501(월2,3,4)"
  },
  {
    "id": "10341-001-2000626",
    "subjectKey": "10341",
    "name": "데이터베이스론",
    "division": "001",
    "department": "경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이은곤",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경401",
    "isOnline": false,
    "source": {
      "schedule": "글경401(월1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경401"
      }
    ],
    "sourceSchedule": "글경401(월1,2,3)"
  },
  {
    "id": "10342-001-2000505",
    "subjectKey": "10342",
    "name": "문화마케팅(경영)",
    "division": "001",
    "department": "경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이현정",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "글경B102",
    "isOnline": false,
    "source": {
      "schedule": "글경B102(화7,8,9)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "글경B102"
      }
    ],
    "sourceSchedule": "글경B102(화7,8,9)"
  },
  {
    "id": "10347-001-2000648",
    "subjectKey": "10347",
    "name": "스포츠마케팅",
    "division": "001",
    "department": "체육학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양홍위",
    "days": [
      "목",
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육116",
    "isOnline": false,
    "source": {
      "schedule": "체육116(목5,6 금3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "체육116"
      },
      {
        "day": "금",
        "periods": [
          3
        ],
        "classroom": "체육116"
      }
    ],
    "sourceSchedule": "체육116(목5,6 금3)"
  },
  {
    "id": "10355-001-2000629",
    "subjectKey": "10355",
    "name": "호텔관광경영전략",
    "division": "001",
    "department": "호텔경영",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "마여실",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경703",
    "isOnline": false,
    "source": {
      "schedule": "글경703(금5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경703"
      }
    ],
    "sourceSchedule": "글경703(금5,6,7)"
  },
  {
    "id": "10363-001-2000630",
    "subjectKey": "10363",
    "name": "식품및조리학입문",
    "division": "001",
    "department": "외식경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조미나",
    "days": [
      "수",
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "글경702",
    "isOnline": false,
    "source": {
      "schedule": "글경702(수2),글경703(화3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2
        ],
        "classroom": "글경702"
      },
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "글경703"
      }
    ],
    "sourceSchedule": "글경702(수2),글경703(화3,4)"
  },
  {
    "id": "10369-001-2000625",
    "subjectKey": "10369",
    "name": "컨벤션영어",
    "division": "001",
    "department": "국제개발협력",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이재민",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경502",
    "isOnline": false,
    "source": {
      "schedule": "글경502(수5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경502"
      }
    ],
    "sourceSchedule": "글경502(수5,6,7)"
  },
  {
    "id": "10371-001-2000625",
    "subjectKey": "10371",
    "name": "환경과개발",
    "division": "001",
    "department": "국제개발협력",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김종천",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경501",
    "isOnline": false,
    "source": {
      "schedule": "글경501(수5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경501"
      }
    ],
    "sourceSchedule": "글경501(수5,6,7)"
  },
  {
    "id": "10373-001-2000504",
    "subjectKey": "10373",
    "name": "국제개발협력세미나2",
    "division": "001",
    "department": "국제개발협력",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최영미",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경503",
    "isOnline": false,
    "source": {
      "schedule": "글경503(월5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경503"
      }
    ],
    "sourceSchedule": "글경503(월5,6,7)"
  },
  {
    "id": "10379-001-2000634",
    "subjectKey": "10379",
    "name": "건설시공학",
    "division": "001",
    "department": "건설환경공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이강욱",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "종합511",
    "isOnline": false,
    "source": {
      "schedule": "종합511(월4 화7,8)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4
        ],
        "classroom": "종합511"
      },
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "종합511"
      }
    ],
    "sourceSchedule": "종합511(월4 화7,8)"
  },
  {
    "id": "10380-001-2000411",
    "subjectKey": "10380",
    "name": "환경플랜트설계",
    "division": "001",
    "department": "건설환경공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "나정균",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합404",
    "isOnline": false,
    "source": {
      "schedule": "종합404(월7,8,9)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합404"
      }
    ],
    "sourceSchedule": "종합404(월7,8,9)"
  },
  {
    "id": "10381-001-2000414",
    "subjectKey": "10381",
    "name": "Presentation",
    "division": "001",
    "department": "건축학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "김현주",
    "days": [
      "금"
    ],
    "startPeriod": 8,
    "endPeriod": 9,
    "room": "2공학314",
    "isOnline": false,
    "source": {
      "schedule": "2공학314(금8,9)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          8,
          9
        ],
        "classroom": "2공학314"
      }
    ],
    "sourceSchedule": "2공학314(금8,9)"
  },
  {
    "id": "10383-001-2000636",
    "subjectKey": "10383",
    "name": "건축디지털표현1",
    "division": "001",
    "department": "건축학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "권혁만",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "2공학202",
    "isOnline": false,
    "source": {
      "schedule": "2공학202(월6,7,8)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "2공학202"
      }
    ],
    "sourceSchedule": "2공학202(월6,7,8)"
  },
  {
    "id": "10386-001-2000636",
    "subjectKey": "10386",
    "name": "건축론2",
    "division": "001",
    "department": "건축학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "권경남",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "2공학313",
    "isOnline": false,
    "source": {
      "schedule": "2공학313(월2,3 수8)"
    },
    "capacity": 35,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "2공학313"
      },
      {
        "day": "수",
        "periods": [
          8
        ],
        "classroom": "2공학313"
      }
    ],
    "sourceSchedule": "2공학313(월2,3 수8)"
  },
  {
    "id": "10389-001-2000414",
    "subjectKey": "10389",
    "name": "실내인테리어디자인",
    "division": "001",
    "department": "건축학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김지영",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "자연대B103",
    "isOnline": false,
    "source": {
      "schedule": "자연대B103(화1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "자연대B103"
      }
    ],
    "sourceSchedule": "자연대B103(화1,2,3)"
  },
  {
    "id": "10392-001-2000637",
    "subjectKey": "10392",
    "name": "부동산금융론",
    "division": "001",
    "department": "도시부동산학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "민성훈",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "2공학314",
    "isOnline": false,
    "source": {
      "schedule": "2공학314(화6,7 수8)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7
        ],
        "classroom": "2공학314"
      },
      {
        "day": "수",
        "periods": [
          8
        ],
        "classroom": "2공학314"
      }
    ],
    "sourceSchedule": "2공학314(화6,7 수8)"
  },
  {
    "id": "10394-001-2000415",
    "subjectKey": "10394",
    "name": "도시부동산세미나",
    "division": "001",
    "department": "도시부동산학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이형석",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "2공학313",
    "isOnline": false,
    "source": {
      "schedule": "2공학313(수5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "2공학313"
      }
    ],
    "sourceSchedule": "2공학313(수5,6,7)"
  },
  {
    "id": "10396-001-2000636",
    "subjectKey": "10396",
    "name": "서양건축사(현대건축)",
    "division": "001",
    "department": "건축학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "진우성",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래102",
    "isOnline": false,
    "source": {
      "schedule": "미래102(화1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래102"
      }
    ],
    "sourceSchedule": "미래102(화1,2,3)"
  },
  {
    "id": "10401-001-2000637",
    "subjectKey": "10401",
    "name": "SOC와민자이론",
    "division": "001",
    "department": "도시부동산학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "남궁혜",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "2공학313",
    "isOnline": false,
    "source": {
      "schedule": "2공학313(화2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "2공학313"
      }
    ],
    "sourceSchedule": "2공학313(화2,3,4)"
  },
  {
    "id": "10404-001-2000639",
    "subjectKey": "10404",
    "name": "동적시뮬레이션응용설계",
    "division": "001",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이상엽",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합506",
    "isOnline": false,
    "source": {
      "schedule": "종합506(수1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합506"
      }
    ],
    "sourceSchedule": "종합506(수1,2,3)"
  },
  {
    "id": "10414-001-2000643",
    "subjectKey": "10414",
    "name": "나노화학공학",
    "division": "001",
    "department": "화학공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박진혁",
    "days": [
      "금",
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "미래B201",
    "isOnline": false,
    "source": {
      "schedule": "미래B201(금2),미래B202(화3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2
        ],
        "classroom": "미래B201"
      },
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B202"
      }
    ],
    "sourceSchedule": "미래B201(금2),미래B202(화3,4)"
  },
  {
    "id": "10419-001-2000640",
    "subjectKey": "10419",
    "name": "로봇제어프로그래밍2",
    "division": "001",
    "department": "전기공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이경희",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연관508",
    "isOnline": false,
    "source": {
      "schedule": "자연관508(수5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연관508"
      }
    ],
    "sourceSchedule": "자연관508(수5,6,7,8)"
  },
  {
    "id": "10421-001-2000635",
    "subjectKey": "10421",
    "name": "신재생에너지(마이크로디그리)",
    "division": "001",
    "department": "환경에너지공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "성기명",
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "종합410",
    "isOnline": false,
    "source": {
      "schedule": "종합410(월8 목2,3)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          8
        ],
        "classroom": "종합410"
      },
      {
        "day": "목",
        "periods": [
          2,
          3
        ],
        "classroom": "종합410"
      }
    ],
    "sourceSchedule": "종합410(월8 목2,3)"
  },
  {
    "id": "10422-001-2000635",
    "subjectKey": "10422",
    "name": "에너지자원과미래(마이크로디그리)",
    "division": "001",
    "department": "환경에너지공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "백영순",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래106",
    "isOnline": false,
    "source": {
      "schedule": "미래106(월1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래106"
      }
    ],
    "sourceSchedule": "미래106(월1,2,3)"
  },
  {
    "id": "10422-002-2000635",
    "subjectKey": "10422",
    "name": "에너지자원과미래(마이크로디그리)",
    "division": "002",
    "department": "환경에너지공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박새롬",
    "days": [
      "수",
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "자연관307",
    "isOnline": false,
    "source": {
      "schedule": "자연관307(수3),종합404(월1,2)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3
        ],
        "classroom": "자연관307"
      },
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "종합404"
      }
    ],
    "sourceSchedule": "자연관307(수3),종합404(월1,2)"
  },
  {
    "id": "10433-001-2000651",
    "subjectKey": "10433",
    "name": "현대수묵화2",
    "division": "001",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김민주",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "조형305",
    "isOnline": false,
    "source": {
      "schedule": "조형305(월6,7,8,9)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "조형305"
      }
    ],
    "sourceSchedule": "조형305(월6,7,8,9)"
  },
  {
    "id": "10435-001-2000651",
    "subjectKey": "10435",
    "name": "현대민화2",
    "division": "001",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "서기환",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "조형305",
    "isOnline": false,
    "source": {
      "schedule": "조형305(수1,2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "조형305"
      }
    ],
    "sourceSchedule": "조형305(수1,2,3,4)"
  },
  {
    "id": "10436-001-2000651",
    "subjectKey": "10436",
    "name": "전통회화2",
    "division": "001",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이광수",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "조형305",
    "isOnline": false,
    "source": {
      "schedule": "조형305(목6,7,8,9)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "조형305"
      }
    ],
    "sourceSchedule": "조형305(목6,7,8,9)"
  },
  {
    "id": "10446-001-2000653",
    "subjectKey": "10446",
    "name": "Design Studio3",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이의정",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술208",
    "isOnline": false,
    "source": {
      "schedule": "미술208(목1,2,3,4)"
    },
    "capacity": 24,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술208"
      }
    ],
    "sourceSchedule": "미술208(목1,2,3,4)"
  },
  {
    "id": "10446-002-2000653",
    "subjectKey": "10446",
    "name": "Design Studio3",
    "division": "002",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "유예원",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술213-2",
    "isOnline": false,
    "source": {
      "schedule": "미술213-2(화6,7,8,9)"
    },
    "capacity": 24,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술213-2"
      }
    ],
    "sourceSchedule": "미술213-2(화6,7,8,9)"
  },
  {
    "id": "10446-003-2000653",
    "subjectKey": "10446",
    "name": "Design Studio3",
    "division": "003",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "유예원",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술213-2",
    "isOnline": false,
    "source": {
      "schedule": "미술213-2(화1,2,3,4)"
    },
    "capacity": 24,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술213-2"
      }
    ],
    "sourceSchedule": "미술213-2(화1,2,3,4)"
  },
  {
    "id": "10448-001-2000653",
    "subjectKey": "10448",
    "name": "Design & Business",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조정민",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술114",
    "isOnline": false,
    "source": {
      "schedule": "미술114(화1,2,3,4)"
    },
    "capacity": 24,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술114"
      }
    ],
    "sourceSchedule": "미술114(화1,2,3,4)"
  },
  {
    "id": "10448-002-2000653",
    "subjectKey": "10448",
    "name": "Design & Business",
    "division": "002",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조정민",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술114",
    "isOnline": false,
    "source": {
      "schedule": "미술114(화5,6,7,8)"
    },
    "capacity": 24,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술114"
      }
    ],
    "sourceSchedule": "미술114(화5,6,7,8)"
  },
  {
    "id": "10449-001-2000653",
    "subjectKey": "10449",
    "name": "Interactive Design",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "원다예",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술213-1",
    "isOnline": false,
    "source": {
      "schedule": "미술213-1(수1,2,3,4)"
    },
    "capacity": 24,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술213-1"
      }
    ],
    "sourceSchedule": "미술213-1(수1,2,3,4)"
  },
  {
    "id": "10454-001-2000257",
    "subjectKey": "10454",
    "name": "Digital Media 2",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박세준",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술208",
    "isOnline": false,
    "source": {
      "schedule": "미술208(월1,2,3,4)"
    },
    "capacity": 24,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술208"
      }
    ],
    "sourceSchedule": "미술208(월1,2,3,4)"
  },
  {
    "id": "10456-001-2000257",
    "subjectKey": "10456",
    "name": "Print Media 2",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이병옥",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술203",
    "isOnline": false,
    "source": {
      "schedule": "미술203(금1,2,3,4)"
    },
    "capacity": 24,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술203"
      }
    ],
    "sourceSchedule": "미술203(금1,2,3,4)"
  },
  {
    "id": "10460-001-2000257",
    "subjectKey": "10460",
    "name": "Promotion Design2",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이정연",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술203",
    "isOnline": false,
    "source": {
      "schedule": "미술203(목5,6,7,8)"
    },
    "capacity": 24,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술203"
      }
    ],
    "sourceSchedule": "미술203(목5,6,7,8)"
  },
  {
    "id": "10468-001-2000596",
    "subjectKey": "10468",
    "name": "빅데이터정보검색",
    "division": "001",
    "department": "컴퓨터학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고혁진",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT309",
    "isOnline": false,
    "source": {
      "schedule": "IT309(금2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT309"
      }
    ],
    "sourceSchedule": "IT309(금2,3,4)"
  },
  {
    "id": "10487-001-2000517",
    "subjectKey": "10487",
    "name": "침해사고대응",
    "division": "001",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김종민",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT413",
    "isOnline": false,
    "source": {
      "schedule": "IT413(화2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT413"
      }
    ],
    "sourceSchedule": "IT413(화2,3,4)"
  },
  {
    "id": "10487-002-2000517",
    "subjectKey": "10487",
    "name": "침해사고대응",
    "division": "002",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김종민",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT514",
    "isOnline": false,
    "source": {
      "schedule": "IT514(화6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT514"
      }
    ],
    "sourceSchedule": "IT514(화6,7,8)"
  },
  {
    "id": "10495-001-2000647",
    "subjectKey": "10495",
    "name": "인터넷보안프로젝트",
    "division": "001",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "전상훈",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT407",
    "isOnline": false,
    "source": {
      "schedule": "IT407(수1,2,3,4)"
    },
    "capacity": 80,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT407"
      }
    ],
    "sourceSchedule": "IT407(수1,2,3,4)"
  },
  {
    "id": "10516-001-2000605",
    "subjectKey": "10516",
    "name": "음악교수학습방법",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정상경",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(수1,2)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(수1,2)"
  },
  {
    "id": "10516-002-2000606",
    "subjectKey": "10516",
    "name": "음악교수학습방법",
    "division": "002",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정상경",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(수1,2)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(수1,2)"
  },
  {
    "id": "10516-003-2000607",
    "subjectKey": "10516",
    "name": "음악교수학습방법",
    "division": "003",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정상경",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(수1,2)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(수1,2)"
  },
  {
    "id": "10516-004-2000608",
    "subjectKey": "10516",
    "name": "음악교수학습방법",
    "division": "004",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정상경",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(수1,2)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(수1,2)"
  },
  {
    "id": "10520-001-2000265",
    "subjectKey": "10520",
    "name": "합창지휘법2",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "전은배",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악215",
    "isOnline": false,
    "source": {
      "schedule": "음악215(월5,6)"
    },
    "capacity": 10,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "음악215"
      }
    ],
    "sourceSchedule": "음악215(월5,6)"
  },
  {
    "id": "10522-001-2000608",
    "subjectKey": "10522",
    "name": "관현악사및문헌2",
    "division": "001",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "박진아",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(화1,2)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(화1,2)"
  },
  {
    "id": "10526-001-2000609",
    "subjectKey": "10526",
    "name": "국악교수학습방법",
    "division": "001",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정영선",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(수6,7)"
    },
    "capacity": 10,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(수6,7)"
  },
  {
    "id": "10531-001-2000430",
    "subjectKey": "10531",
    "name": "보건의료와간호정책",
    "division": "001",
    "department": "간호학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "이경희",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "미래416",
    "isOnline": false,
    "source": {
      "schedule": "미래416(월7,8)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8
        ],
        "classroom": "미래416"
      }
    ],
    "sourceSchedule": "미래416(월7,8)"
  },
  {
    "id": "10532-001-2000430",
    "subjectKey": "10532",
    "name": "보건프로그램개발및평가",
    "division": "001",
    "department": "간호학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "이경희",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래424",
    "isOnline": false,
    "source": {
      "schedule": "미래424(금5,6)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "미래424"
      }
    ],
    "sourceSchedule": "미래424(금5,6)"
  },
  {
    "id": "10533-001-2000430",
    "subjectKey": "10533",
    "name": "임상추론",
    "division": "001",
    "department": "간호학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "박금주",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래418",
    "isOnline": false,
    "source": {
      "schedule": "미래418(목3,4)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "미래418"
      }
    ],
    "sourceSchedule": "미래418(목3,4)"
  },
  {
    "id": "10546-001-2000590",
    "subjectKey": "10546",
    "name": "건축학개론",
    "division": "001",
    "department": "건축도시부동산학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김현주",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "2공학313",
    "isOnline": false,
    "source": {
      "schedule": "2공학313(월6,7,8)"
    },
    "capacity": 52,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "2공학313"
      }
    ],
    "sourceSchedule": "2공학313(월6,7,8)"
  },
  {
    "id": "10546-001-2000763",
    "subjectKey": "10546",
    "name": "건축학개론",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김현주",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "2공학313",
    "isOnline": false,
    "source": {
      "schedule": "2공학313(월6,7,8)"
    },
    "capacity": 52,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "2공학313"
      }
    ],
    "sourceSchedule": "2공학313(월6,7,8)"
  },
  {
    "id": "10546-002-2000590",
    "subjectKey": "10546",
    "name": "건축학개론",
    "division": "002",
    "department": "건축도시부동산학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김현주",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "미래106",
    "isOnline": false,
    "source": {
      "schedule": "미래106(화3,4,5)"
    },
    "capacity": 51,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "미래106"
      }
    ],
    "sourceSchedule": "미래106(화3,4,5)"
  },
  {
    "id": "10546-002-2000763",
    "subjectKey": "10546",
    "name": "건축학개론",
    "division": "002",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김현주",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "미래106",
    "isOnline": false,
    "source": {
      "schedule": "미래106(화3,4,5)"
    },
    "capacity": 51,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "미래106"
      }
    ],
    "sourceSchedule": "미래106(화3,4,5)"
  },
  {
    "id": "10549-001-2000637",
    "subjectKey": "10549",
    "name": "도시개발계획및실습(마이크로디그리)",
    "division": "001",
    "department": "도시부동산학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "안채완",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "종합510",
    "isOnline": false,
    "source": {
      "schedule": "종합510(목1,2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "종합510"
      }
    ],
    "sourceSchedule": "종합510(목1,2,3,4)"
  },
  {
    "id": "10556-001-2000637",
    "subjectKey": "10556",
    "name": "사회조사분석론2",
    "division": "001",
    "department": "도시부동산학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "류강민",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "2공학314",
    "isOnline": false,
    "source": {
      "schedule": "2공학314(금2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "2공학314"
      }
    ],
    "sourceSchedule": "2공학314(금2,3,4)"
  },
  {
    "id": "10557-001-2000637",
    "subjectKey": "10557",
    "name": "공동주거개발계획및실습",
    "division": "001",
    "department": "도시부동산학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이현주",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "2공학314",
    "isOnline": false,
    "source": {
      "schedule": "2공학314(수1,2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "2공학314"
      }
    ],
    "sourceSchedule": "2공학314(수1,2,3,4)"
  },
  {
    "id": "10560-001-2000637",
    "subjectKey": "10560",
    "name": "부동산중개및마케팅론",
    "division": "001",
    "department": "도시부동산학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김종민",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "2공학313",
    "isOnline": false,
    "source": {
      "schedule": "2공학313(금2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "2공학313"
      }
    ],
    "sourceSchedule": "2공학313(금2,3,4)"
  },
  {
    "id": "10563-001-2000639",
    "subjectKey": "10563",
    "name": "자동차부품힘측정및응용",
    "division": "001",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "심재호",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "미래109",
    "isOnline": false,
    "source": {
      "schedule": "미래109(금5,6,7)"
    },
    "capacity": 25,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "미래109"
      }
    ],
    "sourceSchedule": "미래109(금5,6,7)"
  },
  {
    "id": "10576-002-2000617",
    "subjectKey": "10576",
    "name": "캡스톤디자인1",
    "division": "002",
    "department": "사학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정훈진",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합503",
    "isOnline": false,
    "source": {
      "schedule": "종합503(화4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합503"
      }
    ],
    "sourceSchedule": "종합503(화4,5,6)"
  },
  {
    "id": "10576-004-2000621",
    "subjectKey": "10576",
    "name": "캡스톤디자인1",
    "division": "004",
    "department": "중어중문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이화자",
    "days": [
      "수",
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "종합503",
    "isOnline": false,
    "source": {
      "schedule": "종합503(수2 금2,3)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2
        ],
        "classroom": "종합503"
      },
      {
        "day": "금",
        "periods": [
          2,
          3
        ],
        "classroom": "종합503"
      }
    ],
    "sourceSchedule": "종합503(수2 금2,3)"
  },
  {
    "id": "10576-006-2000586",
    "subjectKey": "10576",
    "name": "캡스톤디자인1(회계)",
    "division": "006",
    "department": "경영학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김동원",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "글경601",
    "isOnline": false,
    "source": {
      "schedule": "글경601(월2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "글경601"
      }
    ],
    "sourceSchedule": "글경601(월2,3,4)"
  },
  {
    "id": "10576-008-2000624",
    "subjectKey": "10576",
    "name": "캡스톤디자인1",
    "division": "008",
    "department": "경제금융",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "왕두균",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경503",
    "isOnline": false,
    "source": {
      "schedule": "글경503(금1,2,3)"
    },
    "capacity": 7,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경503"
      }
    ],
    "sourceSchedule": "글경503(금1,2,3)"
  },
  {
    "id": "10576-011-2000635",
    "subjectKey": "10576",
    "name": "캡스톤디자인1",
    "division": "011",
    "department": "환경에너지공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박새롬",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "자연관307",
    "isOnline": false,
    "source": {
      "schedule": "자연관307(화2,3),종합410(목4)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "자연관307"
      },
      {
        "day": "목",
        "periods": [
          4
        ],
        "classroom": "종합410"
      }
    ],
    "sourceSchedule": "자연관307(화2,3),종합410(목4)"
  },
  {
    "id": "10576-013-2000639",
    "subjectKey": "10576",
    "name": "캡스톤디자인1",
    "division": "013",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이찬",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합608",
    "isOnline": false,
    "source": {
      "schedule": "종합608(수5,6,7)"
    },
    "capacity": 35,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합608"
      }
    ],
    "sourceSchedule": "종합608(수5,6,7)"
  },
  {
    "id": "10576-014-2000640",
    "subjectKey": "10576",
    "name": "캡스톤디자인1",
    "division": "014",
    "department": "전기공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "배진용",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "자연관509",
    "isOnline": false,
    "source": {
      "schedule": "자연관509(금5,6,7)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "자연관509"
      }
    ],
    "sourceSchedule": "자연관509(금5,6,7)"
  },
  {
    "id": "10576-017-2000600",
    "subjectKey": "10576",
    "name": "캡스톤디자인1",
    "division": "017",
    "department": "의류학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "사사키치카",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "생활405",
    "isOnline": false,
    "source": {
      "schedule": "생활405(수1,2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "생활405"
      }
    ],
    "sourceSchedule": "생활405(수1,2,3,4)"
  },
  {
    "id": "10576-018-2000654",
    "subjectKey": "10576",
    "name": "캡스톤디자인1(AI Fashion performance_마이크로디그리)",
    "division": "018",
    "department": "패션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "전지현",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술213-1",
    "isOnline": false,
    "source": {
      "schedule": "미술213-1(금6,7,8,9)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술213-1"
      }
    ],
    "sourceSchedule": "미술213-1(금6,7,8,9)"
  },
  {
    "id": "10576-019-2000613",
    "subjectKey": "10576",
    "name": "캡스톤디자인1(영화음악작곡 및 프로덕션 디자인)",
    "division": "019",
    "department": "영화예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김석범",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(목7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(목7,8,9)"
  },
  {
    "id": "10576-021-2000586",
    "subjectKey": "10576",
    "name": "캡스톤디자인1(무역자격증시험대비반)",
    "division": "021",
    "department": "경영학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "설원준",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경602",
    "isOnline": false,
    "source": {
      "schedule": "글경602(화5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경602"
      }
    ],
    "sourceSchedule": "글경602(화5,6,7)"
  },
  {
    "id": "10576-023-2000511",
    "subjectKey": "10576",
    "name": "캡스톤디자인1",
    "division": "023",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정진명",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "글경317",
    "isOnline": false,
    "source": {
      "schedule": "글경317(화5 수2,3)"
    },
    "capacity": 10,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5
        ],
        "classroom": "글경317"
      },
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "글경317"
      }
    ],
    "sourceSchedule": "글경317(화5 수2,3)"
  },
  {
    "id": "10576-024-2000511",
    "subjectKey": "10576",
    "name": "캡스톤디자인1",
    "division": "024",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김진현",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경311",
    "isOnline": false,
    "source": {
      "schedule": "글경311(화4,5,6)"
    },
    "capacity": 10,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경311"
      }
    ],
    "sourceSchedule": "글경311(화4,5,6)"
  },
  {
    "id": "10576-025-2000511",
    "subjectKey": "10576",
    "name": "캡스톤디자인1",
    "division": "025",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "방효은",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "글경317",
    "isOnline": false,
    "source": {
      "schedule": "글경317(화4 목5,6)"
    },
    "capacity": 10,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4
        ],
        "classroom": "글경317"
      },
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "글경317"
      }
    ],
    "sourceSchedule": "글경317(화4 목5,6)"
  },
  {
    "id": "10576-026-2000639",
    "subjectKey": "10576",
    "name": "캡스톤디자인1",
    "division": "026",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "임성혁",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합408",
    "isOnline": false,
    "source": {
      "schedule": "종합408(수5,6,7)"
    },
    "capacity": 35,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합408"
      }
    ],
    "sourceSchedule": "종합408(수5,6,7)"
  },
  {
    "id": "10576-027-2000626",
    "subjectKey": "10576",
    "name": "캡스톤디자인1(경영)",
    "division": "027",
    "department": "경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박창욱",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경603",
    "isOnline": false,
    "source": {
      "schedule": "글경603(금1,2,3)"
    },
    "capacity": 7,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경603"
      }
    ],
    "sourceSchedule": "글경603(금1,2,3)"
  },
  {
    "id": "10577-004-2000408",
    "subjectKey": "10577",
    "name": "캡스톤디자인2(마이크로디그리)",
    "division": "004",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최용복",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "종합404",
    "isOnline": false,
    "source": {
      "schedule": "종합404(수6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "종합404"
      }
    ],
    "sourceSchedule": "종합404(수6,7,8)"
  },
  {
    "id": "10577-006-2000414",
    "subjectKey": "10577",
    "name": "캡스톤디자인2(건축경영)",
    "division": "006",
    "department": "건축학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "임광혁",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "자연대B103",
    "isOnline": false,
    "source": {
      "schedule": "자연대B103(월5 화4,5)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5
        ],
        "classroom": "자연대B103"
      },
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "자연대B103"
      }
    ],
    "sourceSchedule": "자연대B103(월5 화4,5)"
  },
  {
    "id": "10577-009-2000420",
    "subjectKey": "10577",
    "name": "캡스톤디자인2",
    "division": "009",
    "department": "전자재료공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박병규",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합412",
    "isOnline": false,
    "source": {
      "schedule": "종합412(월5,6,7)"
    },
    "capacity": 12,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합412"
      }
    ],
    "sourceSchedule": "종합412(월5,6,7)"
  },
  {
    "id": "10577-010-2000445",
    "subjectKey": "10577",
    "name": "캡스톤디자인2",
    "division": "010",
    "department": "신소재공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "장건수",
    "days": [
      "목",
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "미래B103",
    "isOnline": false,
    "source": {
      "schedule": "미래B103(목4 금7,8)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4
        ],
        "classroom": "미래B103"
      },
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "미래B103"
      }
    ],
    "sourceSchedule": "미래B103(목4 금7,8)"
  },
  {
    "id": "10577-011-2000446",
    "subjectKey": "10577",
    "name": "캡스톤디자인2",
    "division": "011",
    "department": "화학공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "노호식",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "미래723",
    "isOnline": false,
    "source": {
      "schedule": "미래723(목5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "미래723"
      }
    ],
    "sourceSchedule": "미래723(목5,6,7)"
  },
  {
    "id": "10577-012-2000511",
    "subjectKey": "10577",
    "name": "캡스톤디자인2",
    "division": "012",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "염희란",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경317",
    "isOnline": false,
    "source": {
      "schedule": "글경317(월4,5,6)"
    },
    "capacity": 10,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경317"
      }
    ],
    "sourceSchedule": "글경317(월4,5,6)"
  },
  {
    "id": "10577-013-2000517",
    "subjectKey": "10577",
    "name": "캡스톤디자인2",
    "division": "013",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박두식",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "IT215",
    "isOnline": false,
    "source": {
      "schedule": "IT215(금1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "IT215"
      }
    ],
    "sourceSchedule": "IT215(금1,2,3)"
  },
  {
    "id": "10577-014-2000430",
    "subjectKey": "10577",
    "name": "캡스톤디자인2",
    "division": "014",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김라영",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래418",
    "isOnline": false,
    "source": {
      "schedule": "미래418(수1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래418"
      }
    ],
    "sourceSchedule": "미래418(수1,2,3)"
  },
  {
    "id": "10577-015-2000431",
    "subjectKey": "10577",
    "name": "캡스톤디자인2",
    "division": "015",
    "department": "아동가족복지학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김윤희",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "생활502",
    "isOnline": false,
    "source": {
      "schedule": "생활502(화6,7,8,9)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "생활502"
      }
    ],
    "sourceSchedule": "생활502(화6,7,8,9)"
  },
  {
    "id": "10577-017-2000435",
    "subjectKey": "10577",
    "name": "캡스톤디자인2",
    "division": "017",
    "department": "체육학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이지선",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B202",
    "isOnline": false,
    "source": {
      "schedule": "미래B202(화5,6 수4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B202"
      },
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "미래B202"
      }
    ],
    "sourceSchedule": "미래B202(화5,6 수4)"
  },
  {
    "id": "10577-018-2000436",
    "subjectKey": "10577",
    "name": "캡스톤디자인2",
    "division": "018",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양홍위",
    "days": [
      "목",
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "체육113",
    "isOnline": false,
    "source": {
      "schedule": "체육113(목3),체육114(수1,2)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3
        ],
        "classroom": "체육113"
      },
      {
        "day": "수",
        "periods": [
          1,
          2
        ],
        "classroom": "체육114"
      }
    ],
    "sourceSchedule": "체육113(목3),체육114(수1,2)"
  },
  {
    "id": "10577-019-2000437",
    "subjectKey": "10577",
    "name": "캡스톤디자인2",
    "division": "019",
    "department": "운동건강관리",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이지선",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "체육116",
    "isOnline": false,
    "source": {
      "schedule": "체육116(화2),체육117(목1,2)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2
        ],
        "classroom": "체육116"
      },
      {
        "day": "목",
        "periods": [
          1,
          2
        ],
        "classroom": "체육117"
      }
    ],
    "sourceSchedule": "체육116(화2),체육117(목1,2)"
  },
  {
    "id": "10577-020-2000251",
    "subjectKey": "10577",
    "name": "캡스톤디자인2",
    "division": "020",
    "department": "조소",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "심영철",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "조형101",
    "isOnline": false,
    "source": {
      "schedule": "조형101(금6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "조형101"
      }
    ],
    "sourceSchedule": "조형101(금6,7,8)"
  },
  {
    "id": "10577-021-2000256",
    "subjectKey": "10577",
    "name": "캡스톤디자인2",
    "division": "021",
    "department": "공예디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "천혜영",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "미술114",
    "isOnline": false,
    "source": {
      "schedule": "미술114(목5,6,7)"
    },
    "capacity": 25,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "미술114"
      }
    ],
    "sourceSchedule": "미술114(목5,6,7)"
  },
  {
    "id": "10577-022-2000257",
    "subjectKey": "10577",
    "name": "캡스톤디자인2",
    "division": "022",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정유섭",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술205",
    "isOnline": false,
    "source": {
      "schedule": "미술205(금1,2,3,4)"
    },
    "capacity": 24,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술205"
      }
    ],
    "sourceSchedule": "미술205(금1,2,3,4)"
  },
  {
    "id": "10577-024-2000605",
    "subjectKey": "10577",
    "name": "캡스톤디자인2(영화음악작곡 및 프로덕션 디자인)",
    "division": "024",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박영란",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(목7,8,9)"
    },
    "capacity": 10,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(목7,8,9)"
  },
  {
    "id": "10577-025-2000606",
    "subjectKey": "10577",
    "name": "캡스톤디자인2",
    "division": "025",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김지영",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "음악111",
    "isOnline": false,
    "source": {
      "schedule": "음악111(화7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "음악111"
      }
    ],
    "sourceSchedule": "음악111(화7,8,9)"
  },
  {
    "id": "10577-027-2000608",
    "subjectKey": "10577",
    "name": "캡스톤디자인2",
    "division": "027",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "에르완리샤",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(화1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(화1,2,3)"
  },
  {
    "id": "10577-029-2000614",
    "subjectKey": "10577",
    "name": "캡스톤디자인2",
    "division": "029",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "신소현",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "복지305",
    "isOnline": false,
    "source": {
      "schedule": "복지305(수2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "복지305"
      }
    ],
    "sourceSchedule": "복지305(수2,3,4)"
  },
  {
    "id": "10577-031-2000447",
    "subjectKey": "10577",
    "name": "캡스톤디자인2(AI picture book studio)",
    "division": "031",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "심유미",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래312",
    "isOnline": false,
    "source": {
      "schedule": "미래312(수6,7,8)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래312"
      }
    ],
    "sourceSchedule": "미래312(수6,7,8)"
  },
  {
    "id": "10577-032-2000420",
    "subjectKey": "10577",
    "name": "캡스톤디자인2",
    "division": "032",
    "department": "전자재료공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김연준",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합305",
    "isOnline": false,
    "source": {
      "schedule": "종합305(목1,2,3)"
    },
    "capacity": 12,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합305"
      }
    ],
    "sourceSchedule": "종합305(목1,2,3)"
  },
  {
    "id": "10578-002-2000593",
    "subjectKey": "10578",
    "name": "전자회로설계및실험2",
    "division": "002",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "배진용",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연관509",
    "isOnline": false,
    "source": {
      "schedule": "자연관509(월5,6,7,8)"
    },
    "capacity": 25,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연관509"
      }
    ],
    "sourceSchedule": "자연관509(월5,6,7,8)"
  },
  {
    "id": "10578-005-2000593",
    "subjectKey": "10578",
    "name": "전자회로설계및실험2",
    "division": "005",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "서종완",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연대316",
    "isOnline": false,
    "source": {
      "schedule": "자연대316(화5,6,7,8)"
    },
    "capacity": 38,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연대316"
      }
    ],
    "sourceSchedule": "자연대316(화5,6,7,8)"
  },
  {
    "id": "10578-006-2000593",
    "subjectKey": "10578",
    "name": "전자회로설계및실험2",
    "division": "006",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "서종완",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연대316",
    "isOnline": false,
    "source": {
      "schedule": "자연대316(수5,6,7,8)"
    },
    "capacity": 38,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연대316"
      }
    ],
    "sourceSchedule": "자연대316(수5,6,7,8)"
  },
  {
    "id": "10578-007-2000593",
    "subjectKey": "10578",
    "name": "전자회로설계및실험2",
    "division": "007",
    "department": "전기전자공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이상국",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "자연관509",
    "isOnline": false,
    "source": {
      "schedule": "자연관509(화6,7,8,9)"
    },
    "capacity": 25,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "자연관509"
      }
    ],
    "sourceSchedule": "자연관509(화6,7,8,9)"
  },
  {
    "id": "10581-002-2000640",
    "subjectKey": "10581",
    "name": "전기회로설계및실험2",
    "division": "002",
    "department": "전기공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박행원",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연관509",
    "isOnline": false,
    "source": {
      "schedule": "자연관509(목5,6,7,8)"
    },
    "capacity": 25,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연관509"
      }
    ],
    "sourceSchedule": "자연관509(목5,6,7,8)"
  },
  {
    "id": "10581-003-2000641",
    "subjectKey": "10581",
    "name": "전기회로설계및실험2",
    "division": "003",
    "department": "전자공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이창수",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "자연대316",
    "isOnline": false,
    "source": {
      "schedule": "자연대316(수1,2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "자연대316"
      }
    ],
    "sourceSchedule": "자연대316(수1,2,3,4)"
  },
  {
    "id": "10581-004-2000640",
    "subjectKey": "10581",
    "name": "전기회로설계및실험2",
    "division": "004",
    "department": "전기공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박행원",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "자연관509",
    "isOnline": false,
    "source": {
      "schedule": "자연관509(금1,2,3,4)"
    },
    "capacity": 25,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "자연관509"
      }
    ],
    "sourceSchedule": "자연관509(금1,2,3,4)"
  },
  {
    "id": "10581-005-2000641",
    "subjectKey": "10581",
    "name": "전기회로설계및실험2",
    "division": "005",
    "department": "전자공학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박현호",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연대316",
    "isOnline": false,
    "source": {
      "schedule": "자연대316(월5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연대316"
      }
    ],
    "sourceSchedule": "자연대316(월5,6,7,8)"
  },
  {
    "id": "10582-001-2000641",
    "subjectKey": "10582",
    "name": "확률및랜덤과정",
    "division": "001",
    "department": "전자공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조형준",
    "days": [
      "목",
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "종합406",
    "isOnline": false,
    "source": {
      "schedule": "종합406(목4),종합409(금5,6)"
    },
    "capacity": 34,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4
        ],
        "classroom": "종합406"
      },
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "종합409"
      }
    ],
    "sourceSchedule": "종합406(목4),종합409(금5,6)"
  },
  {
    "id": "10585-001-2000181",
    "subjectKey": "10585",
    "name": "네트워크프로그래밍",
    "division": "001",
    "department": "전자공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김우성",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "자연대503",
    "isOnline": false,
    "source": {
      "schedule": "자연대503(화6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "자연대503"
      }
    ],
    "sourceSchedule": "자연대503(화6,7,8)"
  },
  {
    "id": "10586-001-2000181",
    "subjectKey": "10586",
    "name": "초고속시스템설계",
    "division": "001",
    "department": "전자공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박현호",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래106",
    "isOnline": false,
    "source": {
      "schedule": "미래106(화1,2),미래109(금1)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "미래106"
      },
      {
        "day": "금",
        "periods": [
          1
        ],
        "classroom": "미래109"
      }
    ],
    "sourceSchedule": "미래106(화1,2),미래109(금1)"
  },
  {
    "id": "10588-001-2000181",
    "subjectKey": "10588",
    "name": "디스플레이공학",
    "division": "001",
    "department": "전자공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정태혁",
    "days": [
      "수",
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래105",
    "isOnline": false,
    "source": {
      "schedule": "미래105(수1,2),미래B103(화5)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2
        ],
        "classroom": "미래105"
      },
      {
        "day": "화",
        "periods": [
          5
        ],
        "classroom": "미래B103"
      }
    ],
    "sourceSchedule": "미래105(수1,2),미래B103(화5)"
  },
  {
    "id": "10590-002-2000594",
    "subjectKey": "10590",
    "name": "전공영어2",
    "division": "002",
    "department": "화학공학·신소재공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "스리비디아",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합409",
    "isOnline": false,
    "source": {
      "schedule": "종합409(화7,8,9)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합409"
      }
    ],
    "sourceSchedule": "종합409(화7,8,9)"
  },
  {
    "id": "10590-002-2000763",
    "subjectKey": "10590",
    "name": "전공영어2",
    "division": "002",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "스리비디아",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합409",
    "isOnline": false,
    "source": {
      "schedule": "종합409(화7,8,9)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합409"
      }
    ],
    "sourceSchedule": "종합409(화7,8,9)"
  },
  {
    "id": "10590-003-2000594",
    "subjectKey": "10590",
    "name": "전공영어2",
    "division": "003",
    "department": "화학공학·신소재공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "로이드",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합405",
    "isOnline": false,
    "source": {
      "schedule": "종합405(목5,6,7)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합405"
      }
    ],
    "sourceSchedule": "종합405(목5,6,7)"
  },
  {
    "id": "10590-003-2000763",
    "subjectKey": "10590",
    "name": "전공영어2",
    "division": "003",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "로이드",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합405",
    "isOnline": false,
    "source": {
      "schedule": "종합405(목5,6,7)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합405"
      }
    ],
    "sourceSchedule": "종합405(목5,6,7)"
  },
  {
    "id": "10594-001-2000643",
    "subjectKey": "10594",
    "name": "기기분석1",
    "division": "001",
    "department": "화학공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최동웅",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "자연관409",
    "isOnline": false,
    "source": {
      "schedule": "자연관409(월2,3,4)"
    },
    "capacity": 28,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "자연관409"
      }
    ],
    "sourceSchedule": "자연관409(월2,3,4)"
  },
  {
    "id": "10597-001-2000446",
    "subjectKey": "10597",
    "name": "화학공학특강1",
    "division": "001",
    "department": "화학공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최동웅",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "자연관409",
    "isOnline": false,
    "source": {
      "schedule": "자연관409(수2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "자연관409"
      }
    ],
    "sourceSchedule": "자연관409(수2,3,4)"
  },
  {
    "id": "10598-001-2000446",
    "subjectKey": "10598",
    "name": "화공신소재특강(화공)",
    "division": "001",
    "department": "화학공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박종국",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "자연관408",
    "isOnline": false,
    "source": {
      "schedule": "자연관408(수5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "자연관408"
      }
    ],
    "sourceSchedule": "자연관408(수5,6,7)"
  },
  {
    "id": "10603-001-2000642",
    "subjectKey": "10603",
    "name": "차세대탄소재료",
    "division": "001",
    "department": "신소재공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김창민",
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합409",
    "isOnline": false,
    "source": {
      "schedule": "종합409(월5,6),미래105(목7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "종합409"
      },
      {
        "day": "목",
        "periods": [
          7
        ],
        "classroom": "미래105"
      }
    ],
    "sourceSchedule": "종합409(월5,6),미래105(목7)"
  },
  {
    "id": "10606-001-2000763",
    "subjectKey": "10606",
    "name": "소프트웨어적사고",
    "division": "001",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "김홍규",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT308",
    "isOnline": false,
    "source": {
      "schedule": "IT308(금1,2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT308"
      }
    ],
    "sourceSchedule": "IT308(금1,2,3,4)"
  },
  {
    "id": "10606-001-2000844",
    "subjectKey": "10606",
    "name": "소프트웨어적사고",
    "division": "001",
    "department": "컴퓨터공학",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "김홍규",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT308",
    "isOnline": false,
    "source": {
      "schedule": "IT308(금1,2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT308"
      }
    ],
    "sourceSchedule": "IT308(금1,2,3,4)"
  },
  {
    "id": "10606-002-2000763",
    "subjectKey": "10606",
    "name": "소프트웨어적사고",
    "division": "002",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "김홍규",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "IT308",
    "isOnline": false,
    "source": {
      "schedule": "IT308(금6,7,8,9)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "IT308"
      }
    ],
    "sourceSchedule": "IT308(금6,7,8,9)"
  },
  {
    "id": "10606-002-2000844",
    "subjectKey": "10606",
    "name": "소프트웨어적사고",
    "division": "002",
    "department": "컴퓨터공학",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "김홍규",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "IT308",
    "isOnline": false,
    "source": {
      "schedule": "IT308(금6,7,8,9)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "IT308"
      }
    ],
    "sourceSchedule": "IT308(금6,7,8,9)"
  },
  {
    "id": "10606-003-2000763",
    "subjectKey": "10606",
    "name": "소프트웨어적사고",
    "division": "003",
    "department": "자유전공학부",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "홍석우",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "IT214",
    "isOnline": false,
    "source": {
      "schedule": "IT214(화2,3 수2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "IT214"
      },
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "IT214"
      }
    ],
    "sourceSchedule": "IT214(화2,3 수2,3)"
  },
  {
    "id": "10606-003-2000844",
    "subjectKey": "10606",
    "name": "소프트웨어적사고",
    "division": "003",
    "department": "컴퓨터공학",
    "category": "교양필수",
    "sourceCategory": "전교",
    "credit": 3,
    "professor": "홍석우",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "IT214",
    "isOnline": false,
    "source": {
      "schedule": "IT214(화2,3 수2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "IT214"
      },
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "IT214"
      }
    ],
    "sourceSchedule": "IT214(화2,3 수2,3)"
  },
  {
    "id": "10607-001-2000595",
    "subjectKey": "10607",
    "name": "선형대수학과응용",
    "division": "001",
    "department": "데이터과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "한경훈",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "글경315",
    "isOnline": false,
    "source": {
      "schedule": "글경315(수4 목4,5)"
    },
    "capacity": 45,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "글경315"
      },
      {
        "day": "목",
        "periods": [
          4,
          5
        ],
        "classroom": "글경315"
      }
    ],
    "sourceSchedule": "글경315(수4 목4,5)"
  },
  {
    "id": "10607-002-2000595",
    "subjectKey": "10607",
    "name": "선형대수학과응용",
    "division": "002",
    "department": "데이터과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "한경훈",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "글경315",
    "isOnline": false,
    "source": {
      "schedule": "글경315(화2 수5,6)"
    },
    "capacity": 45,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2
        ],
        "classroom": "글경315"
      },
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "글경315"
      }
    ],
    "sourceSchedule": "글경315(화2 수5,6)"
  },
  {
    "id": "10614-001-2000644",
    "subjectKey": "10614",
    "name": "창업실무",
    "division": "001",
    "department": "컴퓨터SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정양구",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "IT415",
    "isOnline": false,
    "source": {
      "schedule": "IT415(금1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "IT415"
      }
    ],
    "sourceSchedule": "IT415(금1,2,3)"
  },
  {
    "id": "10615-001-2000644",
    "subjectKey": "10615",
    "name": "IOT 설계실습",
    "division": "001",
    "department": "컴퓨터SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "허성민",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT406",
    "isOnline": false,
    "source": {
      "schedule": "IT406(목1,2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT406"
      }
    ],
    "sourceSchedule": "IT406(목1,2,3,4)"
  },
  {
    "id": "10615-002-2000644",
    "subjectKey": "10615",
    "name": "IOT 설계실습",
    "division": "002",
    "department": "컴퓨터SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "허성민",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "IT406",
    "isOnline": false,
    "source": {
      "schedule": "IT406(목6,7,8,9)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "IT406"
      }
    ],
    "sourceSchedule": "IT406(목6,7,8,9)"
  },
  {
    "id": "10624-001-2000515",
    "subjectKey": "10624",
    "name": "소프트웨어특강2",
    "division": "001",
    "department": "미디어SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "홍석우",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "IT214",
    "isOnline": false,
    "source": {
      "schedule": "IT214(화5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "IT214"
      }
    ],
    "sourceSchedule": "IT214(화5,6,7)"
  },
  {
    "id": "10629-001-2000646",
    "subjectKey": "10629",
    "name": "디지털논리설계실험",
    "division": "001",
    "department": "정보통신",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김시현",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "IT216",
    "isOnline": false,
    "source": {
      "schedule": "IT216(목5,6,7,8)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "IT216"
      }
    ],
    "sourceSchedule": "IT216(목5,6,7,8)"
  },
  {
    "id": "10632-001-2000646",
    "subjectKey": "10632",
    "name": "네트워크설계및실습",
    "division": "001",
    "department": "정보통신",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이중무",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT307",
    "isOnline": false,
    "source": {
      "schedule": "IT307(화1,2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT307"
      }
    ],
    "sourceSchedule": "IT307(화1,2,3,4)"
  },
  {
    "id": "10636-001-2000516",
    "subjectKey": "10636",
    "name": "지식재산의보호와관리",
    "division": "001",
    "department": "정보통신",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양윤기",
    "days": [
      "수",
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 6,
    "room": "IT408",
    "isOnline": false,
    "source": {
      "schedule": "IT408(수6 금5,6)"
    },
    "capacity": 45,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6
        ],
        "classroom": "IT408"
      },
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "IT408"
      }
    ],
    "sourceSchedule": "IT408(수6 금5,6)"
  },
  {
    "id": "10643-001-2000647",
    "subjectKey": "10643",
    "name": "정보보안관리2",
    "division": "001",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김아람",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT309",
    "isOnline": false,
    "source": {
      "schedule": "IT309(수6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT309"
      }
    ],
    "sourceSchedule": "IT309(수6,7,8)"
  },
  {
    "id": "10644-001-2000647",
    "subjectKey": "10644",
    "name": "정보보안산학협력특론1",
    "division": "001",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고승철",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT407",
    "isOnline": false,
    "source": {
      "schedule": "IT407(금6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT407"
      }
    ],
    "sourceSchedule": "IT407(금6,7,8)"
  },
  {
    "id": "10645-001-2000647",
    "subjectKey": "10645",
    "name": "시스템보안프로젝트",
    "division": "001",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양수미",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT306",
    "isOnline": false,
    "source": {
      "schedule": "IT306(수1,2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT306"
      }
    ],
    "sourceSchedule": "IT306(수1,2,3,4)"
  },
  {
    "id": "10645-002-2000647",
    "subjectKey": "10645",
    "name": "시스템보안프로젝트",
    "division": "002",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김아람",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT215",
    "isOnline": false,
    "source": {
      "schedule": "IT215(수1,2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT215"
      }
    ],
    "sourceSchedule": "IT215(수1,2,3,4)"
  },
  {
    "id": "10647-001-2000517",
    "subjectKey": "10647",
    "name": "모바일운영체제",
    "division": "001",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양수미",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT215",
    "isOnline": false,
    "source": {
      "schedule": "IT215(수6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT215"
      }
    ],
    "sourceSchedule": "IT215(수6,7,8)"
  },
  {
    "id": "10652-001-2000430",
    "subjectKey": "10652",
    "name": "간호와정보",
    "division": "001",
    "department": "간호학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "박선아",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래418",
    "isOnline": false,
    "source": {
      "schedule": "미래418(화5,6)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미래418"
      }
    ],
    "sourceSchedule": "미래418(화5,6)"
  },
  {
    "id": "10659-001-2000602",
    "subjectKey": "10659",
    "name": "응급처치(체육전공)",
    "division": "001",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "윤동식",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "체육114",
    "isOnline": false,
    "source": {
      "schedule": "체육114(화3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "체육114"
      }
    ],
    "sourceSchedule": "체육114(화3,4)"
  },
  {
    "id": "10659-002-2000602",
    "subjectKey": "10659",
    "name": "응급처치(레저스포츠전공)",
    "division": "002",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "윤동식",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "체육114",
    "isOnline": false,
    "source": {
      "schedule": "체육114(화1,2)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "체육114"
      }
    ],
    "sourceSchedule": "체육114(화1,2)"
  },
  {
    "id": "10659-003-2000602",
    "subjectKey": "10659",
    "name": "응급처치(운동건강관리전공)",
    "division": "003",
    "department": "스포츠과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "조수연",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "체육118",
    "isOnline": false,
    "source": {
      "schedule": "체육118(월1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "체육118"
      }
    ],
    "sourceSchedule": "체육118(월1,2)"
  },
  {
    "id": "10664-001-2000648",
    "subjectKey": "10664",
    "name": "검도2",
    "division": "001",
    "department": "체육학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "윤동식",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육201",
    "isOnline": false,
    "source": {
      "schedule": "체육201(화5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "체육201"
      }
    ],
    "sourceSchedule": "체육201(화5,6)"
  },
  {
    "id": "10665-001-2000648",
    "subjectKey": "10665",
    "name": "웨이트트레이닝2",
    "division": "001",
    "department": "체육학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "박득수",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "체육113",
    "isOnline": false,
    "source": {
      "schedule": "체육113(화7,8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "체육113"
      }
    ],
    "sourceSchedule": "체육113(화7,8)"
  },
  {
    "id": "10667-001-2000648",
    "subjectKey": "10667",
    "name": "스포츠교육학",
    "division": "001",
    "department": "체육학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이한울",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래B202",
    "isOnline": false,
    "source": {
      "schedule": "미래B202(목6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래B202"
      }
    ],
    "sourceSchedule": "미래B202(목6,7,8)"
  },
  {
    "id": "10669-001-2000648",
    "subjectKey": "10669",
    "name": "장애인체육실습",
    "division": "001",
    "department": "체육학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "김소정",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "체육105",
    "isOnline": false,
    "source": {
      "schedule": "체육105(화3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "체육105"
      }
    ],
    "sourceSchedule": "체육105(화3,4)"
  },
  {
    "id": "10674-001-2000435",
    "subjectKey": "10674",
    "name": "체육실무영어",
    "division": "001",
    "department": "체육학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "주정선",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육116",
    "isOnline": false,
    "source": {
      "schedule": "체육116(금5,6)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "체육116"
      }
    ],
    "sourceSchedule": "체육116(금5,6)"
  },
  {
    "id": "10675-001-2000435",
    "subjectKey": "10675",
    "name": "체육졸업실기",
    "division": "001",
    "department": "체육학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "서혜진",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B203",
    "isOnline": false,
    "source": {
      "schedule": "미래B203(화3,4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B203"
      }
    ],
    "sourceSchedule": "미래B203(화3,4)"
  },
  {
    "id": "10681-001-2000649",
    "subjectKey": "10681",
    "name": "필라테스",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "서혜진",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육103",
    "isOnline": false,
    "source": {
      "schedule": "체육103(화5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "체육103"
      }
    ],
    "sourceSchedule": "체육103(화5,6)"
  },
  {
    "id": "10682-001-2000649",
    "subjectKey": "10682",
    "name": "실외레크리에이션",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "김율희",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "복지B106-1",
    "isOnline": false,
    "source": {
      "schedule": "복지B106-1(목7,8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8
        ],
        "classroom": "복지B106-1"
      }
    ],
    "sourceSchedule": "복지B106-1(목7,8)"
  },
  {
    "id": "10683-001-2000649",
    "subjectKey": "10683",
    "name": "해양레저산업론",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "윤석균",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래B202",
    "isOnline": false,
    "source": {
      "schedule": "미래B202(금6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래B202"
      }
    ],
    "sourceSchedule": "미래B202(금6,7,8)"
  },
  {
    "id": "10684-001-2000649",
    "subjectKey": "10684",
    "name": "레저스포츠투어리즘(마이크로디그리)",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박지선",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래B202",
    "isOnline": false,
    "source": {
      "schedule": "미래B202(화7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래B202"
      }
    ],
    "sourceSchedule": "미래B202(화7,8,9)"
  },
  {
    "id": "10691-001-2000649",
    "subjectKey": "10691",
    "name": "생활댄스",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "김율희",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "복지B106-1",
    "isOnline": false,
    "source": {
      "schedule": "복지B106-1(목5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "복지B106-1"
      }
    ],
    "sourceSchedule": "복지B106-1(목5,6)"
  },
  {
    "id": "10693-001-2000649",
    "subjectKey": "10693",
    "name": "레저스포츠지도법",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이한울",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B202",
    "isOnline": false,
    "source": {
      "schedule": "미래B202(목1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B202"
      }
    ],
    "sourceSchedule": "미래B202(목1,2,3)"
  },
  {
    "id": "10694-001-2000649",
    "subjectKey": "10694",
    "name": "레저스포츠산업론",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "윤석균",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B202",
    "isOnline": false,
    "source": {
      "schedule": "미래B202(금1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B202"
      }
    ],
    "sourceSchedule": "미래B202(금1,2,3)"
  },
  {
    "id": "10695-001-2000649",
    "subjectKey": "10695",
    "name": "레저사회심리학",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이승주",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "체육117",
    "isOnline": false,
    "source": {
      "schedule": "체육117(화1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "체육117"
      }
    ],
    "sourceSchedule": "체육117(화1,2,3)"
  },
  {
    "id": "10696-001-2000649",
    "subjectKey": "10696",
    "name": "스킨스쿠버",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "표형근",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육112",
    "isOnline": false,
    "source": {
      "schedule": "체육112(수5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "체육112"
      }
    ],
    "sourceSchedule": "체육112(수5,6)"
  },
  {
    "id": "10697-001-2000649",
    "subjectKey": "10697",
    "name": "국제비교레져론",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "현재민",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "체육113",
    "isOnline": false,
    "source": {
      "schedule": "체육113(월1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "체육113"
      }
    ],
    "sourceSchedule": "체육113(월1,2,3)"
  },
  {
    "id": "10703-001-2000436",
    "subjectKey": "10703",
    "name": "레저스포츠연구법",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양홍위",
    "days": [
      "수",
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "체육114",
    "isOnline": false,
    "source": {
      "schedule": "체육114(수3),체육116(화5,6)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3
        ],
        "classroom": "체육114"
      },
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "체육116"
      }
    ],
    "sourceSchedule": "체육114(수3),체육116(화5,6)"
  },
  {
    "id": "10704-001-2000436",
    "subjectKey": "10704",
    "name": "레저스포츠실무영어",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "주정선",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육114",
    "isOnline": false,
    "source": {
      "schedule": "체육114(목5,6)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "체육114"
      }
    ],
    "sourceSchedule": "체육114(목5,6)"
  },
  {
    "id": "10705-001-2000436",
    "subjectKey": "10705",
    "name": "레저스포츠졸업실기",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "김태영",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육114",
    "isOnline": false,
    "source": {
      "schedule": "체육114(수5,6)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "체육114"
      }
    ],
    "sourceSchedule": "체육114(수5,6)"
  },
  {
    "id": "10712-001-2000650",
    "subjectKey": "10712",
    "name": "운동건강관리산업",
    "division": "001",
    "department": "운동건강관리",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "박지선",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B202",
    "isOnline": false,
    "source": {
      "schedule": "미래B202(화1,2)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B202"
      }
    ],
    "sourceSchedule": "미래B202(화1,2)"
  },
  {
    "id": "10713-001-2000650",
    "subjectKey": "10713",
    "name": "운동처방실습",
    "division": "001",
    "department": "운동건강관리",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "백형진",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "체육114",
    "isOnline": false,
    "source": {
      "schedule": "체육114(금6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7
        ],
        "classroom": "체육114"
      }
    ],
    "sourceSchedule": "체육114(금6,7)"
  },
  {
    "id": "10714-001-2000650",
    "subjectKey": "10714",
    "name": "체형교정",
    "division": "001",
    "department": "운동건강관리",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김소정",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "체육116",
    "isOnline": false,
    "source": {
      "schedule": "체육116(화7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "체육116"
      }
    ],
    "sourceSchedule": "체육116(화7,8)"
  },
  {
    "id": "10720-001-2000437",
    "subjectKey": "10720",
    "name": "운동건강관리연구법",
    "division": "001",
    "department": "운동건강관리",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김태형",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "체육118",
    "isOnline": false,
    "source": {
      "schedule": "체육118(목5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "체육118"
      }
    ],
    "sourceSchedule": "체육118(목5,6,7)"
  },
  {
    "id": "10721-001-2000437",
    "subjectKey": "10721",
    "name": "운동건강관리실무영어",
    "division": "001",
    "department": "운동건강관리",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "주정선",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "체육116",
    "isOnline": false,
    "source": {
      "schedule": "체육116(화3,4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "체육116"
      }
    ],
    "sourceSchedule": "체육116(화3,4)"
  },
  {
    "id": "10726-001-2000652",
    "subjectKey": "10726",
    "name": "인체모델링연구2",
    "division": "001",
    "department": "조소",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "지경수",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "조형204",
    "isOnline": false,
    "source": {
      "schedule": "조형204(월1,2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "조형204"
      }
    ],
    "sourceSchedule": "조형204(월1,2,3,4)"
  },
  {
    "id": "10728-001-2000257",
    "subjectKey": "10728",
    "name": "Portfolio 제작",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이수진",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT514",
    "isOnline": false,
    "source": {
      "schedule": "IT514(월1,2,3,4)"
    },
    "capacity": 34,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT514"
      }
    ],
    "sourceSchedule": "IT514(월1,2,3,4)"
  },
  {
    "id": "10728-002-2000257",
    "subjectKey": "10728",
    "name": "Portfolio 제작",
    "division": "002",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이수진",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "IT514",
    "isOnline": false,
    "source": {
      "schedule": "IT514(월5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "IT514"
      }
    ],
    "sourceSchedule": "IT514(월5,6,7,8)"
  },
  {
    "id": "10728-003-2000257",
    "subjectKey": "10728",
    "name": "Portfolio 제작",
    "division": "003",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이수진",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술203",
    "isOnline": false,
    "source": {
      "schedule": "미술203(화1,2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술203"
      }
    ],
    "sourceSchedule": "미술203(화1,2,3,4)"
  },
  {
    "id": "10736-001-2000654",
    "subjectKey": "10736",
    "name": "패턴캐드2",
    "division": "001",
    "department": "패션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "강민정",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술201",
    "isOnline": false,
    "source": {
      "schedule": "미술201(목1,2,3,4)"
    },
    "capacity": 15,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술201"
      }
    ],
    "sourceSchedule": "미술201(목1,2,3,4)"
  },
  {
    "id": "10737-001-2000654",
    "subjectKey": "10737",
    "name": "니트디자인2",
    "division": "001",
    "department": "패션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김미경",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "종합403",
    "isOnline": false,
    "source": {
      "schedule": "종합403(화6,7,8,9)"
    },
    "capacity": 19,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "종합403"
      }
    ],
    "sourceSchedule": "종합403(화6,7,8,9)"
  },
  {
    "id": "10738-001-2000655",
    "subjectKey": "10738",
    "name": "공예교육론",
    "division": "001",
    "department": "공예디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "장혜진",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "종합403",
    "isOnline": false,
    "source": {
      "schedule": "종합403(월6,7,8)"
    },
    "capacity": 25,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "종합403"
      }
    ],
    "sourceSchedule": "종합403(월6,7,8)"
  },
  {
    "id": "10749-001-2000605",
    "subjectKey": "10749",
    "name": "영상음악과사운드디자인2",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "이율구",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "음악106",
    "isOnline": false,
    "source": {
      "schedule": "음악106(수7,8)"
    },
    "capacity": 15,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8
        ],
        "classroom": "음악106"
      }
    ],
    "sourceSchedule": "음악106(수7,8)"
  },
  {
    "id": "10753-001-2000606",
    "subjectKey": "10753",
    "name": "오페라공연및제작기획2",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김지영",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악110",
    "isOnline": false,
    "source": {
      "schedule": "음악110(화5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "음악110"
      }
    ],
    "sourceSchedule": "음악110(화5,6)"
  },
  {
    "id": "10755-001-2000265",
    "subjectKey": "10755",
    "name": "오페라공연및제작기획4",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김지영",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악110",
    "isOnline": false,
    "source": {
      "schedule": "음악110(화5,6)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "음악110"
      }
    ],
    "sourceSchedule": "음악110(화5,6)"
  },
  {
    "id": "10759-001-2000265",
    "subjectKey": "10759",
    "name": "뮤지컬공연및제작기획2",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김성은",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "복지B106",
    "isOnline": false,
    "source": {
      "schedule": "복지B106(목5,6)"
    },
    "capacity": 10,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "복지B106"
      }
    ],
    "sourceSchedule": "복지B106(목5,6)"
  },
  {
    "id": "10774-001-2000267",
    "subjectKey": "10774",
    "name": "국악지도법2",
    "division": "001",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "정영선",
    "days": [
      "수"
    ],
    "startPeriod": 8,
    "endPeriod": 9,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(수8,9)"
    },
    "capacity": 11,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          8,
          9
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(수8,9)"
  },
  {
    "id": "10775-001-2000267",
    "subjectKey": "10775",
    "name": "국악실기법2",
    "division": "001",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "박선영",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(화5,6)"
    },
    "capacity": 11,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(화5,6)"
  },
  {
    "id": "10784-001-2000613",
    "subjectKey": "10784",
    "name": "시나리오분석",
    "division": "001",
    "department": "영화예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "임찬상",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "복지405",
    "isOnline": false,
    "source": {
      "schedule": "복지405(목1,2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "복지405"
      }
    ],
    "sourceSchedule": "복지405(목1,2,3,4)"
  },
  {
    "id": "10786-001-2000613",
    "subjectKey": "10786",
    "name": "연극영화교육프로그램개발",
    "division": "001",
    "department": "영화예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "홍세은",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "글경502",
    "isOnline": false,
    "source": {
      "schedule": "글경502(금1,2)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "글경502"
      }
    ],
    "sourceSchedule": "글경502(금1,2)"
  },
  {
    "id": "10786-002-2000441",
    "subjectKey": "10786",
    "name": "연극영화교육프로그램개발",
    "division": "002",
    "department": "연극",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "홍세은",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "글경502",
    "isOnline": false,
    "source": {
      "schedule": "글경502(금1,2)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "글경502"
      }
    ],
    "sourceSchedule": "글경502(금1,2)"
  },
  {
    "id": "10786-003-2000440",
    "subjectKey": "10786",
    "name": "연극영화교육프로그램개발",
    "division": "003",
    "department": "영화영상",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "홍세은",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "글경502",
    "isOnline": false,
    "source": {
      "schedule": "글경502(금1,2)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "글경502"
      }
    ],
    "sourceSchedule": "글경502(금1,2)"
  },
  {
    "id": "10790-001-2000614",
    "subjectKey": "10790",
    "name": "연극영화교수학습방법",
    "division": "001",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "권석류",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "글경311",
    "isOnline": false,
    "source": {
      "schedule": "글경311(금5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "글경311"
      }
    ],
    "sourceSchedule": "글경311(금5,6)"
  },
  {
    "id": "10791-001-2000441",
    "subjectKey": "10791",
    "name": "예술경영론",
    "division": "001",
    "department": "연극",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "손민경",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "복지202",
    "isOnline": false,
    "source": {
      "schedule": "복지202(수2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "복지202"
      }
    ],
    "sourceSchedule": "복지202(수2,3,4)"
  },
  {
    "id": "10816-001-2000615",
    "subjectKey": "10816",
    "name": "예술사와문화콘텐츠",
    "division": "001",
    "department": "디지털콘텐츠",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박미경",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "미래116",
    "isOnline": false,
    "source": {
      "schedule": "미래116(월2,3 화5)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "미래116"
      },
      {
        "day": "화",
        "periods": [
          5
        ],
        "classroom": "미래116"
      }
    ],
    "sourceSchedule": "미래116(월2,3 화5)"
  },
  {
    "id": "10819-001-2000615",
    "subjectKey": "10819",
    "name": "과학기술과문화콘텐츠",
    "division": "001",
    "department": "디지털콘텐츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박계연",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "미래115",
    "isOnline": false,
    "source": {
      "schedule": "미래115(월5,6,7)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "미래115"
      }
    ],
    "sourceSchedule": "미래115(월5,6,7)"
  },
  {
    "id": "10821-001-2000518",
    "subjectKey": "10821",
    "name": "졸업프로젝트2",
    "division": "001",
    "department": "문화콘텐츠테크놀러지",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박정선",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "미래119",
    "isOnline": false,
    "source": {
      "schedule": "미래119(목2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "미래119"
      }
    ],
    "sourceSchedule": "미래119(목2,3,4)"
  },
  {
    "id": "10825-001-2000518",
    "subjectKey": "10825",
    "name": "미래사회와디지털휴머니티",
    "division": "001",
    "department": "문화콘텐츠테크놀러지",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박계연",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래119",
    "isOnline": false,
    "source": {
      "schedule": "미래119(수6,7,8)"
    },
    "capacity": 25,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래119"
      }
    ],
    "sourceSchedule": "미래119(수6,7,8)"
  },
  {
    "id": "10831-001-2000615",
    "subjectKey": "10831",
    "name": "3D그래픽스2",
    "division": "001",
    "department": "디지털콘텐츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이서준",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "미래115",
    "isOnline": false,
    "source": {
      "schedule": "미래115(목2,3,4)"
    },
    "capacity": 25,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "미래115"
      }
    ],
    "sourceSchedule": "미래115(목2,3,4)"
  },
  {
    "id": "10843-001-2000615",
    "subjectKey": "10843",
    "name": "전시와공간스토리텔링",
    "division": "001",
    "department": "디지털콘텐츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박정선",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래116",
    "isOnline": false,
    "source": {
      "schedule": "미래116(목6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래116"
      }
    ],
    "sourceSchedule": "미래116(목6,7,8)"
  },
  {
    "id": "10844-001-2000615",
    "subjectKey": "10844",
    "name": "문화유산과글로벌콘텐츠",
    "division": "001",
    "department": "디지털콘텐츠",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박미경",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "미래116",
    "isOnline": false,
    "source": {
      "schedule": "미래116(수2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "미래116"
      }
    ],
    "sourceSchedule": "미래116(수2,3,4)"
  },
  {
    "id": "10846-001-2000615",
    "subjectKey": "10846",
    "name": "콘텐츠비지니스와마케팅",
    "division": "001",
    "department": "디지털콘텐츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김상임",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래116",
    "isOnline": false,
    "source": {
      "schedule": "미래116(수6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래116"
      }
    ],
    "sourceSchedule": "미래116(수6,7,8)"
  },
  {
    "id": "10854-001-2000658",
    "subjectKey": "10854",
    "name": "학문과사고",
    "division": "001",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 2,
    "professor": "김중신",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합506",
    "isOnline": false,
    "source": {
      "schedule": "종합506(금2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3
        ],
        "classroom": "종합506"
      }
    ],
    "sourceSchedule": "종합506(금2,3)"
  },
  {
    "id": "10854-002-2000658",
    "subjectKey": "10854",
    "name": "학문과사고",
    "division": "002",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 2,
    "professor": "권지혜",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합507",
    "isOnline": false,
    "source": {
      "schedule": "종합507(금2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3
        ],
        "classroom": "종합507"
      }
    ],
    "sourceSchedule": "종합507(금2,3)"
  },
  {
    "id": "10854-003-2000658",
    "subjectKey": "10854",
    "name": "학문과사고",
    "division": "003",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 2,
    "professor": "장철",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합307",
    "isOnline": false,
    "source": {
      "schedule": "종합307(금2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3
        ],
        "classroom": "종합307"
      }
    ],
    "sourceSchedule": "종합307(금2,3)"
  },
  {
    "id": "10854-004-2000658",
    "subjectKey": "10854",
    "name": "학문과사고",
    "division": "004",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 2,
    "professor": "이아름",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합308",
    "isOnline": false,
    "source": {
      "schedule": "종합308(금2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3
        ],
        "classroom": "종합308"
      }
    ],
    "sourceSchedule": "종합308(금2,3)"
  },
  {
    "id": "10854-005-2000658",
    "subjectKey": "10854",
    "name": "학문과사고",
    "division": "005",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 2,
    "professor": "김중신",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합506",
    "isOnline": false,
    "source": {
      "schedule": "종합506(금5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "종합506"
      }
    ],
    "sourceSchedule": "종합506(금5,6)"
  },
  {
    "id": "10854-006-2000658",
    "subjectKey": "10854",
    "name": "학문과사고",
    "division": "006",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 2,
    "professor": "박상섭",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합507",
    "isOnline": false,
    "source": {
      "schedule": "종합507(금5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "종합507"
      }
    ],
    "sourceSchedule": "종합507(금5,6)"
  },
  {
    "id": "10854-007-2000658",
    "subjectKey": "10854",
    "name": "학문과사고",
    "division": "007",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 2,
    "professor": "장철",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합307",
    "isOnline": false,
    "source": {
      "schedule": "종합307(금5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "종합307"
      }
    ],
    "sourceSchedule": "종합307(금5,6)"
  },
  {
    "id": "10854-008-2000658",
    "subjectKey": "10854",
    "name": "학문과사고",
    "division": "008",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 2,
    "professor": "이아름",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합308",
    "isOnline": false,
    "source": {
      "schedule": "종합308(금5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "종합308"
      }
    ],
    "sourceSchedule": "종합308(금5,6)"
  },
  {
    "id": "10854-009-2000658",
    "subjectKey": "10854",
    "name": "학문과사고",
    "division": "009",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 2,
    "professor": "이철규",
    "days": [
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "종합506",
    "isOnline": false,
    "source": {
      "schedule": "종합506(금7,8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "종합506"
      }
    ],
    "sourceSchedule": "종합506(금7,8)"
  },
  {
    "id": "10854-010-2000658",
    "subjectKey": "10854",
    "name": "학문과사고",
    "division": "010",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 2,
    "professor": "권지혜",
    "days": [
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "종합507",
    "isOnline": false,
    "source": {
      "schedule": "종합507(금7,8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "종합507"
      }
    ],
    "sourceSchedule": "종합507(금7,8)"
  },
  {
    "id": "10858-001-2000602",
    "subjectKey": "10858",
    "name": "교양적글쓰기와고전읽기2",
    "division": "001",
    "department": "스포츠과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "신정숙",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(월4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(월4,5)"
  },
  {
    "id": "10858-002-2000602",
    "subjectKey": "10858",
    "name": "교양적글쓰기와고전읽기2",
    "division": "002",
    "department": "스포츠과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "허윤진",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(화3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(화3,4)"
  },
  {
    "id": "10858-003-2000602",
    "subjectKey": "10858",
    "name": "교양적글쓰기와고전읽기2",
    "division": "003",
    "department": "스포츠과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이민경",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(수6,7)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(수6,7)"
  },
  {
    "id": "10860-001-2000588",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "001",
    "department": "바이오화학산업학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "신정숙",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(월6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(월6,7)"
  },
  {
    "id": "10860-001-2000589",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "001",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "신정숙",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(월6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(월6,7)"
  },
  {
    "id": "10860-001-2000590",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "001",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "신정숙",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(월6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(월6,7)"
  },
  {
    "id": "10860-001-2000591",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "001",
    "department": "산업 및 기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "신정숙",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(월6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(월6,7)"
  },
  {
    "id": "10860-001-2000592",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "001",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "신정숙",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(월6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(월6,7)"
  },
  {
    "id": "10860-001-2000593",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "001",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "신정숙",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(월6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(월6,7)"
  },
  {
    "id": "10860-001-2000594",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "001",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "신정숙",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(월6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(월6,7)"
  },
  {
    "id": "10860-002-2000588",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "002",
    "department": "바이오화학산업학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "권혁수",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(월5,6)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(월5,6)"
  },
  {
    "id": "10860-002-2000589",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "002",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "권혁수",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(월5,6)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(월5,6)"
  },
  {
    "id": "10860-002-2000590",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "002",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "권혁수",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(월5,6)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(월5,6)"
  },
  {
    "id": "10860-002-2000591",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "002",
    "department": "산업 및 기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "권혁수",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(월5,6)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(월5,6)"
  },
  {
    "id": "10860-002-2000592",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "002",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "권혁수",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(월5,6)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(월5,6)"
  },
  {
    "id": "10860-002-2000593",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "002",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "권혁수",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(월5,6)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(월5,6)"
  },
  {
    "id": "10860-002-2000594",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "002",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "권혁수",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(월5,6)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(월5,6)"
  },
  {
    "id": "10860-003-2000588",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "003",
    "department": "바이오화학산업학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "배윤호",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(금3,4)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(금3,4)"
  },
  {
    "id": "10860-003-2000589",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "003",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "배윤호",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(금3,4)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(금3,4)"
  },
  {
    "id": "10860-003-2000590",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "003",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "배윤호",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(금3,4)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(금3,4)"
  },
  {
    "id": "10860-003-2000591",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "003",
    "department": "산업 및 기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "배윤호",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(금3,4)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(금3,4)"
  },
  {
    "id": "10860-003-2000592",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "003",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "배윤호",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(금3,4)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(금3,4)"
  },
  {
    "id": "10860-003-2000593",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "003",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "배윤호",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(금3,4)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(금3,4)"
  },
  {
    "id": "10860-003-2000594",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "003",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "배윤호",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(금3,4)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(금3,4)"
  },
  {
    "id": "10860-004-2000588",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "004",
    "department": "바이오화학산업학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "임선영",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(금6,7)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(금6,7)"
  },
  {
    "id": "10860-004-2000589",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "004",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "임선영",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(금6,7)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(금6,7)"
  },
  {
    "id": "10860-004-2000590",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "004",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "임선영",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(금6,7)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(금6,7)"
  },
  {
    "id": "10860-004-2000591",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "004",
    "department": "산업 및 기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "임선영",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(금6,7)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(금6,7)"
  },
  {
    "id": "10860-004-2000592",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "004",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "임선영",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(금6,7)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(금6,7)"
  },
  {
    "id": "10860-004-2000593",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "004",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "임선영",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(금6,7)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(금6,7)"
  },
  {
    "id": "10860-004-2000594",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "004",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "임선영",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(금6,7)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(금6,7)"
  },
  {
    "id": "10860-005-2000588",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "005",
    "department": "바이오화학산업학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월1,2)"
  },
  {
    "id": "10860-005-2000589",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "005",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월1,2)"
  },
  {
    "id": "10860-005-2000590",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "005",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월1,2)"
  },
  {
    "id": "10860-005-2000591",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "005",
    "department": "산업 및 기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월1,2)"
  },
  {
    "id": "10860-005-2000592",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "005",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월1,2)"
  },
  {
    "id": "10860-005-2000593",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "005",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월1,2)"
  },
  {
    "id": "10860-005-2000594",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "005",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월1,2)"
  },
  {
    "id": "10860-006-2000588",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "006",
    "department": "바이오화학산업학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "정혜린",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(화4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(화4,5)"
  },
  {
    "id": "10860-006-2000589",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "006",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "정혜린",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(화4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(화4,5)"
  },
  {
    "id": "10860-006-2000590",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "006",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "정혜린",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(화4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(화4,5)"
  },
  {
    "id": "10860-006-2000591",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "006",
    "department": "산업 및 기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "정혜린",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(화4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(화4,5)"
  },
  {
    "id": "10860-006-2000592",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "006",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "정혜린",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(화4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(화4,5)"
  },
  {
    "id": "10860-006-2000593",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "006",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "정혜린",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(화4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(화4,5)"
  },
  {
    "id": "10860-006-2000594",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "006",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "정혜린",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(화4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(화4,5)"
  },
  {
    "id": "10860-007-2000588",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "007",
    "department": "바이오화학산업학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "최수현",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(목3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(목3,4)"
  },
  {
    "id": "10860-007-2000589",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "007",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "최수현",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(목3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(목3,4)"
  },
  {
    "id": "10860-007-2000590",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "007",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "최수현",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(목3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(목3,4)"
  },
  {
    "id": "10860-007-2000591",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "007",
    "department": "산업 및 기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "최수현",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(목3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(목3,4)"
  },
  {
    "id": "10860-007-2000592",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "007",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "최수현",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(목3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(목3,4)"
  },
  {
    "id": "10860-007-2000593",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "007",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "최수현",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(목3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(목3,4)"
  },
  {
    "id": "10860-007-2000594",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "007",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "최수현",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(목3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(목3,4)"
  },
  {
    "id": "10860-008-2000588",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "008",
    "department": "바이오화학산업학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월3,4)"
  },
  {
    "id": "10860-008-2000589",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "008",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월3,4)"
  },
  {
    "id": "10860-008-2000590",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "008",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월3,4)"
  },
  {
    "id": "10860-008-2000591",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "008",
    "department": "산업 및 기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월3,4)"
  },
  {
    "id": "10860-008-2000592",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "008",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월3,4)"
  },
  {
    "id": "10860-008-2000593",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "008",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월3,4)"
  },
  {
    "id": "10860-008-2000594",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "008",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월3,4)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월3,4)"
  },
  {
    "id": "10860-009-2000588",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "009",
    "department": "바이오화학산업학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "허윤진",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(화1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(화1,2)"
  },
  {
    "id": "10860-009-2000589",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "009",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "허윤진",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(화1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(화1,2)"
  },
  {
    "id": "10860-009-2000590",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "009",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "허윤진",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(화1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(화1,2)"
  },
  {
    "id": "10860-009-2000591",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "009",
    "department": "산업 및 기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "허윤진",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(화1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(화1,2)"
  },
  {
    "id": "10860-009-2000592",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "009",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "허윤진",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(화1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(화1,2)"
  },
  {
    "id": "10860-009-2000593",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "009",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "허윤진",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(화1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(화1,2)"
  },
  {
    "id": "10860-009-2000594",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "009",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "허윤진",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(화1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(화1,2)"
  },
  {
    "id": "10860-010-2000588",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "010",
    "department": "바이오화학산업학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "임선영",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(금4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(금4,5)"
  },
  {
    "id": "10860-010-2000589",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "010",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "임선영",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(금4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(금4,5)"
  },
  {
    "id": "10860-010-2000590",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "010",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "임선영",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(금4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(금4,5)"
  },
  {
    "id": "10860-010-2000591",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "010",
    "department": "산업 및 기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "임선영",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(금4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(금4,5)"
  },
  {
    "id": "10860-010-2000592",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "010",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "임선영",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(금4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(금4,5)"
  },
  {
    "id": "10860-010-2000593",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "010",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "임선영",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(금4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(금4,5)"
  },
  {
    "id": "10860-010-2000594",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "010",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "임선영",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(금4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(금4,5)"
  },
  {
    "id": "10860-011-2000588",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "011",
    "department": "바이오화학산업학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월5,6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월5,6)"
  },
  {
    "id": "10860-011-2000589",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "011",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월5,6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월5,6)"
  },
  {
    "id": "10860-011-2000590",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "011",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월5,6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월5,6)"
  },
  {
    "id": "10860-011-2000591",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "011",
    "department": "산업 및 기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월5,6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월5,6)"
  },
  {
    "id": "10860-011-2000592",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "011",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월5,6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월5,6)"
  },
  {
    "id": "10860-011-2000593",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "011",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월5,6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월5,6)"
  },
  {
    "id": "10860-011-2000594",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "011",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "변은지",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(월5,6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(월5,6)"
  },
  {
    "id": "10860-012-2000588",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "012",
    "department": "바이오화학산업학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "노희호",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(월4,5)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(월4,5)"
  },
  {
    "id": "10860-012-2000589",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "012",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "노희호",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(월4,5)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(월4,5)"
  },
  {
    "id": "10860-012-2000590",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "012",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "노희호",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(월4,5)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(월4,5)"
  },
  {
    "id": "10860-012-2000591",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "012",
    "department": "산업 및 기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "노희호",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(월4,5)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(월4,5)"
  },
  {
    "id": "10860-012-2000592",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "012",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "노희호",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(월4,5)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(월4,5)"
  },
  {
    "id": "10860-012-2000593",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "012",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "노희호",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(월4,5)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(월4,5)"
  },
  {
    "id": "10860-012-2000594",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "012",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "노희호",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(월4,5)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(월4,5)"
  },
  {
    "id": "10860-013-2000588",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "013",
    "department": "바이오화학산업학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "허윤진",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(화5,6)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(화5,6)"
  },
  {
    "id": "10860-013-2000589",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "013",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "허윤진",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(화5,6)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(화5,6)"
  },
  {
    "id": "10860-013-2000590",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "013",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "허윤진",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(화5,6)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(화5,6)"
  },
  {
    "id": "10860-013-2000591",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "013",
    "department": "산업 및 기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "허윤진",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(화5,6)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(화5,6)"
  },
  {
    "id": "10860-013-2000592",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "013",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "허윤진",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(화5,6)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(화5,6)"
  },
  {
    "id": "10860-013-2000593",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "013",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "허윤진",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(화5,6)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(화5,6)"
  },
  {
    "id": "10860-013-2000594",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "013",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "허윤진",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(화5,6)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(화5,6)"
  },
  {
    "id": "10860-014-2000588",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "014",
    "department": "바이오화학산업학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "배윤호",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(금1,2)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(금1,2)"
  },
  {
    "id": "10860-014-2000589",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "014",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "배윤호",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(금1,2)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(금1,2)"
  },
  {
    "id": "10860-014-2000590",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "014",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "배윤호",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(금1,2)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(금1,2)"
  },
  {
    "id": "10860-014-2000591",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "014",
    "department": "산업 및 기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "배윤호",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(금1,2)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(금1,2)"
  },
  {
    "id": "10860-014-2000592",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "014",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "배윤호",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(금1,2)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(금1,2)"
  },
  {
    "id": "10860-014-2000593",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "014",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "배윤호",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(금1,2)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(금1,2)"
  },
  {
    "id": "10860-014-2000594",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "014",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "배윤호",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(금1,2)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(금1,2)"
  },
  {
    "id": "10860-015-2000588",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "015",
    "department": "바이오화학산업학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이나윤",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(화4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(화4,5)"
  },
  {
    "id": "10860-015-2000589",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "015",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이나윤",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(화4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(화4,5)"
  },
  {
    "id": "10860-015-2000590",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "015",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이나윤",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(화4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(화4,5)"
  },
  {
    "id": "10860-015-2000591",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "015",
    "department": "산업 및 기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이나윤",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(화4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(화4,5)"
  },
  {
    "id": "10860-015-2000592",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "015",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이나윤",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(화4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(화4,5)"
  },
  {
    "id": "10860-015-2000593",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "015",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이나윤",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(화4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(화4,5)"
  },
  {
    "id": "10860-015-2000594",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "015",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이나윤",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(화4,5)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(화4,5)"
  },
  {
    "id": "10860-016-2000588",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "016",
    "department": "바이오화학산업학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "하명진",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(수5,6)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(수5,6)"
  },
  {
    "id": "10860-016-2000589",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "016",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "하명진",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(수5,6)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(수5,6)"
  },
  {
    "id": "10860-016-2000590",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "016",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "하명진",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(수5,6)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(수5,6)"
  },
  {
    "id": "10860-016-2000591",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "016",
    "department": "산업 및 기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "하명진",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(수5,6)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(수5,6)"
  },
  {
    "id": "10860-016-2000592",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "016",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "하명진",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(수5,6)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(수5,6)"
  },
  {
    "id": "10860-016-2000593",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "016",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "하명진",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(수5,6)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(수5,6)"
  },
  {
    "id": "10860-016-2000594",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "016",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "하명진",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(수5,6)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(수5,6)"
  },
  {
    "id": "10860-017-2000588",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "017",
    "department": "바이오화학산업학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이재명",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(목6,7)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(목6,7)"
  },
  {
    "id": "10860-017-2000589",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "017",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이재명",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(목6,7)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(목6,7)"
  },
  {
    "id": "10860-017-2000590",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "017",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이재명",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(목6,7)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(목6,7)"
  },
  {
    "id": "10860-017-2000591",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "017",
    "department": "산업 및 기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이재명",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(목6,7)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(목6,7)"
  },
  {
    "id": "10860-017-2000592",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "017",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이재명",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(목6,7)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(목6,7)"
  },
  {
    "id": "10860-017-2000593",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "017",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이재명",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(목6,7)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(목6,7)"
  },
  {
    "id": "10860-017-2000594",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "017",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이재명",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(목6,7)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(목6,7)"
  },
  {
    "id": "10860-018-2000595",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "018",
    "department": "데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "정혜린",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(화6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(화6,7)"
  },
  {
    "id": "10860-018-2000596",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "018",
    "department": "컴퓨터학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "정혜린",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(화6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(화6,7)"
  },
  {
    "id": "10860-018-2000597",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "018",
    "department": "정보통신학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "정혜린",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(화6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(화6,7)"
  },
  {
    "id": "10860-019-2000595",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "019",
    "department": "데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "하명진",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(수3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(수3,4)"
  },
  {
    "id": "10860-019-2000596",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "019",
    "department": "컴퓨터학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "하명진",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(수3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(수3,4)"
  },
  {
    "id": "10860-019-2000597",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "019",
    "department": "정보통신학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "하명진",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(수3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(수3,4)"
  },
  {
    "id": "10860-020-2000595",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "020",
    "department": "데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "권혁수",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(월1,2)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(월1,2)"
  },
  {
    "id": "10860-020-2000596",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "020",
    "department": "컴퓨터학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "권혁수",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(월1,2)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(월1,2)"
  },
  {
    "id": "10860-020-2000597",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "020",
    "department": "정보통신학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "권혁수",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(월1,2)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(월1,2)"
  },
  {
    "id": "10860-021-2000595",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "021",
    "department": "데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이나윤",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(화6,7)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(화6,7)"
  },
  {
    "id": "10860-021-2000596",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "021",
    "department": "컴퓨터학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이나윤",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(화6,7)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(화6,7)"
  },
  {
    "id": "10860-021-2000597",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "021",
    "department": "정보통신학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이나윤",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(화6,7)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(화6,7)"
  },
  {
    "id": "10860-022-2000595",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "022",
    "department": "데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이민경",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(수4,5)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(수4,5)"
  },
  {
    "id": "10860-022-2000596",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "022",
    "department": "컴퓨터학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이민경",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(수4,5)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(수4,5)"
  },
  {
    "id": "10860-022-2000597",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "022",
    "department": "정보통신학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이민경",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(수4,5)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(수4,5)"
  },
  {
    "id": "10860-023-2000595",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "023",
    "department": "데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "권혁수",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(월3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(월3,4)"
  },
  {
    "id": "10860-023-2000596",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "023",
    "department": "컴퓨터학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "권혁수",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(월3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(월3,4)"
  },
  {
    "id": "10860-023-2000597",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "023",
    "department": "정보통신학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "권혁수",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(월3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(월3,4)"
  },
  {
    "id": "10860-024-2000595",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "024",
    "department": "데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이재명",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(목4,5)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(목4,5)"
  },
  {
    "id": "10860-024-2000596",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "024",
    "department": "컴퓨터학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이재명",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(목4,5)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(목4,5)"
  },
  {
    "id": "10860-024-2000597",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "024",
    "department": "정보통신학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "이재명",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(목4,5)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(목4,5)"
  },
  {
    "id": "10860-025-2000598",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "025",
    "department": "간호학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "노희호",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(월6,7)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(월6,7)"
  },
  {
    "id": "10860-026-2000598",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "026",
    "department": "간호학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "하명진",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(수1,2)"
    },
    "capacity": 38,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(수1,2)"
  },
  {
    "id": "10860-027-2000599",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "027",
    "department": "아동가족복지학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "최수현",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(목1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(목1,2)"
  },
  {
    "id": "10860-027-2000600",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "027",
    "department": "의류학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "최수현",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(목1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(목1,2)"
  },
  {
    "id": "10860-027-2000601",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "027",
    "department": "식품영양학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "최수현",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(목1,2)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(목1,2)"
  },
  {
    "id": "10860-028-2000599",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "028",
    "department": "아동가족복지학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "배윤호",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(금5,6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(금5,6)"
  },
  {
    "id": "10860-028-2000600",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "028",
    "department": "의류학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "배윤호",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(금5,6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(금5,6)"
  },
  {
    "id": "10860-028-2000601",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "028",
    "department": "식품영양학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "배윤호",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(금5,6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(금5,6)"
  },
  {
    "id": "10860-029-2000599",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "029",
    "department": "아동가족복지학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "최수현",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(목5,6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(목5,6)"
  },
  {
    "id": "10860-029-2000600",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "029",
    "department": "의류학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "최수현",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(목5,6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(목5,6)"
  },
  {
    "id": "10860-029-2000601",
    "subjectKey": "10860",
    "name": "과학적글쓰기와고전읽기2",
    "division": "029",
    "department": "식품영양학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "최수현",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(목5,6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(목5,6)"
  },
  {
    "id": "10871-001-2000658",
    "subjectKey": "10871",
    "name": "교양프랑스어",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "매튜",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래104",
    "isOnline": false,
    "source": {
      "schedule": "미래104(화1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래104"
      }
    ],
    "sourceSchedule": "미래104(화1,2,3)"
  },
  {
    "id": "10871-002-2000658",
    "subjectKey": "10871",
    "name": "교양프랑스어",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "허영인",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문309",
    "isOnline": false,
    "source": {
      "schedule": "인문309(월4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문309"
      }
    ],
    "sourceSchedule": "인문309(월4,5,6)"
  },
  {
    "id": "10872-001-2000658",
    "subjectKey": "10872",
    "name": "여행프랑스어",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "매튜",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문508",
    "isOnline": false,
    "source": {
      "schedule": "인문508(월4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문508"
      }
    ],
    "sourceSchedule": "인문508(월4,5,6)"
  },
  {
    "id": "10873-001-2000658",
    "subjectKey": "10873",
    "name": "start 독일어(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박승찬",
    "days": [
      "월",
      "토"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "인문407",
    "isOnline": true,
    "source": {
      "schedule": "인문407(월1 토1,2)"
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1
        ],
        "classroom": "인문407"
      },
      {
        "day": "토",
        "periods": [
          1,
          2
        ],
        "classroom": "인문407"
      }
    ],
    "sourceSchedule": "인문407(월1 토1,2)"
  },
  {
    "id": "10875-001-2000658",
    "subjectKey": "10875",
    "name": "start 러시아어(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박승찬",
    "days": [
      "화",
      "토"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "인문407",
    "isOnline": true,
    "source": {
      "schedule": "인문407(화1 토3,4)"
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1
        ],
        "classroom": "인문407"
      },
      {
        "day": "토",
        "periods": [
          3,
          4
        ],
        "classroom": "인문407"
      }
    ],
    "sourceSchedule": "인문407(화1 토3,4)"
  },
  {
    "id": "10878-001-2000658",
    "subjectKey": "10878",
    "name": "문화와정치",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "유성식",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래109",
    "isOnline": false,
    "source": {
      "schedule": "미래109(목6,7,8)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래109"
      }
    ],
    "sourceSchedule": "미래109(목6,7,8)"
  },
  {
    "id": "10882-001-2000658",
    "subjectKey": "10882",
    "name": "문화콘텐츠의이해와비평",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박혜경",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B201",
    "isOnline": false,
    "source": {
      "schedule": "미래B201(목1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B201"
      }
    ],
    "sourceSchedule": "미래B201(목1,2,3)"
  },
  {
    "id": "10887-001-2000658",
    "subjectKey": "10887",
    "name": "북유럽의이해",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "정연우",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합506",
    "isOnline": false,
    "source": {
      "schedule": "종합506(화1,2,3)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합506"
      }
    ],
    "sourceSchedule": "종합506(화1,2,3)"
  },
  {
    "id": "10888-001-2000658",
    "subjectKey": "10888",
    "name": "동유럽의사회와문화",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "정연우",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래B103",
    "isOnline": false,
    "source": {
      "schedule": "미래B103(화6,7,8)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래B103"
      }
    ],
    "sourceSchedule": "미래B103(화6,7,8)"
  },
  {
    "id": "10890-001-2000658",
    "subjectKey": "10890",
    "name": "미디어와인간관계",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "유성식",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "미래109",
    "isOnline": false,
    "source": {
      "schedule": "미래109(목2,3,4)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "미래109"
      }
    ],
    "sourceSchedule": "미래109(목2,3,4)"
  },
  {
    "id": "10911-001-2000658",
    "subjectKey": "10911",
    "name": "MOS1(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 230,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "10932-001-2000286",
    "subjectKey": "10932",
    "name": "학교폭력예방및학생의이해",
    "division": "001",
    "department": "교양",
    "category": "교직",
    "sourceCategory": "교직",
    "credit": 2,
    "professor": "김신래",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "미래319",
    "isOnline": false,
    "source": {
      "schedule": "미래319(화7,8)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "미래319"
      }
    ],
    "sourceSchedule": "미래319(화7,8)"
  },
  {
    "id": "10939-001-2000658",
    "subjectKey": "10939",
    "name": "인성과삶의가치",
    "division": "001",
    "department": "교양",
    "category": "일반선택",
    "sourceCategory": "소교",
    "credit": 1,
    "professor": "이정헌",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": 1200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "10940-001-2000605",
    "subjectKey": "10940",
    "name": "융합캡스톤디자인(마이크로디그리)",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "권지원",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(금1,2,3)"
    },
    "capacity": 15,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(금1,2,3)"
  },
  {
    "id": "10940-002-2000606",
    "subjectKey": "10940",
    "name": "융합캡스톤디자인(마이크로디그리)",
    "division": "002",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이현정",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "음악110",
    "isOnline": false,
    "source": {
      "schedule": "음악110(금1,2,3)"
    },
    "capacity": 10,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "음악110"
      }
    ],
    "sourceSchedule": "음악110(금1,2,3)"
  },
  {
    "id": "10940-003-2000608",
    "subjectKey": "10940",
    "name": "융합캡스톤디자인(마이크로디그리)",
    "division": "003",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김진환",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "음악109",
    "isOnline": false,
    "source": {
      "schedule": "음악109(금1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "음악109"
      }
    ],
    "sourceSchedule": "음악109(금1,2,3)"
  },
  {
    "id": "10940-004-2000759",
    "subjectKey": "10940",
    "name": "융합캡스톤디자인(마이크로디그리)",
    "division": "004",
    "department": "지능형보안학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김대엽",
    "days": [
      "토"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "IT306",
    "isOnline": false,
    "source": {
      "schedule": "IT306(토5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "토",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "IT306"
      }
    ],
    "sourceSchedule": "IT306(토5,6,7)"
  },
  {
    "id": "10942-001-2000658",
    "subjectKey": "10942",
    "name": "창의프로젝트",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 2,
    "professor": "이다예",
    "days": [
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "종합210-2",
    "isOnline": false,
    "source": {
      "schedule": "종합210-2(금7,8)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "종합210-2"
      }
    ],
    "sourceSchedule": "종합210-2(금7,8)"
  },
  {
    "id": "10944-001-2000653",
    "subjectKey": "10944",
    "name": "Color&Design(마이크로디그리)",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "안희진",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술205",
    "isOnline": false,
    "source": {
      "schedule": "미술205(수1,2,3,4)"
    },
    "capacity": 28,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술205"
      }
    ],
    "sourceSchedule": "미술205(수1,2,3,4)"
  },
  {
    "id": "10944-002-2000654",
    "subjectKey": "10944",
    "name": "Color&Design(마이크로디그리)",
    "division": "002",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권지현",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "미술211",
    "isOnline": false,
    "source": {
      "schedule": "미술211(월2,3,4)"
    },
    "capacity": 15,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "미술211"
      }
    ],
    "sourceSchedule": "미술211(월2,3,4)"
  },
  {
    "id": "10944-003-2000655",
    "subjectKey": "10944",
    "name": "Color&Design(마이크로디그리)",
    "division": "003",
    "department": "공예디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "나미경",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "미술204",
    "isOnline": false,
    "source": {
      "schedule": "미술204(수2,3,4)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "미술204"
      }
    ],
    "sourceSchedule": "미술204(수2,3,4)"
  },
  {
    "id": "10944-004-2000653",
    "subjectKey": "10944",
    "name": "Color&Design(마이크로디그리)",
    "division": "004",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "안희진",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술205",
    "isOnline": false,
    "source": {
      "schedule": "미술205(수6,7,8,9)"
    },
    "capacity": 28,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술205"
      }
    ],
    "sourceSchedule": "미술205(수6,7,8,9)"
  },
  {
    "id": "10944-005-2000654",
    "subjectKey": "10944",
    "name": "Color&Design(마이크로디그리)",
    "division": "005",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권지현",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미술211",
    "isOnline": false,
    "source": {
      "schedule": "미술211(월6,7,8)"
    },
    "capacity": 15,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미술211"
      }
    ],
    "sourceSchedule": "미술211(월6,7,8)"
  },
  {
    "id": "10945-001-2000255",
    "subjectKey": "10945",
    "name": "Creative Construction",
    "division": "001",
    "department": "패션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이상희",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술110",
    "isOnline": false,
    "source": {
      "schedule": "미술110(화1,2,3,4)"
    },
    "capacity": 19,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술110"
      }
    ],
    "sourceSchedule": "미술110(화1,2,3,4)"
  },
  {
    "id": "10950-001-2000654",
    "subjectKey": "10950",
    "name": "Design&Designers",
    "division": "001",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권지현",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미술211",
    "isOnline": false,
    "source": {
      "schedule": "미술211(화6,7,8)"
    },
    "capacity": 11,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미술211"
      }
    ],
    "sourceSchedule": "미술211(화6,7,8)"
  },
  {
    "id": "10950-002-2000654",
    "subjectKey": "10950",
    "name": "Design&Designers",
    "division": "002",
    "department": "패션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김미경",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "종합B107",
    "isOnline": false,
    "source": {
      "schedule": "종합B107(월6,7,8)"
    },
    "capacity": 11,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "종합B107"
      }
    ],
    "sourceSchedule": "종합B107(월6,7,8)"
  },
  {
    "id": "10952-001-2000628",
    "subjectKey": "10952",
    "name": "FTA이론",
    "division": "001",
    "department": "글로벌비즈니스",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이수현",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "글경604",
    "isOnline": false,
    "source": {
      "schedule": "글경604(목2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "글경604"
      }
    ],
    "sourceSchedule": "글경604(목2,3,4)"
  },
  {
    "id": "10953-001-2000595",
    "subjectKey": "10953",
    "name": "R데이터분석 ",
    "division": "001",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정형철",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경203",
    "isOnline": false,
    "source": {
      "schedule": "글경203(화4,5,6)"
    },
    "capacity": 45,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경203"
      }
    ],
    "sourceSchedule": "글경203(화4,5,6)"
  },
  {
    "id": "10953-002-2000595",
    "subjectKey": "10953",
    "name": "R데이터분석 ",
    "division": "002",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정형철",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경203",
    "isOnline": false,
    "source": {
      "schedule": "글경203(목4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경203"
      }
    ],
    "sourceSchedule": "글경203(목4,5,6)"
  },
  {
    "id": "10958-001-2000507",
    "subjectKey": "10958",
    "name": "국제무역이론연습",
    "division": "001",
    "department": "글로벌비즈니스",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이수현",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "글경604",
    "isOnline": false,
    "source": {
      "schedule": "글경604(월2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "글경604"
      }
    ],
    "sourceSchedule": "글경604(월2,3,4)"
  },
  {
    "id": "10960-001-2000507",
    "subjectKey": "10960",
    "name": "글로벌기업환경론",
    "division": "001",
    "department": "글로벌비즈니스",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "류덕기",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경602",
    "isOnline": false,
    "source": {
      "schedule": "글경602(금1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경602"
      }
    ],
    "sourceSchedule": "글경602(금1,2,3)"
  },
  {
    "id": "10961-001-2000628",
    "subjectKey": "10961",
    "name": "글로벌마케팅1",
    "division": "001",
    "department": "글로벌비즈니스",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조니",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경602",
    "isOnline": false,
    "source": {
      "schedule": "글경602(금5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경602"
      }
    ],
    "sourceSchedule": "글경602(금5,6,7)"
  },
  {
    "id": "10965-001-2000632",
    "subjectKey": "10965",
    "name": "단백질공학및실습2",
    "division": "001",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "손영선",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합407",
    "isOnline": false,
    "source": {
      "schedule": "종합407(월5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합407"
      }
    ],
    "sourceSchedule": "종합407(월5,6,7)"
  },
  {
    "id": "10968-002-2000595",
    "subjectKey": "10968",
    "name": "데이터시각화",
    "division": "002",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "방효은",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경507",
    "isOnline": false,
    "source": {
      "schedule": "글경507(목1,2,3)"
    },
    "capacity": 43,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경507"
      }
    ],
    "sourceSchedule": "글경507(목1,2,3)"
  },
  {
    "id": "10968-003-2000595",
    "subjectKey": "10968",
    "name": "데이터시각화",
    "division": "003",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "방효은",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경203",
    "isOnline": false,
    "source": {
      "schedule": "글경203(금1,2,3)"
    },
    "capacity": 43,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경203"
      }
    ],
    "sourceSchedule": "글경203(금1,2,3)"
  },
  {
    "id": "10971-001-2000595",
    "subjectKey": "10971",
    "name": "딥러닝응용2",
    "division": "001",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김진현",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경203",
    "isOnline": false,
    "source": {
      "schedule": "글경203(월4,5,6)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경203"
      }
    ],
    "sourceSchedule": "글경203(월4,5,6)"
  },
  {
    "id": "10971-002-2000595",
    "subjectKey": "10971",
    "name": "딥러닝응용2",
    "division": "002",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김진현",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경203",
    "isOnline": false,
    "source": {
      "schedule": "글경203(수1,2,3)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경203"
      }
    ],
    "sourceSchedule": "글경203(수1,2,3)"
  },
  {
    "id": "10975-001-2000743",
    "subjectKey": "10975",
    "name": "러시아어읽기와듣기",
    "division": "001",
    "department": "러시아언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "마리나세르게예브나",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문401",
    "isOnline": false,
    "source": {
      "schedule": "인문401(수1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문401"
      }
    ],
    "sourceSchedule": "인문401(수1,2,3)"
  },
  {
    "id": "10976-001-2000295",
    "subjectKey": "10976",
    "name": "러시아언어특강",
    "division": "001",
    "department": "러시아어문학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박카밀라",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "종합505",
    "isOnline": false,
    "source": {
      "schedule": "종합505(화1,2 목3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "종합505"
      },
      {
        "day": "목",
        "periods": [
          3
        ],
        "classroom": "종합505"
      }
    ],
    "sourceSchedule": "종합505(화1,2 목3)"
  },
  {
    "id": "10978-001-2000595",
    "subjectKey": "10978",
    "name": "머신러닝2",
    "division": "001",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김순찬",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "글경203",
    "isOnline": false,
    "source": {
      "schedule": "글경203(월7,8,9)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "글경203"
      }
    ],
    "sourceSchedule": "글경203(월7,8,9)"
  },
  {
    "id": "10978-002-2000595",
    "subjectKey": "10978",
    "name": "머신러닝2",
    "division": "002",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김순찬",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "글경203",
    "isOnline": false,
    "source": {
      "schedule": "글경203(목7,8,9)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "글경203"
      }
    ],
    "sourceSchedule": "글경203(목7,8,9)"
  },
  {
    "id": "10979-001-2000628",
    "subjectKey": "10979",
    "name": "무역결제론",
    "division": "001",
    "department": "글로벌비즈니스",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "류창원",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경607",
    "isOnline": false,
    "source": {
      "schedule": "글경607(수1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경607"
      }
    ],
    "sourceSchedule": "글경607(수1,2,3)"
  },
  {
    "id": "10989-001-2000595",
    "subjectKey": "10989",
    "name": "빅데이터분석(딥러닝프로그래밍)",
    "division": "001",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정진명",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경507",
    "isOnline": false,
    "source": {
      "schedule": "글경507(월4,5,6)"
    },
    "capacity": 35,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경507"
      }
    ],
    "sourceSchedule": "글경507(월4,5,6)"
  },
  {
    "id": "10989-002-2000595",
    "subjectKey": "10989",
    "name": "빅데이터분석(딥러닝프로그래밍)",
    "division": "002",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정진명",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경507",
    "isOnline": false,
    "source": {
      "schedule": "글경507(목4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경507"
      }
    ],
    "sourceSchedule": "글경507(목4,5,6)"
  },
  {
    "id": "10990-001-2000595",
    "subjectKey": "10990",
    "name": "빅데이터플랫폼",
    "division": "001",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "안홍렬",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경203",
    "isOnline": false,
    "source": {
      "schedule": "글경203(월1,2,3)"
    },
    "capacity": 41,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경203"
      }
    ],
    "sourceSchedule": "글경203(월1,2,3)"
  },
  {
    "id": "10993-001-2000601",
    "subjectKey": "10993",
    "name": "식품가공및저장학",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정경훈",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "생활305",
    "isOnline": false,
    "source": {
      "schedule": "생활305(수5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "생활305"
      }
    ],
    "sourceSchedule": "생활305(수5,6,7)"
  },
  {
    "id": "10994-001-2000601",
    "subjectKey": "10994",
    "name": "식품분석및실험",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최윤",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "생활202",
    "isOnline": false,
    "source": {
      "schedule": "생활202(목7,8,9)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "생활202"
      }
    ],
    "sourceSchedule": "생활202(목7,8,9)"
  },
  {
    "id": "10996-001-2000507",
    "subjectKey": "10996",
    "name": "아태지역과비즈니스(마이크로디그리)",
    "division": "001",
    "department": "글로벌비즈니스",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조니",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경504",
    "isOnline": false,
    "source": {
      "schedule": "글경504(수1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경504"
      }
    ],
    "sourceSchedule": "글경504(수1,2,3)"
  },
  {
    "id": "11002-001-2000632",
    "subjectKey": "11002",
    "name": "인체유전학",
    "division": "001",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "유기태",
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합407",
    "isOnline": false,
    "source": {
      "schedule": "종합407(월2,3 수4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "종합407"
      },
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "종합407"
      }
    ],
    "sourceSchedule": "종합407(월2,3 수4)"
  },
  {
    "id": "11003-001-2000628",
    "subjectKey": "11003",
    "name": "전자무역사례연구",
    "division": "001",
    "department": "글로벌비즈니스",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "윤성원",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경607",
    "isOnline": false,
    "source": {
      "schedule": "글경607(수5,6,7)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경607"
      }
    ],
    "sourceSchedule": "글경607(수5,6,7)"
  },
  {
    "id": "11005-001-2000623",
    "subjectKey": "11005",
    "name": "정책분석평가",
    "division": "001",
    "department": "행정학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정하나",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문406",
    "isOnline": false,
    "source": {
      "schedule": "인문406(화4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문406"
      }
    ],
    "sourceSchedule": "인문406(화4,5,6)"
  },
  {
    "id": "11006-001-2000405",
    "subjectKey": "11006",
    "name": "정치사회사상",
    "division": "001",
    "department": "행정학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김용훈",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "인문107",
    "isOnline": false,
    "source": {
      "schedule": "인문107(월5,6 화8)"
    },
    "capacity": 35,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "인문107"
      },
      {
        "day": "화",
        "periods": [
          8
        ],
        "classroom": "인문107"
      }
    ],
    "sourceSchedule": "인문107(월5,6 화8)"
  },
  {
    "id": "11010-001-2000654",
    "subjectKey": "11010",
    "name": "패션&디지털클로딩",
    "division": "001",
    "department": "패션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "강민정",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "IT214",
    "isOnline": false,
    "source": {
      "schedule": "IT214(목6,7,8,9)"
    },
    "capacity": 15,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "IT214"
      }
    ],
    "sourceSchedule": "IT214(목6,7,8,9)"
  },
  {
    "id": "11014-001-2000643",
    "subjectKey": "11014",
    "name": "화장품화학공학(마이크로디그리)",
    "division": "001",
    "department": "화학공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "노호식",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "자연관408",
    "isOnline": false,
    "source": {
      "schedule": "자연관408(월5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "자연관408"
      }
    ],
    "sourceSchedule": "자연관408(월5,6,7)"
  },
  {
    "id": "11017-001-2000658",
    "subjectKey": "11017",
    "name": "4차산업과스포츠",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "최성욱",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "체육118",
    "isOnline": false,
    "source": {
      "schedule": "체육118(화1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "체육118"
      }
    ],
    "sourceSchedule": "체육118(화1,2,3)"
  },
  {
    "id": "11018-001-2000658",
    "subjectKey": "11018",
    "name": "4차산업혁명과음악(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "배준",
    "days": [
      "화",
      "토"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "음악315",
    "isOnline": true,
    "source": {
      "schedule": "음악315(화1 토9,10)"
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1
        ],
        "classroom": "음악315"
      },
      {
        "day": "토",
        "periods": [
          9,
          10
        ],
        "classroom": "음악315"
      }
    ],
    "sourceSchedule": "음악315(화1 토9,10)"
  },
  {
    "id": "11023-001-2000658",
    "subjectKey": "11023",
    "name": "과학문명사(마이크로디그리)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "윤병국",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B103",
    "isOnline": false,
    "source": {
      "schedule": "미래B103(수1,2,3)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B103"
      }
    ],
    "sourceSchedule": "미래B103(수1,2,3)"
  },
  {
    "id": "11024-001-2000658",
    "subjectKey": "11024",
    "name": "광고홍보의이해와실제",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이현승",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문508",
    "isOnline": false,
    "source": {
      "schedule": "인문508(목4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문508"
      }
    ],
    "sourceSchedule": "인문508(목4,5,6)"
  },
  {
    "id": "11029-001-2000658",
    "subjectKey": "11029",
    "name": "글로벌교양1(이러닝_글로벌소통의중심,통역과번역)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이혜승",
    "days": [
      "목",
      "토"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "인문507",
    "isOnline": true,
    "source": {
      "schedule": "인문507(목1 토3,4)"
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1
        ],
        "classroom": "인문507"
      },
      {
        "day": "토",
        "periods": [
          3,
          4
        ],
        "classroom": "인문507"
      }
    ],
    "sourceSchedule": "인문507(목1 토3,4)"
  },
  {
    "id": "11029-002-2000658",
    "subjectKey": "11029",
    "name": "글로벌교양1(Communication Strategies)",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "데이비드",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합308",
    "isOnline": false,
    "source": {
      "schedule": "종합308(목7,8,9)"
    },
    "capacity": 15,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합308"
      }
    ],
    "sourceSchedule": "종합308(목7,8,9)"
  },
  {
    "id": "11029-003-2000658",
    "subjectKey": "11029",
    "name": "글로벌교양1(Communication Strategies)",
    "division": "003",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "토드",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합307",
    "isOnline": false,
    "source": {
      "schedule": "종합307(목1,2,3)"
    },
    "capacity": 15,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합307"
      }
    ],
    "sourceSchedule": "종합307(목1,2,3)"
  },
  {
    "id": "11029-004-2000658",
    "subjectKey": "11029",
    "name": "글로벌교양1(Communication Strategies)",
    "division": "004",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "션",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합609",
    "isOnline": false,
    "source": {
      "schedule": "종합609(월4,5,6)"
    },
    "capacity": 15,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합609"
      }
    ],
    "sourceSchedule": "종합609(월4,5,6)"
  },
  {
    "id": "11029-005-2000658",
    "subjectKey": "11029",
    "name": "글로벌교양1(Communication Strategies)",
    "division": "005",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "토마스",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합308",
    "isOnline": false,
    "source": {
      "schedule": "종합308(화1,2,3)"
    },
    "capacity": 15,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합308"
      }
    ],
    "sourceSchedule": "종합308(화1,2,3)"
  },
  {
    "id": "11029-006-2000658",
    "subjectKey": "11029",
    "name": "글로벌교양1(영어로읽고보는미스테리)",
    "division": "006",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "최수연(줄리)",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합308",
    "isOnline": false,
    "source": {
      "schedule": "종합308(목1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합308"
      }
    ],
    "sourceSchedule": "종합308(목1,2,3)"
  },
  {
    "id": "11029-007-2000658",
    "subjectKey": "11029",
    "name": "글로벌교양1(브랜드처럼말하기_비즈니스와마케팅에서의 언어의 힘)",
    "division": "007",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "노디아",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합308",
    "isOnline": false,
    "source": {
      "schedule": "종합308(화7,8,9)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합308"
      }
    ],
    "sourceSchedule": "종합308(화7,8,9)"
  },
  {
    "id": "11030-002-2000658",
    "subjectKey": "11030",
    "name": "글로벌교양2(일본지역문화론)",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "황준호",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합308",
    "isOnline": false,
    "source": {
      "schedule": "종합308(수1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합308"
      }
    ],
    "sourceSchedule": "종합308(수1,2,3)"
  },
  {
    "id": "11030-003-2000658",
    "subjectKey": "11030",
    "name": "글로벌교양2(이러닝_도시와언어로만나는러시아)",
    "division": "003",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이혜승",
    "days": [
      "금",
      "토"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "인문507",
    "isOnline": true,
    "source": {
      "schedule": "인문507(금1 토5,6)"
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1
        ],
        "classroom": "인문507"
      },
      {
        "day": "토",
        "periods": [
          5,
          6
        ],
        "classroom": "인문507"
      }
    ],
    "sourceSchedule": "인문507(금1 토5,6)"
  },
  {
    "id": "11030-004-2000658",
    "subjectKey": "11030",
    "name": "글로벌교양2(세계신화와전설_그 숨겨진 이야기)",
    "division": "004",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "다니엘",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합307",
    "isOnline": false,
    "source": {
      "schedule": "종합307(수7,8,9)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합307"
      }
    ],
    "sourceSchedule": "종합307(수7,8,9)"
  },
  {
    "id": "11030-005-2000658",
    "subjectKey": "11030",
    "name": "글로벌교양2(기후변화와 지속가능한 개발)",
    "division": "005",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "지나인",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B201",
    "isOnline": false,
    "source": {
      "schedule": "미래B201(금4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B201"
      }
    ],
    "sourceSchedule": "미래B201(금4,5,6)"
  },
  {
    "id": "11030-006-2000658",
    "subjectKey": "11030",
    "name": "글로벌교양2(문화로떠나는세계여행)",
    "division": "006",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "알미라",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "국제307",
    "isOnline": false,
    "source": {
      "schedule": "국제307(화1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "국제307"
      }
    ],
    "sourceSchedule": "국제307(화1,2,3)"
  },
  {
    "id": "11030-007-2000658",
    "subjectKey": "11030",
    "name": "글로벌교양2(미식가와함께떠나는중국여행)",
    "division": "007",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "곽상",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합308",
    "isOnline": false,
    "source": {
      "schedule": "종합308(월1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합308"
      }
    ],
    "sourceSchedule": "종합308(월1,2,3)"
  },
  {
    "id": "11031-001-2000658",
    "subjectKey": "11031",
    "name": "글로벌교양3(영화로세상보기)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "곽상",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합608",
    "isOnline": false,
    "source": {
      "schedule": "종합608(화1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합608"
      }
    ],
    "sourceSchedule": "종합608(화1,2,3)"
  },
  {
    "id": "11031-002-2000658",
    "subjectKey": "11031",
    "name": "글로벌교양3(영화로세상보기)",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "곽상",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합608",
    "isOnline": false,
    "source": {
      "schedule": "종합608(금1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합608"
      }
    ],
    "sourceSchedule": "종합608(금1,2,3)"
  },
  {
    "id": "11031-003-2000658",
    "subjectKey": "11031",
    "name": "글로벌교양3(이러닝_Gaming and Society)",
    "division": "003",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "매튜",
    "days": [
      "목",
      "토"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "인문309",
    "isOnline": true,
    "source": {
      "schedule": "인문309(목1),인문508(토2,3)"
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1
        ],
        "classroom": "인문309"
      },
      {
        "day": "토",
        "periods": [
          2,
          3
        ],
        "classroom": "인문508"
      }
    ],
    "sourceSchedule": "인문309(목1),인문508(토2,3)"
  },
  {
    "id": "11031-004-2000658",
    "subjectKey": "11031",
    "name": "글로벌교양3(심리학의세계_마음을 읽는기술)",
    "division": "004",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "유젤",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합305",
    "isOnline": false,
    "source": {
      "schedule": "종합305(월4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합305"
      }
    ],
    "sourceSchedule": "종합305(월4,5,6)"
  },
  {
    "id": "11031-005-2000658",
    "subjectKey": "11031",
    "name": "글로벌교양3(세계식음료문화사)",
    "division": "005",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "쉐인",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합308",
    "isOnline": false,
    "source": {
      "schedule": "종합308(월4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합308"
      }
    ],
    "sourceSchedule": "종합308(월4,5,6)"
  },
  {
    "id": "11031-008-2000658",
    "subjectKey": "11031",
    "name": "글로벌교양3(융합전공경제학)",
    "division": "008",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이상엽",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경402",
    "isOnline": false,
    "source": {
      "schedule": "글경402(월5,6,7)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경402"
      }
    ],
    "sourceSchedule": "글경402(월5,6,7)"
  },
  {
    "id": "11031-009-2000658",
    "subjectKey": "11031",
    "name": "글로벌교양3(중급요가탐구)",
    "division": "009",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "프레미",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합506",
    "isOnline": false,
    "source": {
      "schedule": "종합506(수7,8,9)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합506"
      }
    ],
    "sourceSchedule": "종합506(수7,8,9)"
  },
  {
    "id": "11032-001-2000658",
    "subjectKey": "11032",
    "name": "글로벌교양4(대중문화속초자연적과학이야기_X-files)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "코스민",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B103",
    "isOnline": false,
    "source": {
      "schedule": "미래B103(금1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B103"
      }
    ],
    "sourceSchedule": "미래B103(금1,2,3)"
  },
  {
    "id": "11032-002-2000658",
    "subjectKey": "11032",
    "name": "글로벌교양4(이러닝-C++과코딩)",
    "division": "002",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11032-003-2000658",
    "subjectKey": "11032",
    "name": "글로벌교양4(생성형 AI 첫걸음)",
    "division": "003",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김준태",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래311",
    "isOnline": false,
    "source": {
      "schedule": "미래311(화4,5,6)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래311"
      }
    ],
    "sourceSchedule": "미래311(화4,5,6)"
  },
  {
    "id": "11032-004-2000658",
    "subjectKey": "11032",
    "name": "글로벌교양4(이러닝_인공지능HRI)",
    "division": "004",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "임동원",
    "days": [
      "금",
      "토"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "인문408",
    "isOnline": true,
    "source": {
      "schedule": "인문408(금1 토1,2)"
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1
        ],
        "classroom": "인문408"
      },
      {
        "day": "토",
        "periods": [
          1,
          2
        ],
        "classroom": "인문408"
      }
    ],
    "sourceSchedule": "인문408(금1 토1,2)"
  },
  {
    "id": "11033-001-2000658",
    "subjectKey": "11033",
    "name": "글로벌교양5(4차산업 스타트업 실무)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "홍태민",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래520",
    "isOnline": false,
    "source": {
      "schedule": "미래520(금4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래520"
      }
    ],
    "sourceSchedule": "미래520(금4,5,6)"
  },
  {
    "id": "11033-002-2000658",
    "subjectKey": "11033",
    "name": "글로벌교양5(생활속아이디어)",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김현철",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래311",
    "isOnline": false,
    "source": {
      "schedule": "미래311(월1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래311"
      }
    ],
    "sourceSchedule": "미래311(월1,2,3)"
  },
  {
    "id": "11033-003-2000658",
    "subjectKey": "11033",
    "name": "글로벌교양5(기술창업스토리텔링)",
    "division": "003",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김영출",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래319",
    "isOnline": false,
    "source": {
      "schedule": "미래319(화4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래319"
      }
    ],
    "sourceSchedule": "미래319(화4,5,6)"
  },
  {
    "id": "11033-005-2000658",
    "subjectKey": "11033",
    "name": "글로벌교양5(인터넷마케팅이해)",
    "division": "005",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김창회",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래319",
    "isOnline": false,
    "source": {
      "schedule": "미래319(수1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래319"
      }
    ],
    "sourceSchedule": "미래319(수1,2,3)"
  },
  {
    "id": "11034-001-2000658",
    "subjectKey": "11034",
    "name": "글로벌교양6(현대미술프로젝트연구)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "안효정",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B103",
    "isOnline": false,
    "source": {
      "schedule": "미래B103(월4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B103"
      }
    ],
    "sourceSchedule": "미래B103(월4,5,6)"
  },
  {
    "id": "11034-002-2000658",
    "subjectKey": "11034",
    "name": "글로벌교양6(현대미술큐레이팅)",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "장해미",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B201",
    "isOnline": false,
    "source": {
      "schedule": "미래B201(화1,2,3)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B201"
      }
    ],
    "sourceSchedule": "미래B201(화1,2,3)"
  },
  {
    "id": "11034-004-2000658",
    "subjectKey": "11034",
    "name": "글로벌교양6(요가와마음챙김운동소개)",
    "division": "004",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "프레미",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합307",
    "isOnline": false,
    "source": {
      "schedule": "종합307(월7,8,9)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합307"
      }
    ],
    "sourceSchedule": "종합307(월7,8,9)"
  },
  {
    "id": "11034-005-2000658",
    "subjectKey": "11034",
    "name": "글로벌교양6(알렉산더테크닉(올바른몸사용법))",
    "division": "005",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "최현철",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "미래110",
    "isOnline": false,
    "source": {
      "schedule": "미래110(월3,4,5)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "미래110"
      }
    ],
    "sourceSchedule": "미래110(월3,4,5)"
  },
  {
    "id": "11034-006-2000658",
    "subjectKey": "11034",
    "name": "글로벌교양6(K-컨텐츠의미래)",
    "division": "006",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "석무현",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래110",
    "isOnline": false,
    "source": {
      "schedule": "미래110(화4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래110"
      }
    ],
    "sourceSchedule": "미래110(화4,5,6)"
  },
  {
    "id": "11034-007-2000658",
    "subjectKey": "11034",
    "name": "글로벌교양6(판화-실크스크린)",
    "division": "007",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "윤세희",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "조형209",
    "isOnline": false,
    "source": {
      "schedule": "조형209(수2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "조형209"
      }
    ],
    "sourceSchedule": "조형209(수2,3,4)"
  },
  {
    "id": "11034-008-2000658",
    "subjectKey": "11034",
    "name": "글로벌교양6(클래식음악입문)",
    "division": "008",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "최인환",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "음악315",
    "isOnline": false,
    "source": {
      "schedule": "음악315(목7,8,9)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "음악315"
      }
    ],
    "sourceSchedule": "음악315(목7,8,9)"
  },
  {
    "id": "11034-009-2000658",
    "subjectKey": "11034",
    "name": "글로벌교양6(대중문화속의클래식)",
    "division": "009",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박진아",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "음악315",
    "isOnline": false,
    "source": {
      "schedule": "음악315(금5,6,7)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악315"
      }
    ],
    "sourceSchedule": "음악315(금5,6,7)"
  },
  {
    "id": "11035-001-2000658",
    "subjectKey": "11035",
    "name": "글로벌리더십을위한외국어학습방법",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김현진",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합510",
    "isOnline": false,
    "source": {
      "schedule": "종합510(금4,5,6)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합510"
      }
    ],
    "sourceSchedule": "종합510(금4,5,6)"
  },
  {
    "id": "11038-001-2000658",
    "subjectKey": "11038",
    "name": "다이어트와체형관리",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "엄정인",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합608",
    "isOnline": false,
    "source": {
      "schedule": "종합608(화7,8,9)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합608"
      }
    ],
    "sourceSchedule": "종합608(화7,8,9)"
  },
  {
    "id": "11046-001-2000658",
    "subjectKey": "11046",
    "name": "디지털사회의마케팅",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박성모",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경101",
    "isOnline": false,
    "source": {
      "schedule": "글경101(화1,2,3)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경101"
      }
    ],
    "sourceSchedule": "글경101(화1,2,3)"
  },
  {
    "id": "11046-002-2000658",
    "subjectKey": "11046",
    "name": "디지털사회의마케팅",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박성모",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경101",
    "isOnline": false,
    "source": {
      "schedule": "글경101(화4,5,6)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경101"
      }
    ],
    "sourceSchedule": "글경101(화4,5,6)"
  },
  {
    "id": "11051-001-2000658",
    "subjectKey": "11051",
    "name": "무대예술의이해와감상",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이은경",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합507",
    "isOnline": false,
    "source": {
      "schedule": "종합507(월4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합507"
      }
    ],
    "sourceSchedule": "종합507(월4,5,6)"
  },
  {
    "id": "11052-001-2000658",
    "subjectKey": "11052",
    "name": "문학철학의이해",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이주향",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합506",
    "isOnline": false,
    "source": {
      "schedule": "종합506(화4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합506"
      }
    ],
    "sourceSchedule": "종합506(화4,5,6)"
  },
  {
    "id": "11062-001-2000658",
    "subjectKey": "11062",
    "name": "산업사회의이해(3,4학년 대상)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "조유호",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합305",
    "isOnline": false,
    "source": {
      "schedule": "종합305(화1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합305"
      }
    ],
    "sourceSchedule": "종합305(화1,2,3)"
  },
  {
    "id": "11062-002-2000658",
    "subjectKey": "11062",
    "name": "산업사회의이해(3,4학년 대상)",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "조유호",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합305",
    "isOnline": false,
    "source": {
      "schedule": "종합305(화4,5,6)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합305"
      }
    ],
    "sourceSchedule": "종합305(화4,5,6)"
  },
  {
    "id": "11062-003-2000658",
    "subjectKey": "11062",
    "name": "산업사회의이해(3,4학년 대상)",
    "division": "003",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "조유호",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합305",
    "isOnline": false,
    "source": {
      "schedule": "종합305(목4,5,6)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합305"
      }
    ],
    "sourceSchedule": "종합305(목4,5,6)"
  },
  {
    "id": "11065-001-2000658",
    "subjectKey": "11065",
    "name": "생애주기건강관리",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이승주",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "체육117",
    "isOnline": false,
    "source": {
      "schedule": "체육117(화5,6,7)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "체육117"
      }
    ],
    "sourceSchedule": "체육117(화5,6,7)"
  },
  {
    "id": "11066-001-2000658",
    "subjectKey": "11066",
    "name": "생활속의과학원리(마이크로디그리)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김충섭",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래110",
    "isOnline": false,
    "source": {
      "schedule": "미래110(목4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래110"
      }
    ],
    "sourceSchedule": "미래110(목4,5,6)"
  },
  {
    "id": "11067-002-2000739",
    "subjectKey": "11067",
    "name": "설득커뮤니케이션",
    "division": "002",
    "department": "한국언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조정미",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문508",
    "isOnline": false,
    "source": {
      "schedule": "인문508(수5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문508"
      }
    ],
    "sourceSchedule": "인문508(수5,6,7)"
  },
  {
    "id": "11067-002-2000763",
    "subjectKey": "11067",
    "name": "설득커뮤니케이션",
    "division": "002",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조정미",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문508",
    "isOnline": false,
    "source": {
      "schedule": "인문508(수5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문508"
      }
    ],
    "sourceSchedule": "인문508(수5,6,7)"
  },
  {
    "id": "11068-001-2000658",
    "subjectKey": "11068",
    "name": "세계연극이야기",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "남승연",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합507",
    "isOnline": false,
    "source": {
      "schedule": "종합507(월1,2,3)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합507"
      }
    ],
    "sourceSchedule": "종합507(월1,2,3)"
  },
  {
    "id": "11069-001-2000658",
    "subjectKey": "11069",
    "name": "세계영화이야기",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이수길",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래110",
    "isOnline": false,
    "source": {
      "schedule": "미래110(금4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래110"
      }
    ],
    "sourceSchedule": "미래110(금4,5,6)"
  },
  {
    "id": "11071-001-2000658",
    "subjectKey": "11071",
    "name": "세계의축제와여행",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김승준",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경701",
    "isOnline": false,
    "source": {
      "schedule": "글경701(월4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경701"
      }
    ],
    "sourceSchedule": "글경701(월4,5,6)"
  },
  {
    "id": "11072-001-2000658",
    "subjectKey": "11072",
    "name": "세계차(tea)산업의이해",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "오사다사치코",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "생활101",
    "isOnline": false,
    "source": {
      "schedule": "생활101(화1,2,3)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "생활101"
      }
    ],
    "sourceSchedule": "생활101(화1,2,3)"
  },
  {
    "id": "11072-002-2000658",
    "subjectKey": "11072",
    "name": "세계차(tea)산업의이해",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "오사다사치코",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "생활101",
    "isOnline": false,
    "source": {
      "schedule": "생활101(화4,5,6)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "생활101"
      }
    ],
    "sourceSchedule": "생활101(화4,5,6)"
  },
  {
    "id": "11076-001-2000658",
    "subjectKey": "11076",
    "name": "시베리아횡단열차와도시(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박승찬",
    "days": [
      "목",
      "토"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "인문407",
    "isOnline": true,
    "source": {
      "schedule": "인문407(목1 토7,8)"
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1
        ],
        "classroom": "인문407"
      },
      {
        "day": "토",
        "periods": [
          7,
          8
        ],
        "classroom": "인문407"
      }
    ],
    "sourceSchedule": "인문407(목1 토7,8)"
  },
  {
    "id": "11079-001-2000658",
    "subjectKey": "11079",
    "name": "식생활과영양",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "서정연",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합308",
    "isOnline": false,
    "source": {
      "schedule": "종합308(월7,8,9)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합308"
      }
    ],
    "sourceSchedule": "종합308(월7,8,9)"
  },
  {
    "id": "11080-001-2000658",
    "subjectKey": "11080",
    "name": "신화와철학",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이주향",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합506",
    "isOnline": false,
    "source": {
      "schedule": "종합506(월4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합506"
      }
    ],
    "sourceSchedule": "종합506(월4,5,6)"
  },
  {
    "id": "11081-001-2000658",
    "subjectKey": "11081",
    "name": "신화의이해",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김동섭",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합307",
    "isOnline": false,
    "source": {
      "schedule": "종합307(화4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합307"
      }
    ],
    "sourceSchedule": "종합307(화4,5,6)"
  },
  {
    "id": "11082-001-2000658",
    "subjectKey": "11082",
    "name": "실용음악과공연예술(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "배준",
    "days": [
      "금",
      "토"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "음악315",
    "isOnline": true,
    "source": {
      "schedule": "음악315(금1 토7,8)"
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1
        ],
        "classroom": "음악315"
      },
      {
        "day": "토",
        "periods": [
          7,
          8
        ],
        "classroom": "음악315"
      }
    ],
    "sourceSchedule": "음악315(금1 토7,8)"
  },
  {
    "id": "11084-001-2000658",
    "subjectKey": "11084",
    "name": "아이디어와발명",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김남국",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래110",
    "isOnline": false,
    "source": {
      "schedule": "미래110(수4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래110"
      }
    ],
    "sourceSchedule": "미래110(수4,5,6)"
  },
  {
    "id": "11087-001-2000658",
    "subjectKey": "11087",
    "name": "여성과법률",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "류여해",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합507",
    "isOnline": false,
    "source": {
      "schedule": "종합507(화1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합507"
      }
    ],
    "sourceSchedule": "종합507(화1,2,3)"
  },
  {
    "id": "11090-001-2000658",
    "subjectKey": "11090",
    "name": "영화와여성이미지(마이크로디그리)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박소연",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(목6,7,8)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(목6,7,8)"
  },
  {
    "id": "11095-001-2000658",
    "subjectKey": "11095",
    "name": "우리연극이야기",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "남승연",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합608",
    "isOnline": false,
    "source": {
      "schedule": "종합608(월4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합608"
      }
    ],
    "sourceSchedule": "종합608(월4,5,6)"
  },
  {
    "id": "11099-001-2000658",
    "subjectKey": "11099",
    "name": "응급처치와안전",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "조수연",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "체육118",
    "isOnline": false,
    "source": {
      "schedule": "체육118(월5,6,7)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "체육118"
      }
    ],
    "sourceSchedule": "체육118(월5,6,7)"
  },
  {
    "id": "11103-001-2000658",
    "subjectKey": "11103",
    "name": "인공지능개념과원리",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이철규",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래312",
    "isOnline": false,
    "source": {
      "schedule": "미래312(화4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래312"
      }
    ],
    "sourceSchedule": "미래312(화4,5,6)"
  },
  {
    "id": "11104-001-2000658",
    "subjectKey": "11104",
    "name": "일본사회의이해",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김선희",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문507",
    "isOnline": false,
    "source": {
      "schedule": "인문507(월4,5,6)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문507"
      }
    ],
    "sourceSchedule": "인문507(월4,5,6)"
  },
  {
    "id": "11107-001-2000658",
    "subjectKey": "11107",
    "name": "재난의과학적이해(마이크로디그리)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김영출",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(화7,8,9)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(화7,8,9)"
  },
  {
    "id": "11112-001-2000658",
    "subjectKey": "11112",
    "name": "조직속의심리학",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "소원근",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경607",
    "isOnline": false,
    "source": {
      "schedule": "글경607(월4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경607"
      }
    ],
    "sourceSchedule": "글경607(월4,5,6)"
  },
  {
    "id": "11112-002-2000658",
    "subjectKey": "11112",
    "name": "조직속의심리학",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "소원근",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경B101",
    "isOnline": false,
    "source": {
      "schedule": "글경B101(화4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경B101"
      }
    ],
    "sourceSchedule": "글경B101(화4,5,6)"
  },
  {
    "id": "11112-003-2000658",
    "subjectKey": "11112",
    "name": "조직속의심리학",
    "division": "003",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "소원근",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경603",
    "isOnline": false,
    "source": {
      "schedule": "글경603(목1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경603"
      }
    ],
    "sourceSchedule": "글경603(목1,2,3)"
  },
  {
    "id": "11114-001-2000658",
    "subjectKey": "11114",
    "name": "지성인의자아혁신과리더쉽",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이정헌",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래319",
    "isOnline": false,
    "source": {
      "schedule": "미래319(월4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래319"
      }
    ],
    "sourceSchedule": "미래319(월4,5,6)"
  },
  {
    "id": "11115-001-2000658",
    "subjectKey": "11115",
    "name": "지역사회와봉사(인문사회융합대학, 경영공학대학)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 2,
    "professor": "김현",
    "days": [
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "종합305",
    "isOnline": false,
    "source": {
      "schedule": "종합305(금7,8)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "종합305"
      }
    ],
    "sourceSchedule": "종합305(금7,8)"
  },
  {
    "id": "11115-002-2000658",
    "subjectKey": "11115",
    "name": "지역사회와봉사(혁신공과대학, 지능형SW융합대학)",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 2,
    "professor": "유도근",
    "days": [
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "종합305",
    "isOnline": false,
    "source": {
      "schedule": "종합305(금7,8)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "종합305"
      }
    ],
    "sourceSchedule": "종합305(금7,8)"
  },
  {
    "id": "11115-003-2000658",
    "subjectKey": "11115",
    "name": "지역사회와봉사(라이프케어사이언스대학, 음악테크놀로지대학)",
    "division": "003",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 2,
    "professor": "고선주",
    "days": [
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "종합305",
    "isOnline": false,
    "source": {
      "schedule": "종합305(금7,8)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "종합305"
      }
    ],
    "sourceSchedule": "종합305(금7,8)"
  },
  {
    "id": "11115-005-2000658",
    "subjectKey": "11115",
    "name": "지역사회와봉사",
    "division": "005",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 2,
    "professor": "국제협력처",
    "days": [
      "월"
    ],
    "startPeriod": 11,
    "endPeriod": 12,
    "room": "종합209",
    "isOnline": false,
    "source": {
      "schedule": "종합209(월11,12)"
    },
    "capacity": null,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          11,
          12
        ],
        "classroom": "종합209"
      }
    ],
    "sourceSchedule": "종합209(월11,12)"
  },
  {
    "id": "11116-001-2000658",
    "subjectKey": "11116",
    "name": "창업마케팅",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "최종학",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B201",
    "isOnline": false,
    "source": {
      "schedule": "미래B201(화4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B201"
      }
    ],
    "sourceSchedule": "미래B201(화4,5,6)"
  },
  {
    "id": "11116-002-2000658",
    "subjectKey": "11116",
    "name": "창업마케팅",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "최종학",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B201",
    "isOnline": false,
    "source": {
      "schedule": "미래B201(수4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B201"
      }
    ],
    "sourceSchedule": "미래B201(수4,5,6)"
  },
  {
    "id": "11127-001-2000658",
    "subjectKey": "11127",
    "name": "한국영화로보는세상",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박소연",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래110",
    "isOnline": false,
    "source": {
      "schedule": "미래110(목1,2,3)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래110"
      }
    ],
    "sourceSchedule": "미래110(목1,2,3)"
  },
  {
    "id": "11128-001-2000658",
    "subjectKey": "11128",
    "name": "한국행정의이해",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박창화",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B103",
    "isOnline": false,
    "source": {
      "schedule": "미래B103(수4,5,6)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B103"
      }
    ],
    "sourceSchedule": "미래B103(수4,5,6)"
  },
  {
    "id": "11132-001-2000658",
    "subjectKey": "11132",
    "name": "현대생활과스포츠",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "허갑철",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "체육118",
    "isOnline": false,
    "source": {
      "schedule": "체육118(수1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "체육118"
      }
    ],
    "sourceSchedule": "체육118(수1,2,3)"
  },
  {
    "id": "11132-002-2000658",
    "subjectKey": "11132",
    "name": "현대생활과스포츠",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김태형",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "체육118",
    "isOnline": false,
    "source": {
      "schedule": "체육118(목1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "체육118"
      }
    ],
    "sourceSchedule": "체육118(목1,2,3)"
  },
  {
    "id": "11135-001-2000658",
    "subjectKey": "11135",
    "name": "현대중국사회의이해",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이화자",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합308",
    "isOnline": false,
    "source": {
      "schedule": "종합308(수4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합308"
      }
    ],
    "sourceSchedule": "종합308(수4,5,6)"
  },
  {
    "id": "11141-001-2000642",
    "subjectKey": "11141",
    "name": "생활속의고분자",
    "division": "001",
    "department": "신소재공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "장건수",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래315",
    "isOnline": false,
    "source": {
      "schedule": "미래315(화5,6),미래319(수7)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미래315"
      },
      {
        "day": "수",
        "periods": [
          7
        ],
        "classroom": "미래319"
      }
    ],
    "sourceSchedule": "미래315(화5,6),미래319(수7)"
  },
  {
    "id": "11141-001-2000763",
    "subjectKey": "11141",
    "name": "생활속의고분자",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "장건수",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래315",
    "isOnline": false,
    "source": {
      "schedule": "미래315(화5,6),미래319(수7)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미래315"
      },
      {
        "day": "수",
        "periods": [
          7
        ],
        "classroom": "미래319"
      }
    ],
    "sourceSchedule": "미래315(화5,6),미래319(수7)"
  },
  {
    "id": "11143-001-2000745",
    "subjectKey": "11143",
    "name": "경찰행정학",
    "division": "001",
    "department": "행정학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "장다흰",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문409",
    "isOnline": false,
    "source": {
      "schedule": "인문409(수2,3,4)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문409"
      }
    ],
    "sourceSchedule": "인문409(수2,3,4)"
  },
  {
    "id": "11144-001-2000642",
    "subjectKey": "11144",
    "name": "고분자표면및계면",
    "division": "001",
    "department": "신소재공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박준수",
    "days": [
      "목",
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "종합403",
    "isOnline": false,
    "source": {
      "schedule": "종합403(목1),종합507(화1,2)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1
        ],
        "classroom": "종합403"
      },
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "종합507"
      }
    ],
    "sourceSchedule": "종합403(목1),종합507(화1,2)"
  },
  {
    "id": "11146-001-2000445",
    "subjectKey": "11146",
    "name": "바이오신소재",
    "division": "001",
    "department": "신소재공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정대원",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "자연관407",
    "isOnline": false,
    "source": {
      "schedule": "자연관407(목5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "자연관407"
      }
    ],
    "sourceSchedule": "자연관407(목5,6,7)"
  },
  {
    "id": "11159-001-2000658",
    "subjectKey": "11159",
    "name": "기술사업화이해",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김창회",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래319",
    "isOnline": false,
    "source": {
      "schedule": "미래319(수4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래319"
      }
    ],
    "sourceSchedule": "미래319(수4,5,6)"
  },
  {
    "id": "11160-001-2000658",
    "subjectKey": "11160",
    "name": "허브식물학(마이크로디그리)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "오사다사치코",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "생활101",
    "isOnline": false,
    "source": {
      "schedule": "생활101(수1,2,3)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "생활101"
      }
    ],
    "sourceSchedule": "생활101(수1,2,3)"
  },
  {
    "id": "11160-002-2000658",
    "subjectKey": "11160",
    "name": "허브식물학(마이크로디그리)",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "오사다사치코",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "생활101",
    "isOnline": false,
    "source": {
      "schedule": "생활101(수4,5,6)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "생활101"
      }
    ],
    "sourceSchedule": "생활101(수4,5,6)"
  },
  {
    "id": "11161-001-2000658",
    "subjectKey": "11161",
    "name": "레저스포츠의이해와실제",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이승환",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "체육117",
    "isOnline": false,
    "source": {
      "schedule": "체육117(목5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "체육117"
      }
    ],
    "sourceSchedule": "체육117(목5,6,7)"
  },
  {
    "id": "11161-002-2000658",
    "subjectKey": "11161",
    "name": "레저스포츠의이해와실제",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "양홍위",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "체육118",
    "isOnline": false,
    "source": {
      "schedule": "체육118(수5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "체육118"
      }
    ],
    "sourceSchedule": "체육118(수5,6,7)"
  },
  {
    "id": "11163-001-2000658",
    "subjectKey": "11163",
    "name": "문화컨텐츠산업의이해",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박미경",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B103",
    "isOnline": false,
    "source": {
      "schedule": "미래B103(화1,2,3)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B103"
      }
    ],
    "sourceSchedule": "미래B103(화1,2,3)"
  },
  {
    "id": "11171-001-2000658",
    "subjectKey": "11171",
    "name": "안전및조직관리사례연구",
    "division": "001",
    "department": "교양",
    "category": "일반선택",
    "sourceCategory": "RT",
    "credit": 3,
    "professor": "학군단",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "국제101",
    "isOnline": false,
    "source": {
      "schedule": "국제101(화7,8 금1,2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "국제101"
      },
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "국제101"
      }
    ],
    "sourceSchedule": "국제101(화7,8 금1,2,3,4)"
  },
  {
    "id": "11171-002-2000658",
    "subjectKey": "11171",
    "name": "안전및조직관리사례연구",
    "division": "002",
    "department": "교양",
    "category": "일반선택",
    "sourceCategory": "RT",
    "credit": 3,
    "professor": "학군단",
    "days": [
      "목",
      "금"
    ],
    "startPeriod": 9,
    "endPeriod": 10,
    "room": "국제101",
    "isOnline": false,
    "source": {
      "schedule": "국제101(목9,10 금9,10,11,12)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          9,
          10
        ],
        "classroom": "국제101"
      },
      {
        "day": "금",
        "periods": [
          9,
          10,
          11,
          12
        ],
        "classroom": "국제101"
      }
    ],
    "sourceSchedule": "국제101(목9,10 금9,10,11,12)"
  },
  {
    "id": "11173-001-2000286",
    "subjectKey": "11173",
    "name": "조직리더십사례연구",
    "division": "001",
    "department": "교양",
    "category": "일반선택",
    "sourceCategory": "RT",
    "credit": 3,
    "professor": "학군단",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "국제102",
    "isOnline": false,
    "source": {
      "schedule": "국제102(화7,8 금1,2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "국제102"
      },
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "국제102"
      }
    ],
    "sourceSchedule": "국제102(화7,8 금1,2,3,4)"
  },
  {
    "id": "11173-002-2000286",
    "subjectKey": "11173",
    "name": "조직리더십사례연구",
    "division": "002",
    "department": "교양",
    "category": "일반선택",
    "sourceCategory": "RT",
    "credit": 3,
    "professor": "학군단",
    "days": [
      "목",
      "금"
    ],
    "startPeriod": 9,
    "endPeriod": 10,
    "room": "국제102",
    "isOnline": false,
    "source": {
      "schedule": "국제102(목9,10 금9,10,11,12)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          9,
          10
        ],
        "classroom": "국제102"
      },
      {
        "day": "금",
        "periods": [
          9,
          10,
          11,
          12
        ],
        "classroom": "국제102"
      }
    ],
    "sourceSchedule": "국제102(목9,10 금9,10,11,12)"
  },
  {
    "id": "11180-001-2000658",
    "subjectKey": "11180",
    "name": "창의적콘텐츠와명품브랜딩론",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이정헌",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래319",
    "isOnline": false,
    "source": {
      "schedule": "미래319(금4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래319"
      }
    ],
    "sourceSchedule": "미래319(금4,5,6)"
  },
  {
    "id": "11208-001-2000658",
    "subjectKey": "11208",
    "name": "ALL that English Basic(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 230,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11208-002-2000658",
    "subjectKey": "11208",
    "name": "ALL that English Basic(군-이러닝)",
    "division": "002",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11209-001-2000658",
    "subjectKey": "11209",
    "name": "ALL that English1(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11210-001-2000658",
    "subjectKey": "11210",
    "name": "ALL that English Speaking1(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11211-001-2000658",
    "subjectKey": "11211",
    "name": "ALL that English2(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11212-001-2000658",
    "subjectKey": "11212",
    "name": "ALL that English3(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11213-001-2000658",
    "subjectKey": "11213",
    "name": "ALL that English Speaking2(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11214-001-2000658",
    "subjectKey": "11214",
    "name": "MOS2(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11214-002-2000658",
    "subjectKey": "11214",
    "name": "MOS2(군-이러닝)",
    "division": "002",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11216-001-2000658",
    "subjectKey": "11216",
    "name": "Google G-Suite활용과 이해(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 250,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11218-001-2000658",
    "subjectKey": "11218",
    "name": "클라우드컴퓨팅의이해",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "송재숙",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "미래109",
    "isOnline": false,
    "source": {
      "schedule": "미래109(금2,3,4)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "미래109"
      }
    ],
    "sourceSchedule": "미래109(금2,3,4)"
  },
  {
    "id": "11221-001-2000658",
    "subjectKey": "11221",
    "name": "4차산업혁명과미래(마이크로디그리)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "윤영석",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합609",
    "isOnline": false,
    "source": {
      "schedule": "종합609(화1,2,3)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합609"
      }
    ],
    "sourceSchedule": "종합609(화1,2,3)"
  },
  {
    "id": "11223-001-2000653",
    "subjectKey": "11223",
    "name": "Digital Design3(마이크로디그리)",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "조윤희",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술213-1",
    "isOnline": false,
    "source": {
      "schedule": "미술213-1(화1,2,3,4)"
    },
    "capacity": 26,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술213-1"
      }
    ],
    "sourceSchedule": "미술213-1(화1,2,3,4)"
  },
  {
    "id": "11223-002-2000653",
    "subjectKey": "11223",
    "name": "Digital Design3(마이크로디그리)",
    "division": "002",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "전성재",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "생활108",
    "isOnline": false,
    "source": {
      "schedule": "생활108(수1,2,3,4)"
    },
    "capacity": 24,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "생활108"
      }
    ],
    "sourceSchedule": "생활108(수1,2,3,4)"
  },
  {
    "id": "11223-003-2000653",
    "subjectKey": "11223",
    "name": "Digital Design3(마이크로디그리)",
    "division": "003",
    "department": "커뮤니케이션디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박세준",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술208",
    "isOnline": false,
    "source": {
      "schedule": "미술208(월1,2,3,4)"
    },
    "capacity": 24,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술208"
      }
    ],
    "sourceSchedule": "미술208(월1,2,3,4)"
  },
  {
    "id": "11225-001-2000517",
    "subjectKey": "11225",
    "name": "IoT보안",
    "division": "001",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "전상훈",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT215",
    "isOnline": false,
    "source": {
      "schedule": "IT215(월2,3,4)"
    },
    "capacity": 10,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT215"
      }
    ],
    "sourceSchedule": "IT215(월2,3,4)"
  },
  {
    "id": "11228-001-2000658",
    "subjectKey": "11228",
    "name": "JAVA프로그래밍입문",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이철규",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래311",
    "isOnline": false,
    "source": {
      "schedule": "미래311(화1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래311"
      }
    ],
    "sourceSchedule": "미래311(화1,2,3)"
  },
  {
    "id": "11232-001-2000652",
    "subjectKey": "11232",
    "name": "Photography2",
    "division": "001",
    "department": "조소",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "성지연",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술202",
    "isOnline": false,
    "source": {
      "schedule": "미술202(화1,2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술202"
      }
    ],
    "sourceSchedule": "미술202(화1,2,3,4)"
  },
  {
    "id": "11237-001-2000615",
    "subjectKey": "11237",
    "name": "VR3D드로잉",
    "division": "001",
    "department": "디지털콘텐츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "심유미",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "미래119",
    "isOnline": false,
    "source": {
      "schedule": "미래119(화2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "미래119"
      }
    ],
    "sourceSchedule": "미래119(화2,3,4)"
  },
  {
    "id": "11240-001-2000606",
    "subjectKey": "11240",
    "name": "가곡앙상블2",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "이명국",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(목2,3)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(목2,3)"
  },
  {
    "id": "11241-001-2000636",
    "subjectKey": "11241",
    "name": "건물유틸리티및방재시스템",
    "division": "001",
    "department": "건축학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정창호",
    "days": [
      "월",
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "자연대B106",
    "isOnline": false,
    "source": {
      "schedule": "자연대B106(월5,6),종합410(금2)"
    },
    "capacity": 35,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "자연대B106"
      },
      {
        "day": "금",
        "periods": [
          2
        ],
        "classroom": "종합410"
      }
    ],
    "sourceSchedule": "자연대B106(월5,6),종합410(금2)"
  },
  {
    "id": "11243-001-2000414",
    "subjectKey": "11243",
    "name": "건축환경성능평가방법론",
    "division": "001",
    "department": "건축학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정창호",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "자연대B103",
    "isOnline": false,
    "source": {
      "schedule": "자연대B103(수6,7),2공학313(목2)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7
        ],
        "classroom": "자연대B103"
      },
      {
        "day": "목",
        "periods": [
          2
        ],
        "classroom": "2공학313"
      }
    ],
    "sourceSchedule": "자연대B103(수6,7),2공학313(목2)"
  },
  {
    "id": "11246-001-2000609",
    "subjectKey": "11246",
    "name": "경서도소리2",
    "division": "001",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "최정아",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "음악217",
    "isOnline": false,
    "source": {
      "schedule": "음악217(월4,5)"
    },
    "capacity": 5,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5
        ],
        "classroom": "음악217"
      }
    ],
    "sourceSchedule": "음악217(월4,5)"
  },
  {
    "id": "11248-001-2000585",
    "subjectKey": "11248",
    "name": "경제빅데이터입문",
    "division": "001",
    "department": "경제학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이상엽",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "글경503",
    "isOnline": false,
    "source": {
      "schedule": "글경503(화6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "글경503"
      }
    ],
    "sourceSchedule": "글경503(화6,7,8)"
  },
  {
    "id": "11255-001-2000631",
    "subjectKey": "11255",
    "name": "관광빅데이터분석론",
    "division": "001",
    "department": "관광경영",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "허경석",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "글경407",
    "isOnline": false,
    "source": {
      "schedule": "글경407(화6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "글경407"
      }
    ],
    "sourceSchedule": "글경407(화6,7,8)"
  },
  {
    "id": "11256-001-2000631",
    "subjectKey": "11256",
    "name": "관광서비스마케팅",
    "division": "001",
    "department": "관광경영",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김병용",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경703",
    "isOnline": false,
    "source": {
      "schedule": "글경703(월1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경703"
      }
    ],
    "sourceSchedule": "글경703(월1,2,3)"
  },
  {
    "id": "11259-001-2000615",
    "subjectKey": "11259",
    "name": "광고프로덕션",
    "division": "001",
    "department": "디지털콘텐츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "도정윤",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래115",
    "isOnline": false,
    "source": {
      "schedule": "미래115(화6,7,8)"
    },
    "capacity": 25,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래115"
      }
    ],
    "sourceSchedule": "미래115(화6,7,8)"
  },
  {
    "id": "11264-001-2000503",
    "subjectKey": "11264",
    "name": "금융빅데이터분석",
    "division": "001",
    "department": "경제금융",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "왕두균",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경501",
    "isOnline": false,
    "source": {
      "schedule": "글경501(화1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경501"
      }
    ],
    "sourceSchedule": "글경501(화1,2,3)"
  },
  {
    "id": "11267-001-2000608",
    "subjectKey": "11267",
    "name": "기악교수법2",
    "division": "001",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "박가경",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악105",
    "isOnline": false,
    "source": {
      "schedule": "음악105(화3,4)"
    },
    "capacity": 25,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "음악105"
      }
    ],
    "sourceSchedule": "음악105(화3,4)"
  },
  {
    "id": "11275-001-2000658",
    "subjectKey": "11275",
    "name": "데이터베이스언어SQL입문",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "장철",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래311",
    "isOnline": false,
    "source": {
      "schedule": "미래311(목1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래311"
      }
    ],
    "sourceSchedule": "미래311(목1,2,3)"
  },
  {
    "id": "11277-001-2000440",
    "subjectKey": "11277",
    "name": "독립프로젝트2",
    "division": "001",
    "department": "영화영상",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "이정현",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "복지202",
    "isOnline": false,
    "source": {
      "schedule": "복지202(화2,3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "복지202"
      }
    ],
    "sourceSchedule": "복지202(화2,3)"
  },
  {
    "id": "11281-001-2000590",
    "subjectKey": "11281",
    "name": "디자인이해2(마이크로디그리)",
    "division": "001",
    "department": "건축도시부동산학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 4,
    "professor": "권경남",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 7,
    "room": "2공학304",
    "isOnline": false,
    "source": {
      "schedule": "2공학304(금1,2,3,5,6,7)"
    },
    "capacity": 9,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          5,
          6,
          7
        ],
        "classroom": "2공학304"
      }
    ],
    "sourceSchedule": "2공학304(금1,2,3,5,6,7)"
  },
  {
    "id": "11281-001-2000763",
    "subjectKey": "11281",
    "name": "디자인이해2",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 4,
    "professor": "권경남",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 7,
    "room": "2공학304",
    "isOnline": false,
    "source": {
      "schedule": "2공학304(금1,2,3,5,6,7)"
    },
    "capacity": 9,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          5,
          6,
          7
        ],
        "classroom": "2공학304"
      }
    ],
    "sourceSchedule": "2공학304(금1,2,3,5,6,7)"
  },
  {
    "id": "11281-002-2000590",
    "subjectKey": "11281",
    "name": "디자인이해2(마이크로디그리)",
    "division": "002",
    "department": "건축도시부동산학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 4,
    "professor": "김유라",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 7,
    "room": "2공학206",
    "isOnline": false,
    "source": {
      "schedule": "2공학206(금1,2,3,5,6,7)"
    },
    "capacity": 9,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          5,
          6,
          7
        ],
        "classroom": "2공학206"
      }
    ],
    "sourceSchedule": "2공학206(금1,2,3,5,6,7)"
  },
  {
    "id": "11281-002-2000763",
    "subjectKey": "11281",
    "name": "디자인이해2",
    "division": "002",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 4,
    "professor": "김유라",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 7,
    "room": "2공학206",
    "isOnline": false,
    "source": {
      "schedule": "2공학206(금1,2,3,5,6,7)"
    },
    "capacity": 9,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          5,
          6,
          7
        ],
        "classroom": "2공학206"
      }
    ],
    "sourceSchedule": "2공학206(금1,2,3,5,6,7)"
  },
  {
    "id": "11284-001-2000613",
    "subjectKey": "11284",
    "name": "디지털시각효과2",
    "division": "001",
    "department": "영화예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정주호",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "생활108",
    "isOnline": false,
    "source": {
      "schedule": "생활108(화6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "생활108"
      }
    ],
    "sourceSchedule": "생활108(화6,7,8)"
  },
  {
    "id": "11288-001-2000595",
    "subjectKey": "11288",
    "name": "딥러닝2",
    "division": "001",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "한경훈",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "글경315",
    "isOnline": false,
    "source": {
      "schedule": "글경315(월4,5 화3)"
    },
    "capacity": 56,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5
        ],
        "classroom": "글경315"
      },
      {
        "day": "화",
        "periods": [
          3
        ],
        "classroom": "글경315"
      }
    ],
    "sourceSchedule": "글경315(월4,5 화3)"
  },
  {
    "id": "11289-001-2000658",
    "subjectKey": "11289",
    "name": "라켓스포츠의이론과실제(테니스)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "유정인",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "체육113",
    "isOnline": false,
    "source": {
      "schedule": "체육113(화1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "체육113"
      }
    ],
    "sourceSchedule": "체육113(화1,2,3)"
  },
  {
    "id": "11292-002-2000418",
    "subjectKey": "11292",
    "name": "로봇공학",
    "division": "002",
    "department": "기계공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "임동원",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "자연관309",
    "isOnline": false,
    "source": {
      "schedule": "자연관309(월6,7 화6)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "자연관309"
      },
      {
        "day": "화",
        "periods": [
          6
        ],
        "classroom": "자연관309"
      }
    ],
    "sourceSchedule": "자연관309(월6,7 화6)"
  },
  {
    "id": "11301-001-2000614",
    "subjectKey": "11301",
    "name": "무대미술입문실습",
    "division": "001",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "손정은",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "복지B109-1",
    "isOnline": false,
    "source": {
      "schedule": "복지B109-1(월2,3)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "복지B109-1"
      }
    ],
    "sourceSchedule": "복지B109-1(월2,3)"
  },
  {
    "id": "11302-001-2000614",
    "subjectKey": "11302",
    "name": "무대미술제작",
    "division": "001",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "경은주",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "복지B109-1",
    "isOnline": false,
    "source": {
      "schedule": "복지B109-1(화7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "복지B109-1"
      }
    ],
    "sourceSchedule": "복지B109-1(화7,8,9)"
  },
  {
    "id": "11302-002-2000614",
    "subjectKey": "11302",
    "name": "무대미술제작",
    "division": "002",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "손정은",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "복지B109-1",
    "isOnline": false,
    "source": {
      "schedule": "복지B109-1(수7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "복지B109-1"
      }
    ],
    "sourceSchedule": "복지B109-1(수7,8,9)"
  },
  {
    "id": "11304-001-2000658",
    "subjectKey": "11304",
    "name": "문화기술과디지털콘텐츠",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김상임",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합507",
    "isOnline": false,
    "source": {
      "schedule": "종합507(수1,2,3)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합507"
      }
    ],
    "sourceSchedule": "종합507(수1,2,3)"
  },
  {
    "id": "11308-001-2000264",
    "subjectKey": "11308",
    "name": "문화예술창업론",
    "division": "001",
    "department": "작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김진환",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(화1,2)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(화1,2)"
  },
  {
    "id": "11308-002-2000265",
    "subjectKey": "11308",
    "name": "문화예술창업론",
    "division": "002",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김진환",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(화1,2)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(화1,2)"
  },
  {
    "id": "11308-003-2000267",
    "subjectKey": "11308",
    "name": "문화예술창업론",
    "division": "003",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김진환",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(화1,2)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(화1,2)"
  },
  {
    "id": "11308-004-2000276",
    "subjectKey": "11308",
    "name": "문화예술창업론",
    "division": "004",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김진환",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(화1,2)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(화1,2)"
  },
  {
    "id": "11308-005-2000277",
    "subjectKey": "11308",
    "name": "문화예술창업론",
    "division": "005",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김진환",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(화1,2)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(화1,2)"
  },
  {
    "id": "11310-001-2000655",
    "subjectKey": "11310",
    "name": "물레성형2",
    "division": "001",
    "department": "공예디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "문다운",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "조형103",
    "isOnline": false,
    "source": {
      "schedule": "조형103(목3,4,5)"
    },
    "capacity": 25,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "조형103"
      }
    ],
    "sourceSchedule": "조형103(목3,4,5)"
  },
  {
    "id": "11312-001-2000658",
    "subjectKey": "11312",
    "name": "미술과인문학",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박규현",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문407",
    "isOnline": false,
    "source": {
      "schedule": "인문407(목7,8,9)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문407"
      }
    ],
    "sourceSchedule": "인문407(목7,8,9)"
  },
  {
    "id": "11315-001-2000658",
    "subjectKey": "11315",
    "name": "발달주기와생애설계",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "강남주",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합307",
    "isOnline": false,
    "source": {
      "schedule": "종합307(화7,8,9)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합307"
      }
    ],
    "sourceSchedule": "종합307(화7,8,9)"
  },
  {
    "id": "11316-001-2000286",
    "subjectKey": "11316",
    "name": "법의사유적접근(학점교류)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11321-001-2000613",
    "subjectKey": "11321",
    "name": "사운드디자인실습2",
    "division": "001",
    "department": "영화예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김민정",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "복지406",
    "isOnline": false,
    "source": {
      "schedule": "복지406(월2,3,4)"
    },
    "capacity": 10,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "복지406"
      }
    ],
    "sourceSchedule": "복지406(월2,3,4)"
  },
  {
    "id": "11324-001-2000658",
    "subjectKey": "11324",
    "name": "생활과금융",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이창우",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경607",
    "isOnline": false,
    "source": {
      "schedule": "글경607(금5,6,7)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경607"
      }
    ],
    "sourceSchedule": "글경607(금5,6,7)"
  },
  {
    "id": "11324-002-2000658",
    "subjectKey": "11324",
    "name": "생활과금융",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김호영",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경607",
    "isOnline": false,
    "source": {
      "schedule": "글경607(목1,2,3)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경607"
      }
    ],
    "sourceSchedule": "글경607(목1,2,3)"
  },
  {
    "id": "11325-001-2000658",
    "subjectKey": "11325",
    "name": "생활구기의이론과실제(축구)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "곽태원",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "체육113",
    "isOnline": false,
    "source": {
      "schedule": "체육113(목5,6,7)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "체육113"
      }
    ],
    "sourceSchedule": "체육113(목5,6,7)"
  },
  {
    "id": "11326-001-2000658",
    "subjectKey": "11326",
    "name": "생활속의경제경영론(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11328-001-2000606",
    "subjectKey": "11328",
    "name": "성악의이해2",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "이승희",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(수7,8)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(수7,8)"
  },
  {
    "id": "11333-001-2000601",
    "subjectKey": "11333",
    "name": "식품위생관계법규",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최윤",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "생활202",
    "isOnline": false,
    "source": {
      "schedule": "생활202(목2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "생활202"
      }
    ],
    "sourceSchedule": "생활202(목2,3,4)"
  },
  {
    "id": "11338-001-2000631",
    "subjectKey": "11338",
    "name": "여행·항공업실무론",
    "division": "001",
    "department": "관광경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조영훈",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경702",
    "isOnline": false,
    "source": {
      "schedule": "글경702(수5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경702"
      }
    ],
    "sourceSchedule": "글경702(수5,6,7)"
  },
  {
    "id": "11339-001-2000658",
    "subjectKey": "11339",
    "name": "여행영어와세계",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "딜런",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합307",
    "isOnline": false,
    "source": {
      "schedule": "종합307(목7,8,9)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합307"
      }
    ],
    "sourceSchedule": "종합307(목7,8,9)"
  },
  {
    "id": "11340-001-2000614",
    "subjectKey": "11340",
    "name": "연극연출실습",
    "division": "001",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "전용환",
    "days": [
      "화"
    ],
    "startPeriod": 10,
    "endPeriod": 12,
    "room": "글경503",
    "isOnline": false,
    "source": {
      "schedule": "글경503(화10,11,12)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          10,
          11,
          12
        ],
        "classroom": "글경503"
      }
    ],
    "sourceSchedule": "글경503(화10,11,12)"
  },
  {
    "id": "11356-001-2000605",
    "subjectKey": "11356",
    "name": "연주와비평4",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "정진호",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악111",
    "isOnline": false,
    "source": {
      "schedule": "음악111(화5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "음악111"
      }
    ],
    "sourceSchedule": "음악111(화5,6)"
  },
  {
    "id": "11357-001-2000608",
    "subjectKey": "11357",
    "name": "연주와비평4(관현악)",
    "division": "001",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "김영은",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악111",
    "isOnline": false,
    "source": {
      "schedule": "음악111(목5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "음악111"
      }
    ],
    "sourceSchedule": "음악111(목5,6)"
  },
  {
    "id": "11358-001-2000609",
    "subjectKey": "11358",
    "name": "연주와비평4(국악)",
    "division": "001",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "박혜진",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악111",
    "isOnline": false,
    "source": {
      "schedule": "음악111(목3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "음악111"
      }
    ],
    "sourceSchedule": "음악111(목3,4)"
  },
  {
    "id": "11359-001-2000606",
    "subjectKey": "11359",
    "name": "연주와비평4(성악)",
    "division": "001",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "이현정",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악111",
    "isOnline": false,
    "source": {
      "schedule": "음악111(수5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "음악111"
      }
    ],
    "sourceSchedule": "음악111(수5,6)"
  },
  {
    "id": "11360-001-2000607",
    "subjectKey": "11360",
    "name": "연주와비평4(피아노)",
    "division": "001",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "공원영",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악111",
    "isOnline": false,
    "source": {
      "schedule": "음악111(화3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "음악111"
      }
    ],
    "sourceSchedule": "음악111(화3,4)"
  },
  {
    "id": "11366-001-2000605",
    "subjectKey": "11366",
    "name": "연주와비평6",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "정진호",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악111",
    "isOnline": false,
    "source": {
      "schedule": "음악111(화5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "음악111"
      }
    ],
    "sourceSchedule": "음악111(화5,6)"
  },
  {
    "id": "11367-001-2000608",
    "subjectKey": "11367",
    "name": "연주와비평6(관현악)",
    "division": "001",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "김영은",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악111",
    "isOnline": false,
    "source": {
      "schedule": "음악111(목5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "음악111"
      }
    ],
    "sourceSchedule": "음악111(목5,6)"
  },
  {
    "id": "11368-001-2000609",
    "subjectKey": "11368",
    "name": "연주와비평6(국악)",
    "division": "001",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "박혜진",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악111",
    "isOnline": false,
    "source": {
      "schedule": "음악111(목3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "음악111"
      }
    ],
    "sourceSchedule": "음악111(목3,4)"
  },
  {
    "id": "11369-001-2000606",
    "subjectKey": "11369",
    "name": "연주와비평6(성악)",
    "division": "001",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "이현정",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악111",
    "isOnline": false,
    "source": {
      "schedule": "음악111(수5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "음악111"
      }
    ],
    "sourceSchedule": "음악111(수5,6)"
  },
  {
    "id": "11370-001-2000607",
    "subjectKey": "11370",
    "name": "연주와비평6(피아노)",
    "division": "001",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "공원영",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악111",
    "isOnline": false,
    "source": {
      "schedule": "음악111(화3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "음악111"
      }
    ],
    "sourceSchedule": "음악111(화3,4)"
  },
  {
    "id": "11371-001-2000277",
    "subjectKey": "11371",
    "name": "연주캡스톤(관현악)",
    "division": "001",
    "department": "관현악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "김영은",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "음악219",
    "isOnline": false,
    "source": {
      "schedule": "음악219(목2)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2
        ],
        "classroom": "음악219"
      }
    ],
    "sourceSchedule": "음악219(목2)"
  },
  {
    "id": "11372-001-2000267",
    "subjectKey": "11372",
    "name": "연주캡스톤(국악)",
    "division": "001",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "박혜진",
    "days": [
      "목"
    ],
    "startPeriod": 9,
    "endPeriod": 9,
    "room": "음악107",
    "isOnline": false,
    "source": {
      "schedule": "음악107(목9)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          9
        ],
        "classroom": "음악107"
      }
    ],
    "sourceSchedule": "음악107(목9)"
  },
  {
    "id": "11373-001-2000265",
    "subjectKey": "11373",
    "name": "연주캡스톤(성악)",
    "division": "001",
    "department": "성악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "이현정",
    "days": [
      "월"
    ],
    "startPeriod": 10,
    "endPeriod": 10,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(월10)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          10
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(월10)"
  },
  {
    "id": "11374-001-2000264",
    "subjectKey": "11374",
    "name": "연주캡스톤(작곡)",
    "division": "001",
    "department": "작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "권지원",
    "days": [
      "월"
    ],
    "startPeriod": 11,
    "endPeriod": 11,
    "room": "음악106",
    "isOnline": false,
    "source": {
      "schedule": "음악106(월11)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          11
        ],
        "classroom": "음악106"
      }
    ],
    "sourceSchedule": "음악106(월11)"
  },
  {
    "id": "11375-001-2000276",
    "subjectKey": "11375",
    "name": "연주캡스톤(피아노)",
    "division": "001",
    "department": "피아노과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "공원영",
    "days": [
      "목"
    ],
    "startPeriod": 9,
    "endPeriod": 9,
    "room": "음악216",
    "isOnline": false,
    "source": {
      "schedule": "음악216(목9)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          9
        ],
        "classroom": "음악216"
      }
    ],
    "sourceSchedule": "음악216(목9)"
  },
  {
    "id": "11376-001-2000615",
    "subjectKey": "11376",
    "name": "영상언어와서사",
    "division": "001",
    "department": "디지털콘텐츠",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "주명진",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래116",
    "isOnline": false,
    "source": {
      "schedule": "미래116(화6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래116"
      }
    ],
    "sourceSchedule": "미래116(화6,7,8)"
  },
  {
    "id": "11377-001-2000658",
    "subjectKey": "11377",
    "name": "영상언어의이해",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "주명진",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래109",
    "isOnline": false,
    "source": {
      "schedule": "미래109(수7,8,9)"
    },
    "capacity": 70,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래109"
      }
    ],
    "sourceSchedule": "미래109(수7,8,9)"
  },
  {
    "id": "11380-001-2000605",
    "subjectKey": "11380",
    "name": "영상음악과사운드디자인4",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김명종",
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악106",
    "isOnline": false,
    "source": {
      "schedule": "음악106(목3,4)"
    },
    "capacity": 15,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "음악106"
      }
    ],
    "sourceSchedule": "음악106(목3,4)"
  },
  {
    "id": "11382-001-2000613",
    "subjectKey": "11382",
    "name": "영화분석세미나",
    "division": "001",
    "department": "영화예술",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김동윤",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경703",
    "isOnline": false,
    "source": {
      "schedule": "글경703(수1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경703"
      }
    ],
    "sourceSchedule": "글경703(수1,2,3)"
  },
  {
    "id": "11385-001-2000613",
    "subjectKey": "11385",
    "name": "영화장르연구",
    "division": "001",
    "department": "영화예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이수길",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "복지305",
    "isOnline": false,
    "source": {
      "schedule": "복지305(월4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "복지305"
      }
    ],
    "sourceSchedule": "복지305(월4,5,6)"
  },
  {
    "id": "11386-001-2000613",
    "subjectKey": "11386",
    "name": "영화제작실습1",
    "division": "001",
    "department": "영화예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김계중",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "복지202",
    "isOnline": false,
    "source": {
      "schedule": "복지202(금6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "복지202"
      }
    ],
    "sourceSchedule": "복지202(금6,7,8)"
  },
  {
    "id": "11386-002-2000613",
    "subjectKey": "11386",
    "name": "영화제작실습1",
    "division": "002",
    "department": "영화예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이상노",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "복지203",
    "isOnline": false,
    "source": {
      "schedule": "복지203(금6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "복지203"
      }
    ],
    "sourceSchedule": "복지203(금6,7,8)"
  },
  {
    "id": "11388-001-2000613",
    "subjectKey": "11388",
    "name": "영화제작실습3",
    "division": "001",
    "department": "영화예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김혜지",
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "복지405",
    "isOnline": false,
    "source": {
      "schedule": "복지405(금3,4,5)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "복지405"
      }
    ],
    "sourceSchedule": "복지405(금3,4,5)"
  },
  {
    "id": "11388-002-2000613",
    "subjectKey": "11388",
    "name": "영화제작실습3",
    "division": "002",
    "department": "영화예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김혜지",
    "days": [
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "복지305",
    "isOnline": false,
    "source": {
      "schedule": "복지305(금7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "복지305"
      }
    ],
    "sourceSchedule": "복지305(금7,8,9)"
  },
  {
    "id": "11390-001-2000440",
    "subjectKey": "11390",
    "name": "영화제작실습5",
    "division": "001",
    "department": "영화영상",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 4,
    "professor": "이승훈",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "복지401",
    "isOnline": false,
    "source": {
      "schedule": "복지401(금5,6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "복지401"
      }
    ],
    "sourceSchedule": "복지401(금5,6,7,8)"
  },
  {
    "id": "11390-002-2000440",
    "subjectKey": "11390",
    "name": "영화제작실습5",
    "division": "002",
    "department": "영화영상",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 4,
    "professor": "이승훈",
    "days": [
      "금"
    ],
    "startPeriod": 9,
    "endPeriod": 12,
    "room": "복지401",
    "isOnline": false,
    "source": {
      "schedule": "복지401(금9,10,11,12)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          9,
          10,
          11,
          12
        ],
        "classroom": "복지401"
      }
    ],
    "sourceSchedule": "복지401(금9,10,11,12)"
  },
  {
    "id": "11395-001-2000256",
    "subjectKey": "11395",
    "name": "우븐스트럭쳐2",
    "division": "001",
    "department": "공예디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "유지은",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미술212",
    "isOnline": false,
    "source": {
      "schedule": "미술212(화1,2,3)"
    },
    "capacity": 25,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미술212"
      }
    ],
    "sourceSchedule": "미술212(화1,2,3)"
  },
  {
    "id": "11397-001-2000614",
    "subjectKey": "11397",
    "name": "움직임2",
    "division": "001",
    "department": "연기예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "박상하",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "복지B106-1",
    "isOnline": false,
    "source": {
      "schedule": "복지B106-1(화1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "복지B106-1"
      }
    ],
    "sourceSchedule": "복지B106-1(화1,2,3)"
  },
  {
    "id": "11398-001-2000647",
    "subjectKey": "11398",
    "name": "웹보안",
    "division": "001",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김대엽",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT306",
    "isOnline": false,
    "source": {
      "schedule": "IT306(목6,7,8)"
    },
    "capacity": 25,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT306"
      }
    ],
    "sourceSchedule": "IT306(목6,7,8)"
  },
  {
    "id": "11398-002-2000647",
    "subjectKey": "11398",
    "name": "웹보안",
    "division": "002",
    "department": "정보보호",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김대엽",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT306",
    "isOnline": false,
    "source": {
      "schedule": "IT306(금6,7,8)"
    },
    "capacity": 25,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT306"
      }
    ],
    "sourceSchedule": "IT306(금6,7,8)"
  },
  {
    "id": "11401-001-2000655",
    "subjectKey": "11401",
    "name": "위빙2",
    "division": "001",
    "department": "공예디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김유림",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미술111",
    "isOnline": false,
    "source": {
      "schedule": "미술111(월6,7,8)"
    },
    "capacity": 25,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미술111"
      }
    ],
    "sourceSchedule": "미술111(월6,7,8)"
  },
  {
    "id": "11402-001-2000515",
    "subjectKey": "11402",
    "name": "융합소프트웨어",
    "division": "001",
    "department": "미디어SW",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정주호",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT309",
    "isOnline": false,
    "source": {
      "schedule": "IT309(화2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT309"
      }
    ],
    "sourceSchedule": "IT309(화2,3,4)"
  },
  {
    "id": "11403-001-2000658",
    "subjectKey": "11403",
    "name": "음식문화로이해하는중국",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "송진영",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합308",
    "isOnline": false,
    "source": {
      "schedule": "종합308(화4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합308"
      }
    ],
    "sourceSchedule": "종합308(화4,5,6)"
  },
  {
    "id": "11405-001-2000276",
    "subjectKey": "11405",
    "name": "음악미디어앙상블2",
    "division": "001",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김수진",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악313",
    "isOnline": false,
    "source": {
      "schedule": "음악313(화3,4)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "음악313"
      }
    ],
    "sourceSchedule": "음악313(화3,4)"
  },
  {
    "id": "11405-002-2000277",
    "subjectKey": "11405",
    "name": "음악미디어앙상블2",
    "division": "002",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김수진",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악313",
    "isOnline": false,
    "source": {
      "schedule": "음악313(화3,4)"
    },
    "capacity": 20,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "음악313"
      }
    ],
    "sourceSchedule": "음악313(화3,4)"
  },
  {
    "id": "11406-001-2000595",
    "subjectKey": "11406",
    "name": "응용통계",
    "division": "001",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김진흠",
    "days": [
      "목",
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "글경203",
    "isOnline": false,
    "source": {
      "schedule": "글경203(목3),글경314(화2,3)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          3
        ],
        "classroom": "글경203"
      },
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "글경314"
      }
    ],
    "sourceSchedule": "글경203(목3),글경314(화2,3)"
  },
  {
    "id": "11412-001-2000609",
    "subjectKey": "11412",
    "name": "전공워크샵2",
    "division": "001",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "지서훤",
    "days": [
      "수"
    ],
    "startPeriod": 8,
    "endPeriod": 9,
    "room": "체육105",
    "isOnline": false,
    "source": {
      "schedule": "체육105(수8,9)"
    },
    "capacity": 15,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          8,
          9
        ],
        "classroom": "체육105"
      }
    ],
    "sourceSchedule": "체육105(수8,9)"
  },
  {
    "id": "11414-001-2000609",
    "subjectKey": "11414",
    "name": "전공워크샵4",
    "division": "001",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "지서훤",
    "days": [
      "수"
    ],
    "startPeriod": 10,
    "endPeriod": 11,
    "room": "체육105",
    "isOnline": false,
    "source": {
      "schedule": "체육105(수10,11)"
    },
    "capacity": 5,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          10,
          11
        ],
        "classroom": "체육105"
      }
    ],
    "sourceSchedule": "체육105(수10,11)"
  },
  {
    "id": "11415-001-2000754",
    "subjectKey": "11415",
    "name": "전공진로세미나1(1-1반)",
    "division": "001",
    "department": "경영공학대학",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "이은곤",
    "days": [
      "목"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "글경401",
    "isOnline": false,
    "source": {
      "schedule": "글경401(목8)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          8
        ],
        "classroom": "글경401"
      }
    ],
    "sourceSchedule": "글경401(목8)"
  },
  {
    "id": "11415-002-2000757",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "002",
    "department": "AI데이터과학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김진흠",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "글경317",
    "isOnline": false,
    "source": {
      "schedule": "글경317(화7)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7
        ],
        "classroom": "글경317"
      }
    ],
    "sourceSchedule": "글경317(화7)"
  },
  {
    "id": "11415-003-2000759",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "003",
    "department": "지능형보안학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김대엽",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "IT106",
    "isOnline": false,
    "source": {
      "schedule": "IT106(목5)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5
        ],
        "classroom": "IT106"
      }
    ],
    "sourceSchedule": "IT106(목5)"
  },
  {
    "id": "11415-004-2000844",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "004",
    "department": "컴퓨터공학",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "장성태",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "IT406",
    "isOnline": false,
    "source": {
      "schedule": "IT406(수7)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7
        ],
        "classroom": "IT406"
      }
    ],
    "sourceSchedule": "IT406(수7)"
  },
  {
    "id": "11415-005-2000603",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "005",
    "department": "조형예술학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김건희",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "조형407",
    "isOnline": false,
    "source": {
      "schedule": "조형407(화5)"
    },
    "capacity": 45,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5
        ],
        "classroom": "조형407"
      }
    ],
    "sourceSchedule": "조형407(화5)"
  },
  {
    "id": "11415-006-2000653",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "006",
    "department": "커뮤니케이션디자인",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "조윤희",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "미술102",
    "isOnline": false,
    "source": {
      "schedule": "미술102(화5)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5
        ],
        "classroom": "미술102"
      }
    ],
    "sourceSchedule": "미술102(화5)"
  },
  {
    "id": "11415-007-2000654",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "007",
    "department": "패션디자인",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "권지현",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "미술211",
    "isOnline": false,
    "source": {
      "schedule": "미술211(월1)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1
        ],
        "classroom": "미술211"
      }
    ],
    "sourceSchedule": "미술211(월1)"
  },
  {
    "id": "11415-008-2000655",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "008",
    "department": "공예디자인",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "유지은",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "미술204",
    "isOnline": false,
    "source": {
      "schedule": "미술204(수5)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5
        ],
        "classroom": "미술204"
      }
    ],
    "sourceSchedule": "미술204(수5)"
  },
  {
    "id": "11415-009-2000605",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "009",
    "department": "아트앤테크놀로지작곡과",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "권지원",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "음악216",
    "isOnline": false,
    "source": {
      "schedule": "음악216(화5)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5
        ],
        "classroom": "음악216"
      }
    ],
    "sourceSchedule": "음악216(화5)"
  },
  {
    "id": "11415-010-2000606",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "010",
    "department": "성악과",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "윤이나",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "음악217",
    "isOnline": false,
    "source": {
      "schedule": "음악217(화7)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7
        ],
        "classroom": "음악217"
      }
    ],
    "sourceSchedule": "음악217(화7)"
  },
  {
    "id": "11415-011-2000607",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "011",
    "department": "피아노과",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "공원영",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "음악218",
    "isOnline": false,
    "source": {
      "schedule": "음악218(화5)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5
        ],
        "classroom": "음악218"
      }
    ],
    "sourceSchedule": "음악218(화5)"
  },
  {
    "id": "11415-012-2000608",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "012",
    "department": "관현악과",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "윤현임",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "음악216",
    "isOnline": false,
    "source": {
      "schedule": "음악216(화1)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1
        ],
        "classroom": "음악216"
      }
    ],
    "sourceSchedule": "음악216(화1)"
  },
  {
    "id": "11415-013-2000609",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "013",
    "department": "국악과",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "홍주희",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "음악215",
    "isOnline": false,
    "source": {
      "schedule": "음악215(목5)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5
        ],
        "classroom": "음악215"
      }
    ],
    "sourceSchedule": "음악215(목5)"
  },
  {
    "id": "11415-014-2000613",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "014",
    "department": "영화예술",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김동윤",
    "days": [
      "금"
    ],
    "startPeriod": 9,
    "endPeriod": 9,
    "room": "복지202",
    "isOnline": false,
    "source": {
      "schedule": "복지202(금9)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          9
        ],
        "classroom": "복지202"
      }
    ],
    "sourceSchedule": "복지202(금9)"
  },
  {
    "id": "11415-015-2000614",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "015",
    "department": "연기예술",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "고영민",
    "days": [
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "복지B102",
    "isOnline": false,
    "source": {
      "schedule": "복지B102(수3)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          3
        ],
        "classroom": "복지B102"
      }
    ],
    "sourceSchedule": "복지B102(수3)"
  },
  {
    "id": "11415-016-2000615",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "016",
    "department": "디지털콘텐츠",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "박미경",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "미래116",
    "isOnline": false,
    "source": {
      "schedule": "미래116(월5)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5
        ],
        "classroom": "미래116"
      }
    ],
    "sourceSchedule": "미래116(월5)"
  },
  {
    "id": "11415-017-2000763",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "017",
    "department": "자유전공학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김상기",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "미래319",
    "isOnline": false,
    "source": {
      "schedule": "미래319(월7)"
    },
    "capacity": 10,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "미래319"
      }
    ],
    "sourceSchedule": "미래319(월7)"
  },
  {
    "id": "11415-018-2000754",
    "subjectKey": "11415",
    "name": "전공진로세미나1(1-2반)",
    "division": "018",
    "department": "경영공학대학",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김동원",
    "days": [
      "목"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "글경601",
    "isOnline": false,
    "source": {
      "schedule": "글경601(목8)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          8
        ],
        "classroom": "글경601"
      }
    ],
    "sourceSchedule": "글경601(목8)"
  },
  {
    "id": "11415-019-2000754",
    "subjectKey": "11415",
    "name": "전공진로세미나1(1-3반)",
    "division": "019",
    "department": "경영공학대학",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "류덕기",
    "days": [
      "목"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "글경602",
    "isOnline": false,
    "source": {
      "schedule": "글경602(목8)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          8
        ],
        "classroom": "글경602"
      }
    ],
    "sourceSchedule": "글경602(목8)"
  },
  {
    "id": "11415-020-2000754",
    "subjectKey": "11415",
    "name": "전공진로세미나1(1-4반)",
    "division": "020",
    "department": "경영공학대학",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "왕두균",
    "days": [
      "목"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "글경501",
    "isOnline": false,
    "source": {
      "schedule": "글경501(목8)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          8
        ],
        "classroom": "글경501"
      }
    ],
    "sourceSchedule": "글경501(목8)"
  },
  {
    "id": "11415-021-2000754",
    "subjectKey": "11415",
    "name": "전공진로세미나1(1-5반)",
    "division": "021",
    "department": "경영공학대학",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "최준봉",
    "days": [
      "목"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "글경702",
    "isOnline": false,
    "source": {
      "schedule": "글경702(목8)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          8
        ],
        "classroom": "글경702"
      }
    ],
    "sourceSchedule": "글경702(목8)"
  },
  {
    "id": "11415-022-2000757",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "022",
    "department": "AI데이터과학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "정형철",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "글경314",
    "isOnline": false,
    "source": {
      "schedule": "글경314(화7)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7
        ],
        "classroom": "글경314"
      }
    ],
    "sourceSchedule": "글경314(화7)"
  },
  {
    "id": "11415-023-2000757",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "023",
    "department": "AI데이터과학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "안주희",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "글경311",
    "isOnline": false,
    "source": {
      "schedule": "글경311(화7)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7
        ],
        "classroom": "글경311"
      }
    ],
    "sourceSchedule": "글경311(화7)"
  },
  {
    "id": "11415-024-2000844",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "024",
    "department": "컴퓨터공학",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "홍석우",
    "days": [
      "수"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "IT214",
    "isOnline": false,
    "source": {
      "schedule": "IT214(수8)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          8
        ],
        "classroom": "IT214"
      }
    ],
    "sourceSchedule": "IT214(수8)"
  },
  {
    "id": "11415-026-2000603",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "026",
    "department": "조형예술학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김성헌",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "조형208",
    "isOnline": false,
    "source": {
      "schedule": "조형208(화5)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5
        ],
        "classroom": "조형208"
      }
    ],
    "sourceSchedule": "조형208(화5)"
  },
  {
    "id": "11415-027-2000763",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "027",
    "department": "자유전공학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김상준",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "인문305",
    "isOnline": false,
    "source": {
      "schedule": "인문305(월7)"
    },
    "capacity": 10,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "인문305"
      }
    ],
    "sourceSchedule": "인문305(월7)"
  },
  {
    "id": "11415-028-2000763",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "028",
    "department": "자유전공학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김준태",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "인문306",
    "isOnline": false,
    "source": {
      "schedule": "인문306(월7)"
    },
    "capacity": 10,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "인문306"
      }
    ],
    "sourceSchedule": "인문306(월7)"
  },
  {
    "id": "11415-029-2000763",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "029",
    "department": "자유전공학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김진형",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "인문307",
    "isOnline": false,
    "source": {
      "schedule": "인문307(월7)"
    },
    "capacity": 10,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "인문307"
      }
    ],
    "sourceSchedule": "인문307(월7)"
  },
  {
    "id": "11415-030-2000763",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "030",
    "department": "자유전공학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김현철",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "인문311",
    "isOnline": false,
    "source": {
      "schedule": "인문311(월7)"
    },
    "capacity": 10,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "인문311"
      }
    ],
    "sourceSchedule": "인문311(월7)"
  },
  {
    "id": "11415-031-2000763",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "031",
    "department": "자유전공학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김호영",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "인문312",
    "isOnline": false,
    "source": {
      "schedule": "인문312(월7)"
    },
    "capacity": 10,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "인문312"
      }
    ],
    "sourceSchedule": "인문312(월7)"
  },
  {
    "id": "11415-032-2000763",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "032",
    "department": "자유전공학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "박상석",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "인문411",
    "isOnline": false,
    "source": {
      "schedule": "인문411(월7)"
    },
    "capacity": 10,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "인문411"
      }
    ],
    "sourceSchedule": "인문411(월7)"
  },
  {
    "id": "11415-033-2000763",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "033",
    "department": "자유전공학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "박행원",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "인문505",
    "isOnline": false,
    "source": {
      "schedule": "인문505(월7)"
    },
    "capacity": 10,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "인문505"
      }
    ],
    "sourceSchedule": "인문505(월7)"
  },
  {
    "id": "11415-034-2000763",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "034",
    "department": "자유전공학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "박효남",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "인문510",
    "isOnline": false,
    "source": {
      "schedule": "인문510(월7)"
    },
    "capacity": 10,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "인문510"
      }
    ],
    "sourceSchedule": "인문510(월7)"
  },
  {
    "id": "11415-035-2000763",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "035",
    "department": "자유전공학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "서정석",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "인문511",
    "isOnline": false,
    "source": {
      "schedule": "인문511(월7)"
    },
    "capacity": 10,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "인문511"
      }
    ],
    "sourceSchedule": "인문511(월7)"
  },
  {
    "id": "11415-036-2000763",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "036",
    "department": "자유전공학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "홍태민",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "인문401",
    "isOnline": false,
    "source": {
      "schedule": "인문401(월7)"
    },
    "capacity": 10,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "인문401"
      }
    ],
    "sourceSchedule": "인문401(월7)"
  },
  {
    "id": "11415-037-2000763",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "037",
    "department": "자유전공학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "윤병국",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "인문501",
    "isOnline": false,
    "source": {
      "schedule": "인문501(월7)"
    },
    "capacity": 10,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "인문501"
      }
    ],
    "sourceSchedule": "인문501(월7)"
  },
  {
    "id": "11415-038-2000763",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "038",
    "department": "자유전공학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "윤영석",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "인문512",
    "isOnline": false,
    "source": {
      "schedule": "인문512(월7)"
    },
    "capacity": 10,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "인문512"
      }
    ],
    "sourceSchedule": "인문512(월7)"
  },
  {
    "id": "11415-039-2000763",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "039",
    "department": "자유전공학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "이정배",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "인문309",
    "isOnline": false,
    "source": {
      "schedule": "인문309(월7)"
    },
    "capacity": 10,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "인문309"
      }
    ],
    "sourceSchedule": "인문309(월7)"
  },
  {
    "id": "11415-040-2000763",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "040",
    "department": "자유전공학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "정태혁",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "미래B103",
    "isOnline": false,
    "source": {
      "schedule": "미래B103(월7)"
    },
    "capacity": 10,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "미래B103"
      }
    ],
    "sourceSchedule": "미래B103(월7)"
  },
  {
    "id": "11415-041-2000763",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "041",
    "department": "자유전공학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "조원모",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "종합305",
    "isOnline": false,
    "source": {
      "schedule": "종합305(월7)"
    },
    "capacity": 10,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "종합305"
      }
    ],
    "sourceSchedule": "종합305(월7)"
  },
  {
    "id": "11415-042-2000763",
    "subjectKey": "11415",
    "name": "전공진로세미나1",
    "division": "042",
    "department": "자유전공학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "조장하",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "종합510",
    "isOnline": false,
    "source": {
      "schedule": "종합510(월7)"
    },
    "capacity": 10,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "종합510"
      }
    ],
    "sourceSchedule": "종합510(월7)"
  },
  {
    "id": "11416-001-2000585",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "001",
    "department": "경제학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김지송",
    "days": [
      "수"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "글경501",
    "isOnline": false,
    "source": {
      "schedule": "글경501(수8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          8
        ],
        "classroom": "글경501"
      }
    ],
    "sourceSchedule": "글경501(수8)"
  },
  {
    "id": "11416-002-2000586",
    "subjectKey": "11416",
    "name": "전공진로세미나2(회계)",
    "division": "002",
    "department": "경영학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "조태진",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "글경503",
    "isOnline": false,
    "source": {
      "schedule": "글경503(수7)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7
        ],
        "classroom": "글경503"
      }
    ],
    "sourceSchedule": "글경503(수7)"
  },
  {
    "id": "11416-003-2000587",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "003",
    "department": "호텔관광학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "최준봉",
    "days": [
      "수"
    ],
    "startPeriod": 9,
    "endPeriod": 9,
    "room": "글경703",
    "isOnline": false,
    "source": {
      "schedule": "글경703(수9)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          9
        ],
        "classroom": "글경703"
      }
    ],
    "sourceSchedule": "글경703(수9)"
  },
  {
    "id": "11416-004-2000595",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "004",
    "department": "데이터과학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "안홍렬",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "글경311",
    "isOnline": false,
    "source": {
      "schedule": "글경311(수7)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7
        ],
        "classroom": "글경311"
      }
    ],
    "sourceSchedule": "글경311(수7)"
  },
  {
    "id": "11416-005-2000596",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "005",
    "department": "컴퓨터학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "변희정",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "IT514",
    "isOnline": false,
    "source": {
      "schedule": "IT514(목1)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1
        ],
        "classroom": "IT514"
      }
    ],
    "sourceSchedule": "IT514(목1)"
  },
  {
    "id": "11416-006-2000597",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "006",
    "department": "정보통신학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "양윤기",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "IT408",
    "isOnline": false,
    "source": {
      "schedule": "IT408(목2)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2
        ],
        "classroom": "IT408"
      }
    ],
    "sourceSchedule": "IT408(목2)"
  },
  {
    "id": "11416-007-2000603",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "007",
    "department": "조형예술학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김건희",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "조형408",
    "isOnline": false,
    "source": {
      "schedule": "조형408(수5)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5
        ],
        "classroom": "조형408"
      }
    ],
    "sourceSchedule": "조형408(수5)"
  },
  {
    "id": "11416-008-2000604",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "008",
    "department": "디자인학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김미경",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "종합B107",
    "isOnline": false,
    "source": {
      "schedule": "종합B107(월5)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5
        ],
        "classroom": "종합B107"
      }
    ],
    "sourceSchedule": "종합B107(월5)"
  },
  {
    "id": "11416-009-2000605",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "009",
    "department": "아트앤테크놀로지작곡과",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "정진호",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "음악216",
    "isOnline": false,
    "source": {
      "schedule": "음악216(월5)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5
        ],
        "classroom": "음악216"
      }
    ],
    "sourceSchedule": "음악216(월5)"
  },
  {
    "id": "11416-010-2000606",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "010",
    "department": "성악과",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김현정",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "음악217",
    "isOnline": false,
    "source": {
      "schedule": "음악217(화2)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2
        ],
        "classroom": "음악217"
      }
    ],
    "sourceSchedule": "음악217(화2)"
  },
  {
    "id": "11416-011-2000607",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "011",
    "department": "피아노과",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "공원영",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 6,
    "room": "음악218",
    "isOnline": false,
    "source": {
      "schedule": "음악218(화6)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6
        ],
        "classroom": "음악218"
      }
    ],
    "sourceSchedule": "음악218(화6)"
  },
  {
    "id": "11416-012-2000608",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "012",
    "department": "관현악과",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김수진",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "음악216",
    "isOnline": false,
    "source": {
      "schedule": "음악216(목1)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1
        ],
        "classroom": "음악216"
      }
    ],
    "sourceSchedule": "음악216(목1)"
  },
  {
    "id": "11416-013-2000609",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "013",
    "department": "국악과",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "홍주희",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "음악215",
    "isOnline": false,
    "source": {
      "schedule": "음악215(목1)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1
        ],
        "classroom": "음악215"
      }
    ],
    "sourceSchedule": "음악215(목1)"
  },
  {
    "id": "11416-014-2000613",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "014",
    "department": "영화예술",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "이정현",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "복지202",
    "isOnline": false,
    "source": {
      "schedule": "복지202(화4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4
        ],
        "classroom": "복지202"
      }
    ],
    "sourceSchedule": "복지202(화4)"
  },
  {
    "id": "11416-015-2000614",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "015",
    "department": "연기예술",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "고영민",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "복지B102",
    "isOnline": false,
    "source": {
      "schedule": "복지B102(수2)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2
        ],
        "classroom": "복지B102"
      }
    ],
    "sourceSchedule": "복지B102(수2)"
  },
  {
    "id": "11416-016-2000615",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "016",
    "department": "디지털콘텐츠",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "박계연",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "미래116",
    "isOnline": false,
    "source": {
      "schedule": "미래116(월4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4
        ],
        "classroom": "미래116"
      }
    ],
    "sourceSchedule": "미래116(월4)"
  },
  {
    "id": "11416-017-2000587",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "017",
    "department": "호텔관광학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김병용",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "글경502",
    "isOnline": false,
    "source": {
      "schedule": "글경502(화7)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7
        ],
        "classroom": "글경502"
      }
    ],
    "sourceSchedule": "글경502(화7)"
  },
  {
    "id": "11416-018-2000587",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "018",
    "department": "호텔관광학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "조미나",
    "days": [
      "수"
    ],
    "startPeriod": 9,
    "endPeriod": 9,
    "room": "글경604",
    "isOnline": false,
    "source": {
      "schedule": "글경604(수9)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          9
        ],
        "classroom": "글경604"
      }
    ],
    "sourceSchedule": "글경604(수9)"
  },
  {
    "id": "11416-019-2000586",
    "subjectKey": "11416",
    "name": "전공진로세미나2(글로벌비즈니스)",
    "division": "019",
    "department": "경영학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "윤성원",
    "days": [
      "수"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "글경504",
    "isOnline": false,
    "source": {
      "schedule": "글경504(수8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          8
        ],
        "classroom": "글경504"
      }
    ],
    "sourceSchedule": "글경504(수8)"
  },
  {
    "id": "11416-020-2000586",
    "subjectKey": "11416",
    "name": "전공진로세미나2(경영)",
    "division": "020",
    "department": "경영학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "이은곤",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "글경401",
    "isOnline": false,
    "source": {
      "schedule": "글경401(수7)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7
        ],
        "classroom": "글경401"
      }
    ],
    "sourceSchedule": "글경401(수7)"
  },
  {
    "id": "11416-021-2000595",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "021",
    "department": "데이터과학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "방효은",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "글경314",
    "isOnline": false,
    "source": {
      "schedule": "글경314(수7)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7
        ],
        "classroom": "글경314"
      }
    ],
    "sourceSchedule": "글경314(수7)"
  },
  {
    "id": "11416-022-2000595",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "022",
    "department": "데이터과학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "한경훈",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "글경315",
    "isOnline": false,
    "source": {
      "schedule": "글경315(수7)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7
        ],
        "classroom": "글경315"
      }
    ],
    "sourceSchedule": "글경315(수7)"
  },
  {
    "id": "11416-023-2000596",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "023",
    "department": "컴퓨터학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "장성태",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "IT406",
    "isOnline": false,
    "source": {
      "schedule": "IT406(수4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "IT406"
      }
    ],
    "sourceSchedule": "IT406(수4)"
  },
  {
    "id": "11416-024-2000596",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "024",
    "department": "컴퓨터학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "딜립 쿠말",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "IT413",
    "isOnline": false,
    "source": {
      "schedule": "IT413(월4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4
        ],
        "classroom": "IT413"
      }
    ],
    "sourceSchedule": "IT413(월4)"
  },
  {
    "id": "11416-026-2000603",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "026",
    "department": "조형예술학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "지경수",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "조형208",
    "isOnline": false,
    "source": {
      "schedule": "조형208(월5)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5
        ],
        "classroom": "조형208"
      }
    ],
    "sourceSchedule": "조형208(월5)"
  },
  {
    "id": "11416-027-2000604",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "027",
    "department": "디자인학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "고은미",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "미술213-1",
    "isOnline": false,
    "source": {
      "schedule": "미술213-1(월4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4
        ],
        "classroom": "미술213-1"
      }
    ],
    "sourceSchedule": "미술213-1(월4)"
  },
  {
    "id": "11416-028-2000604",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "028",
    "department": "디자인학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "천혜영",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "미술114",
    "isOnline": false,
    "source": {
      "schedule": "미술114(목1)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1
        ],
        "classroom": "미술114"
      }
    ],
    "sourceSchedule": "미술114(목1)"
  },
  {
    "id": "11416-029-2000597",
    "subjectKey": "11416",
    "name": "전공진로세미나2",
    "division": "029",
    "department": "정보통신학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김아람",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "IT306",
    "isOnline": false,
    "source": {
      "schedule": "IT306(목5)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5
        ],
        "classroom": "IT306"
      }
    ],
    "sourceSchedule": "IT306(목5)"
  },
  {
    "id": "11417-001-2000581",
    "subjectKey": "11417",
    "name": "전공진로세미나3(중어중문학)",
    "division": "001",
    "department": "외국어학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "송진영",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "인문401",
    "isOnline": false,
    "source": {
      "schedule": "인문401(월2)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2
        ],
        "classroom": "인문401"
      }
    ],
    "sourceSchedule": "인문401(월2)"
  },
  {
    "id": "11417-002-2000581",
    "subjectKey": "11417",
    "name": "전공진로세미나3(영어영문학)",
    "division": "002",
    "department": "외국어학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김현진",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "인문301",
    "isOnline": false,
    "source": {
      "schedule": "인문301(월5)"
    },
    "capacity": 50,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5
        ],
        "classroom": "인문301"
      }
    ],
    "sourceSchedule": "인문301(월5)"
  },
  {
    "id": "11417-003-2000582",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "003",
    "department": "법·행정학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "권지혜",
    "days": [
      "월"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "인문400",
    "isOnline": false,
    "source": {
      "schedule": "인문400(월8)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          8
        ],
        "classroom": "인문400"
      }
    ],
    "sourceSchedule": "인문400(월8)"
  },
  {
    "id": "11417-004-2000583",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "004",
    "department": "미디어커뮤니케이션학과",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "장경은",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "인문406",
    "isOnline": false,
    "source": {
      "schedule": "인문406(화1)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1
        ],
        "classroom": "인문406"
      }
    ],
    "sourceSchedule": "인문406(화1)"
  },
  {
    "id": "11417-005-2000584",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "005",
    "department": "소방행정학과(야)",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김순덕",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 6,
    "room": "인문107",
    "isOnline": false,
    "source": {
      "schedule": "인문107(수6)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6
        ],
        "classroom": "인문107"
      }
    ],
    "sourceSchedule": "인문107(수6)"
  },
  {
    "id": "11417-006-2000585",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "006",
    "department": "경제학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김지송",
    "days": [
      "수"
    ],
    "startPeriod": 9,
    "endPeriod": 9,
    "room": "글경501",
    "isOnline": false,
    "source": {
      "schedule": "글경501(수9)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          9
        ],
        "classroom": "글경501"
      }
    ],
    "sourceSchedule": "글경501(수9)"
  },
  {
    "id": "11417-007-2000586",
    "subjectKey": "11417",
    "name": "전공진로세미나3(회계)",
    "division": "007",
    "department": "경영학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "박상섭",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "글경601",
    "isOnline": false,
    "source": {
      "schedule": "글경601(수7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7
        ],
        "classroom": "글경601"
      }
    ],
    "sourceSchedule": "글경601(수7)"
  },
  {
    "id": "11417-008-2000587",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "008",
    "department": "호텔관광학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "최준봉",
    "days": [
      "수"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "글경703",
    "isOnline": false,
    "source": {
      "schedule": "글경703(수8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          8
        ],
        "classroom": "글경703"
      }
    ],
    "sourceSchedule": "글경703(수8)"
  },
  {
    "id": "11417-009-2000595",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "009",
    "department": "데이터과학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김순찬",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "글경315",
    "isOnline": false,
    "source": {
      "schedule": "글경315(화1)"
    },
    "capacity": 35,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1
        ],
        "classroom": "글경315"
      }
    ],
    "sourceSchedule": "글경315(화1)"
  },
  {
    "id": "11417-010-2000596",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "010",
    "department": "컴퓨터학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "장성태",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "IT415",
    "isOnline": false,
    "source": {
      "schedule": "IT415(화1)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1
        ],
        "classroom": "IT415"
      }
    ],
    "sourceSchedule": "IT415(화1)"
  },
  {
    "id": "11417-011-2000597",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "011",
    "department": "정보통신학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김시현",
    "days": [
      "월"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "IT413",
    "isOnline": false,
    "source": {
      "schedule": "IT413(월8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          8
        ],
        "classroom": "IT413"
      }
    ],
    "sourceSchedule": "IT413(월8)"
  },
  {
    "id": "11417-012-2000603",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "012",
    "department": "조형예술학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "이소영",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "조형302",
    "isOnline": false,
    "source": {
      "schedule": "조형302(목5)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5
        ],
        "classroom": "조형302"
      }
    ],
    "sourceSchedule": "조형302(목5)"
  },
  {
    "id": "11417-013-2000604",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "013",
    "department": "디자인학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "이상희",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "미술211",
    "isOnline": false,
    "source": {
      "schedule": "미술211(월5)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5
        ],
        "classroom": "미술211"
      }
    ],
    "sourceSchedule": "미술211(월5)"
  },
  {
    "id": "11417-014-2000605",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "014",
    "department": "아트앤테크놀로지작곡과",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "정진호",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "음악218",
    "isOnline": false,
    "source": {
      "schedule": "음악218(금4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4
        ],
        "classroom": "음악218"
      }
    ],
    "sourceSchedule": "음악218(금4)"
  },
  {
    "id": "11417-015-2000606",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "015",
    "department": "성악과",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김현정",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(금4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(금4)"
  },
  {
    "id": "11417-016-2000607",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "016",
    "department": "피아노과",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "히로타슌지",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "음악217",
    "isOnline": false,
    "source": {
      "schedule": "음악217(금4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4
        ],
        "classroom": "음악217"
      }
    ],
    "sourceSchedule": "음악217(금4)"
  },
  {
    "id": "11417-017-2000608",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "017",
    "department": "관현악과",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김영은",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "음악219",
    "isOnline": false,
    "source": {
      "schedule": "음악219(금4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4
        ],
        "classroom": "음악219"
      }
    ],
    "sourceSchedule": "음악219(금4)"
  },
  {
    "id": "11417-018-2000609",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "018",
    "department": "국악과",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "박혜진",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "음악216",
    "isOnline": false,
    "source": {
      "schedule": "음악216(금4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4
        ],
        "classroom": "음악216"
      }
    ],
    "sourceSchedule": "음악216(금4)"
  },
  {
    "id": "11417-019-2000613",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "019",
    "department": "영화예술",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "이정현",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "복지202",
    "isOnline": false,
    "source": {
      "schedule": "복지202(화5)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5
        ],
        "classroom": "복지202"
      }
    ],
    "sourceSchedule": "복지202(화5)"
  },
  {
    "id": "11417-020-2000614",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "020",
    "department": "연기예술",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "고영민",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "복지B102",
    "isOnline": false,
    "source": {
      "schedule": "복지B102(수1)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1
        ],
        "classroom": "복지B102"
      }
    ],
    "sourceSchedule": "복지B102(수1)"
  },
  {
    "id": "11417-021-2000615",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "021",
    "department": "디지털콘텐츠",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "박미경",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "미래116",
    "isOnline": false,
    "source": {
      "schedule": "미래116(수1)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1
        ],
        "classroom": "미래116"
      }
    ],
    "sourceSchedule": "미래116(수1)"
  },
  {
    "id": "11417-022-2000581",
    "subjectKey": "11417",
    "name": "전공진로세미나3(일어일문학)",
    "division": "022",
    "department": "외국어학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "방윤형",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "종합509",
    "isOnline": false,
    "source": {
      "schedule": "종합509(목4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4
        ],
        "classroom": "종합509"
      }
    ],
    "sourceSchedule": "종합509(목4)"
  },
  {
    "id": "11417-023-2000580",
    "subjectKey": "11417",
    "name": "전공진로세미나3(사학)",
    "division": "023",
    "department": "인문학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "양정석",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "인문501",
    "isOnline": false,
    "source": {
      "schedule": "인문501(월2)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2
        ],
        "classroom": "인문501"
      }
    ],
    "sourceSchedule": "인문501(월2)"
  },
  {
    "id": "11417-024-2000587",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "024",
    "department": "호텔관광학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김병용",
    "days": [
      "수"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "글경704",
    "isOnline": false,
    "source": {
      "schedule": "글경704(수8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          8
        ],
        "classroom": "글경704"
      }
    ],
    "sourceSchedule": "글경704(수8)"
  },
  {
    "id": "11417-025-2000587",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "025",
    "department": "호텔관광학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "조미나",
    "days": [
      "수"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "글경604",
    "isOnline": false,
    "source": {
      "schedule": "글경604(수8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          8
        ],
        "classroom": "글경604"
      }
    ],
    "sourceSchedule": "글경604(수8)"
  },
  {
    "id": "11417-026-2000586",
    "subjectKey": "11417",
    "name": "전공진로세미나3(글로벌비즈니스)",
    "division": "026",
    "department": "경영학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "양지연",
    "days": [
      "수"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "글경602",
    "isOnline": false,
    "source": {
      "schedule": "글경602(수8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          8
        ],
        "classroom": "글경602"
      }
    ],
    "sourceSchedule": "글경602(수8)"
  },
  {
    "id": "11417-027-2000586",
    "subjectKey": "11417",
    "name": "전공진로세미나3(경영)",
    "division": "027",
    "department": "경영학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "이은곤",
    "days": [
      "수"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "글경401",
    "isOnline": false,
    "source": {
      "schedule": "글경401(수8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          8
        ],
        "classroom": "글경401"
      }
    ],
    "sourceSchedule": "글경401(수8)"
  },
  {
    "id": "11417-028-2000595",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "028",
    "department": "데이터과학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김진현",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "글경314",
    "isOnline": false,
    "source": {
      "schedule": "글경314(화1)"
    },
    "capacity": 35,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1
        ],
        "classroom": "글경314"
      }
    ],
    "sourceSchedule": "글경314(화1)"
  },
  {
    "id": "11417-029-2000595",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "029",
    "department": "데이터과학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "염희란",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "글경311",
    "isOnline": false,
    "source": {
      "schedule": "글경311(화1)"
    },
    "capacity": 35,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1
        ],
        "classroom": "글경311"
      }
    ],
    "sourceSchedule": "글경311(화1)"
  },
  {
    "id": "11417-030-2000596",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "030",
    "department": "컴퓨터학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "한성일",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "IT105",
    "isOnline": false,
    "source": {
      "schedule": "IT105(목1)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1
        ],
        "classroom": "IT105"
      }
    ],
    "sourceSchedule": "IT105(목1)"
  },
  {
    "id": "11417-031-2000596",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "031",
    "department": "컴퓨터학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "딜립 쿠말",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "IT413",
    "isOnline": false,
    "source": {
      "schedule": "IT413(월5)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5
        ],
        "classroom": "IT413"
      }
    ],
    "sourceSchedule": "IT413(월5)"
  },
  {
    "id": "11417-033-2000603",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "033",
    "department": "조형예술학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "지경수",
    "days": [
      "화"
    ],
    "startPeriod": 10,
    "endPeriod": 10,
    "room": "조형208",
    "isOnline": false,
    "source": {
      "schedule": "조형208(화10)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          10
        ],
        "classroom": "조형208"
      }
    ],
    "sourceSchedule": "조형208(화10)"
  },
  {
    "id": "11417-034-2000604",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "034",
    "department": "디자인학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "이의정",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "미술208",
    "isOnline": false,
    "source": {
      "schedule": "미술208(목5)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5
        ],
        "classroom": "미술208"
      }
    ],
    "sourceSchedule": "미술208(목5)"
  },
  {
    "id": "11417-035-2000604",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "035",
    "department": "디자인학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "유지은",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "미술111",
    "isOnline": false,
    "source": {
      "schedule": "미술111(수1)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1
        ],
        "classroom": "미술111"
      }
    ],
    "sourceSchedule": "미술111(수1)"
  },
  {
    "id": "11417-036-2000582",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "036",
    "department": "법·행정학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "김용훈",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "인문107",
    "isOnline": false,
    "source": {
      "schedule": "인문107(금5)"
    },
    "capacity": 35,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5
        ],
        "classroom": "인문107"
      }
    ],
    "sourceSchedule": "인문107(금5)"
  },
  {
    "id": "11417-037-2000580",
    "subjectKey": "11417",
    "name": "전공진로세미나3(국어국문학)",
    "division": "037",
    "department": "인문학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "문현수",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "인문310",
    "isOnline": false,
    "source": {
      "schedule": "인문310(금1)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1
        ],
        "classroom": "인문310"
      }
    ],
    "sourceSchedule": "인문310(금1)"
  },
  {
    "id": "11417-038-2000581",
    "subjectKey": "11417",
    "name": "전공진로세미나3(러시아어문학)",
    "division": "038",
    "department": "외국어학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "박카밀라",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "종합505",
    "isOnline": false,
    "source": {
      "schedule": "종합505(수7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7
        ],
        "classroom": "종합505"
      }
    ],
    "sourceSchedule": "종합505(수7)"
  },
  {
    "id": "11417-039-2000582",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "039",
    "department": "법·행정학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "권지혜",
    "days": [
      "수"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "인문400",
    "isOnline": false,
    "source": {
      "schedule": "인문400(수8)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          8
        ],
        "classroom": "인문400"
      }
    ],
    "sourceSchedule": "인문400(수8)"
  },
  {
    "id": "11417-040-2000597",
    "subjectKey": "11417",
    "name": "전공진로세미나3",
    "division": "040",
    "department": "정보통신학부",
    "category": "일반선택",
    "sourceCategory": "전취",
    "credit": 1,
    "professor": "전상훈",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "IT407",
    "isOnline": false,
    "source": {
      "schedule": "IT407(목5)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5
        ],
        "classroom": "IT407"
      }
    ],
    "sourceSchedule": "IT407(목5)"
  },
  {
    "id": "11418-001-2000505",
    "subjectKey": "11418",
    "name": "전략정보시스템실무",
    "division": "001",
    "department": "경영",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이은곤",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경401",
    "isOnline": false,
    "source": {
      "schedule": "글경401(화1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경401"
      }
    ],
    "sourceSchedule": "글경401(화1,2,3)"
  },
  {
    "id": "11419-001-2000592",
    "subjectKey": "11419",
    "name": "전자재료및소자설계",
    "division": "001",
    "department": "반도체공학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정석환",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "첨단109",
    "isOnline": false,
    "source": {
      "schedule": "첨단109(월5,6,7,8)"
    },
    "capacity": 16,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "첨단109"
      }
    ],
    "sourceSchedule": "첨단109(월5,6,7,8)"
  },
  {
    "id": "11419-002-2000592",
    "subjectKey": "11419",
    "name": "전자재료및소자설계",
    "division": "002",
    "department": "반도체공학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정석환",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "첨단109",
    "isOnline": false,
    "source": {
      "schedule": "첨단109(화5,6,7,8)"
    },
    "capacity": 16,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "첨단109"
      }
    ],
    "sourceSchedule": "첨단109(화5,6,7,8)"
  },
  {
    "id": "11420-001-2000624",
    "subjectKey": "11420",
    "name": "정치경제학",
    "division": "001",
    "department": "경제금융",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "윤면식",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경503",
    "isOnline": false,
    "source": {
      "schedule": "글경503(수1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경503"
      }
    ],
    "sourceSchedule": "글경503(수1,2,3)"
  },
  {
    "id": "11422-001-2000652",
    "subjectKey": "11422",
    "name": "조형실기4",
    "division": "001",
    "department": "조소",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김영재",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 10,
    "room": "조형207",
    "isOnline": false,
    "source": {
      "schedule": "조형207(월7,8,9,10)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9,
          10
        ],
        "classroom": "조형207"
      }
    ],
    "sourceSchedule": "조형207(월7,8,9,10)"
  },
  {
    "id": "11423-001-2000440",
    "subjectKey": "11423",
    "name": "졸업논문및작품",
    "division": "001",
    "department": "영화영상",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "김석범",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 6,
    "room": "복지306",
    "isOnline": false,
    "source": {
      "schedule": "복지306(목6)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6
        ],
        "classroom": "복지306"
      }
    ],
    "sourceSchedule": "복지306(목6)"
  },
  {
    "id": "11423-002-2000441",
    "subjectKey": "11423",
    "name": "졸업논문및작품",
    "division": "002",
    "department": "연극",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "김선욱",
    "days": [
      "목"
    ],
    "startPeriod": 15,
    "endPeriod": 15,
    "room": "복지B105",
    "isOnline": false,
    "source": {
      "schedule": "복지B105(목15)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          15
        ],
        "classroom": "복지B105"
      }
    ],
    "sourceSchedule": "복지B105(목15)"
  },
  {
    "id": "11425-001-2000256",
    "subjectKey": "11425",
    "name": "졸업작품연구2",
    "division": "001",
    "department": "공예디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "유지은",
    "days": [
      "목",
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "미술114",
    "isOnline": false,
    "source": {
      "schedule": "미술114(목2,3),미술212(화5,6)"
    },
    "capacity": 25,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3
        ],
        "classroom": "미술114"
      },
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미술212"
      }
    ],
    "sourceSchedule": "미술114(목2,3),미술212(화5,6)"
  },
  {
    "id": "11432-001-2000587",
    "subjectKey": "11432",
    "name": "커피와바리스타",
    "division": "001",
    "department": "호텔관광학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김단비",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "글경702",
    "isOnline": false,
    "source": {
      "schedule": "글경702(화2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "글경702"
      }
    ],
    "sourceSchedule": "글경702(화2,3,4)"
  },
  {
    "id": "11438-001-2000658",
    "subjectKey": "11438",
    "name": "클래식음악과오페라",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "신윤석",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래109",
    "isOnline": false,
    "source": {
      "schedule": "미래109(수4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래109"
      }
    ],
    "sourceSchedule": "미래109(수4,5,6)"
  },
  {
    "id": "11438-002-2000658",
    "subjectKey": "11438",
    "name": "클래식음악과오페라",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박진아",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래109",
    "isOnline": false,
    "source": {
      "schedule": "미래109(수1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래109"
      }
    ],
    "sourceSchedule": "미래109(수1,2,3)"
  },
  {
    "id": "11447-001-2000613",
    "subjectKey": "11447",
    "name": "편집및프로덕션디자인실습2",
    "division": "001",
    "department": "영화예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박경목",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "복지305",
    "isOnline": false,
    "source": {
      "schedule": "복지305(목2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "복지305"
      }
    ],
    "sourceSchedule": "복지305(목2,3,4)"
  },
  {
    "id": "11447-002-2000613",
    "subjectKey": "11447",
    "name": "편집및프로덕션디자인실습2",
    "division": "002",
    "department": "영화예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박경목",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "복지305",
    "isOnline": false,
    "source": {
      "schedule": "복지305(목6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "복지305"
      }
    ],
    "sourceSchedule": "복지305(목6,7,8)"
  },
  {
    "id": "11449-001-2000606",
    "subjectKey": "11449",
    "name": "프랑스어딕션2",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "윤아르나",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(월7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(월7,8)"
  },
  {
    "id": "11450-001-2000613",
    "subjectKey": "11450",
    "name": "프로덕션피치크리틱1",
    "division": "001",
    "department": "영화예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "이상노",
    "days": [
      "금"
    ],
    "startPeriod": 10,
    "endPeriod": 10,
    "room": "글경602",
    "isOnline": false,
    "source": {
      "schedule": "글경602(금10)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          10
        ],
        "classroom": "글경602"
      }
    ],
    "sourceSchedule": "글경602(금10)"
  },
  {
    "id": "11450-002-2000613",
    "subjectKey": "11450",
    "name": "프로덕션피치크리틱1",
    "division": "002",
    "department": "영화예술",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "김석범",
    "days": [
      "금"
    ],
    "startPeriod": 10,
    "endPeriod": 10,
    "room": "글경101",
    "isOnline": false,
    "source": {
      "schedule": "글경101(금10)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          10
        ],
        "classroom": "글경101"
      }
    ],
    "sourceSchedule": "글경101(금10)"
  },
  {
    "id": "11452-001-2000613",
    "subjectKey": "11452",
    "name": "프로덕션피치크리틱3",
    "division": "001",
    "department": "영화예술",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "김계중",
    "days": [
      "금"
    ],
    "startPeriod": 10,
    "endPeriod": 10,
    "room": "글경603",
    "isOnline": false,
    "source": {
      "schedule": "글경603(금10)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          10
        ],
        "classroom": "글경603"
      }
    ],
    "sourceSchedule": "글경603(금10)"
  },
  {
    "id": "11454-001-2000607",
    "subjectKey": "11454",
    "name": "피아노앙상블2",
    "division": "001",
    "department": "피아노과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "히로타슌지",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "음악315",
    "isOnline": false,
    "source": {
      "schedule": "음악315(수5,6,7)"
    },
    "capacity": 24,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악315"
      }
    ],
    "sourceSchedule": "음악315(수5,6,7)"
  },
  {
    "id": "11458-001-2000651",
    "subjectKey": "11458",
    "name": "한국미술의이해2",
    "division": "001",
    "department": "회화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "성혜진",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "미술114",
    "isOnline": false,
    "source": {
      "schedule": "미술114(월2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "미술114"
      }
    ],
    "sourceSchedule": "미술114(월2,3)"
  },
  {
    "id": "11458-002-2000652",
    "subjectKey": "11458",
    "name": "한국미술의이해2",
    "division": "002",
    "department": "조소",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "성혜진",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미술102",
    "isOnline": false,
    "source": {
      "schedule": "미술102(목5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "미술102"
      }
    ],
    "sourceSchedule": "미술102(목5,6)"
  },
  {
    "id": "11459-001-2000658",
    "subjectKey": "11459",
    "name": "한국사의재조명",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "예대열",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문408",
    "isOnline": false,
    "source": {
      "schedule": "인문408(목4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문408"
      }
    ],
    "sourceSchedule": "인문408(목4,5,6)"
  },
  {
    "id": "11460-001-2000658",
    "subjectKey": "11460",
    "name": "한국음악의이해와감상",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "석무현",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래110",
    "isOnline": false,
    "source": {
      "schedule": "미래110(화1,2,3)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래110"
      }
    ],
    "sourceSchedule": "미래110(화1,2,3)"
  },
  {
    "id": "11463-001-2000649",
    "subjectKey": "11463",
    "name": "해양레저스포츠실습2",
    "division": "001",
    "department": "레저스포츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "표형근",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "체육112",
    "isOnline": false,
    "source": {
      "schedule": "체육112(수7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8
        ],
        "classroom": "체육112"
      }
    ],
    "sourceSchedule": "체육112(수7,8)"
  },
  {
    "id": "11467-001-2000658",
    "subjectKey": "11467",
    "name": "현대사회의창업과리더십",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김동주",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경702",
    "isOnline": false,
    "source": {
      "schedule": "글경702(월4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경702"
      }
    ],
    "sourceSchedule": "글경702(월4,5,6)"
  },
  {
    "id": "11470-001-2000652",
    "subjectKey": "11470",
    "name": "현대작가연구2",
    "division": "001",
    "department": "조소",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "최정희",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미술114",
    "isOnline": false,
    "source": {
      "schedule": "미술114(월5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미술114"
      }
    ],
    "sourceSchedule": "미술114(월5,6)"
  },
  {
    "id": "11471-001-2000658",
    "subjectKey": "11471",
    "name": "화성의문화와역사",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "장우영",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문408",
    "isOnline": false,
    "source": {
      "schedule": "인문408(수4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문408"
      }
    ],
    "sourceSchedule": "인문408(수4,5,6)"
  },
  {
    "id": "11480-001-2000717",
    "subjectKey": "11480",
    "name": "클라우드핵심서비스",
    "division": "001",
    "department": "클라우드융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김남국",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래B103",
    "isOnline": false,
    "source": {
      "schedule": "미래B103(수7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래B103"
      }
    ],
    "sourceSchedule": "미래B103(수7,8,9)"
  },
  {
    "id": "11483-001-2000717",
    "subjectKey": "11483",
    "name": "스토리지구조",
    "division": "001",
    "department": "클라우드융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "송재숙",
    "days": [
      "목"
    ],
    "startPeriod": 10,
    "endPeriod": 12,
    "room": "미래311",
    "isOnline": false,
    "source": {
      "schedule": "미래311(목10,11,12)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          10,
          11,
          12
        ],
        "classroom": "미래311"
      }
    ],
    "sourceSchedule": "미래311(목10,11,12)"
  },
  {
    "id": "11484-001-2000717",
    "subjectKey": "11484",
    "name": "No-SQL구조",
    "division": "001",
    "department": "클라우드융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "송재숙",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미래311",
    "isOnline": false,
    "source": {
      "schedule": "미래311(금6,7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미래311"
      }
    ],
    "sourceSchedule": "미래311(금6,7,8,9)"
  },
  {
    "id": "11485-001-2000717",
    "subjectKey": "11485",
    "name": "ICT와클라우드컴퓨팅",
    "division": "001",
    "department": "클라우드융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김남국",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래B201",
    "isOnline": false,
    "source": {
      "schedule": "미래B201(화7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래B201"
      }
    ],
    "sourceSchedule": "미래B201(화7,8,9)"
  },
  {
    "id": "11487-001-2000717",
    "subjectKey": "11487",
    "name": "클라우드인프라운영",
    "division": "001",
    "department": "클라우드융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "장경성",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래311",
    "isOnline": false,
    "source": {
      "schedule": "미래311(월7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래311"
      }
    ],
    "sourceSchedule": "미래311(월7,8,9)"
  },
  {
    "id": "11488-001-2000717",
    "subjectKey": "11488",
    "name": "클라우드기반개발",
    "division": "001",
    "department": "클라우드융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "장경성",
    "days": [
      "월"
    ],
    "startPeriod": 10,
    "endPeriod": 13,
    "room": "미래311",
    "isOnline": false,
    "source": {
      "schedule": "미래311(월10,11,12,13)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          10,
          11,
          12,
          13
        ],
        "classroom": "미래311"
      }
    ],
    "sourceSchedule": "미래311(월10,11,12,13)"
  },
  {
    "id": "11499-001-2000658",
    "subjectKey": "11499",
    "name": "일.사랑.행복(마이크로디그리)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김지송",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경101",
    "isOnline": false,
    "source": {
      "schedule": "글경101(목4,5,6)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경101"
      }
    ],
    "sourceSchedule": "글경101(목4,5,6)"
  },
  {
    "id": "11509-001-2000715",
    "subjectKey": "11509",
    "name": "System IC의이해",
    "division": "001",
    "department": "시스템반도체융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이병렬",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "첨단608",
    "isOnline": false,
    "source": {
      "schedule": "첨단608(수1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "첨단608"
      }
    ],
    "sourceSchedule": "첨단608(수1,2,3)"
  },
  {
    "id": "11511-001-2000715",
    "subjectKey": "11511",
    "name": "고체전자공학",
    "division": "001",
    "department": "시스템반도체융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박병규",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합509",
    "isOnline": false,
    "source": {
      "schedule": "종합509(수1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합509"
      }
    ],
    "sourceSchedule": "종합509(수1,2,3)"
  },
  {
    "id": "11512-001-2000715",
    "subjectKey": "11512",
    "name": "반도체소자개론",
    "division": "001",
    "department": "시스템반도체융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "유민권",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "첨단608",
    "isOnline": false,
    "source": {
      "schedule": "첨단608(화4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "첨단608"
      }
    ],
    "sourceSchedule": "첨단608(화4,5,6)"
  },
  {
    "id": "11513-001-2000715",
    "subjectKey": "11513",
    "name": "디지털시스템설계실습",
    "division": "001",
    "department": "시스템반도체융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "윤보열",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "2공학115",
    "isOnline": false,
    "source": {
      "schedule": "2공학115(목5,6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "2공학115"
      }
    ],
    "sourceSchedule": "2공학115(목5,6,7,8)"
  },
  {
    "id": "11517-001-2000553",
    "subjectKey": "11517",
    "name": "반도체업무분장",
    "division": "001",
    "department": "시스템반도체융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "유민권",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "첨단610",
    "isOnline": false,
    "source": {
      "schedule": "첨단610(수1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "첨단610"
      }
    ],
    "sourceSchedule": "첨단610(수1,2,3)"
  },
  {
    "id": "11518-001-2000553",
    "subjectKey": "11518",
    "name": "나노소자및신소재",
    "division": "001",
    "department": "시스템반도체융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "강동헌",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "첨단610",
    "isOnline": false,
    "source": {
      "schedule": "첨단610(월5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "첨단610"
      }
    ],
    "sourceSchedule": "첨단610(월5,6,7)"
  },
  {
    "id": "11519-001-2000553",
    "subjectKey": "11519",
    "name": "집적회로설계실습",
    "division": "001",
    "department": "시스템반도체융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "2공학115",
    "isOnline": false,
    "source": {
      "schedule": "2공학115(화1,2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "2공학115"
      }
    ],
    "sourceSchedule": "2공학115(화1,2,3,4)"
  },
  {
    "id": "11520-001-2000506",
    "subjectKey": "11520",
    "name": "재경관리연습",
    "division": "001",
    "department": "회계",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박상섭",
    "days": [
      "수",
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "글경601",
    "isOnline": false,
    "source": {
      "schedule": "글경601(수5,6),글경607(화7)"
    },
    "capacity": 50,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "글경601"
      },
      {
        "day": "화",
        "periods": [
          7
        ],
        "classroom": "글경607"
      }
    ],
    "sourceSchedule": "글경601(수5,6),글경607(화7)"
  },
  {
    "id": "11521-001-2000627",
    "subjectKey": "11521",
    "name": "부가가치세회계",
    "division": "001",
    "department": "회계",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김경옥",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경601",
    "isOnline": false,
    "source": {
      "schedule": "글경601(화5,6,7)"
    },
    "capacity": 80,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경601"
      }
    ],
    "sourceSchedule": "글경601(화5,6,7)"
  },
  {
    "id": "11525-001-2000600",
    "subjectKey": "11525",
    "name": "패션디자인캐드2",
    "division": "001",
    "department": "의류학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김선영",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "IT309",
    "isOnline": false,
    "source": {
      "schedule": "IT309(목1,2,3)"
    },
    "capacity": 19,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "IT309"
      }
    ],
    "sourceSchedule": "IT309(목1,2,3)"
  },
  {
    "id": "11526-001-2000600",
    "subjectKey": "11526",
    "name": "테크니컬디자인",
    "division": "001",
    "department": "의류학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김선영",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "생활301",
    "isOnline": false,
    "source": {
      "schedule": "생활301(목5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "생활301"
      }
    ],
    "sourceSchedule": "생활301(목5,6,7)"
  },
  {
    "id": "11528-003-2000650",
    "subjectKey": "11528",
    "name": "스포츠동작및경기분석",
    "division": "003",
    "department": "운동건강관리",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최성욱",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "체육118",
    "isOnline": false,
    "source": {
      "schedule": "체육118(화6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "체육118"
      }
    ],
    "sourceSchedule": "체육118(화6,7,8)"
  },
  {
    "id": "11532-001-2000595",
    "subjectKey": "11532",
    "name": "라이프케어빅데이터분석(마이크로디그리)",
    "division": "001",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "염희란",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경507",
    "isOnline": false,
    "source": {
      "schedule": "글경507(화4,5,6)"
    },
    "capacity": 32,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경507"
      }
    ],
    "sourceSchedule": "글경507(화4,5,6)"
  },
  {
    "id": "11532-002-2000595",
    "subjectKey": "11532",
    "name": "라이프케어빅데이터분석(마이크로디그리)",
    "division": "002",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "염희란",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경507",
    "isOnline": false,
    "source": {
      "schedule": "글경507(수4,5,6)"
    },
    "capacity": 32,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경507"
      }
    ],
    "sourceSchedule": "글경507(수4,5,6)"
  },
  {
    "id": "11535-001-2000625",
    "subjectKey": "11535",
    "name": "World Culture and Travel English",
    "division": "001",
    "department": "국제개발협력",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "딜런",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "글경504",
    "isOnline": false,
    "source": {
      "schedule": "글경504(화2,3 목2)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "글경504"
      },
      {
        "day": "목",
        "periods": [
          2
        ],
        "classroom": "글경504"
      }
    ],
    "sourceSchedule": "글경504(화2,3 목2)"
  },
  {
    "id": "11538-001-2000609",
    "subjectKey": "11538",
    "name": "국악관현악과성악2",
    "division": "001",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김만석",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악107",
    "isOnline": false,
    "source": {
      "schedule": "음악107(화5,6 금5,6)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "음악107"
      },
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "음악107"
      }
    ],
    "sourceSchedule": "음악107(화5,6 금5,6)"
  },
  {
    "id": "11538-002-2000609",
    "subjectKey": "11538",
    "name": "국악관현악과성악2",
    "division": "002",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김미림",
    "days": [
      "금",
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육105",
    "isOnline": false,
    "source": {
      "schedule": "체육105(금5,6),음악315(화5,6)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "체육105"
      },
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "음악315"
      }
    ],
    "sourceSchedule": "체육105(금5,6),음악315(화5,6)"
  },
  {
    "id": "11540-001-2000609",
    "subjectKey": "11540",
    "name": "국악관현악과성악4",
    "division": "001",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김만석",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악107",
    "isOnline": false,
    "source": {
      "schedule": "음악107(화5,6 금5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "음악107"
      },
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "음악107"
      }
    ],
    "sourceSchedule": "음악107(화5,6 금5,6)"
  },
  {
    "id": "11540-002-2000609",
    "subjectKey": "11540",
    "name": "국악관현악과성악4",
    "division": "002",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김미림",
    "days": [
      "금",
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육105",
    "isOnline": false,
    "source": {
      "schedule": "체육105(금5,6),음악315(화5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "체육105"
      },
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "음악315"
      }
    ],
    "sourceSchedule": "체육105(금5,6),음악315(화5,6)"
  },
  {
    "id": "11542-001-2000609",
    "subjectKey": "11542",
    "name": "국악관현악과성악6",
    "division": "001",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김만석",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "음악107",
    "isOnline": false,
    "source": {
      "schedule": "음악107(화7,8 금7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "음악107"
      },
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "음악107"
      }
    ],
    "sourceSchedule": "음악107(화7,8 금7,8)"
  },
  {
    "id": "11542-002-2000609",
    "subjectKey": "11542",
    "name": "국악관현악과성악6",
    "division": "002",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김미림",
    "days": [
      "금",
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "체육105",
    "isOnline": false,
    "source": {
      "schedule": "체육105(금7,8),음악315(화7,8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "체육105"
      },
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "음악315"
      }
    ],
    "sourceSchedule": "체육105(금7,8),음악315(화7,8)"
  },
  {
    "id": "11544-001-2000267",
    "subjectKey": "11544",
    "name": "국악관현악과성악8",
    "division": "001",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김만석",
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "음악107",
    "isOnline": false,
    "source": {
      "schedule": "음악107(화7,8 금7,8)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "음악107"
      },
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "음악107"
      }
    ],
    "sourceSchedule": "음악107(화7,8 금7,8)"
  },
  {
    "id": "11544-002-2000267",
    "subjectKey": "11544",
    "name": "국악관현악과성악8",
    "division": "002",
    "department": "국악과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김미림",
    "days": [
      "금",
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "체육105",
    "isOnline": false,
    "source": {
      "schedule": "체육105(금7,8),음악315(화7,8)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          7,
          8
        ],
        "classroom": "체육105"
      },
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "음악315"
      }
    ],
    "sourceSchedule": "체육105(금7,8),음악315(화7,8)"
  },
  {
    "id": "11548-001-2000747",
    "subjectKey": "11548",
    "name": "디지털헤리티지의초대",
    "division": "001",
    "department": "디지털헤리티지",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양정석",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문512",
    "isOnline": false,
    "source": {
      "schedule": "인문512(목5,6,7)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문512"
      }
    ],
    "sourceSchedule": "인문512(목5,6,7)"
  },
  {
    "id": "11548-001-2000763",
    "subjectKey": "11548",
    "name": "디지털헤리티지의초대",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양정석",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문512",
    "isOnline": false,
    "source": {
      "schedule": "인문512(목5,6,7)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문512"
      }
    ],
    "sourceSchedule": "인문512(목5,6,7)"
  },
  {
    "id": "11554-001-2000642",
    "subjectKey": "11554",
    "name": "기능재료와원소",
    "division": "001",
    "department": "신소재공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박상원",
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합409",
    "isOnline": false,
    "source": {
      "schedule": "종합409(수5,6 목8)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "종합409"
      },
      {
        "day": "목",
        "periods": [
          8
        ],
        "classroom": "종합409"
      }
    ],
    "sourceSchedule": "종합409(수5,6 목8)"
  },
  {
    "id": "11558-001-2000716",
    "subjectKey": "11558",
    "name": "스타트업마케팅전략",
    "division": "001",
    "department": "창업학 융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "최종학",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B201",
    "isOnline": false,
    "source": {
      "schedule": "미래B201(화4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B201"
      }
    ],
    "sourceSchedule": "미래B201(화4,5,6)"
  },
  {
    "id": "11558-002-2000716",
    "subjectKey": "11558",
    "name": "스타트업마케팅전략",
    "division": "002",
    "department": "창업학 융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "최종학",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B201",
    "isOnline": false,
    "source": {
      "schedule": "미래B201(수4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B201"
      }
    ],
    "sourceSchedule": "미래B201(수4,5,6)"
  },
  {
    "id": "11561-001-2000559",
    "subjectKey": "11561",
    "name": "스타트업사업계획서(학점교류)",
    "division": "001",
    "department": "창업학 융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11562-001-2000559",
    "subjectKey": "11562",
    "name": "스타트업자금조달과투자유치",
    "division": "001",
    "department": "창업학 융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김성민",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래521",
    "isOnline": false,
    "source": {
      "schedule": "미래521(수7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래521"
      }
    ],
    "sourceSchedule": "미래521(수7,8,9)"
  },
  {
    "id": "11566-001-2000716",
    "subjectKey": "11566",
    "name": "디지털마케팅실무",
    "division": "001",
    "department": "창업학 융복합전공",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김기선",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래521",
    "isOnline": false,
    "source": {
      "schedule": "미래521(목4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래521"
      }
    ],
    "sourceSchedule": "미래521(목4,5,6)"
  },
  {
    "id": "11567-001-2000559",
    "subjectKey": "11567",
    "name": "인공지능과창업",
    "division": "001",
    "department": "창업학 융복합전공",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김영환",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래521",
    "isOnline": false,
    "source": {
      "schedule": "미래521(화1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래521"
      }
    ],
    "sourceSchedule": "미래521(화1,2,3)"
  },
  {
    "id": "11568-001-2000716",
    "subjectKey": "11568",
    "name": "소셜벤처창업",
    "division": "001",
    "department": "창업학 융복합전공",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김성민",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래521",
    "isOnline": false,
    "source": {
      "schedule": "미래521(수1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래521"
      }
    ],
    "sourceSchedule": "미래521(수1,2,3)"
  },
  {
    "id": "11571-001-2000658",
    "subjectKey": "11571",
    "name": "중국도시랜선여행",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "손미리",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합308",
    "isOnline": false,
    "source": {
      "schedule": "종합308(목4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합308"
      }
    ],
    "sourceSchedule": "종합308(목4,5,6)"
  },
  {
    "id": "11573-001-2000658",
    "subjectKey": "11573",
    "name": "글로벌비즈니스에티켓&매너",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박성모",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경B104",
    "isOnline": false,
    "source": {
      "schedule": "글경B104(목1,2,3)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경B104"
      }
    ],
    "sourceSchedule": "글경B104(목1,2,3)"
  },
  {
    "id": "11576-001-2000658",
    "subjectKey": "11576",
    "name": "자기개발과청년창업",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박효남",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B203",
    "isOnline": false,
    "source": {
      "schedule": "미래B203(월4,5,6)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B203"
      }
    ],
    "sourceSchedule": "미래B203(월4,5,6)"
  },
  {
    "id": "11585-001-2000587",
    "subjectKey": "11585",
    "name": "로컬콘텐츠와해양레저관광(마이크로디그리)",
    "division": "001",
    "department": "호텔관광학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김승준",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "글경701",
    "isOnline": false,
    "source": {
      "schedule": "글경701(월7,8,9)"
    },
    "capacity": 62,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "글경701"
      }
    ],
    "sourceSchedule": "글경701(월7,8,9)"
  },
  {
    "id": "11587-001-2000716",
    "subjectKey": "11587",
    "name": "실전창업워크숍",
    "division": "001",
    "department": "창업학 융복합전공",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "신의현",
    "days": [
      "금"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래521",
    "isOnline": false,
    "source": {
      "schedule": "미래521(금7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래521"
      }
    ],
    "sourceSchedule": "미래521(금7,8,9)"
  },
  {
    "id": "11599-001-2000180",
    "subjectKey": "11599",
    "name": "전동화시스템및실험(마이그로디그리)",
    "division": "001",
    "department": "전기공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "배진용",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연관509",
    "isOnline": false,
    "source": {
      "schedule": "자연관509(수5,6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연관509"
      }
    ],
    "sourceSchedule": "자연관509(수5,6,7,8)"
  },
  {
    "id": "11606-001-2000615",
    "subjectKey": "11606",
    "name": "이머시브미디어제작",
    "division": "001",
    "department": "디지털콘텐츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "진창명",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "미래115",
    "isOnline": false,
    "source": {
      "schedule": "미래115(금2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "미래115"
      }
    ],
    "sourceSchedule": "미래115(금2,3,4)"
  },
  {
    "id": "11611-001-2000658",
    "subjectKey": "11611",
    "name": "그린리더십산업의발견(마이크로디그리)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "류덕기",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경B104",
    "isOnline": false,
    "source": {
      "schedule": "글경B104(목4,5,6)"
    },
    "capacity": 31,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경B104"
      }
    ],
    "sourceSchedule": "글경B104(목4,5,6)"
  },
  {
    "id": "11614-001-2000658",
    "subjectKey": "11614",
    "name": "빅데이터시각화와탐색",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "서정석",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래312",
    "isOnline": false,
    "source": {
      "schedule": "미래312(목4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래312"
      }
    ],
    "sourceSchedule": "미래312(목4,5,6)"
  },
  {
    "id": "11616-001-2000658",
    "subjectKey": "11616",
    "name": "인공지능으로일하는기술",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "이정배",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문507",
    "isOnline": false,
    "source": {
      "schedule": "인문507(수4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문507"
      }
    ],
    "sourceSchedule": "인문507(수4,5,6)"
  },
  {
    "id": "11617-001-2000658",
    "subjectKey": "11617",
    "name": "스포츠와심리학의이해",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김한솔",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "체육117",
    "isOnline": false,
    "source": {
      "schedule": "체육117(월5,6,7)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "체육117"
      }
    ],
    "sourceSchedule": "체육117(월5,6,7)"
  },
  {
    "id": "11619-001-2000658",
    "subjectKey": "11619",
    "name": "로컬콘텐츠와창업(마이크로디그리)",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "한승헌",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래520",
    "isOnline": false,
    "source": {
      "schedule": "미래520(목1,2,3)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래520"
      }
    ],
    "sourceSchedule": "미래520(목1,2,3)"
  },
  {
    "id": "11621-001-2000658",
    "subjectKey": "11621",
    "name": "신제품개발과아이디어창출기법",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "조원모",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B201",
    "isOnline": false,
    "source": {
      "schedule": "미래B201(월4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B201"
      }
    ],
    "sourceSchedule": "미래B201(월4,5,6)"
  },
  {
    "id": "11627-001-2000600",
    "subjectKey": "11627",
    "name": "복식디자인실습2",
    "division": "001",
    "department": "의류학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "사사키치카",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "생활405",
    "isOnline": false,
    "source": {
      "schedule": "생활405(화1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "생활405"
      }
    ],
    "sourceSchedule": "생활405(화1,2,3)"
  },
  {
    "id": "11633-001-2000598",
    "subjectKey": "11633",
    "name": "인체구조와기능",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박경희",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래417",
    "isOnline": false,
    "source": {
      "schedule": "미래417(금1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래417"
      }
    ],
    "sourceSchedule": "미래417(금1,2,3)"
  },
  {
    "id": "11633-002-2000598",
    "subjectKey": "11633",
    "name": "인체구조와기능",
    "division": "002",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박경희",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "미래417",
    "isOnline": false,
    "source": {
      "schedule": "미래417(금5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "미래417"
      }
    ],
    "sourceSchedule": "미래417(금5,6,7)"
  },
  {
    "id": "11638-001-2000615",
    "subjectKey": "11638",
    "name": "로컬메이커2(마이크로디그리)",
    "division": "001",
    "department": "디지털콘텐츠",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "주명진",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래116",
    "isOnline": false,
    "source": {
      "schedule": "미래116(월6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래116"
      }
    ],
    "sourceSchedule": "미래116(월6,7,8)"
  },
  {
    "id": "11639-001-2000658",
    "subjectKey": "11639",
    "name": "생성형인공지능헬스케어",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김준태",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래311",
    "isOnline": false,
    "source": {
      "schedule": "미래311(월4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래311"
      }
    ],
    "sourceSchedule": "미래311(월4,5,6)"
  },
  {
    "id": "11647-001-2000592",
    "subjectKey": "11647",
    "name": "나노소재과학2",
    "division": "001",
    "department": "반도체공학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이관",
    "days": [
      "수",
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "종합408",
    "isOnline": false,
    "source": {
      "schedule": "종합408(수1,2),종합412(월3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2
        ],
        "classroom": "종합408"
      },
      {
        "day": "월",
        "periods": [
          3
        ],
        "classroom": "종합412"
      }
    ],
    "sourceSchedule": "종합408(수1,2),종합412(월3)"
  },
  {
    "id": "11652-001-2000632",
    "subjectKey": "11652",
    "name": "자원생명공학",
    "division": "001",
    "department": "바이오공학 및 마케팅",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "람야 마티야라간",
    "days": [
      "월",
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "종합404",
    "isOnline": false,
    "source": {
      "schedule": "종합404(월5 금2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5
        ],
        "classroom": "종합404"
      },
      {
        "day": "금",
        "periods": [
          2,
          3
        ],
        "classroom": "종합404"
      }
    ],
    "sourceSchedule": "종합404(월5 금2,3)"
  },
  {
    "id": "11659-001-2000739",
    "subjectKey": "11659",
    "name": "고전과캐릭터",
    "division": "001",
    "department": "한국언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박순",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문500",
    "isOnline": false,
    "source": {
      "schedule": "인문500(월6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문500"
      }
    ],
    "sourceSchedule": "인문500(월6,7,8)"
  },
  {
    "id": "11660-001-2000739",
    "subjectKey": "11660",
    "name": "K드라마의구조",
    "division": "001",
    "department": "한국언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "송선령",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문500",
    "isOnline": false,
    "source": {
      "schedule": "인문500(수5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문500"
      }
    ],
    "sourceSchedule": "인문500(수5,6,7)"
  },
  {
    "id": "11666-002-2000739",
    "subjectKey": "11666",
    "name": "화법의원리(외국인전용)",
    "division": "002",
    "department": "한국언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "문미종",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문400",
    "isOnline": false,
    "source": {
      "schedule": "인문400(화6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문400"
      }
    ],
    "sourceSchedule": "인문400(화6,7,8)"
  },
  {
    "id": "11669-001-2000739",
    "subjectKey": "11669",
    "name": "생성형AI와한국어(학점교류)",
    "division": "001",
    "department": "한국언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": false,
    "source": {
      "schedule": ""
    },
    "capacity": null,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11670-001-2000739",
    "subjectKey": "11670",
    "name": "출판과편집",
    "division": "001",
    "department": "한국언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조정미",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래312",
    "isOnline": false,
    "source": {
      "schedule": "미래312(목1,2,3)"
    },
    "capacity": 39,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래312"
      }
    ],
    "sourceSchedule": "미래312(목1,2,3)"
  },
  {
    "id": "11683-001-2000748",
    "subjectKey": "11683",
    "name": "소방방재개론",
    "division": "001",
    "department": "소방행정",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김미리",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문506",
    "isOnline": false,
    "source": {
      "schedule": "인문506(수6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문506"
      }
    ],
    "sourceSchedule": "인문506(수6,7,8)"
  },
  {
    "id": "11686-001-2000551",
    "subjectKey": "11686",
    "name": "소방세미나",
    "division": "001",
    "department": "소방행정학과(야)",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정요안",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문310",
    "isOnline": false,
    "source": {
      "schedule": "인문310(화2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문310"
      }
    ],
    "sourceSchedule": "인문310(화2,3,4)"
  },
  {
    "id": "11687-001-2000551",
    "subjectKey": "11687",
    "name": "소방심리학",
    "division": "001",
    "department": "소방행정학과(야)",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김순덕",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문310",
    "isOnline": false,
    "source": {
      "schedule": "인문310(목6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문310"
      }
    ],
    "sourceSchedule": "인문310(목6,7,8)"
  },
  {
    "id": "11690-001-2000584",
    "subjectKey": "11690",
    "name": "소방조직론",
    "division": "001",
    "department": "소방행정학과(야)",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김성곤",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "종합306",
    "isOnline": false,
    "source": {
      "schedule": "종합306(화6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "종합306"
      }
    ],
    "sourceSchedule": "종합306(화6,7,8)"
  },
  {
    "id": "11691-001-2000551",
    "subjectKey": "11691",
    "name": "소방체육",
    "division": "001",
    "department": "소방행정학과(야)",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이철원",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문103",
    "isOnline": false,
    "source": {
      "schedule": "인문103(목2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문103"
      }
    ],
    "sourceSchedule": "인문103(목2,3,4)"
  },
  {
    "id": "11694-001-2000748",
    "subjectKey": "11694",
    "name": "소방행정학",
    "division": "001",
    "department": "소방행정",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정요안",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문107",
    "isOnline": false,
    "source": {
      "schedule": "인문107(수2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문107"
      }
    ],
    "sourceSchedule": "인문107(수2,3,4)"
  },
  {
    "id": "11694-001-2000763",
    "subjectKey": "11694",
    "name": "소방행정학",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정요안",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문107",
    "isOnline": false,
    "source": {
      "schedule": "인문107(수2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문107"
      }
    ],
    "sourceSchedule": "인문107(수2,3,4)"
  },
  {
    "id": "11700-001-2000584",
    "subjectKey": "11700",
    "name": "첨단산업화재예방론",
    "division": "001",
    "department": "소방행정학과(야)",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정요안",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "첨단401",
    "isOnline": false,
    "source": {
      "schedule": "첨단401(목2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "첨단401"
      }
    ],
    "sourceSchedule": "첨단401(목2,3,4)"
  },
  {
    "id": "11701-001-2000748",
    "subjectKey": "11701",
    "name": "화재현상론",
    "division": "001",
    "department": "소방행정",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김승룡",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문406",
    "isOnline": false,
    "source": {
      "schedule": "인문406(월2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문406"
      }
    ],
    "sourceSchedule": "인문406(월2,3,4)"
  },
  {
    "id": "11703-001-2000598",
    "subjectKey": "11703",
    "name": "정신간호학실습1",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권민",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래423",
    "isOnline": false,
    "source": {
      "schedule": "미래423(월7,8,9 화7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래423"
      },
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래423"
      }
    ],
    "sourceSchedule": "미래423(월7,8,9 화7,8,9)"
  },
  {
    "id": "11703-002-2000598",
    "subjectKey": "11703",
    "name": "정신간호학실습1",
    "division": "002",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "권민",
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래416",
    "isOnline": false,
    "source": {
      "schedule": "미래416(월4,5,6 화4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래416"
      },
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래416"
      }
    ],
    "sourceSchedule": "미래416(월4,5,6 화4,5,6)"
  },
  {
    "id": "11705-001-2000598",
    "subjectKey": "11705",
    "name": "보완대체간호",
    "division": "001",
    "department": "간호학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "박금주",
    "days": [
      "수"
    ],
    "startPeriod": 8,
    "endPeriod": 9,
    "room": "미래427",
    "isOnline": false,
    "source": {
      "schedule": "미래427(수8,9)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          8,
          9
        ],
        "classroom": "미래427"
      }
    ],
    "sourceSchedule": "미래427(수8,9)"
  },
  {
    "id": "11708-001-2000653",
    "subjectKey": "11708",
    "name": "Design Theory",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "박지윤",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "종합403",
    "isOnline": false,
    "source": {
      "schedule": "종합403(월4,5)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5
        ],
        "classroom": "종합403"
      }
    ],
    "sourceSchedule": "종합403(월4,5)"
  },
  {
    "id": "11708-002-2000655",
    "subjectKey": "11708",
    "name": "Design Theory",
    "division": "002",
    "department": "공예디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "천혜영",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "미술204",
    "isOnline": false,
    "source": {
      "schedule": "미술204(월2,3,4)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "미술204"
      }
    ],
    "sourceSchedule": "미술204(월2,3,4)"
  },
  {
    "id": "11713-001-2000430",
    "subjectKey": "11713",
    "name": "지역사회간호학실습2",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 1,
    "professor": "박경희",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래418",
    "isOnline": false,
    "source": {
      "schedule": "미래418(화7,8,9)"
    },
    "capacity": 100,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래418"
      }
    ],
    "sourceSchedule": "미래418(화7,8,9)"
  },
  {
    "id": "11714-001-2000655",
    "subjectKey": "11714",
    "name": "Ceramic & Material Studies2",
    "division": "001",
    "department": "공예디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "임경아",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "조형103",
    "isOnline": false,
    "source": {
      "schedule": "조형103(월2,3,4)"
    },
    "capacity": 25,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "조형103"
      }
    ],
    "sourceSchedule": "조형103(월2,3,4)"
  },
  {
    "id": "11715-001-2000655",
    "subjectKey": "11715",
    "name": "오브제2",
    "division": "001",
    "department": "공예디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "황재원",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "조형203",
    "isOnline": false,
    "source": {
      "schedule": "조형203(화2,3,4)"
    },
    "capacity": 15,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "조형203"
      }
    ],
    "sourceSchedule": "조형203(화2,3,4)"
  },
  {
    "id": "11717-001-2000655",
    "subjectKey": "11717",
    "name": "Fiber & Material Studies2",
    "division": "001",
    "department": "공예디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "유지은",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "미술111",
    "isOnline": false,
    "source": {
      "schedule": "미술111(수2,3,4)"
    },
    "capacity": 29,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "미술111"
      }
    ],
    "sourceSchedule": "미술111(수2,3,4)"
  },
  {
    "id": "11718-001-2000653",
    "subjectKey": "11718",
    "name": "UXUI1",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "원다예",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술213-1",
    "isOnline": false,
    "source": {
      "schedule": "미술213-1(수5,6,7,8)"
    },
    "capacity": 24,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술213-1"
      }
    ],
    "sourceSchedule": "미술213-1(수5,6,7,8)"
  },
  {
    "id": "11718-002-2000653",
    "subjectKey": "11718",
    "name": "UXUI1",
    "division": "002",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "원다예",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술213-1",
    "isOnline": false,
    "source": {
      "schedule": "미술213-1(금1,2,3,4)"
    },
    "capacity": 24,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술213-1"
      }
    ],
    "sourceSchedule": "미술213-1(금1,2,3,4)"
  },
  {
    "id": "11719-001-2000655",
    "subjectKey": "11719",
    "name": "Digital Fabrication2",
    "division": "001",
    "department": "공예디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "노선영",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "조형202",
    "isOnline": false,
    "source": {
      "schedule": "조형202(수6,7,8)"
    },
    "capacity": 25,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "조형202"
      }
    ],
    "sourceSchedule": "조형202(수6,7,8)"
  },
  {
    "id": "11721-001-2000598",
    "subjectKey": "11721",
    "name": "다문화의이해",
    "division": "001",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김라영",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래314",
    "isOnline": false,
    "source": {
      "schedule": "미래314(금1,2)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "미래314"
      }
    ],
    "sourceSchedule": "미래314(금1,2)"
  },
  {
    "id": "11721-002-2000598",
    "subjectKey": "11721",
    "name": "다문화의이해",
    "division": "002",
    "department": "간호학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "김라영",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래315",
    "isOnline": false,
    "source": {
      "schedule": "미래315(금5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "미래315"
      }
    ],
    "sourceSchedule": "미래315(금5,6)"
  },
  {
    "id": "11724-001-2000653",
    "subjectKey": "11724",
    "name": "Intro. to Design",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "진향기",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술213-1",
    "isOnline": false,
    "source": {
      "schedule": "미술213-1(목1,2,3,4)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술213-1"
      }
    ],
    "sourceSchedule": "미술213-1(목1,2,3,4)"
  },
  {
    "id": "11724-002-2000655",
    "subjectKey": "11724",
    "name": "Intro. to Design",
    "division": "002",
    "department": "공예디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "유지은",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술204",
    "isOnline": false,
    "source": {
      "schedule": "미술204(목1,2,3,4)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술204"
      }
    ],
    "sourceSchedule": "미술204(목1,2,3,4)"
  },
  {
    "id": "11724-003-2000653",
    "subjectKey": "11724",
    "name": "Intro. to Design",
    "division": "003",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "진향기",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술213-1",
    "isOnline": false,
    "source": {
      "schedule": "미술213-1(목5,6,7,8)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술213-1"
      }
    ],
    "sourceSchedule": "미술213-1(목5,6,7,8)"
  },
  {
    "id": "11729-001-2000257",
    "subjectKey": "11729",
    "name": "3D Graphic Studio",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "조한진",
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술213-1",
    "isOnline": false,
    "source": {
      "schedule": "미술213-1(월5,6,7,8)"
    },
    "capacity": 24,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술213-1"
      }
    ],
    "sourceSchedule": "미술213-1(월5,6,7,8)"
  },
  {
    "id": "11730-001-2000256",
    "subjectKey": "11730",
    "name": "텍스타일상품기획및제작2",
    "division": "001",
    "department": "공예디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "심용주",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 5,
    "room": "미술212",
    "isOnline": false,
    "source": {
      "schedule": "미술212(금2,3,4,5)"
    },
    "capacity": 25,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4,
          5
        ],
        "classroom": "미술212"
      }
    ],
    "sourceSchedule": "미술212(금2,3,4,5)"
  },
  {
    "id": "11731-001-2000655",
    "subjectKey": "11731",
    "name": "디지털모델링2",
    "division": "001",
    "department": "공예디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박동민",
    "days": [
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "미술202",
    "isOnline": false,
    "source": {
      "schedule": "미술202(금2,3,4)"
    },
    "capacity": 18,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "미술202"
      }
    ],
    "sourceSchedule": "미술202(금2,3,4)"
  },
  {
    "id": "11731-002-2000655",
    "subjectKey": "11731",
    "name": "디지털모델링2",
    "division": "002",
    "department": "공예디자인",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박동민",
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미술202",
    "isOnline": false,
    "source": {
      "schedule": "미술202(금6,7,8)"
    },
    "capacity": 18,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미술202"
      }
    ],
    "sourceSchedule": "미술202(금6,7,8)"
  },
  {
    "id": "11733-001-2000653",
    "subjectKey": "11733",
    "name": "기초일러스트레이션",
    "division": "001",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "한성원",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술205",
    "isOnline": false,
    "source": {
      "schedule": "미술205(화5,6,7,8)"
    },
    "capacity": 20,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술205"
      }
    ],
    "sourceSchedule": "미술205(화5,6,7,8)"
  },
  {
    "id": "11733-002-2000653",
    "subjectKey": "11733",
    "name": "기초일러스트레이션",
    "division": "002",
    "department": "커뮤니케이션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "한성원",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술203",
    "isOnline": false,
    "source": {
      "schedule": "미술203(목1,2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술203"
      }
    ],
    "sourceSchedule": "미술203(목1,2,3,4)"
  },
  {
    "id": "11738-001-2000741",
    "subjectKey": "11738",
    "name": "베이직일본어2",
    "division": "001",
    "department": "일본언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "박진현",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "종합505",
    "isOnline": false,
    "source": {
      "schedule": "종합505(화6,7,8)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "종합505"
      }
    ],
    "sourceSchedule": "종합505(화6,7,8)"
  },
  {
    "id": "11743-001-2000741",
    "subjectKey": "11743",
    "name": "일본어듣기첫걸음2",
    "division": "001",
    "department": "일본언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김선희",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문401",
    "isOnline": false,
    "source": {
      "schedule": "인문401(목5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문401"
      }
    ],
    "sourceSchedule": "인문401(목5,6,7)"
  },
  {
    "id": "11744-001-2000741",
    "subjectKey": "11744",
    "name": "실생활일본어",
    "division": "001",
    "department": "일본언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "야스코우치 아키코",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문313",
    "isOnline": false,
    "source": {
      "schedule": "인문313(수1,2,3)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문313"
      }
    ],
    "sourceSchedule": "인문313(수1,2,3)"
  },
  {
    "id": "11750-001-2000741",
    "subjectKey": "11750",
    "name": "일본어와일본문화",
    "division": "001",
    "department": "일본언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "방윤형",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합509",
    "isOnline": false,
    "source": {
      "schedule": "종합509(수5,6,7)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합509"
      }
    ],
    "sourceSchedule": "종합509(수5,6,7)"
  },
  {
    "id": "11750-001-2000763",
    "subjectKey": "11750",
    "name": "일본어와일본문화",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "방윤형",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합509",
    "isOnline": false,
    "source": {
      "schedule": "종합509(수5,6,7)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합509"
      }
    ],
    "sourceSchedule": "종합509(수5,6,7)"
  },
  {
    "id": "11751-001-2000741",
    "subjectKey": "11751",
    "name": "미디어로배우는일본문화",
    "division": "001",
    "department": "일본언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김선희",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문313",
    "isOnline": false,
    "source": {
      "schedule": "인문313(수4,5,6)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문313"
      }
    ],
    "sourceSchedule": "인문313(수4,5,6)"
  },
  {
    "id": "11753-001-2000742",
    "subjectKey": "11753",
    "name": "차이나문화컨텐츠산책",
    "division": "001",
    "department": "중국언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "송진영",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문401",
    "isOnline": false,
    "source": {
      "schedule": "인문401(수5,6,7)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문401"
      }
    ],
    "sourceSchedule": "인문401(수5,6,7)"
  },
  {
    "id": "11753-001-2000763",
    "subjectKey": "11753",
    "name": "차이나문화컨텐츠산책",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "송진영",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문401",
    "isOnline": false,
    "source": {
      "schedule": "인문401(수5,6,7)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문401"
      }
    ],
    "sourceSchedule": "인문401(수5,6,7)"
  },
  {
    "id": "11755-001-2000742",
    "subjectKey": "11755",
    "name": "AI활용중국어작문연습",
    "division": "001",
    "department": "중국언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "최영",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문500",
    "isOnline": false,
    "source": {
      "schedule": "인문500(화1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문500"
      }
    ],
    "sourceSchedule": "인문500(화1,2,3)"
  },
  {
    "id": "11759-001-2000743",
    "subjectKey": "11759",
    "name": "러시아사",
    "division": "001",
    "department": "러시아언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "벨랴코프일리야",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문501",
    "isOnline": false,
    "source": {
      "schedule": "인문501(수5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문501"
      }
    ],
    "sourceSchedule": "인문501(수5,6,7)"
  },
  {
    "id": "11761-001-2000743",
    "subjectKey": "11761",
    "name": "러시아어와문화",
    "division": "001",
    "department": "러시아언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이혜승",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문501",
    "isOnline": false,
    "source": {
      "schedule": "인문501(목4,5,6)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문501"
      }
    ],
    "sourceSchedule": "인문501(목4,5,6)"
  },
  {
    "id": "11761-001-2000763",
    "subjectKey": "11761",
    "name": "러시아어와문화",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이혜승",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문501",
    "isOnline": false,
    "source": {
      "schedule": "인문501(목4,5,6)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문501"
      }
    ],
    "sourceSchedule": "인문501(목4,5,6)"
  },
  {
    "id": "11763-001-2000740",
    "subjectKey": "11763",
    "name": "영어와영어권문화",
    "division": "001",
    "department": "영미언어문화",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고영란",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문301",
    "isOnline": false,
    "source": {
      "schedule": "인문301(수6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문301"
      }
    ],
    "sourceSchedule": "인문301(수6,7,8)"
  },
  {
    "id": "11763-001-2000763",
    "subjectKey": "11763",
    "name": "영어와영어권문화",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "고영란",
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문301",
    "isOnline": false,
    "source": {
      "schedule": "인문301(수6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문301"
      }
    ],
    "sourceSchedule": "인문301(수6,7,8)"
  },
  {
    "id": "11764-001-2000744",
    "subjectKey": "11764",
    "name": "법과4차산업사회",
    "division": "001",
    "department": "법학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "손창일",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문509",
    "isOnline": false,
    "source": {
      "schedule": "인문509(수5,6,7)"
    },
    "capacity": 51,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문509"
      }
    ],
    "sourceSchedule": "인문509(수5,6,7)"
  },
  {
    "id": "11764-001-2000763",
    "subjectKey": "11764",
    "name": "법과4차산업사회",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "손창일",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문509",
    "isOnline": false,
    "source": {
      "schedule": "인문509(수5,6,7)"
    },
    "capacity": 51,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문509"
      }
    ],
    "sourceSchedule": "인문509(수5,6,7)"
  },
  {
    "id": "11764-002-2000744",
    "subjectKey": "11764",
    "name": "법과4차산업사회",
    "division": "002",
    "department": "법학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "손창일",
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문400",
    "isOnline": false,
    "source": {
      "schedule": "인문400(월2,3,4)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문400"
      }
    ],
    "sourceSchedule": "인문400(월2,3,4)"
  },
  {
    "id": "11769-001-2000748",
    "subjectKey": "11769",
    "name": "소방전기회로 II(소방전기론2)",
    "division": "001",
    "department": "소방행정",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "문기현",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "첨단401",
    "isOnline": false,
    "source": {
      "schedule": "첨단401(화6,7,8)"
    },
    "capacity": 30,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "첨단401"
      }
    ],
    "sourceSchedule": "첨단401(화6,7,8)"
  },
  {
    "id": "11775-001-2000747",
    "subjectKey": "11775",
    "name": "문화유산과생성형AI",
    "division": "001",
    "department": "디지털헤리티지",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양정석",
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "인문401",
    "isOnline": false,
    "source": {
      "schedule": "인문401(화7,8 목4)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8
        ],
        "classroom": "인문401"
      },
      {
        "day": "목",
        "periods": [
          4
        ],
        "classroom": "인문401"
      }
    ],
    "sourceSchedule": "인문401(화7,8 목4)"
  },
  {
    "id": "11776-001-2000747",
    "subjectKey": "11776",
    "name": "공공역사학",
    "division": "001",
    "department": "디지털헤리티지",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양훈도",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문103",
    "isOnline": false,
    "source": {
      "schedule": "인문103(목5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문103"
      }
    ],
    "sourceSchedule": "인문103(목5,6,7)"
  },
  {
    "id": "11785-001-2000760",
    "subjectKey": "11785",
    "name": "비즈니스영어(외국인전용)",
    "division": "001",
    "department": "글로벌자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 2,
    "professor": "사무엘",
    "days": [
      "월"
    ],
    "startPeriod": 8,
    "endPeriod": 9,
    "room": "국제309",
    "isOnline": false,
    "source": {
      "schedule": "국제309(월8,9)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          8,
          9
        ],
        "classroom": "국제309"
      }
    ],
    "sourceSchedule": "국제309(월8,9)"
  },
  {
    "id": "11787-001-2000748",
    "subjectKey": "11787",
    "name": "소방관계법규2",
    "division": "001",
    "department": "소방행정",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김성곤",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "종합306",
    "isOnline": false,
    "source": {
      "schedule": "종합306(화2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "종합306"
      }
    ],
    "sourceSchedule": "종합306(화2,3,4)"
  },
  {
    "id": "11789-001-2000763",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "001",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "지나인",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문303",
    "isOnline": false,
    "source": {
      "schedule": "인문303(월4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문303"
      }
    ],
    "sourceSchedule": "인문303(월4,5,6)"
  },
  {
    "id": "11789-002-2000763",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "002",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "조셉",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문410",
    "isOnline": false,
    "source": {
      "schedule": "인문410(월4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문410"
      }
    ],
    "sourceSchedule": "인문410(월4,5,6)"
  },
  {
    "id": "11789-003-2000763",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "003",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이유리",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문404",
    "isOnline": false,
    "source": {
      "schedule": "인문404(월4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문404"
      }
    ],
    "sourceSchedule": "인문404(월4,5,6)"
  },
  {
    "id": "11789-004-2000763",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "004",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "유정화(소피)",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문102",
    "isOnline": false,
    "source": {
      "schedule": "인문102(화4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문102"
      }
    ],
    "sourceSchedule": "인문102(화4,5,6)"
  },
  {
    "id": "11789-005-2000763",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "005",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이유리",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문410",
    "isOnline": false,
    "source": {
      "schedule": "인문410(화4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문410"
      }
    ],
    "sourceSchedule": "인문410(화4,5,6)"
  },
  {
    "id": "11789-006-2000763",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "006",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "코스민",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문412",
    "isOnline": false,
    "source": {
      "schedule": "인문412(수4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문412"
      }
    ],
    "sourceSchedule": "인문412(수4,5,6)"
  },
  {
    "id": "11789-007-2000763",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "007",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "도미닉",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문306",
    "isOnline": false,
    "source": {
      "schedule": "인문306(수4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문306"
      }
    ],
    "sourceSchedule": "인문306(수4,5,6)"
  },
  {
    "id": "11789-008-2000738",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "008",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "로레타",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문302",
    "isOnline": false,
    "source": {
      "schedule": "인문302(화1,2,3)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문302"
      }
    ],
    "sourceSchedule": "인문302(화1,2,3)"
  },
  {
    "id": "11789-009-2000738",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "009",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "레이한",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문303",
    "isOnline": false,
    "source": {
      "schedule": "인문303(화1,2,3)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문303"
      }
    ],
    "sourceSchedule": "인문303(화1,2,3)"
  },
  {
    "id": "11789-010-2000738",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "010",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "레라니",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문107",
    "isOnline": false,
    "source": {
      "schedule": "인문107(화1,2,3)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문107"
      }
    ],
    "sourceSchedule": "인문107(화1,2,3)"
  },
  {
    "id": "11789-011-2000738",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "011",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "안쉬카",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문306",
    "isOnline": false,
    "source": {
      "schedule": "인문306(화1,2,3)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문306"
      }
    ],
    "sourceSchedule": "인문306(화1,2,3)"
  },
  {
    "id": "11789-012-2000738",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "012",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "제이슨",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문302",
    "isOnline": false,
    "source": {
      "schedule": "인문302(화4,5,6)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문302"
      }
    ],
    "sourceSchedule": "인문302(화4,5,6)"
  },
  {
    "id": "11789-013-2000738",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "013",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "제프리",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문303",
    "isOnline": false,
    "source": {
      "schedule": "인문303(화4,5,6)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문303"
      }
    ],
    "sourceSchedule": "인문303(화4,5,6)"
  },
  {
    "id": "11789-014-2000738",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "014",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "크리스",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문412",
    "isOnline": false,
    "source": {
      "schedule": "인문412(화4,5,6)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문412"
      }
    ],
    "sourceSchedule": "인문412(화4,5,6)"
  },
  {
    "id": "11789-015-2000738",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "015",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "미시카",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문306",
    "isOnline": false,
    "source": {
      "schedule": "인문306(화4,5,6)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문306"
      }
    ],
    "sourceSchedule": "인문306(화4,5,6)"
  },
  {
    "id": "11789-016-2000738",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "016",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "데이비드던",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문302",
    "isOnline": false,
    "source": {
      "schedule": "인문302(화7,8,9)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문302"
      }
    ],
    "sourceSchedule": "인문302(화7,8,9)"
  },
  {
    "id": "11789-017-2000738",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "017",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "데이비드",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문303",
    "isOnline": false,
    "source": {
      "schedule": "인문303(화7,8,9)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문303"
      }
    ],
    "sourceSchedule": "인문303(화7,8,9)"
  },
  {
    "id": "11789-018-2000738",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "018",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "코스민",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문412",
    "isOnline": false,
    "source": {
      "schedule": "인문412(화7,8,9)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문412"
      }
    ],
    "sourceSchedule": "인문412(화7,8,9)"
  },
  {
    "id": "11789-019-2000754",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "019",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "레이한",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문402",
    "isOnline": false,
    "source": {
      "schedule": "인문402(월1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문402"
      }
    ],
    "sourceSchedule": "인문402(월1,2,3)"
  },
  {
    "id": "11789-020-2000754",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "020",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "프린세나",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문403",
    "isOnline": false,
    "source": {
      "schedule": "인문403(월1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문403"
      }
    ],
    "sourceSchedule": "인문403(월1,2,3)"
  },
  {
    "id": "11789-021-2000754",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "021",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "제프리",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문402",
    "isOnline": false,
    "source": {
      "schedule": "인문402(월4,5,6)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문402"
      }
    ],
    "sourceSchedule": "인문402(월4,5,6)"
  },
  {
    "id": "11789-022-2000754",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "022",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "프레미",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문403",
    "isOnline": false,
    "source": {
      "schedule": "인문403(월4,5,6)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문403"
      }
    ],
    "sourceSchedule": "인문403(월4,5,6)"
  },
  {
    "id": "11789-023-2000754",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "023",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "제임",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문501",
    "isOnline": false,
    "source": {
      "schedule": "인문501(월4,5,6)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문501"
      }
    ],
    "sourceSchedule": "인문501(월4,5,6)"
  },
  {
    "id": "11789-024-2000754",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "024",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "사무엘",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문501",
    "isOnline": false,
    "source": {
      "schedule": "인문501(화7,8,9)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문501"
      }
    ],
    "sourceSchedule": "인문501(화7,8,9)"
  },
  {
    "id": "11789-025-2000754",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "025",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "로레타",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문102",
    "isOnline": false,
    "source": {
      "schedule": "인문102(수1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문102"
      }
    ],
    "sourceSchedule": "인문102(수1,2,3)"
  },
  {
    "id": "11789-026-2000754",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "026",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이안마이클",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문507",
    "isOnline": false,
    "source": {
      "schedule": "인문507(수1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문507"
      }
    ],
    "sourceSchedule": "인문507(수1,2,3)"
  },
  {
    "id": "11789-027-2000754",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "027",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "프린세나",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문403",
    "isOnline": false,
    "source": {
      "schedule": "인문403(수1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문403"
      }
    ],
    "sourceSchedule": "인문403(수1,2,3)"
  },
  {
    "id": "11789-029-2000755",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "029",
    "department": "바이오공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "크리스",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문302",
    "isOnline": false,
    "source": {
      "schedule": "인문302(수4,5,6)"
    },
    "capacity": 21,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문302"
      }
    ],
    "sourceSchedule": "인문302(수4,5,6)"
  },
  {
    "id": "11789-030-2000755",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "030",
    "department": "바이오공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "쉐인",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문303",
    "isOnline": false,
    "source": {
      "schedule": "인문303(수4,5,6)"
    },
    "capacity": 21,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문303"
      }
    ],
    "sourceSchedule": "인문303(수4,5,6)"
  },
  {
    "id": "11789-031-2000589",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "031",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "도미닉",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문307",
    "isOnline": false,
    "source": {
      "schedule": "인문307(화4,5,6)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문307"
      }
    ],
    "sourceSchedule": "인문307(화4,5,6)"
  },
  {
    "id": "11789-032-2000589",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "032",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "지나인",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문101",
    "isOnline": false,
    "source": {
      "schedule": "인문101(화4,5,6)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문101"
      }
    ],
    "sourceSchedule": "인문101(화4,5,6)"
  },
  {
    "id": "11789-033-2000589",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "033",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "조셉",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문402",
    "isOnline": false,
    "source": {
      "schedule": "인문402(화4,5,6)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문402"
      }
    ],
    "sourceSchedule": "인문402(화4,5,6)"
  },
  {
    "id": "11789-034-2000589",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "034",
    "department": "건설환경에너지공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "마이클",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문403",
    "isOnline": false,
    "source": {
      "schedule": "인문403(화4,5,6)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문403"
      }
    ],
    "sourceSchedule": "인문403(화4,5,6)"
  },
  {
    "id": "11789-035-2000590",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "035",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "로이드",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문302",
    "isOnline": false,
    "source": {
      "schedule": "인문302(수7,8,9)"
    },
    "capacity": 28,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문302"
      }
    ],
    "sourceSchedule": "인문302(수7,8,9)"
  },
  {
    "id": "11789-036-2000590",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "036",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "마이클",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문303",
    "isOnline": false,
    "source": {
      "schedule": "인문303(수7,8,9)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문303"
      }
    ],
    "sourceSchedule": "인문303(수7,8,9)"
  },
  {
    "id": "11789-037-2000590",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "037",
    "department": "건축도시부동산학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "스리비디아",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문412",
    "isOnline": false,
    "source": {
      "schedule": "인문412(수7,8,9)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문412"
      }
    ],
    "sourceSchedule": "인문412(수7,8,9)"
  },
  {
    "id": "11789-038-2000756",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "038",
    "department": "기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "안쉬카",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문404",
    "isOnline": false,
    "source": {
      "schedule": "인문404(수1,2,3)"
    },
    "capacity": 22,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문404"
      }
    ],
    "sourceSchedule": "인문404(수1,2,3)"
  },
  {
    "id": "11789-039-2000756",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "039",
    "department": "기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "최수연(줄리)",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문400",
    "isOnline": false,
    "source": {
      "schedule": "인문400(수1,2,3)"
    },
    "capacity": 22,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문400"
      }
    ],
    "sourceSchedule": "인문400(수1,2,3)"
  },
  {
    "id": "11789-040-2000756",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "040",
    "department": "기계공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "매튜",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문411",
    "isOnline": false,
    "source": {
      "schedule": "인문411(수1,2,3)"
    },
    "capacity": 22,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문411"
      }
    ],
    "sourceSchedule": "인문411(수1,2,3)"
  },
  {
    "id": "11789-041-2000592",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "041",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "프레미",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문402",
    "isOnline": false,
    "source": {
      "schedule": "인문402(화7,8,9)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문402"
      }
    ],
    "sourceSchedule": "인문402(화7,8,9)"
  },
  {
    "id": "11789-042-2000592",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "042",
    "department": "반도체공학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "토드",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문307",
    "isOnline": false,
    "source": {
      "schedule": "인문307(화7,8,9)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문307"
      }
    ],
    "sourceSchedule": "인문307(화7,8,9)"
  },
  {
    "id": "11789-043-2000593",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "043",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이선영",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문302",
    "isOnline": false,
    "source": {
      "schedule": "인문302(목1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문302"
      }
    ],
    "sourceSchedule": "인문302(목1,2,3)"
  },
  {
    "id": "11789-044-2000593",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "044",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이안마이클",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문408",
    "isOnline": false,
    "source": {
      "schedule": "인문408(목1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문408"
      }
    ],
    "sourceSchedule": "인문408(목1,2,3)"
  },
  {
    "id": "11789-045-2000593",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "045",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "재스민",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문412",
    "isOnline": false,
    "source": {
      "schedule": "인문412(목1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문412"
      }
    ],
    "sourceSchedule": "인문412(목1,2,3)"
  },
  {
    "id": "11789-046-2000593",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "046",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "유젤",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문101",
    "isOnline": false,
    "source": {
      "schedule": "인문101(목1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문101"
      }
    ],
    "sourceSchedule": "인문101(목1,2,3)"
  },
  {
    "id": "11789-047-2000593",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "047",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "레라니",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문303",
    "isOnline": false,
    "source": {
      "schedule": "인문303(목1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문303"
      }
    ],
    "sourceSchedule": "인문303(목1,2,3)"
  },
  {
    "id": "11789-048-2000593",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "048",
    "department": "전기전자공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "안쉬카",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문306",
    "isOnline": false,
    "source": {
      "schedule": "인문306(목1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문306"
      }
    ],
    "sourceSchedule": "인문306(목1,2,3)"
  },
  {
    "id": "11789-049-2000594",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "049",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "유젤",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문302",
    "isOnline": false,
    "source": {
      "schedule": "인문302(금1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문302"
      }
    ],
    "sourceSchedule": "인문302(금1,2,3)"
  },
  {
    "id": "11789-050-2000594",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "050",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "미시카",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문303",
    "isOnline": false,
    "source": {
      "schedule": "인문303(금1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문303"
      }
    ],
    "sourceSchedule": "인문303(금1,2,3)"
  },
  {
    "id": "11789-051-2000594",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "051",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "최수연(줄리)",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문412",
    "isOnline": false,
    "source": {
      "schedule": "인문412(금1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문412"
      }
    ],
    "sourceSchedule": "인문412(금1,2,3)"
  },
  {
    "id": "11789-052-2000594",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "052",
    "department": "화학공학·신소재공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "프린세나",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문306",
    "isOnline": false,
    "source": {
      "schedule": "인문306(금1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문306"
      }
    ],
    "sourceSchedule": "인문306(금1,2,3)"
  },
  {
    "id": "11789-053-2000757",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "053",
    "department": "AI데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "제이슨",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문402",
    "isOnline": false,
    "source": {
      "schedule": "인문402(목4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문402"
      }
    ],
    "sourceSchedule": "인문402(목4,5,6)"
  },
  {
    "id": "11789-054-2000757",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "054",
    "department": "AI데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "로레타",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문403",
    "isOnline": false,
    "source": {
      "schedule": "인문403(목4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문403"
      }
    ],
    "sourceSchedule": "인문403(목4,5,6)"
  },
  {
    "id": "11789-055-2000757",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "055",
    "department": "AI데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "제임",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문404",
    "isOnline": false,
    "source": {
      "schedule": "인문404(목4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문404"
      }
    ],
    "sourceSchedule": "인문404(목4,5,6)"
  },
  {
    "id": "11789-056-2000757",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "056",
    "department": "AI데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "도미닉",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문305",
    "isOnline": false,
    "source": {
      "schedule": "인문305(목4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문305"
      }
    ],
    "sourceSchedule": "인문305(목4,5,6)"
  },
  {
    "id": "11789-057-2000758",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "057",
    "department": "컴퓨터공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "유정화(소피)",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문402",
    "isOnline": false,
    "source": {
      "schedule": "인문402(목7,8,9)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문402"
      }
    ],
    "sourceSchedule": "인문402(목7,8,9)"
  },
  {
    "id": "11789-058-2000758",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "058",
    "department": "컴퓨터공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "아킬라",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문403",
    "isOnline": false,
    "source": {
      "schedule": "인문403(목7,8,9)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문403"
      }
    ],
    "sourceSchedule": "인문403(목7,8,9)"
  },
  {
    "id": "11789-059-2000758",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "059",
    "department": "컴퓨터공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "스리비디아",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문404",
    "isOnline": false,
    "source": {
      "schedule": "인문404(목7,8,9)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문404"
      }
    ],
    "sourceSchedule": "인문404(목7,8,9)"
  },
  {
    "id": "11789-060-2000758",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "060",
    "department": "컴퓨터공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "지나인",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문305",
    "isOnline": false,
    "source": {
      "schedule": "인문305(목7,8,9)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문305"
      }
    ],
    "sourceSchedule": "인문305(목7,8,9)"
  },
  {
    "id": "11789-061-2000759",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "061",
    "department": "지능형보안학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "유정화(소피)",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문502",
    "isOnline": false,
    "source": {
      "schedule": "인문502(수7,8,9)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문502"
      }
    ],
    "sourceSchedule": "인문502(수7,8,9)"
  },
  {
    "id": "11789-062-2000759",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "062",
    "department": "지능형보안학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "데이비드던",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문503",
    "isOnline": false,
    "source": {
      "schedule": "인문503(수7,8,9)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문503"
      }
    ],
    "sourceSchedule": "인문503(수7,8,9)"
  },
  {
    "id": "11789-063-2000598",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "063",
    "department": "간호학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "토마스",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문302",
    "isOnline": false,
    "source": {
      "schedule": "인문302(수1,2,3)"
    },
    "capacity": 22,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문302"
      }
    ],
    "sourceSchedule": "인문302(수1,2,3)"
  },
  {
    "id": "11789-064-2000598",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "064",
    "department": "간호학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "션",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문303",
    "isOnline": false,
    "source": {
      "schedule": "인문303(수1,2,3)"
    },
    "capacity": 22,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문303"
      }
    ],
    "sourceSchedule": "인문303(수1,2,3)"
  },
  {
    "id": "11789-065-2000598",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "065",
    "department": "간호학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "딜런",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문412",
    "isOnline": false,
    "source": {
      "schedule": "인문412(수1,2,3)"
    },
    "capacity": 22,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문412"
      }
    ],
    "sourceSchedule": "인문412(수1,2,3)"
  },
  {
    "id": "11789-066-2000598",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "066",
    "department": "간호학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "아킬라",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문503",
    "isOnline": false,
    "source": {
      "schedule": "인문503(수1,2,3)"
    },
    "capacity": 22,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문503"
      }
    ],
    "sourceSchedule": "인문503(수1,2,3)"
  },
  {
    "id": "11789-067-2000598",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "067",
    "department": "간호학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "미시카",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문306",
    "isOnline": false,
    "source": {
      "schedule": "인문306(수1,2,3)"
    },
    "capacity": 22,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문306"
      }
    ],
    "sourceSchedule": "인문306(수1,2,3)"
  },
  {
    "id": "11789-068-2000599",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "068",
    "department": "아동가족복지학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "재스민",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문305",
    "isOnline": false,
    "source": {
      "schedule": "인문305(수4,5,6)"
    },
    "capacity": 19,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문305"
      }
    ],
    "sourceSchedule": "인문305(수4,5,6)"
  },
  {
    "id": "11789-069-2000599",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "069",
    "department": "아동가족복지학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "조셉",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문410",
    "isOnline": false,
    "source": {
      "schedule": "인문410(수4,5,6)"
    },
    "capacity": 19,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문410"
      }
    ],
    "sourceSchedule": "인문410(수4,5,6)"
  },
  {
    "id": "11789-070-2000600",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "070",
    "department": "의류학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "데이비드던",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문412",
    "isOnline": false,
    "source": {
      "schedule": "인문412(월7,8,9)"
    },
    "capacity": 16,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문412"
      }
    ],
    "sourceSchedule": "인문412(월7,8,9)"
  },
  {
    "id": "11789-071-2000600",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "071",
    "department": "의류학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "레이한",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문303",
    "isOnline": false,
    "source": {
      "schedule": "인문303(월7,8,9)"
    },
    "capacity": 16,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문303"
      }
    ],
    "sourceSchedule": "인문303(월7,8,9)"
  },
  {
    "id": "11789-072-2000601",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "072",
    "department": "식품영양학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "레라니",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문307",
    "isOnline": false,
    "source": {
      "schedule": "인문307(수1,2,3)"
    },
    "capacity": 19,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문307"
      }
    ],
    "sourceSchedule": "인문307(수1,2,3)"
  },
  {
    "id": "11789-073-2000601",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "073",
    "department": "식품영양학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "알미라",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문101",
    "isOnline": false,
    "source": {
      "schedule": "인문101(수1,2,3)"
    },
    "capacity": 19,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문101"
      }
    ],
    "sourceSchedule": "인문101(수1,2,3)"
  },
  {
    "id": "11789-074-2000602",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "074",
    "department": "스포츠과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이선영",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문305",
    "isOnline": false,
    "source": {
      "schedule": "인문305(월1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문305"
      }
    ],
    "sourceSchedule": "인문305(월1,2,3)"
  },
  {
    "id": "11789-075-2000602",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "075",
    "department": "스포츠과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "최수연(줄리)",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문503",
    "isOnline": false,
    "source": {
      "schedule": "인문503(월1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문503"
      }
    ],
    "sourceSchedule": "인문503(월1,2,3)"
  },
  {
    "id": "11789-076-2000602",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "076",
    "department": "스포츠과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "알미라",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문409",
    "isOnline": false,
    "source": {
      "schedule": "인문409(월1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문409"
      }
    ],
    "sourceSchedule": "인문409(월1,2,3)"
  },
  {
    "id": "11789-077-2000602",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "077",
    "department": "스포츠과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "크리스",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문505",
    "isOnline": false,
    "source": {
      "schedule": "인문505(월1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문505"
      }
    ],
    "sourceSchedule": "인문505(월1,2,3)"
  },
  {
    "id": "11789-078-2000603",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "078",
    "department": "조형예술학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "마이클",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문502",
    "isOnline": false,
    "source": {
      "schedule": "인문502(목1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문502"
      }
    ],
    "sourceSchedule": "인문502(목1,2,3)"
  },
  {
    "id": "11789-079-2000603",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "079",
    "department": "조형예술학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "알미라",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문503",
    "isOnline": false,
    "source": {
      "schedule": "인문503(목1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문503"
      }
    ],
    "sourceSchedule": "인문503(목1,2,3)"
  },
  {
    "id": "11789-080-2000603",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "080",
    "department": "조형예술학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "쉐인",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문310",
    "isOnline": false,
    "source": {
      "schedule": "인문310(목1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문310"
      }
    ],
    "sourceSchedule": "인문310(목1,2,3)"
  },
  {
    "id": "11789-081-2000603",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "081",
    "department": "조형예술학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이유리",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문505",
    "isOnline": false,
    "source": {
      "schedule": "인문505(목1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문505"
      }
    ],
    "sourceSchedule": "인문505(목1,2,3)"
  },
  {
    "id": "11789-082-2000653",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "082",
    "department": "커뮤니케이션디자인",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "제이슨",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문307",
    "isOnline": false,
    "source": {
      "schedule": "인문307(금1,2,3)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문307"
      }
    ],
    "sourceSchedule": "인문307(금1,2,3)"
  },
  {
    "id": "11789-083-2000653",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "083",
    "department": "커뮤니케이션디자인",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이안마이클",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문400",
    "isOnline": false,
    "source": {
      "schedule": "인문400(금1,2,3)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문400"
      }
    ],
    "sourceSchedule": "인문400(금1,2,3)"
  },
  {
    "id": "11789-084-2000654",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "084",
    "department": "패션디자인",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "토드",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문101",
    "isOnline": false,
    "source": {
      "schedule": "인문101(금1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문101"
      }
    ],
    "sourceSchedule": "인문101(금1,2,3)"
  },
  {
    "id": "11789-085-2000655",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "085",
    "department": "공예디자인",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "션",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문102",
    "isOnline": false,
    "source": {
      "schedule": "인문102(금1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문102"
      }
    ],
    "sourceSchedule": "인문102(금1,2,3)"
  },
  {
    "id": "11789-086-2000605",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "086",
    "department": "아트앤테크놀로지작곡과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "다니엘",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문502",
    "isOnline": false,
    "source": {
      "schedule": "인문502(화7,8,9)"
    },
    "capacity": 22,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문502"
      }
    ],
    "sourceSchedule": "인문502(화7,8,9)"
  },
  {
    "id": "11789-087-2000606",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "087",
    "department": "성악과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "제프리",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문502",
    "isOnline": false,
    "source": {
      "schedule": "인문502(목7,8,9)"
    },
    "capacity": 33,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문502"
      }
    ],
    "sourceSchedule": "인문502(목7,8,9)"
  },
  {
    "id": "11789-088-2000607",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "088",
    "department": "피아노과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "제프리",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문409",
    "isOnline": false,
    "source": {
      "schedule": "인문409(금4,5,6)"
    },
    "capacity": 21,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문409"
      }
    ],
    "sourceSchedule": "인문409(금4,5,6)"
  },
  {
    "id": "11789-089-2000607",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "089",
    "department": "피아노과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이선영",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문102",
    "isOnline": false,
    "source": {
      "schedule": "인문102(금4,5,6)"
    },
    "capacity": 21,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문102"
      }
    ],
    "sourceSchedule": "인문102(금4,5,6)"
  },
  {
    "id": "11789-090-2000608",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "090",
    "department": "관현악과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "재스민",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문412",
    "isOnline": false,
    "source": {
      "schedule": "인문412(금4,5,6)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문412"
      }
    ],
    "sourceSchedule": "인문412(금4,5,6)"
  },
  {
    "id": "11789-091-2000608",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "091",
    "department": "관현악과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "유정화(소피)",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문505",
    "isOnline": false,
    "source": {
      "schedule": "인문505(금4,5,6)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문505"
      }
    ],
    "sourceSchedule": "인문505(금4,5,6)"
  },
  {
    "id": "11789-092-2000609",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "092",
    "department": "국악과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "제임",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문503",
    "isOnline": false,
    "source": {
      "schedule": "인문503(수4,5,6)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문503"
      }
    ],
    "sourceSchedule": "인문503(수4,5,6)"
  },
  {
    "id": "11789-093-2000613",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "093",
    "department": "영화예술",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "데이비드",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문502",
    "isOnline": false,
    "source": {
      "schedule": "인문502(월7,8,9)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문502"
      }
    ],
    "sourceSchedule": "인문502(월7,8,9)"
  },
  {
    "id": "11789-094-2000614",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "094",
    "department": "연기예술",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "다니엘",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문503",
    "isOnline": false,
    "source": {
      "schedule": "인문503(월7,8,9)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문503"
      }
    ],
    "sourceSchedule": "인문503(월7,8,9)"
  },
  {
    "id": "11789-095-2000615",
    "subjectKey": "11789",
    "name": "AI활용ESL2",
    "division": "095",
    "department": "디지털콘텐츠",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "노디아",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문409",
    "isOnline": false,
    "source": {
      "schedule": "인문409(월7,8,9)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문409"
      }
    ],
    "sourceSchedule": "인문409(월7,8,9)"
  },
  {
    "id": "11789-096-2000658",
    "subjectKey": "11789",
    "name": "AI활용ESL2(재수강)",
    "division": "096",
    "department": "교양",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "조니",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문102",
    "isOnline": false,
    "source": {
      "schedule": "인문102(목1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문102"
      }
    ],
    "sourceSchedule": "인문102(목1,2,3)"
  },
  {
    "id": "11789-097-2000658",
    "subjectKey": "11789",
    "name": "AI활용ESL2(재수강)",
    "division": "097",
    "department": "교양",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "레이한",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문505",
    "isOnline": false,
    "source": {
      "schedule": "인문505(목7,8,9)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문505"
      }
    ],
    "sourceSchedule": "인문505(목7,8,9)"
  },
  {
    "id": "11789-098-2000658",
    "subjectKey": "11789",
    "name": "AI활용ESL2(재수강)",
    "division": "098",
    "department": "교양",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "아킬라",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문403",
    "isOnline": false,
    "source": {
      "schedule": "인문403(금4,5,6)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문403"
      }
    ],
    "sourceSchedule": "인문403(금4,5,6)"
  },
  {
    "id": "11789-099-2000658",
    "subjectKey": "11789",
    "name": "AI활용ESL2(재수강)",
    "division": "099",
    "department": "교양",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "로이드",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문302",
    "isOnline": false,
    "source": {
      "schedule": "인문302(월7,8,9)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문302"
      }
    ],
    "sourceSchedule": "인문302(월7,8,9)"
  },
  {
    "id": "11789-100-2000658",
    "subjectKey": "11789",
    "name": "AI활용ESL2(재수강)",
    "division": "100",
    "department": "교양",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "로이드",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문302",
    "isOnline": false,
    "source": {
      "schedule": "인문302(월7,8,9)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문302"
      }
    ],
    "sourceSchedule": "인문302(월7,8,9)"
  },
  {
    "id": "11789-101-2000658",
    "subjectKey": "11789",
    "name": "AI활용ESL2(재수강)",
    "division": "101",
    "department": "교양",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "노디아",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문306",
    "isOnline": false,
    "source": {
      "schedule": "인문306(수7,8,9)"
    },
    "capacity": 31,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문306"
      }
    ],
    "sourceSchedule": "인문306(수7,8,9)"
  },
  {
    "id": "11790-001-2000757",
    "subjectKey": "11790",
    "name": "AI활용CSL1",
    "division": "001",
    "department": "AI데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "고건혁",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문402",
    "isOnline": false,
    "source": {
      "schedule": "인문402(월7,8,9)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문402"
      }
    ],
    "sourceSchedule": "인문402(월7,8,9)"
  },
  {
    "id": "11790-002-2000757",
    "subjectKey": "11790",
    "name": "AI활용CSL1",
    "division": "002",
    "department": "AI데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "왕치엔",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문403",
    "isOnline": false,
    "source": {
      "schedule": "인문403(월7,8,9)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문403"
      }
    ],
    "sourceSchedule": "인문403(월7,8,9)"
  },
  {
    "id": "11790-003-2000757",
    "subjectKey": "11790",
    "name": "AI활용CSL1",
    "division": "003",
    "department": "AI데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "왕홍위",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문404",
    "isOnline": false,
    "source": {
      "schedule": "인문404(월7,8,9)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문404"
      }
    ],
    "sourceSchedule": "인문404(월7,8,9)"
  },
  {
    "id": "11790-004-2000757",
    "subjectKey": "11790",
    "name": "AI활용CSL1",
    "division": "004",
    "department": "AI데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "위보",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문410",
    "isOnline": false,
    "source": {
      "schedule": "인문410(월7,8,9)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문410"
      }
    ],
    "sourceSchedule": "인문410(월7,8,9)"
  },
  {
    "id": "11790-005-2000758",
    "subjectKey": "11790",
    "name": "AI활용CSL1",
    "division": "005",
    "department": "컴퓨터공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "두린린",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문402",
    "isOnline": false,
    "source": {
      "schedule": "인문402(수4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문402"
      }
    ],
    "sourceSchedule": "인문402(수4,5,6)"
  },
  {
    "id": "11790-006-2000758",
    "subjectKey": "11790",
    "name": "AI활용CSL1",
    "division": "006",
    "department": "컴퓨터공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "왕치엔",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문403",
    "isOnline": false,
    "source": {
      "schedule": "인문403(수4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문403"
      }
    ],
    "sourceSchedule": "인문403(수4,5,6)"
  },
  {
    "id": "11790-007-2000758",
    "subjectKey": "11790",
    "name": "AI활용CSL1",
    "division": "007",
    "department": "컴퓨터공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "위보",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문404",
    "isOnline": false,
    "source": {
      "schedule": "인문404(수4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문404"
      }
    ],
    "sourceSchedule": "인문404(수4,5,6)"
  },
  {
    "id": "11790-008-2000758",
    "subjectKey": "11790",
    "name": "AI활용CSL1",
    "division": "008",
    "department": "컴퓨터공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "황지군",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문411",
    "isOnline": false,
    "source": {
      "schedule": "인문411(수4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문411"
      }
    ],
    "sourceSchedule": "인문411(수4,5,6)"
  },
  {
    "id": "11790-009-2000759",
    "subjectKey": "11790",
    "name": "AI활용CSL1",
    "division": "009",
    "department": "지능형보안학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "왕치엔",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문411",
    "isOnline": false,
    "source": {
      "schedule": "인문411(목1,2,3)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문411"
      }
    ],
    "sourceSchedule": "인문411(목1,2,3)"
  },
  {
    "id": "11790-010-2000759",
    "subjectKey": "11790",
    "name": "AI활용CSL1",
    "division": "010",
    "department": "지능형보안학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "왕홍위",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문410",
    "isOnline": false,
    "source": {
      "schedule": "인문410(목1,2,3)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문410"
      }
    ],
    "sourceSchedule": "인문410(목1,2,3)"
  },
  {
    "id": "11791-001-2000763",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "001",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "두린린",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문307",
    "isOnline": false,
    "source": {
      "schedule": "인문307(월1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문307"
      }
    ],
    "sourceSchedule": "인문307(월1,2,3)"
  },
  {
    "id": "11791-002-2000763",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "002",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "김화",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문101",
    "isOnline": false,
    "source": {
      "schedule": "인문101(월1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문101"
      }
    ],
    "sourceSchedule": "인문101(월1,2,3)"
  },
  {
    "id": "11791-003-2000763",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "003",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "맹춘영",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문410",
    "isOnline": false,
    "source": {
      "schedule": "인문410(수1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문410"
      }
    ],
    "sourceSchedule": "인문410(수1,2,3)"
  },
  {
    "id": "11791-004-2000763",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "004",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "김연희",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문512",
    "isOnline": false,
    "source": {
      "schedule": "인문512(수1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문512"
      }
    ],
    "sourceSchedule": "인문512(수1,2,3)"
  },
  {
    "id": "11791-005-2000763",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "005",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "유흔",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문307",
    "isOnline": false,
    "source": {
      "schedule": "인문307(수4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문307"
      }
    ],
    "sourceSchedule": "인문307(수4,5,6)"
  },
  {
    "id": "11791-006-2000763",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "006",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "박신순",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문101",
    "isOnline": false,
    "source": {
      "schedule": "인문101(수4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문101"
      }
    ],
    "sourceSchedule": "인문101(수4,5,6)"
  },
  {
    "id": "11791-007-2000763",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "007",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "고건혁",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문102",
    "isOnline": false,
    "source": {
      "schedule": "인문102(수4,5,6)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문102"
      }
    ],
    "sourceSchedule": "인문102(수4,5,6)"
  },
  {
    "id": "11791-008-2000738",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "008",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "맹춘영",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문307",
    "isOnline": false,
    "source": {
      "schedule": "인문307(월4,5,6)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문307"
      }
    ],
    "sourceSchedule": "인문307(월4,5,6)"
  },
  {
    "id": "11791-009-2000738",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "009",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "조려연",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문101",
    "isOnline": false,
    "source": {
      "schedule": "인문101(월4,5,6)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문101"
      }
    ],
    "sourceSchedule": "인문101(월4,5,6)"
  },
  {
    "id": "11791-010-2000738",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "010",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "박신순",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문102",
    "isOnline": false,
    "source": {
      "schedule": "인문102(월4,5,6)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문102"
      }
    ],
    "sourceSchedule": "인문102(월4,5,6)"
  },
  {
    "id": "11791-011-2000738",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "011",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이계정",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문306",
    "isOnline": false,
    "source": {
      "schedule": "인문306(월4,5,6)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문306"
      }
    ],
    "sourceSchedule": "인문306(월4,5,6)"
  },
  {
    "id": "11791-012-2000738",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "012",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "유흔",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문505",
    "isOnline": false,
    "source": {
      "schedule": "인문505(화4,5,6)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문505"
      }
    ],
    "sourceSchedule": "인문505(화4,5,6)"
  },
  {
    "id": "11791-013-2000738",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "013",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "손양",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문305",
    "isOnline": false,
    "source": {
      "schedule": "인문305(화4,5,6)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문305"
      }
    ],
    "sourceSchedule": "인문305(화4,5,6)"
  },
  {
    "id": "11791-014-2000738",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "014",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "장수",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문107",
    "isOnline": false,
    "source": {
      "schedule": "인문107(화4,5,6)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문107"
      }
    ],
    "sourceSchedule": "인문107(화4,5,6)"
  },
  {
    "id": "11791-015-2000738",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "015",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "얀준",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문404",
    "isOnline": false,
    "source": {
      "schedule": "인문404(수7,8,9)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문404"
      }
    ],
    "sourceSchedule": "인문404(수7,8,9)"
  },
  {
    "id": "11791-016-2000738",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "016",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "손양",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문305",
    "isOnline": false,
    "source": {
      "schedule": "인문305(수7,8,9)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문305"
      }
    ],
    "sourceSchedule": "인문305(수7,8,9)"
  },
  {
    "id": "11791-017-2000738",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "017",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "두린린",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문302",
    "isOnline": false,
    "source": {
      "schedule": "인문302(금4,5,6)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문302"
      }
    ],
    "sourceSchedule": "인문302(금4,5,6)"
  },
  {
    "id": "11791-018-2000738",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "018",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "요홍염",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문303",
    "isOnline": false,
    "source": {
      "schedule": "인문303(금4,5,6)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문303"
      }
    ],
    "sourceSchedule": "인문303(금4,5,6)"
  },
  {
    "id": "11791-019-2000754",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "019",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "고춘화",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문107",
    "isOnline": false,
    "source": {
      "schedule": "인문107(월1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문107"
      }
    ],
    "sourceSchedule": "인문107(월1,2,3)"
  },
  {
    "id": "11791-020-2000754",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "020",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "수우죽",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문404",
    "isOnline": false,
    "source": {
      "schedule": "인문404(월1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문404"
      }
    ],
    "sourceSchedule": "인문404(월1,2,3)"
  },
  {
    "id": "11791-021-2000754",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "021",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이계정",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문403",
    "isOnline": false,
    "source": {
      "schedule": "인문403(화1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문403"
      }
    ],
    "sourceSchedule": "인문403(화1,2,3)"
  },
  {
    "id": "11791-022-2000754",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "022",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "장정",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "국제307",
    "isOnline": false,
    "source": {
      "schedule": "국제307(수1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "국제307"
      }
    ],
    "sourceSchedule": "국제307(수1,2,3)"
  },
  {
    "id": "11791-023-2000754",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "023",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "장수",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "국제308",
    "isOnline": false,
    "source": {
      "schedule": "국제308(수1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "국제308"
      }
    ],
    "sourceSchedule": "국제308(수1,2,3)"
  },
  {
    "id": "11791-024-2000754",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "024",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "조려연",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "국제309",
    "isOnline": false,
    "source": {
      "schedule": "국제309(수1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "국제309"
      }
    ],
    "sourceSchedule": "국제309(수1,2,3)"
  },
  {
    "id": "11791-025-2000754",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "025",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "김화",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문512",
    "isOnline": false,
    "source": {
      "schedule": "인문512(수7,8,9)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문512"
      }
    ],
    "sourceSchedule": "인문512(수7,8,9)"
  },
  {
    "id": "11791-026-2000754",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "026",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "고춘화",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문410",
    "isOnline": false,
    "source": {
      "schedule": "인문410(수7,8,9)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문410"
      }
    ],
    "sourceSchedule": "인문410(수7,8,9)"
  },
  {
    "id": "11791-027-2000754",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "027",
    "department": "경영공학대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "왕홍위",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문411",
    "isOnline": false,
    "source": {
      "schedule": "인문411(월1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문411"
      }
    ],
    "sourceSchedule": "인문411(월1,2,3)"
  },
  {
    "id": "11791-029-2000598",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "029",
    "department": "간호학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "장수",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문410",
    "isOnline": false,
    "source": {
      "schedule": "인문410(목7,8,9)"
    },
    "capacity": 22,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문410"
      }
    ],
    "sourceSchedule": "인문410(목7,8,9)"
  },
  {
    "id": "11791-030-2000598",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "030",
    "department": "간호학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "쑤위",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문411",
    "isOnline": false,
    "source": {
      "schedule": "인문411(목7,8,9)"
    },
    "capacity": 22,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문411"
      }
    ],
    "sourceSchedule": "인문411(목7,8,9)"
  },
  {
    "id": "11791-031-2000598",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "031",
    "department": "간호학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "유흔",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문503",
    "isOnline": false,
    "source": {
      "schedule": "인문503(목7,8,9)"
    },
    "capacity": 22,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문503"
      }
    ],
    "sourceSchedule": "인문503(목7,8,9)"
  },
  {
    "id": "11791-032-2000598",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "032",
    "department": "간호학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이계정",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문406",
    "isOnline": false,
    "source": {
      "schedule": "인문406(목7,8,9)"
    },
    "capacity": 22,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문406"
      }
    ],
    "sourceSchedule": "인문406(목7,8,9)"
  },
  {
    "id": "11791-033-2000598",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "033",
    "department": "간호학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "김연희",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문302",
    "isOnline": false,
    "source": {
      "schedule": "인문302(목7,8,9)"
    },
    "capacity": 22,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문302"
      }
    ],
    "sourceSchedule": "인문302(목7,8,9)"
  },
  {
    "id": "11791-034-2000599",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "034",
    "department": "아동가족복지학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "황지군",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문102",
    "isOnline": false,
    "source": {
      "schedule": "인문102(월1,2,3)"
    },
    "capacity": 19,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문102"
      }
    ],
    "sourceSchedule": "인문102(월1,2,3)"
  },
  {
    "id": "11791-035-2000599",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "035",
    "department": "아동가족복지학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "쑤위",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문410",
    "isOnline": false,
    "source": {
      "schedule": "인문410(월1,2,3)"
    },
    "capacity": 19,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문410"
      }
    ],
    "sourceSchedule": "인문410(월1,2,3)"
  },
  {
    "id": "11791-036-2000600",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "036",
    "department": "의류학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "장정",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문410",
    "isOnline": false,
    "source": {
      "schedule": "인문410(금4,5,6)"
    },
    "capacity": 16,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문410"
      }
    ],
    "sourceSchedule": "인문410(금4,5,6)"
  },
  {
    "id": "11791-037-2000600",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "037",
    "department": "의류학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "맹춘영",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문411",
    "isOnline": false,
    "source": {
      "schedule": "인문411(금4,5,6)"
    },
    "capacity": 16,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문411"
      }
    ],
    "sourceSchedule": "인문411(금4,5,6)"
  },
  {
    "id": "11791-038-2000601",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "038",
    "department": "식품영양학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "손양",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문410",
    "isOnline": false,
    "source": {
      "schedule": "인문410(목4,5,6)"
    },
    "capacity": 19,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문410"
      }
    ],
    "sourceSchedule": "인문410(목4,5,6)"
  },
  {
    "id": "11791-039-2000601",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "039",
    "department": "식품영양학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "얀준",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문411",
    "isOnline": false,
    "source": {
      "schedule": "인문411(목4,5,6)"
    },
    "capacity": 19,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문411"
      }
    ],
    "sourceSchedule": "인문411(목4,5,6)"
  },
  {
    "id": "11791-040-2000602",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "040",
    "department": "스포츠과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "요홍염",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문307",
    "isOnline": false,
    "source": {
      "schedule": "인문307(화1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문307"
      }
    ],
    "sourceSchedule": "인문307(화1,2,3)"
  },
  {
    "id": "11791-041-2000602",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "041",
    "department": "스포츠과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "박신순",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문101",
    "isOnline": false,
    "source": {
      "schedule": "인문101(화1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문101"
      }
    ],
    "sourceSchedule": "인문101(화1,2,3)"
  },
  {
    "id": "11791-042-2000602",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "042",
    "department": "스포츠과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "장정",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문102",
    "isOnline": false,
    "source": {
      "schedule": "인문102(화1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문102"
      }
    ],
    "sourceSchedule": "인문102(화1,2,3)"
  },
  {
    "id": "11791-043-2000602",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "043",
    "department": "스포츠과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "고춘화",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문402",
    "isOnline": false,
    "source": {
      "schedule": "인문402(화1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문402"
      }
    ],
    "sourceSchedule": "인문402(화1,2,3)"
  },
  {
    "id": "11791-044-2000603",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "044",
    "department": "조형예술학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "유흔",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문302",
    "isOnline": false,
    "source": {
      "schedule": "인문302(월1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문302"
      }
    ],
    "sourceSchedule": "인문302(월1,2,3)"
  },
  {
    "id": "11791-045-2000603",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "045",
    "department": "조형예술학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "장정",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문303",
    "isOnline": false,
    "source": {
      "schedule": "인문303(월1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문303"
      }
    ],
    "sourceSchedule": "인문303(월1,2,3)"
  },
  {
    "id": "11791-046-2000603",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "046",
    "department": "조형예술학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "조려연",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문412",
    "isOnline": false,
    "source": {
      "schedule": "인문412(월1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문412"
      }
    ],
    "sourceSchedule": "인문412(월1,2,3)"
  },
  {
    "id": "11791-047-2000603",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "047",
    "department": "조형예술학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "장수",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문306",
    "isOnline": false,
    "source": {
      "schedule": "인문306(월1,2,3)"
    },
    "capacity": 23,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문306"
      }
    ],
    "sourceSchedule": "인문306(월1,2,3)"
  },
  {
    "id": "11791-048-2000653",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "048",
    "department": "커뮤니케이션디자인",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "쑤위",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문404",
    "isOnline": false,
    "source": {
      "schedule": "인문404(화1,2,3)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문404"
      }
    ],
    "sourceSchedule": "인문404(화1,2,3)"
  },
  {
    "id": "11791-049-2000653",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "049",
    "department": "커뮤니케이션디자인",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "왕치엔",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문505",
    "isOnline": false,
    "source": {
      "schedule": "인문505(화1,2,3)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문505"
      }
    ],
    "sourceSchedule": "인문505(화1,2,3)"
  },
  {
    "id": "11791-050-2000654",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "050",
    "department": "패션디자인",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "황지군",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문410",
    "isOnline": false,
    "source": {
      "schedule": "인문410(화1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문410"
      }
    ],
    "sourceSchedule": "인문410(화1,2,3)"
  },
  {
    "id": "11791-051-2000655",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "051",
    "department": "공예디자인",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "왕홍위",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문411",
    "isOnline": false,
    "source": {
      "schedule": "인문411(화1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문411"
      }
    ],
    "sourceSchedule": "인문411(화1,2,3)"
  },
  {
    "id": "11791-052-2000605",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "052",
    "department": "아트앤테크놀로지작곡과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "요홍염",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문411",
    "isOnline": false,
    "source": {
      "schedule": "인문411(월4,5,6)"
    },
    "capacity": 22,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문411"
      }
    ],
    "sourceSchedule": "인문411(월4,5,6)"
  },
  {
    "id": "11791-053-2000606",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "053",
    "department": "성악과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "고건혁",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문307",
    "isOnline": false,
    "source": {
      "schedule": "인문307(목1,2,3)"
    },
    "capacity": 32,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문307"
      }
    ],
    "sourceSchedule": "인문307(목1,2,3)"
  },
  {
    "id": "11791-054-2000607",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "054",
    "department": "피아노과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "조려연",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문403",
    "isOnline": false,
    "source": {
      "schedule": "인문403(화7,8,9)"
    },
    "capacity": 21,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문403"
      }
    ],
    "sourceSchedule": "인문403(화7,8,9)"
  },
  {
    "id": "11791-055-2000607",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "055",
    "department": "피아노과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "맹춘영",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문102",
    "isOnline": false,
    "source": {
      "schedule": "인문102(화7,8,9)"
    },
    "capacity": 21,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문102"
      }
    ],
    "sourceSchedule": "인문102(화7,8,9)"
  },
  {
    "id": "11791-056-2000608",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "056",
    "department": "관현악과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "수우죽",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문404",
    "isOnline": false,
    "source": {
      "schedule": "인문404(금1,2,3)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문404"
      }
    ],
    "sourceSchedule": "인문404(금1,2,3)"
  },
  {
    "id": "11791-057-2000608",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "057",
    "department": "관현악과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "고춘화",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문401",
    "isOnline": false,
    "source": {
      "schedule": "인문401(금1,2,3)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문401"
      }
    ],
    "sourceSchedule": "인문401(금1,2,3)"
  },
  {
    "id": "11791-058-2000609",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "058",
    "department": "국악과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "얀준",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문412",
    "isOnline": false,
    "source": {
      "schedule": "인문412(월4,5,6)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문412"
      }
    ],
    "sourceSchedule": "인문412(월4,5,6)"
  },
  {
    "id": "11791-059-2000613",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "059",
    "department": "영화예술",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "수우죽",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문512",
    "isOnline": false,
    "source": {
      "schedule": "인문512(화1,2,3)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문512"
      }
    ],
    "sourceSchedule": "인문512(화1,2,3)"
  },
  {
    "id": "11791-060-2000614",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "060",
    "department": "연기예술",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "위보",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문503",
    "isOnline": false,
    "source": {
      "schedule": "인문503(화1,2,3)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문503"
      }
    ],
    "sourceSchedule": "인문503(화1,2,3)"
  },
  {
    "id": "11791-061-2000615",
    "subjectKey": "11791",
    "name": "AI활용CSL2",
    "division": "061",
    "department": "디지털콘텐츠",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "김화",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문506",
    "isOnline": false,
    "source": {
      "schedule": "인문506(화1,2,3)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문506"
      }
    ],
    "sourceSchedule": "인문506(화1,2,3)"
  },
  {
    "id": "11791-062-2000658",
    "subjectKey": "11791",
    "name": "AI활용CSL2(재수강)",
    "division": "062",
    "department": "교양",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "손양",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문508",
    "isOnline": false,
    "source": {
      "schedule": "인문508(금4,5,6)"
    },
    "capacity": 51,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문508"
      }
    ],
    "sourceSchedule": "인문508(금4,5,6)"
  },
  {
    "id": "11791-063-2000658",
    "subjectKey": "11791",
    "name": "AI활용CSL2(재수강)",
    "division": "063",
    "department": "교양",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "박신순",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문508",
    "isOnline": false,
    "source": {
      "schedule": "인문508(금1,2,3)"
    },
    "capacity": 53,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문508"
      }
    ],
    "sourceSchedule": "인문508(금1,2,3)"
  },
  {
    "id": "11792-001-2000763",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "001",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "송치호",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(화1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(화1,2,3)"
  },
  {
    "id": "11792-002-2000763",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "002",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "한우섭",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(수7,8,9)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(수7,8,9)"
  },
  {
    "id": "11792-003-2000763",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "003",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "박동비",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(금1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(금1,2,3)"
  },
  {
    "id": "11792-004-2000763",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "004",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이상오",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(금4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(금4,5,6)"
  },
  {
    "id": "11792-005-2000738",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "005",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "정은선",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(목4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(목4,5,6)"
  },
  {
    "id": "11792-005-2000763",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "005",
    "department": "자유전공학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "정은선",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(목4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(목4,5,6)"
  },
  {
    "id": "11792-006-2000738",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "006",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이승아",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(월1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(월1,2,3)"
  },
  {
    "id": "11792-007-2000738",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "007",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "한우섭",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(수1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(수1,2,3)"
  },
  {
    "id": "11792-008-2000738",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "008",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "정갑준",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(수1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(수1,2,3)"
  },
  {
    "id": "11792-009-2000738",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "009",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "김중신",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(수4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(수4,5,6)"
  },
  {
    "id": "11792-010-2000738",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "010",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "정은선",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(목1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(목1,2,3)"
  },
  {
    "id": "11792-011-2000738",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "011",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "김보경",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(목4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(목4,5,6)"
  },
  {
    "id": "11792-012-2000738",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "012",
    "department": "인문사회융합대학",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이상오",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(금1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(금1,2,3)"
  },
  {
    "id": "11792-013-2000757",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "013",
    "department": "AI데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "곽예근",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(화1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(화1,2,3)"
  },
  {
    "id": "11792-013-2000759",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "013",
    "department": "지능형보안학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "곽예근",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(화1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(화1,2,3)"
  },
  {
    "id": "11792-014-2000757",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "014",
    "department": "AI데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "정갑준",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(수4,5,6)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(수4,5,6)"
  },
  {
    "id": "11792-014-2000759",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "014",
    "department": "지능형보안학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "정갑준",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(수4,5,6)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(수4,5,6)"
  },
  {
    "id": "11792-015-2000757",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "015",
    "department": "AI데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "임선영",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(금1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(금1,2,3)"
  },
  {
    "id": "11792-015-2000759",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "015",
    "department": "지능형보안학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "임선영",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B108",
    "isOnline": false,
    "source": {
      "schedule": "미래B108(금1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B108"
      }
    ],
    "sourceSchedule": "미래B108(금1,2,3)"
  },
  {
    "id": "11792-016-2000757",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "016",
    "department": "AI데이터과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "권근영",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(수4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(수4,5,6)"
  },
  {
    "id": "11792-016-2000759",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "016",
    "department": "지능형보안학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "권근영",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(수4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(수4,5,6)"
  },
  {
    "id": "11792-017-2000598",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "017",
    "department": "간호학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "정혜린",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(화1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(화1,2,3)"
  },
  {
    "id": "11792-018-2000598",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "018",
    "department": "간호학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "권근영",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(목1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(목1,2,3)"
  },
  {
    "id": "11792-019-2000598",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "019",
    "department": "간호학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "김연지",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(금4,5,6)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(금4,5,6)"
  },
  {
    "id": "11792-020-2000599",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "020",
    "department": "아동가족복지학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "권근영",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(수1,2,3)"
    },
    "capacity": 38,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(수1,2,3)"
  },
  {
    "id": "11792-020-2000600",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "020",
    "department": "의류학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "권근영",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(수1,2,3)"
    },
    "capacity": 38,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(수1,2,3)"
  },
  {
    "id": "11792-020-2000601",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "020",
    "department": "식품영양학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "권근영",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(수1,2,3)"
    },
    "capacity": 38,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(수1,2,3)"
  },
  {
    "id": "11792-020-2000602",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "020",
    "department": "스포츠과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "권근영",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(수1,2,3)"
    },
    "capacity": 38,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(수1,2,3)"
  },
  {
    "id": "11792-021-2000599",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "021",
    "department": "아동가족복지학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "노희호",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(월1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(월1,2,3)"
  },
  {
    "id": "11792-021-2000600",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "021",
    "department": "의류학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "노희호",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(월1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(월1,2,3)"
  },
  {
    "id": "11792-021-2000601",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "021",
    "department": "식품영양학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "노희호",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(월1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(월1,2,3)"
  },
  {
    "id": "11792-021-2000602",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "021",
    "department": "스포츠과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "노희호",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(월1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(월1,2,3)"
  },
  {
    "id": "11792-022-2000599",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "022",
    "department": "아동가족복지학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "신정숙",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(월1,2,3)"
    },
    "capacity": 38,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(월1,2,3)"
  },
  {
    "id": "11792-022-2000600",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "022",
    "department": "의류학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "신정숙",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(월1,2,3)"
    },
    "capacity": 38,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(월1,2,3)"
  },
  {
    "id": "11792-022-2000601",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "022",
    "department": "식품영양학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "신정숙",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(월1,2,3)"
    },
    "capacity": 38,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(월1,2,3)"
  },
  {
    "id": "11792-022-2000602",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "022",
    "department": "스포츠과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "신정숙",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(월1,2,3)"
    },
    "capacity": 38,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(월1,2,3)"
  },
  {
    "id": "11792-023-2000599",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "023",
    "department": "아동가족복지학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "곽예근",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(화4,5,6)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(화4,5,6)"
  },
  {
    "id": "11792-023-2000600",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "023",
    "department": "의류학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "곽예근",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(화4,5,6)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(화4,5,6)"
  },
  {
    "id": "11792-023-2000601",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "023",
    "department": "식품영양학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "곽예근",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(화4,5,6)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(화4,5,6)"
  },
  {
    "id": "11792-023-2000602",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "023",
    "department": "스포츠과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "곽예근",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B106",
    "isOnline": false,
    "source": {
      "schedule": "미래B106(화4,5,6)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B106"
      }
    ],
    "sourceSchedule": "미래B106(화4,5,6)"
  },
  {
    "id": "11792-024-2000599",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "024",
    "department": "아동가족복지학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이민경",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(수1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(수1,2,3)"
  },
  {
    "id": "11792-024-2000600",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "024",
    "department": "의류학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이민경",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(수1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(수1,2,3)"
  },
  {
    "id": "11792-024-2000601",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "024",
    "department": "식품영양학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이민경",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(수1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(수1,2,3)"
  },
  {
    "id": "11792-024-2000602",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "024",
    "department": "스포츠과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이민경",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(수1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(수1,2,3)"
  },
  {
    "id": "11792-025-2000599",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "025",
    "department": "아동가족복지학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "김보경",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(목1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(목1,2,3)"
  },
  {
    "id": "11792-025-2000600",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "025",
    "department": "의류학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "김보경",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(목1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(목1,2,3)"
  },
  {
    "id": "11792-025-2000601",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "025",
    "department": "식품영양학과",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "김보경",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(목1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(목1,2,3)"
  },
  {
    "id": "11792-025-2000602",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "025",
    "department": "스포츠과학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "김보경",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(목1,2,3)"
    },
    "capacity": 35,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(목1,2,3)"
  },
  {
    "id": "11792-026-2000603",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "026",
    "department": "조형예술학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이나윤",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(화1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(화1,2,3)"
  },
  {
    "id": "11792-026-2000604",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "026",
    "department": "디자인학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이나윤",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(화1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(화1,2,3)"
  },
  {
    "id": "11792-027-2000603",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "027",
    "department": "조형예술학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "김연지",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(금1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(금1,2,3)"
  },
  {
    "id": "11792-027-2000604",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "027",
    "department": "디자인학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "김연지",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래113",
    "isOnline": false,
    "source": {
      "schedule": "미래113(금1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래113"
      }
    ],
    "sourceSchedule": "미래113(금1,2,3)"
  },
  {
    "id": "11792-028-2000603",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "028",
    "department": "조형예술학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "박동비",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(금4,5,6)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(금4,5,6)"
  },
  {
    "id": "11792-028-2000604",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "028",
    "department": "디자인학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "박동비",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(금4,5,6)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(금4,5,6)"
  },
  {
    "id": "11792-029-2000603",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "029",
    "department": "조형예술학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이승아",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(월4,5,6)"
    },
    "capacity": 36,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(월4,5,6)"
  },
  {
    "id": "11792-029-2000604",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "029",
    "department": "디자인학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이승아",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(월4,5,6)"
    },
    "capacity": 36,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(월4,5,6)"
  },
  {
    "id": "11792-030-2000603",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "030",
    "department": "조형예술학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "송치호",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(화4,5,6)"
    },
    "capacity": 36,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(화4,5,6)"
  },
  {
    "id": "11792-030-2000604",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "030",
    "department": "디자인학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "송치호",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래112",
    "isOnline": false,
    "source": {
      "schedule": "미래112(화4,5,6)"
    },
    "capacity": 36,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래112"
      }
    ],
    "sourceSchedule": "미래112(화4,5,6)"
  },
  {
    "id": "11792-031-2000603",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "031",
    "department": "조형예술학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이재명",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(목1,2,3)"
    },
    "capacity": 36,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(목1,2,3)"
  },
  {
    "id": "11792-031-2000604",
    "subjectKey": "11792",
    "name": "AI활용글쓰기",
    "division": "031",
    "department": "디자인학부",
    "category": "기초교양",
    "sourceCategory": "기교",
    "credit": 3,
    "professor": "이재명",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B107",
    "isOnline": false,
    "source": {
      "schedule": "미래B107(목1,2,3)"
    },
    "capacity": 36,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B107"
      }
    ],
    "sourceSchedule": "미래B107(목1,2,3)"
  },
  {
    "id": "11793-001-2000754",
    "subjectKey": "11793",
    "name": "AI리터러시",
    "division": "001",
    "department": "경영공학대학",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "김진형",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합606",
    "isOnline": false,
    "source": {
      "schedule": "종합606(월1,2,3)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합606"
      }
    ],
    "sourceSchedule": "종합606(월1,2,3)"
  },
  {
    "id": "11793-002-2000754",
    "subjectKey": "11793",
    "name": "AI리터러시",
    "division": "002",
    "department": "경영공학대학",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "김현",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합605",
    "isOnline": false,
    "source": {
      "schedule": "종합605(화1,2,3)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합605"
      }
    ],
    "sourceSchedule": "종합605(화1,2,3)"
  },
  {
    "id": "11793-003-2000754",
    "subjectKey": "11793",
    "name": "AI리터러시",
    "division": "003",
    "department": "경영공학대학",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "연경열",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합606",
    "isOnline": false,
    "source": {
      "schedule": "종합606(화1,2,3)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합606"
      }
    ],
    "sourceSchedule": "종합606(화1,2,3)"
  },
  {
    "id": "11793-004-2000754",
    "subjectKey": "11793",
    "name": "AI리터러시",
    "division": "004",
    "department": "경영공학대학",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "박흥수",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합605",
    "isOnline": false,
    "source": {
      "schedule": "종합605(화4,5,6)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합605"
      }
    ],
    "sourceSchedule": "종합605(화4,5,6)"
  },
  {
    "id": "11793-005-2000754",
    "subjectKey": "11793",
    "name": "AI리터러시",
    "division": "005",
    "department": "경영공학대학",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "박상석",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합606",
    "isOnline": false,
    "source": {
      "schedule": "종합606(화4,5,6)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합606"
      }
    ],
    "sourceSchedule": "종합606(화4,5,6)"
  },
  {
    "id": "11793-006-2000754",
    "subjectKey": "11793",
    "name": "AI리터러시",
    "division": "006",
    "department": "경영공학대학",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "윤병국",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합605",
    "isOnline": false,
    "source": {
      "schedule": "종합605(월4,5,6)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합605"
      }
    ],
    "sourceSchedule": "종합605(월4,5,6)"
  },
  {
    "id": "11793-007-2000754",
    "subjectKey": "11793",
    "name": "AI리터러시",
    "division": "007",
    "department": "경영공학대학",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "서정석",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합606",
    "isOnline": false,
    "source": {
      "schedule": "종합606(월4,5,6)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합606"
      }
    ],
    "sourceSchedule": "종합606(월4,5,6)"
  },
  {
    "id": "11793-008-2000754",
    "subjectKey": "11793",
    "name": "AI리터러시",
    "division": "008",
    "department": "경영공학대학",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "강성민",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합605",
    "isOnline": false,
    "source": {
      "schedule": "종합605(수7,8,9)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합605"
      }
    ],
    "sourceSchedule": "종합605(수7,8,9)"
  },
  {
    "id": "11793-009-2000754",
    "subjectKey": "11793",
    "name": "AI리터러시",
    "division": "009",
    "department": "경영공학대학",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "김현철",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합606",
    "isOnline": false,
    "source": {
      "schedule": "종합606(금1,2,3)"
    },
    "capacity": 26,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합606"
      }
    ],
    "sourceSchedule": "종합606(금1,2,3)"
  },
  {
    "id": "11793-010-2000758",
    "subjectKey": "11793",
    "name": "AI리터러시",
    "division": "010",
    "department": "컴퓨터공학부",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "정형철",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합605",
    "isOnline": false,
    "source": {
      "schedule": "종합605(수1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합605"
      }
    ],
    "sourceSchedule": "종합605(수1,2,3)"
  },
  {
    "id": "11793-011-2000758",
    "subjectKey": "11793",
    "name": "AI리터러시",
    "division": "011",
    "department": "컴퓨터공학부",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "박효남",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합606",
    "isOnline": false,
    "source": {
      "schedule": "종합606(수1,2,3)"
    },
    "capacity": 24,
    "targetGrade": 1,
    "departmentLimit": true,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합606"
      }
    ],
    "sourceSchedule": "종합606(수1,2,3)"
  },
  {
    "id": "11793-012-2000758",
    "subjectKey": "11793",
    "name": "AI리터러시",
    "division": "012",
    "department": "컴퓨터공학부",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "김창회",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합606",
    "isOnline": false,
    "source": {
      "schedule": "종합606(목1,2,3)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합606"
      }
    ],
    "sourceSchedule": "종합606(목1,2,3)"
  },
  {
    "id": "11793-013-2000758",
    "subjectKey": "11793",
    "name": "AI리터러시",
    "division": "013",
    "department": "컴퓨터공학부",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "조희근",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합606",
    "isOnline": false,
    "source": {
      "schedule": "종합606(목4,5,6)"
    },
    "capacity": 27,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합606"
      }
    ],
    "sourceSchedule": "종합606(목4,5,6)"
  },
  {
    "id": "11793-014-2000755",
    "subjectKey": "11793",
    "name": "AI리터러시(이러닝)",
    "division": "014",
    "department": "바이오공학과",
    "category": "이러닝",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11793-015-2000589",
    "subjectKey": "11793",
    "name": "AI리터러시(이러닝)",
    "division": "015",
    "department": "건설환경에너지공학부",
    "category": "이러닝",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11793-016-2000590",
    "subjectKey": "11793",
    "name": "AI리터러시(이러닝)",
    "division": "016",
    "department": "건축도시부동산학부",
    "category": "이러닝",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11793-017-2000756",
    "subjectKey": "11793",
    "name": "AI리터러시(이러닝)",
    "division": "017",
    "department": "기계공학부",
    "category": "이러닝",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 70,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11793-018-2000592",
    "subjectKey": "11793",
    "name": "AI리터러시(이러닝)",
    "division": "018",
    "department": "반도체공학과",
    "category": "이러닝",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11793-019-2000593",
    "subjectKey": "11793",
    "name": "AI리터러시(이러닝)",
    "division": "019",
    "department": "전기전자공학부",
    "category": "이러닝",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11793-020-2000593",
    "subjectKey": "11793",
    "name": "AI리터러시(이러닝)",
    "division": "020",
    "department": "전기전자공학부",
    "category": "이러닝",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11793-021-2000594",
    "subjectKey": "11793",
    "name": "AI리터러시(이러닝)",
    "division": "021",
    "department": "화학공학·신소재공학부",
    "category": "이러닝",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11793-022-2000605",
    "subjectKey": "11793",
    "name": "AI리터러시(이러닝)",
    "division": "022",
    "department": "아트앤테크놀로지작곡과",
    "category": "이러닝",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11793-023-2000606",
    "subjectKey": "11793",
    "name": "AI리터러시(이러닝)",
    "division": "023",
    "department": "성악과",
    "category": "이러닝",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11793-024-2000607",
    "subjectKey": "11793",
    "name": "AI리터러시(이러닝)",
    "division": "024",
    "department": "피아노과",
    "category": "이러닝",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11793-025-2000608",
    "subjectKey": "11793",
    "name": "AI리터러시(이러닝)",
    "division": "025",
    "department": "관현악과",
    "category": "이러닝",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "교양대학",
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": ""
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [],
    "sourceSchedule": ""
  },
  {
    "id": "11793-026-2000609",
    "subjectKey": "11793",
    "name": "AI리터러시(이러닝)",
    "division": "026",
    "department": "국악과",
    "category": "이러닝",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "교양대학",
    "days": [
      "토"
    ],
    "startPeriod": 10,
    "endPeriod": 12,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": "(토10,11,12)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "토",
        "periods": [
          10,
          11,
          12
        ],
        "classroom": ""
      }
    ],
    "sourceSchedule": "(토10,11,12)"
  },
  {
    "id": "11793-027-2000610",
    "subjectKey": "11793",
    "name": "AI리터러시(이러닝)",
    "division": "027",
    "department": "아트앤엔터테인먼트학부",
    "category": "이러닝",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "교양대학",
    "days": [
      "토"
    ],
    "startPeriod": 13,
    "endPeriod": 15,
    "room": "",
    "isOnline": true,
    "source": {
      "schedule": "(토13,14,15)"
    },
    "capacity": 110,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "토",
        "periods": [
          13,
          14,
          15
        ],
        "classroom": ""
      }
    ],
    "sourceSchedule": "(토13,14,15)"
  },
  {
    "id": "11794-001-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "001",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "박행원",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합604",
    "isOnline": false,
    "source": {
      "schedule": "종합604(월1,2,3)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합604"
      }
    ],
    "sourceSchedule": "종합604(월1,2,3)"
  },
  {
    "id": "11794-003-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "003",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "김인환",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합604",
    "isOnline": false,
    "source": {
      "schedule": "종합604(월4,5,6)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합604"
      }
    ],
    "sourceSchedule": "종합604(월4,5,6)"
  },
  {
    "id": "11794-004-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "004",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "이정배",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합605",
    "isOnline": false,
    "source": {
      "schedule": "종합605(월1,2,3)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합605"
      }
    ],
    "sourceSchedule": "종합605(월1,2,3)"
  },
  {
    "id": "11794-005-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "005",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "김창회",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합604",
    "isOnline": false,
    "source": {
      "schedule": "종합604(화1,2,3)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합604"
      }
    ],
    "sourceSchedule": "종합604(화1,2,3)"
  },
  {
    "id": "11794-006-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "006",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "조원모",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래102",
    "isOnline": false,
    "source": {
      "schedule": "미래102(화4,5,6)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래102"
      }
    ],
    "sourceSchedule": "미래102(화4,5,6)"
  },
  {
    "id": "11794-007-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "007",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "조원모",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래102",
    "isOnline": false,
    "source": {
      "schedule": "미래102(화7,8,9)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래102"
      }
    ],
    "sourceSchedule": "미래102(화7,8,9)"
  },
  {
    "id": "11794-008-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "008",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "윤영석",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합604",
    "isOnline": false,
    "source": {
      "schedule": "종합604(화7,8,9)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합604"
      }
    ],
    "sourceSchedule": "종합604(화7,8,9)"
  },
  {
    "id": "11794-009-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "009",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "강성민",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합605",
    "isOnline": false,
    "source": {
      "schedule": "종합605(화7,8,9)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합605"
      }
    ],
    "sourceSchedule": "종합605(화7,8,9)"
  },
  {
    "id": "11794-010-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "010",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "곽정훈",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합604",
    "isOnline": false,
    "source": {
      "schedule": "종합604(수1,2,3)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합604"
      }
    ],
    "sourceSchedule": "종합604(수1,2,3)"
  },
  {
    "id": "11794-011-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "011",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "김진형",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래102",
    "isOnline": false,
    "source": {
      "schedule": "미래102(수1,2,3)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래102"
      }
    ],
    "sourceSchedule": "미래102(수1,2,3)"
  },
  {
    "id": "11794-012-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "012",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "김성민",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합605",
    "isOnline": false,
    "source": {
      "schedule": "종합605(수4,5,6)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합605"
      }
    ],
    "sourceSchedule": "종합605(수4,5,6)"
  },
  {
    "id": "11794-013-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "013",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "이진하",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합604",
    "isOnline": false,
    "source": {
      "schedule": "종합604(화4,5,6)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합604"
      }
    ],
    "sourceSchedule": "종합604(화4,5,6)"
  },
  {
    "id": "11794-014-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "014",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "이진하",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합604",
    "isOnline": false,
    "source": {
      "schedule": "종합604(수4,5,6)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합604"
      }
    ],
    "sourceSchedule": "종합604(수4,5,6)"
  },
  {
    "id": "11794-015-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "015",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "조장하",
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래102",
    "isOnline": false,
    "source": {
      "schedule": "미래102(월4,5,6)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래102"
      }
    ],
    "sourceSchedule": "미래102(월4,5,6)"
  },
  {
    "id": "11794-016-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "016",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "조장하",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합606",
    "isOnline": false,
    "source": {
      "schedule": "종합606(수4,5,6)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합606"
      }
    ],
    "sourceSchedule": "종합606(수4,5,6)"
  },
  {
    "id": "11794-017-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "017",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "조장하",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합606",
    "isOnline": false,
    "source": {
      "schedule": "종합606(수7,8,9)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합606"
      }
    ],
    "sourceSchedule": "종합606(수7,8,9)"
  },
  {
    "id": "11794-018-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "018",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "김준태",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합604",
    "isOnline": false,
    "source": {
      "schedule": "종합604(수7,8,9)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합604"
      }
    ],
    "sourceSchedule": "종합604(수7,8,9)"
  },
  {
    "id": "11794-019-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "019",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "장종환",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합604",
    "isOnline": false,
    "source": {
      "schedule": "종합604(목1,2,3)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합604"
      }
    ],
    "sourceSchedule": "종합604(목1,2,3)"
  },
  {
    "id": "11794-020-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "020",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "김현",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합605",
    "isOnline": false,
    "source": {
      "schedule": "종합605(목1,2,3)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합605"
      }
    ],
    "sourceSchedule": "종합605(목1,2,3)"
  },
  {
    "id": "11794-021-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "021",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "박흥수",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합604",
    "isOnline": false,
    "source": {
      "schedule": "종합604(목4,5,6)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합604"
      }
    ],
    "sourceSchedule": "종합604(목4,5,6)"
  },
  {
    "id": "11794-022-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "022",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "한승헌",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합605",
    "isOnline": false,
    "source": {
      "schedule": "종합605(목4,5,6)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합605"
      }
    ],
    "sourceSchedule": "종합605(목4,5,6)"
  },
  {
    "id": "11794-023-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "023",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "김현철",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합604",
    "isOnline": false,
    "source": {
      "schedule": "종합604(금4,5,6)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합604"
      }
    ],
    "sourceSchedule": "종합604(금4,5,6)"
  },
  {
    "id": "11794-024-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "024",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "조희근",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합605",
    "isOnline": false,
    "source": {
      "schedule": "종합605(금4,5,6)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합605"
      }
    ],
    "sourceSchedule": "종합605(금4,5,6)"
  },
  {
    "id": "11794-025-2000658",
    "subjectKey": "11794",
    "name": "AI시대의기업가정신-도전과창조",
    "division": "025",
    "department": "교양",
    "category": "핵심교양",
    "sourceCategory": "중핵",
    "credit": 3,
    "professor": "김기선",
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합606",
    "isOnline": false,
    "source": {
      "schedule": "종합606(금4,5,6)"
    },
    "capacity": 29,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합606"
      }
    ],
    "sourceSchedule": "종합606(금4,5,6)"
  },
  {
    "id": "11799-001-2000601",
    "subjectKey": "11799",
    "name": "바이오데이터의이해(GUIP)",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "서정연",
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "IT307",
    "isOnline": false,
    "source": {
      "schedule": "IT307(화5,6,7)"
    },
    "capacity": 25,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "IT307"
      }
    ],
    "sourceSchedule": "IT307(화5,6,7)"
  },
  {
    "id": "11800-001-2000601",
    "subjectKey": "11800",
    "name": "디지털헬스프로젝트(GUIP_융합캡스톤)",
    "division": "001",
    "department": "식품영양학과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이유현",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "생활202",
    "isOnline": false,
    "source": {
      "schedule": "생활202(화7,8,9)"
    },
    "capacity": 20,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "생활202"
      }
    ],
    "sourceSchedule": "생활202(화7,8,9)"
  },
  {
    "id": "11800-002-2000595",
    "subjectKey": "11800",
    "name": "디지털헬스프로젝트(GUIP_융합캡스톤)",
    "division": "002",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "안홍렬",
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "글경507",
    "isOnline": false,
    "source": {
      "schedule": "글경507(화7,8,9)"
    },
    "capacity": 35,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "글경507"
      }
    ],
    "sourceSchedule": "글경507(화7,8,9)"
  },
  {
    "id": "12436-001-2000754",
    "subjectKey": "12436",
    "name": "글로벌비즈니스론(1-1전용반_마이크로디그리)",
    "division": "001",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "류창원",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경101",
    "isOnline": false,
    "source": {
      "schedule": "글경101(수4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경101"
      }
    ],
    "sourceSchedule": "글경101(수4,5,6)"
  },
  {
    "id": "12436-002-2000754",
    "subjectKey": "12436",
    "name": "글로벌비즈니스론(1-2전용반_마이크로디그리)",
    "division": "002",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김지송",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경B101",
    "isOnline": false,
    "source": {
      "schedule": "글경B101(수4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경B101"
      }
    ],
    "sourceSchedule": "글경B101(수4,5,6)"
  },
  {
    "id": "12436-003-2000754",
    "subjectKey": "12436",
    "name": "글로벌비즈니스론(1-3전용반_마이크로디그리)",
    "division": "003",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "류덕기",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경B102",
    "isOnline": false,
    "source": {
      "schedule": "글경B102(수4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경B102"
      }
    ],
    "sourceSchedule": "글경B102(수4,5,6)"
  },
  {
    "id": "12436-004-2000754",
    "subjectKey": "12436",
    "name": "글로벌비즈니스론(1-4전용반_마이크로디그리)",
    "division": "004",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "김동주",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경B103",
    "isOnline": false,
    "source": {
      "schedule": "글경B103(수4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경B103"
      }
    ],
    "sourceSchedule": "글경B103(수4,5,6)"
  },
  {
    "id": "12436-005-2000754",
    "subjectKey": "12436",
    "name": "글로벌비즈니스론(1-5전용반_마이크로디그리)",
    "division": "005",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "장종환",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경B104",
    "isOnline": false,
    "source": {
      "schedule": "글경B104(수4,5,6)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경B104"
      }
    ],
    "sourceSchedule": "글경B104(수4,5,6)"
  },
  {
    "id": "12436-006-2000754",
    "subjectKey": "12436",
    "name": "글로벌비즈니스론(기타 전공)",
    "division": "006",
    "department": "경영공학대학",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "류덕기",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경602",
    "isOnline": false,
    "source": {
      "schedule": "글경602(목1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경602"
      }
    ],
    "sourceSchedule": "글경602(목1,2,3)"
  },
  {
    "id": "12436-006-2000763",
    "subjectKey": "12436",
    "name": "글로벌비즈니스론",
    "division": "006",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "류덕기",
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경602",
    "isOnline": false,
    "source": {
      "schedule": "글경602(목1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경602"
      }
    ],
    "sourceSchedule": "글경602(목1,2,3)"
  },
  {
    "id": "12436-007-2000754",
    "subjectKey": "12436",
    "name": "글로벌비즈니스론(기타 전공_이러닝)",
    "division": "007",
    "department": "경영공학대학",
    "category": "이러닝",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "윤성원",
    "days": [
      "화",
      "토"
    ],
    "startPeriod": 9,
    "endPeriod": 9,
    "room": "글경607",
    "isOnline": true,
    "source": {
      "schedule": "글경607(화9 토5,6)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          9
        ],
        "classroom": "글경607"
      },
      {
        "day": "토",
        "periods": [
          5,
          6
        ],
        "classroom": "글경607"
      }
    ],
    "sourceSchedule": "글경607(화9 토5,6)"
  },
  {
    "id": "12502-001-2000615",
    "subjectKey": "12502",
    "name": "디지털문화와미디어",
    "division": "001",
    "department": "디지털콘텐츠",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "박계연",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "미래116",
    "isOnline": false,
    "source": {
      "schedule": "미래116(목2,3,4)"
    },
    "capacity": 34,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "미래116"
      }
    ],
    "sourceSchedule": "미래116(목2,3,4)"
  },
  {
    "id": "12503-001-2000615",
    "subjectKey": "12503",
    "name": "그래픽스기초",
    "division": "001",
    "department": "디지털콘텐츠",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "임명진",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래115",
    "isOnline": false,
    "source": {
      "schedule": "미래115(목6,7,8)"
    },
    "capacity": 31,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래115"
      }
    ],
    "sourceSchedule": "미래115(목6,7,8)"
  },
  {
    "id": "12521-001-2000608",
    "subjectKey": "12521",
    "name": "서양음악기초이론통법2",
    "division": "001",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김예지",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악104",
    "isOnline": false,
    "source": {
      "schedule": "음악104(월3,4)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "음악104"
      }
    ],
    "sourceSchedule": "음악104(월3,4)"
  },
  {
    "id": "12530-001-2000608",
    "subjectKey": "12530",
    "name": "무대음향이론(마이크로디그리)",
    "division": "001",
    "department": "관현악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "서순정",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "음악103",
    "isOnline": false,
    "source": {
      "schedule": "음악103(월1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "음악103"
      }
    ],
    "sourceSchedule": "음악103(월1,2,3)"
  },
  {
    "id": "12538-001-2000605",
    "subjectKey": "12538",
    "name": "국악기초이론",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김만석",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "음악215",
    "isOnline": false,
    "source": {
      "schedule": "음악215(수2,3)"
    },
    "capacity": 21,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "음악215"
      }
    ],
    "sourceSchedule": "음악215(수2,3)"
  },
  {
    "id": "12538-002-2000609",
    "subjectKey": "12538",
    "name": "국악기초이론",
    "division": "002",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김만석",
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "음악215",
    "isOnline": false,
    "source": {
      "schedule": "음악215(수2,3)"
    },
    "capacity": 21,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "음악215"
      }
    ],
    "sourceSchedule": "음악215(수2,3)"
  },
  {
    "id": "12539-001-2000609",
    "subjectKey": "12539",
    "name": "경기민요실습",
    "division": "001",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "최정아",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "음악217",
    "isOnline": false,
    "source": {
      "schedule": "음악217(월3)"
    },
    "capacity": 15,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3
        ],
        "classroom": "음악217"
      }
    ],
    "sourceSchedule": "음악217(월3)"
  },
  {
    "id": "12565-001-2000606",
    "subjectKey": "12565",
    "name": "공연무대움직임2",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "박준희",
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "복지B106",
    "isOnline": false,
    "source": {
      "schedule": "복지B106(월3,4)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "복지B106"
      }
    ],
    "sourceSchedule": "복지B106(월3,4)"
  },
  {
    "id": "12566-001-2000606",
    "subjectKey": "12566",
    "name": "이태리어딕션및가곡2",
    "division": "001",
    "department": "성악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 2,
    "professor": "김현정",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악315",
    "isOnline": false,
    "source": {
      "schedule": "음악315(화3,4)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "음악315"
      }
    ],
    "sourceSchedule": "음악315(화3,4)"
  },
  {
    "id": "12585-001-2000605",
    "subjectKey": "12585",
    "name": "시벨리우스심화실습",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "이율구",
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악106",
    "isOnline": false,
    "source": {
      "schedule": "음악106(화3,4)"
    },
    "capacity": 15,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "음악106"
      }
    ],
    "sourceSchedule": "음악106(화3,4)"
  },
  {
    "id": "12587-001-2000605",
    "subjectKey": "12587",
    "name": "화성의이해2",
    "division": "001",
    "department": "아트앤테크놀로지작곡과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 2,
    "professor": "조한나",
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "음악215",
    "isOnline": false,
    "source": {
      "schedule": "음악215(수5,6)"
    },
    "capacity": 20,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "음악215"
      }
    ],
    "sourceSchedule": "음악215(수5,6)"
  },
  {
    "id": "12615-001-2000584",
    "subjectKey": "12615",
    "name": "소방행정실무",
    "division": "001",
    "department": "소방행정학과(야)",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김승룡",
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문406",
    "isOnline": false,
    "source": {
      "schedule": "인문406(월6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문406"
      }
    ],
    "sourceSchedule": "인문406(월6,7,8)"
  },
  {
    "id": "12620-001-2000584",
    "subjectKey": "12620",
    "name": "소방기계론2",
    "division": "001",
    "department": "소방행정학과(야)",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "문기현",
    "days": [
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "첨단401",
    "isOnline": false,
    "source": {
      "schedule": "첨단401(화2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "첨단401"
      }
    ],
    "sourceSchedule": "첨단401(화2,3,4)"
  },
  {
    "id": "12621-001-2000551",
    "subjectKey": "12621",
    "name": "응급처치론",
    "division": "001",
    "department": "소방행정학과(야)",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "정요안",
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문310",
    "isOnline": false,
    "source": {
      "schedule": "인문310(화6,7,8)"
    },
    "capacity": 40,
    "targetGrade": 4,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문310"
      }
    ],
    "sourceSchedule": "인문310(화6,7,8)"
  },
  {
    "id": "12641-001-2000757",
    "subjectKey": "12641",
    "name": "AI기초",
    "division": "001",
    "department": "AI데이터과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "안주희",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경507",
    "isOnline": false,
    "source": {
      "schedule": "글경507(월1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경507"
      }
    ],
    "sourceSchedule": "글경507(월1,2,3)"
  },
  {
    "id": "12641-001-2000763",
    "subjectKey": "12641",
    "name": "AI기초",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "안주희",
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경507",
    "isOnline": false,
    "source": {
      "schedule": "글경507(월1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경507"
      }
    ],
    "sourceSchedule": "글경507(월1,2,3)"
  },
  {
    "id": "12641-002-2000757",
    "subjectKey": "12641",
    "name": "AI기초",
    "division": "002",
    "department": "AI데이터과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "안주희",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경507",
    "isOnline": false,
    "source": {
      "schedule": "글경507(화1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경507"
      }
    ],
    "sourceSchedule": "글경507(화1,2,3)"
  },
  {
    "id": "12641-002-2000763",
    "subjectKey": "12641",
    "name": "AI기초",
    "division": "002",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "안주희",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경507",
    "isOnline": false,
    "source": {
      "schedule": "글경507(화1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경507"
      }
    ],
    "sourceSchedule": "글경507(화1,2,3)"
  },
  {
    "id": "12641-003-2000757",
    "subjectKey": "12641",
    "name": "AI기초",
    "division": "003",
    "department": "AI데이터과학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "안주희",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경507",
    "isOnline": false,
    "source": {
      "schedule": "글경507(수1,2,3)"
    },
    "capacity": 32,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경507"
      }
    ],
    "sourceSchedule": "글경507(수1,2,3)"
  },
  {
    "id": "12641-003-2000763",
    "subjectKey": "12641",
    "name": "AI기초",
    "division": "003",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "안주희",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경507",
    "isOnline": false,
    "source": {
      "schedule": "글경507(수1,2,3)"
    },
    "capacity": 32,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경507"
      }
    ],
    "sourceSchedule": "글경507(수1,2,3)"
  },
  {
    "id": "12644-001-2000595",
    "subjectKey": "12644",
    "name": "머신러닝프로젝트(RISE)",
    "division": "001",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "안홍렬",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경507",
    "isOnline": false,
    "source": {
      "schedule": "글경507(금5,6,7)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경507"
      }
    ],
    "sourceSchedule": "글경507(금5,6,7)"
  },
  {
    "id": "12644-002-2000595",
    "subjectKey": "12644",
    "name": "머신러닝프로젝트(RISE)",
    "division": "002",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김순찬",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경B103",
    "isOnline": false,
    "source": {
      "schedule": "글경B103(금5,6,7)"
    },
    "capacity": 35,
    "targetGrade": 2,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경B103"
      }
    ],
    "sourceSchedule": "글경B103(금5,6,7)"
  },
  {
    "id": "12648-001-2000595",
    "subjectKey": "12648",
    "name": "AI융합산업1",
    "division": "001",
    "department": "데이터과학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "안홍렬",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래311",
    "isOnline": false,
    "source": {
      "schedule": "미래311(금1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 3,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래311"
      }
    ],
    "sourceSchedule": "미래311(금1,2,3)"
  },
  {
    "id": "12666-001-2000759",
    "subjectKey": "12666",
    "name": "리눅스",
    "division": "001",
    "department": "지능형보안학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양수미",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT306",
    "isOnline": false,
    "source": {
      "schedule": "IT306(금1,2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT306"
      }
    ],
    "sourceSchedule": "IT306(금1,2,3,4)"
  },
  {
    "id": "12666-001-2000763",
    "subjectKey": "12666",
    "name": "리눅스",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "양수미",
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "IT306",
    "isOnline": false,
    "source": {
      "schedule": "IT306(금1,2,3,4)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "IT306"
      }
    ],
    "sourceSchedule": "IT306(금1,2,3,4)"
  },
  {
    "id": "12667-001-2000759",
    "subjectKey": "12667",
    "name": "IT프로젝트1",
    "division": "001",
    "department": "지능형보안학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김대엽",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "IT306",
    "isOnline": false,
    "source": {
      "schedule": "IT306(화5,6 수5,6)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "IT306"
      },
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "IT306"
      }
    ],
    "sourceSchedule": "IT306(화5,6 수5,6)"
  },
  {
    "id": "12667-001-2000763",
    "subjectKey": "12667",
    "name": "IT프로젝트1",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "김대엽",
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "IT306",
    "isOnline": false,
    "source": {
      "schedule": "IT306(화5,6 수5,6)"
    },
    "capacity": 60,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "IT306"
      },
      {
        "day": "수",
        "periods": [
          5,
          6
        ],
        "classroom": "IT306"
      }
    ],
    "sourceSchedule": "IT306(화5,6 수5,6)"
  },
  {
    "id": "12681-001-2000763",
    "subjectKey": "12681",
    "name": "네트워크기초",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "변희정",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "IT308",
    "isOnline": false,
    "source": {
      "schedule": "IT308(화1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "IT308"
      }
    ],
    "sourceSchedule": "IT308(화1,2,3)"
  },
  {
    "id": "12681-001-2000844",
    "subjectKey": "12681",
    "name": "네트워크기초",
    "division": "001",
    "department": "컴퓨터공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "변희정",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "IT308",
    "isOnline": false,
    "source": {
      "schedule": "IT308(화1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "IT308"
      }
    ],
    "sourceSchedule": "IT308(화1,2,3)"
  },
  {
    "id": "12681-002-2000763",
    "subjectKey": "12681",
    "name": "네트워크기초",
    "division": "002",
    "department": "자유전공학부",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "변희정",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT308",
    "isOnline": false,
    "source": {
      "schedule": "IT308(목2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT308"
      }
    ],
    "sourceSchedule": "IT308(목2,3,4)"
  },
  {
    "id": "12681-002-2000844",
    "subjectKey": "12681",
    "name": "네트워크기초",
    "division": "002",
    "department": "컴퓨터공학",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "변희정",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT308",
    "isOnline": false,
    "source": {
      "schedule": "IT308(목2,3,4)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT308"
      }
    ],
    "sourceSchedule": "IT308(목2,3,4)"
  },
  {
    "id": "12715-001-2000658",
    "subjectKey": "12715",
    "name": "AI시대의동서양신화읽기",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "전주현",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문309",
    "isOnline": false,
    "source": {
      "schedule": "인문309(수7,8,9)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문309"
      }
    ],
    "sourceSchedule": "인문309(수7,8,9)"
  },
  {
    "id": "12717-001-2000658",
    "subjectKey": "12717",
    "name": "생활한자",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "손미리",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합507",
    "isOnline": false,
    "source": {
      "schedule": "종합507(화4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합507"
      }
    ],
    "sourceSchedule": "종합507(화4,5,6)"
  },
  {
    "id": "12718-001-2000658",
    "subjectKey": "12718",
    "name": "동아시아도시의문화유산",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김호",
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문408",
    "isOnline": false,
    "source": {
      "schedule": "인문408(화4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문408"
      }
    ],
    "sourceSchedule": "인문408(화4,5,6)"
  },
  {
    "id": "12720-001-2000658",
    "subjectKey": "12720",
    "name": "응용중국어커뮤니케이션",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "최영",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합307",
    "isOnline": false,
    "source": {
      "schedule": "종합307(수4,5,6)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합307"
      }
    ],
    "sourceSchedule": "종합307(수4,5,6)"
  },
  {
    "id": "12721-001-2000658",
    "subjectKey": "12721",
    "name": "과학기술의변천사",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김상준",
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래105",
    "isOnline": false,
    "source": {
      "schedule": "미래105(수4,5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래105"
      }
    ],
    "sourceSchedule": "미래105(수4,5,6)"
  },
  {
    "id": "12722-001-2000658",
    "subjectKey": "12722",
    "name": "전쟁속삶의지혜와전략",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "윤영석",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B201",
    "isOnline": false,
    "source": {
      "schedule": "미래B201(수1,2,3)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B201"
      }
    ],
    "sourceSchedule": "미래B201(수1,2,3)"
  },
  {
    "id": "12723-001-2000658",
    "subjectKey": "12723",
    "name": "한국사회와언어문화",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "박카밀라",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합307",
    "isOnline": false,
    "source": {
      "schedule": "종합307(수1,2,3)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합307"
      }
    ],
    "sourceSchedule": "종합307(수1,2,3)"
  },
  {
    "id": "12725-001-2000658",
    "subjectKey": "12725",
    "name": "창업리더십과코칭",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "곽정훈",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래319",
    "isOnline": false,
    "source": {
      "schedule": "미래319(화1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래319"
      }
    ],
    "sourceSchedule": "미래319(화1,2,3)"
  },
  {
    "id": "12726-001-2000658",
    "subjectKey": "12726",
    "name": "지역유산브랜딩개론",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김승준",
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "글경701",
    "isOnline": false,
    "source": {
      "schedule": "글경701(수7,8,9)"
    },
    "capacity": 80,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "글경701"
      }
    ],
    "sourceSchedule": "글경701(수7,8,9)"
  },
  {
    "id": "12727-001-2000658",
    "subjectKey": "12727",
    "name": "생성AI를활용한영상기획/제작/편집입문",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "김인환",
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래311",
    "isOnline": false,
    "source": {
      "schedule": "미래311(목4,5,6)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래311"
      }
    ],
    "sourceSchedule": "미래311(목4,5,6)"
  },
  {
    "id": "12729-001-2000658",
    "subjectKey": "12729",
    "name": "음악으로읽는20세기문화와사회(이러닝)",
    "division": "001",
    "department": "교양",
    "category": "이러닝",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "배준",
    "days": [
      "월",
      "토"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "음악315",
    "isOnline": true,
    "source": {
      "schedule": "음악315(월1 토11,12)"
    },
    "capacity": 200,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          1
        ],
        "classroom": "음악315"
      },
      {
        "day": "토",
        "periods": [
          11,
          12
        ],
        "classroom": "음악315"
      }
    ],
    "sourceSchedule": "음악315(월1 토11,12)"
  },
  {
    "id": "12730-001-2000658",
    "subjectKey": "12730",
    "name": "캠퍼스합창",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "최인환",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "음악111",
    "isOnline": false,
    "source": {
      "schedule": "음악111(월7,8,9)"
    },
    "capacity": 50,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "음악111"
      }
    ],
    "sourceSchedule": "음악111(월7,8,9)"
  },
  {
    "id": "12731-001-2000658",
    "subjectKey": "12731",
    "name": "미래모빌리티",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "심재호",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래110",
    "isOnline": false,
    "source": {
      "schedule": "미래110(수1,2,3)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래110"
      }
    ],
    "sourceSchedule": "미래110(수1,2,3)"
  },
  {
    "id": "12732-001-2000658",
    "subjectKey": "12732",
    "name": "EDISON전공설계",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 3,
    "professor": "임경희",
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래101",
    "isOnline": false,
    "source": {
      "schedule": "미래101(화1,2,3)"
    },
    "capacity": 30,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래101"
      }
    ],
    "sourceSchedule": "미래101(화1,2,3)"
  },
  {
    "id": "12733-001-2000658",
    "subjectKey": "12733",
    "name": "4차산업혁명시대의품질경영",
    "division": "001",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 2,
    "professor": "박상석",
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "미래520",
    "isOnline": false,
    "source": {
      "schedule": "미래520(목7,8)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8
        ],
        "classroom": "미래520"
      }
    ],
    "sourceSchedule": "미래520(목7,8)"
  },
  {
    "id": "12733-002-2000658",
    "subjectKey": "12733",
    "name": "4차산업혁명시대의품질경영",
    "division": "002",
    "department": "교양",
    "category": "교양선택",
    "sourceCategory": "선교",
    "credit": 2,
    "professor": "박상석",
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래520",
    "isOnline": false,
    "source": {
      "schedule": "미래520(목5,6)"
    },
    "capacity": 40,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6
        ],
        "classroom": "미래520"
      }
    ],
    "sourceSchedule": "미래520(목5,6)"
  },
  {
    "id": "12749-001-2000654",
    "subjectKey": "12749",
    "name": "Basic Sewing Techniques ",
    "division": "001",
    "department": "패션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "권준희",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "종합B108",
    "isOnline": false,
    "source": {
      "schedule": "종합B108(목6,7,8,9)"
    },
    "capacity": 17,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "종합B108"
      }
    ],
    "sourceSchedule": "종합B108(목6,7,8,9)"
  },
  {
    "id": "12749-002-2000654",
    "subjectKey": "12749",
    "name": "Basic Sewing Techniques ",
    "division": "002",
    "department": "패션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "이민정",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "종합B107",
    "isOnline": false,
    "source": {
      "schedule": "종합B107(목6,7,8,9)"
    },
    "capacity": 16,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "종합B107"
      }
    ],
    "sourceSchedule": "종합B107(목6,7,8,9)"
  },
  {
    "id": "12750-001-2000654",
    "subjectKey": "12750",
    "name": "Intro. to Fashion Design",
    "division": "001",
    "department": "패션디자인",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 3,
    "professor": "허민",
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술211",
    "isOnline": false,
    "source": {
      "schedule": "미술211(수1,2,3,4)"
    },
    "capacity": 20,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술211"
      }
    ],
    "sourceSchedule": "미술211(수1,2,3,4)"
  },
  {
    "id": "12768-001-2000613",
    "subjectKey": "12768",
    "name": "영화제작테크놀로지실습",
    "division": "001",
    "department": "영화예술",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이상노",
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "생활108",
    "isOnline": false,
    "source": {
      "schedule": "생활108(목2,3,4)"
    },
    "capacity": 15,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "생활108"
      }
    ],
    "sourceSchedule": "생활108(목2,3,4)"
  },
  {
    "id": "12768-002-2000613",
    "subjectKey": "12768",
    "name": "영화제작테크놀로지실습",
    "division": "002",
    "department": "영화예술",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "이상노",
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "생활108",
    "isOnline": false,
    "source": {
      "schedule": "생활108(목6,7,8)"
    },
    "capacity": 15,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "생활108"
      }
    ],
    "sourceSchedule": "생활108(목6,7,8)"
  },
  {
    "id": "12785-001-2000609",
    "subjectKey": "12785",
    "name": "기초장단2",
    "division": "001",
    "department": "국악과",
    "category": "전공선택",
    "sourceCategory": "전선",
    "credit": 1,
    "professor": "정택수",
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "음악107",
    "isOnline": false,
    "source": {
      "schedule": "음악107(월7)"
    },
    "capacity": 11,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "음악107"
      }
    ],
    "sourceSchedule": "음악107(월7)"
  },
  {
    "id": "12800-001-2000755",
    "subjectKey": "12800",
    "name": "바이오공학개론",
    "division": "001",
    "department": "바이오공학과",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "유기태",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합407",
    "isOnline": false,
    "source": {
      "schedule": "종합407(금5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합407"
      }
    ],
    "sourceSchedule": "종합407(금5,6,7)"
  },
  {
    "id": "12800-001-2000763",
    "subjectKey": "12800",
    "name": "바이오공학개론",
    "division": "001",
    "department": "자유전공학부",
    "category": "전공필수",
    "sourceCategory": "전핵",
    "credit": 3,
    "professor": "유기태",
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합407",
    "isOnline": false,
    "source": {
      "schedule": "종합407(금5,6,7)"
    },
    "capacity": 100,
    "targetGrade": 1,
    "departmentLimit": false,
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합407"
      }
    ],
    "sourceSchedule": "종합407(금5,6,7)"
  }
]

export const COURSE_DATA = applyCourseDataOverrides(RAW_COURSE_DATA, COURSE_DATA_META)
